
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7bb0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7bb0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.0";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.0";

});



parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



/**
 * react-router v7.9.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $43f18c0047822054$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-4WY6JWTD.mjs"
});
var $43f18c0047822054$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $43f18c0047822054$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $43f18c0047822054$var$__typeError("Cannot " + msg);
var $43f18c0047822054$var$__privateGet = (obj, member, getter)=>($43f18c0047822054$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $43f18c0047822054$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $43f18c0047822054$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $43f18c0047822054$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($43f18c0047822054$export$e19cd5f9376f8cee || {});
var $43f18c0047822054$var$PopStateEventType = "popstate";
function $43f18c0047822054$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $43f18c0047822054$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $43f18c0047822054$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $43f18c0047822054$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $43f18c0047822054$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $43f18c0047822054$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $43f18c0047822054$export$fe53371bee54353d(to);
    }
    return $43f18c0047822054$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $43f18c0047822054$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $43f18c0047822054$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $43f18c0047822054$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $43f18c0047822054$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $43f18c0047822054$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $43f18c0047822054$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $43f18c0047822054$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $43f18c0047822054$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $43f18c0047822054$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $43f18c0047822054$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $43f18c0047822054$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $43f18c0047822054$var$createKey()
    };
    return location;
}
function $43f18c0047822054$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $43f18c0047822054$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $43f18c0047822054$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $43f18c0047822054$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $43f18c0047822054$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $43f18c0047822054$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $43f18c0047822054$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $43f18c0047822054$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($43f18c0047822054$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($43f18c0047822054$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $43f18c0047822054$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $43f18c0047822054$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $43f18c0047822054$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $43f18c0047822054$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $43f18c0047822054$var$_map;
var $43f18c0047822054$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $43f18c0047822054$var$__privateAdd(this, $43f18c0047822054$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($43f18c0047822054$var$__privateGet(this, $43f18c0047822054$var$_map).has(context)) return $43f18c0047822054$var$__privateGet(this, $43f18c0047822054$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $43f18c0047822054$var$__privateGet(this, $43f18c0047822054$var$_map).set(context, value);
    }
};
$43f18c0047822054$var$_map = new WeakMap();
var $43f18c0047822054$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $43f18c0047822054$var$isUnsupportedLazyRouteObjectKey(key) {
    return $43f18c0047822054$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $43f18c0047822054$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $43f18c0047822054$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $43f18c0047822054$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $43f18c0047822054$var$isIndexRoute(route) {
    return route.index === true;
}
function $43f18c0047822054$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $43f18c0047822054$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $43f18c0047822054$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($43f18c0047822054$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $43f18c0047822054$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $43f18c0047822054$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $43f18c0047822054$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $43f18c0047822054$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $43f18c0047822054$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $43f18c0047822054$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $43f18c0047822054$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $43f18c0047822054$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $43f18c0047822054$var$flattenRoutes(routes);
    $43f18c0047822054$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $43f18c0047822054$var$decodePath(pathname);
        matches = $43f18c0047822054$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $43f18c0047822054$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $43f18c0047822054$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $43f18c0047822054$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $43f18c0047822054$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $43f18c0047822054$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $43f18c0047822054$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $43f18c0047822054$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $43f18c0047822054$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $43f18c0047822054$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $43f18c0047822054$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $43f18c0047822054$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $43f18c0047822054$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $43f18c0047822054$var$paramRe = /^:[\w-]+$/;
var $43f18c0047822054$var$dynamicSegmentValue = 3;
var $43f18c0047822054$var$indexRouteValue = 2;
var $43f18c0047822054$var$emptySegmentValue = 1;
var $43f18c0047822054$var$staticSegmentValue = 10;
var $43f18c0047822054$var$splatPenalty = -2;
var $43f18c0047822054$var$isSplat = (s)=>s === "*";
function $43f18c0047822054$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($43f18c0047822054$var$isSplat)) initialScore += $43f18c0047822054$var$splatPenalty;
    if (index) initialScore += $43f18c0047822054$var$indexRouteValue;
    return segments.filter((s)=>!$43f18c0047822054$var$isSplat(s)).reduce((score, segment)=>score + ($43f18c0047822054$var$paramRe.test(segment) ? $43f18c0047822054$var$dynamicSegmentValue : segment === "" ? $43f18c0047822054$var$emptySegmentValue : $43f18c0047822054$var$staticSegmentValue), initialScore);
}
function $43f18c0047822054$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $43f18c0047822054$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $43f18c0047822054$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $43f18c0047822054$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $43f18c0047822054$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $43f18c0047822054$var$normalizePathname($43f18c0047822054$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $43f18c0047822054$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $43f18c0047822054$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $43f18c0047822054$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $43f18c0047822054$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $43f18c0047822054$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $43f18c0047822054$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $43f18c0047822054$var$compilePath(path, caseSensitive = false, end = true) {
    $43f18c0047822054$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $43f18c0047822054$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $43f18c0047822054$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $43f18c0047822054$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $43f18c0047822054$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $43f18c0047822054$var$joinPaths([
        basename,
        pathname
    ]);
}
var $43f18c0047822054$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $43f18c0047822054$var$isAbsoluteUrl = (url)=>$43f18c0047822054$var$ABSOLUTE_URL_REGEX.test(url);
function $43f18c0047822054$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($43f18c0047822054$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $43f18c0047822054$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $43f18c0047822054$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $43f18c0047822054$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $43f18c0047822054$var$normalizeSearch(search),
        hash: $43f18c0047822054$var$normalizeHash(hash)
    };
}
function $43f18c0047822054$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $43f18c0047822054$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $43f18c0047822054$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $43f18c0047822054$var$getResolveToMatches(matches) {
    let pathMatches = $43f18c0047822054$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $43f18c0047822054$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $43f18c0047822054$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $43f18c0047822054$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $43f18c0047822054$var$getInvalidPathError("?", "pathname", "search", to));
        $43f18c0047822054$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $43f18c0047822054$var$getInvalidPathError("#", "pathname", "hash", to));
        $43f18c0047822054$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $43f18c0047822054$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $43f18c0047822054$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $43f18c0047822054$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $43f18c0047822054$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $43f18c0047822054$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $43f18c0047822054$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $43f18c0047822054$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $43f18c0047822054$export$4051a07651545597(data2, init) {
    return new $43f18c0047822054$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $43f18c0047822054$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $43f18c0047822054$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $43f18c0047822054$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $43f18c0047822054$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $43f18c0047822054$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $43f18c0047822054$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $43f18c0047822054$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $43f18c0047822054$var$getRoutePattern(paths) {
    return paths.filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $43f18c0047822054$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $43f18c0047822054$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $43f18c0047822054$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $43f18c0047822054$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$43f18c0047822054$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $43f18c0047822054$var$wrapImpl(aggregated[key], original, (...args)=>$43f18c0047822054$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$43f18c0047822054$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$43f18c0047822054$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $43f18c0047822054$var$wrapImpl(aggregated.middleware, original, (...args)=>$43f18c0047822054$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$43f18c0047822054$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $43f18c0047822054$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$43f18c0047822054$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $43f18c0047822054$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $43f18c0047822054$export$fe53371bee54353d(to) : ".",
                ...$43f18c0047822054$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$43f18c0047822054$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$43f18c0047822054$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $43f18c0047822054$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$43f18c0047822054$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$43f18c0047822054$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $43f18c0047822054$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $43f18c0047822054$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $43f18c0047822054$var$getReadonlyRequest(request),
            context: context != null ? $43f18c0047822054$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $43f18c0047822054$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $43f18c0047822054$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $43f18c0047822054$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $43f18c0047822054$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $43f18c0047822054$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $43f18c0047822054$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $43f18c0047822054$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $43f18c0047822054$var$getReadonlyContext(context)
    };
}
function $43f18c0047822054$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $43f18c0047822054$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $43f18c0047822054$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $43f18c0047822054$var$getReadonlyContext(context) {
    if ($43f18c0047822054$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $43f18c0047822054$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $43f18c0047822054$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $43f18c0047822054$var$objectProtoNames;
}
// lib/router/router.ts
var $43f18c0047822054$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $43f18c0047822054$var$validMutationMethods = new Set($43f18c0047822054$var$validMutationMethodsArr);
var $43f18c0047822054$var$validRequestMethodsArr = [
    "GET",
    ...$43f18c0047822054$var$validMutationMethodsArr
];
var $43f18c0047822054$var$validRequestMethods = new Set($43f18c0047822054$var$validRequestMethodsArr);
var $43f18c0047822054$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $43f18c0047822054$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $43f18c0047822054$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $43f18c0047822054$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $43f18c0047822054$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $43f18c0047822054$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $43f18c0047822054$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $43f18c0047822054$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $43f18c0047822054$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $43f18c0047822054$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $43f18c0047822054$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$43f18c0047822054$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $43f18c0047822054$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $43f18c0047822054$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $43f18c0047822054$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $43f18c0047822054$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $43f18c0047822054$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$43f18c0047822054$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$43f18c0047822054$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$43f18c0047822054$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $43f18c0047822054$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $43f18c0047822054$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $43f18c0047822054$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $43f18c0047822054$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$43f18c0047822054$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $43f18c0047822054$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $43f18c0047822054$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $43f18c0047822054$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $43f18c0047822054$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $43f18c0047822054$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $43f18c0047822054$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $43f18c0047822054$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $43f18c0047822054$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $43f18c0047822054$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $43f18c0047822054$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $43f18c0047822054$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $43f18c0047822054$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $43f18c0047822054$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $43f18c0047822054$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $43f18c0047822054$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $43f18c0047822054$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $43f18c0047822054$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $43f18c0047822054$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($43f18c0047822054$var$isErrorResult(result) && $43f18c0047822054$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $43f18c0047822054$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $43f18c0047822054$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$43f18c0047822054$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $43f18c0047822054$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $43f18c0047822054$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $43f18c0047822054$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $43f18c0047822054$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $43f18c0047822054$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($43f18c0047822054$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $43f18c0047822054$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($43f18c0047822054$var$isErrorResult(result)) {
            let boundaryMatch = $43f18c0047822054$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $43f18c0047822054$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $43f18c0047822054$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $43f18c0047822054$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $43f18c0047822054$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $43f18c0047822054$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $43f18c0047822054$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$43f18c0047822054$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $43f18c0047822054$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $43f18c0047822054$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $43f18c0047822054$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$43f18c0047822054$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $43f18c0047822054$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $43f18c0047822054$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $43f18c0047822054$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $43f18c0047822054$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $43f18c0047822054$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $43f18c0047822054$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $43f18c0047822054$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $43f18c0047822054$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $43f18c0047822054$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $43f18c0047822054$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $43f18c0047822054$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $43f18c0047822054$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($43f18c0047822054$var$isRedirectResult(actionResult) || $43f18c0047822054$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $43f18c0047822054$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($43f18c0047822054$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $43f18c0047822054$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $43f18c0047822054$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($43f18c0047822054$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $43f18c0047822054$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $43f18c0047822054$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $43f18c0047822054$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $43f18c0047822054$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $43f18c0047822054$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $43f18c0047822054$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $43f18c0047822054$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $43f18c0047822054$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $43f18c0047822054$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $43f18c0047822054$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $43f18c0047822054$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $43f18c0047822054$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $43f18c0047822054$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $43f18c0047822054$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $43f18c0047822054$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $43f18c0047822054$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $43f18c0047822054$var$getDoneFetcher(void 0));
            return;
        }
        if ($43f18c0047822054$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $43f18c0047822054$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($43f18c0047822054$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $43f18c0047822054$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $43f18c0047822054$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $43f18c0047822054$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $43f18c0047822054$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($43f18c0047822054$var$isAbsoluteUrl(location)) {
                const url = $43f18c0047822054$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $43f18c0047822054$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $43f18c0047822054$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($43f18c0047822054$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $43f18c0047822054$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $43f18c0047822054$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $43f18c0047822054$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($43f18c0047822054$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $43f18c0047822054$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $43f18c0047822054$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $43f18c0047822054$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $43f18c0047822054$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $43f18c0047822054$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $43f18c0047822054$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $43f18c0047822054$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $43f18c0047822054$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $43f18c0047822054$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $43f18c0047822054$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $43f18c0047822054$export$386d57f03f0b2883;
        $43f18c0047822054$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $43f18c0047822054$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $43f18c0047822054$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $43f18c0047822054$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $43f18c0047822054$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$43f18c0047822054$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $43f18c0047822054$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $43f18c0047822054$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $43f18c0047822054$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $43f18c0047822054$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $43f18c0047822054$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $43f18c0047822054$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $43f18c0047822054$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $43f18c0047822054$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $43f18c0047822054$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $43f18c0047822054$export$3336b097a6fbc59a(routes, opts) {
    $43f18c0047822054$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $43f18c0047822054$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$43f18c0047822054$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $43f18c0047822054$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $43f18c0047822054$var$createLocation("", $43f18c0047822054$export$fe53371bee54353d(url), null, "default");
        let matches = $43f18c0047822054$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $43f18c0047822054$export$b8d3e69d4b3eff04();
        if (!$43f18c0047822054$var$isValidMethod(method) && method !== "HEAD") {
            let error = $43f18c0047822054$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $43f18c0047822054$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $43f18c0047822054$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $43f18c0047822054$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $43f18c0047822054$export$f5708dca728d7177(requestContext instanceof $43f18c0047822054$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $43f18c0047822054$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $43f18c0047822054$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $43f18c0047822054$var$getRoutePattern(matches.map((m)=>m.route.path)),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($43f18c0047822054$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($43f18c0047822054$export$6e80290866a84dd4(error)) return error;
                    if ($43f18c0047822054$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $43f18c0047822054$export$f2680fa305b734ca(error.status, error.statusText, await $43f18c0047822054$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($43f18c0047822054$export$e0163cfdf7bc9cfa(error)) error = $43f18c0047822054$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $43f18c0047822054$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $43f18c0047822054$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $43f18c0047822054$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $43f18c0047822054$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($43f18c0047822054$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($43f18c0047822054$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $43f18c0047822054$var$createLocation("", $43f18c0047822054$export$fe53371bee54353d(url), null, "default");
        let matches = $43f18c0047822054$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $43f18c0047822054$export$b8d3e69d4b3eff04();
        if (!$43f18c0047822054$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $43f18c0047822054$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $43f18c0047822054$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $43f18c0047822054$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $43f18c0047822054$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $43f18c0047822054$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $43f18c0047822054$export$f5708dca728d7177(requestContext instanceof $43f18c0047822054$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $43f18c0047822054$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $43f18c0047822054$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $43f18c0047822054$var$getRoutePattern(matches.map((m)=>m.route.path)),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $43f18c0047822054$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($43f18c0047822054$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($43f18c0047822054$var$dataWithResponseInitToResponse(error));
                if ($43f18c0047822054$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($43f18c0047822054$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $43f18c0047822054$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($43f18c0047822054$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $43f18c0047822054$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $43f18c0047822054$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($43f18c0047822054$var$isDataStrategyResult(e) && $43f18c0047822054$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($43f18c0047822054$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $43f18c0047822054$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $43f18c0047822054$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($43f18c0047822054$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($43f18c0047822054$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($43f18c0047822054$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $43f18c0047822054$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $43f18c0047822054$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($43f18c0047822054$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $43f18c0047822054$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $43f18c0047822054$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $43f18c0047822054$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $43f18c0047822054$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $43f18c0047822054$var$getRoutePattern(matches.map((m)=>m.route.path));
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $43f18c0047822054$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $43f18c0047822054$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $43f18c0047822054$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $43f18c0047822054$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $43f18c0047822054$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $43f18c0047822054$var$callDataStrategyImpl(dataStrategy || $43f18c0047822054$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($43f18c0047822054$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $43f18c0047822054$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($43f18c0047822054$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($43f18c0047822054$export$e0163cfdf7bc9cfa(result.result)) throw $43f18c0047822054$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $43f18c0047822054$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $43f18c0047822054$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $43f18c0047822054$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $43f18c0047822054$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $43f18c0047822054$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $43f18c0047822054$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $43f18c0047822054$var$resolveTo(to ? to : ".", $43f18c0047822054$var$getResolveToMatches(contextualMatches), $43f18c0047822054$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $43f18c0047822054$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $43f18c0047822054$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $43f18c0047822054$export$fe53371bee54353d(path);
}
function $43f18c0047822054$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$43f18c0047822054$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$43f18c0047822054$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $43f18c0047822054$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $43f18c0047822054$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $43f18c0047822054$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$43f18c0047822054$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$43f18c0047822054$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $43f18c0047822054$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $43f18c0047822054$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $43f18c0047822054$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $43f18c0047822054$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $43f18c0047822054$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($43f18c0047822054$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $43f18c0047822054$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $43f18c0047822054$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $43f18c0047822054$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $43f18c0047822054$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $43f18c0047822054$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $43f18c0047822054$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $43f18c0047822054$var$getRoutePattern(matches.map((m)=>m.route.path));
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$43f18c0047822054$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $43f18c0047822054$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($43f18c0047822054$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $43f18c0047822054$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $43f18c0047822054$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $43f18c0047822054$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $43f18c0047822054$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $43f18c0047822054$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $43f18c0047822054$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $43f18c0047822054$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($43f18c0047822054$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $43f18c0047822054$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $43f18c0047822054$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$43f18c0047822054$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $43f18c0047822054$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $43f18c0047822054$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $43f18c0047822054$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $43f18c0047822054$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $43f18c0047822054$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$43f18c0047822054$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $43f18c0047822054$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $43f18c0047822054$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $43f18c0047822054$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$43f18c0047822054$var$isSameRoute(aChild, bChild)));
}
var $43f18c0047822054$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $43f18c0047822054$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $43f18c0047822054$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $43f18c0047822054$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $43f18c0047822054$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $43f18c0047822054$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $43f18c0047822054$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $43f18c0047822054$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $43f18c0047822054$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $43f18c0047822054$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $43f18c0047822054$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $43f18c0047822054$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $43f18c0047822054$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $43f18c0047822054$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $43f18c0047822054$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $43f18c0047822054$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $43f18c0047822054$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $43f18c0047822054$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $43f18c0047822054$var$isNonNullable(value) {
    return value !== void 0;
}
function $43f18c0047822054$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $43f18c0047822054$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($43f18c0047822054$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $43f18c0047822054$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $43f18c0047822054$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $43f18c0047822054$var$defaultDataStrategy(args);
    return $43f18c0047822054$var$runClientMiddlewarePipeline(args, ()=>$43f18c0047822054$var$defaultDataStrategy(args));
}
function $43f18c0047822054$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $43f18c0047822054$var$runMiddlewarePipeline(args, handler, processResult, $43f18c0047822054$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $43f18c0047822054$export$e0163cfdf7bc9cfa(result) ? $43f18c0047822054$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $43f18c0047822054$var$runClientMiddlewarePipeline(args, handler) {
    return $43f18c0047822054$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $43f18c0047822054$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.unstable_shouldCallHandler()), 0));
            let boundaryRouteId = $43f18c0047822054$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $43f18c0047822054$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $43f18c0047822054$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $43f18c0047822054$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $43f18c0047822054$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $43f18c0047822054$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $43f18c0047822054$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $43f18c0047822054$var$loadLazyRoute(match.route, $43f18c0047822054$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $43f18c0047822054$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $43f18c0047822054$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $43f18c0047822054$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $43f18c0047822054$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$43f18c0047822054$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($43f18c0047822054$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $43f18c0047822054$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $43f18c0047822054$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $43f18c0047822054$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $43f18c0047822054$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $43f18c0047822054$var$getRoutePattern(matches.map((m)=>m.route.path)), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $43f18c0047822054$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $43f18c0047822054$var$getRoutePattern(matches.map((m)=>m.route.path)),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $43f18c0047822054$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $43f18c0047822054$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $43f18c0047822054$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $43f18c0047822054$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $43f18c0047822054$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $43f18c0047822054$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $43f18c0047822054$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($43f18c0047822054$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $43f18c0047822054$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $43f18c0047822054$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($43f18c0047822054$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $43f18c0047822054$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $43f18c0047822054$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $43f18c0047822054$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($43f18c0047822054$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $43f18c0047822054$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $43f18c0047822054$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$43f18c0047822054$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $43f18c0047822054$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $43f18c0047822054$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($43f18c0047822054$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $43f18c0047822054$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $43f18c0047822054$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($43f18c0047822054$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $43f18c0047822054$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $43f18c0047822054$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $43f18c0047822054$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $43f18c0047822054$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $43f18c0047822054$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $43f18c0047822054$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $43f18c0047822054$export$f5708dca728d7177(!$43f18c0047822054$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($43f18c0047822054$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $43f18c0047822054$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $43f18c0047822054$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $43f18c0047822054$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $43f18c0047822054$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $43f18c0047822054$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $43f18c0047822054$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($43f18c0047822054$var$isErrorResult(result)) {
            let boundaryMatch = $43f18c0047822054$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($43f18c0047822054$var$isRedirectResult(result)) $43f18c0047822054$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $43f18c0047822054$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $43f18c0047822054$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $43f18c0047822054$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $43f18c0047822054$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $43f18c0047822054$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $43f18c0047822054$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $43f18c0047822054$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $43f18c0047822054$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $43f18c0047822054$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $43f18c0047822054$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($43f18c0047822054$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $43f18c0047822054$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(path) : path;
    return $43f18c0047822054$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $43f18c0047822054$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $43f18c0047822054$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $43f18c0047822054$var$dataWithResponseInitToErrorResponse(data2) {
    return new $43f18c0047822054$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $43f18c0047822054$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $43f18c0047822054$var$isDataStrategyResult(value));
}
function $43f18c0047822054$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $43f18c0047822054$var$isRedirectDataStrategyResult(result) {
    return $43f18c0047822054$export$3f1eb41d9a6a6a27(result.result) && $43f18c0047822054$var$redirectStatusCodes.has(result.result.status);
}
function $43f18c0047822054$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $43f18c0047822054$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $43f18c0047822054$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $43f18c0047822054$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $43f18c0047822054$export$794b2760043cf8cd(statusCode) {
    return $43f18c0047822054$var$redirectStatusCodes.has(statusCode);
}
function $43f18c0047822054$export$6e80290866a84dd4(result) {
    return $43f18c0047822054$export$3f1eb41d9a6a6a27(result) && $43f18c0047822054$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $43f18c0047822054$var$isValidMethod(method) {
    return $43f18c0047822054$var$validRequestMethods.has(method.toUpperCase());
}
function $43f18c0047822054$export$cbae47800eb95bc3(method) {
    return $43f18c0047822054$var$validMutationMethods.has(method.toUpperCase());
}
function $43f18c0047822054$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $43f18c0047822054$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $43f18c0047822054$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $43f18c0047822054$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $43f18c0047822054$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $43f18c0047822054$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $43f18c0047822054$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $43f18c0047822054$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $43f18c0047822054$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $43f18c0047822054$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $43f18c0047822054$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($43f18c0047822054$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $43f18c0047822054$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($43f18c0047822054$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $43f18c0047822054$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $43f18c0047822054$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $43f18c0047822054$export$2eeee58951ff3c1c = $acw62.createContext(null);
$43f18c0047822054$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $43f18c0047822054$export$315e3ffb01f217 = $acw62.createContext(null);
$43f18c0047822054$export$315e3ffb01f217.displayName = "DataRouterState";
var $43f18c0047822054$export$717f757c655223f1 = $acw62.createContext(false);
function $43f18c0047822054$var$useIsRSCRouterContext() {
    return $acw62.useContext($43f18c0047822054$export$717f757c655223f1);
}
var $43f18c0047822054$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$43f18c0047822054$export$3681f408decb40d1.displayName = "ViewTransition";
var $43f18c0047822054$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$43f18c0047822054$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $43f18c0047822054$var$AwaitContext = $acw62.createContext(null);
$43f18c0047822054$var$AwaitContext.displayName = "Await";
var $43f18c0047822054$export$2666c20e15407622 = (props)=>$acw62.createElement($43f18c0047822054$var$AwaitContext.Provider, props);
var $43f18c0047822054$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$43f18c0047822054$export$3044ab7fdabeaee6.displayName = "Navigation";
var $43f18c0047822054$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$43f18c0047822054$export$e6a44b110a0c44d3.displayName = "Location";
var $43f18c0047822054$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$43f18c0047822054$export$aac280ed165a4397.displayName = "Route";
var $43f18c0047822054$var$RouteErrorContext = $acw62.createContext(null);
$43f18c0047822054$var$RouteErrorContext.displayName = "RouteError";
var $43f18c0047822054$export$945fecf35a8ef089 = true;
function $43f18c0047822054$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $43f18c0047822054$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $43f18c0047822054$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $43f18c0047822054$export$9c954a9d03d32f4a() {
    return $acw62.useContext($43f18c0047822054$export$e6a44b110a0c44d3) != null;
}
function $43f18c0047822054$export$45d76561a5302f2b() {
    $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($43f18c0047822054$export$e6a44b110a0c44d3).location;
}
function $43f18c0047822054$export$1b3f31771c5d07c() {
    return $acw62.useContext($43f18c0047822054$export$e6a44b110a0c44d3).navigationType;
}
function $43f18c0047822054$export$6c330e8992e8a295(pattern) {
    $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $43f18c0047822054$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$43f18c0047822054$export$81336c211d5ff295(pattern, $43f18c0047822054$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $43f18c0047822054$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $43f18c0047822054$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $43f18c0047822054$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    return isDataRoute ? $43f18c0047822054$var$useNavigateStable() : $43f18c0047822054$var$useNavigateUnstable();
}
function $43f18c0047822054$var$useNavigateUnstable() {
    $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($43f18c0047822054$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    let { pathname: locationPathname } = $43f18c0047822054$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($43f18c0047822054$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $43f18c0047822054$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $43f18c0047822054$var$warning(activeRef.current, $43f18c0047822054$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $43f18c0047822054$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $43f18c0047822054$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $43f18c0047822054$var$OutletContext = $acw62.createContext(null);
function $43f18c0047822054$export$4138103a3ae699cc() {
    return $acw62.useContext($43f18c0047822054$var$OutletContext);
}
function $43f18c0047822054$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $43f18c0047822054$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $43f18c0047822054$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    let { pathname: locationPathname } = $43f18c0047822054$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($43f18c0047822054$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$43f18c0047822054$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $43f18c0047822054$export$5d3fca4a98652595(routes, locationArg) {
    return $43f18c0047822054$var$useRoutesImpl(routes, locationArg);
}
function $43f18c0047822054$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($43f18c0047822054$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $43f18c0047822054$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $43f18c0047822054$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $43f18c0047822054$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $43f18c0047822054$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $43f18c0047822054$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($43f18c0047822054$export$945fecf35a8ef089) {
        $43f18c0047822054$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $43f18c0047822054$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $43f18c0047822054$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $43f18c0047822054$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $43f18c0047822054$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $43f18c0047822054$var$DefaultErrorComponent() {
    let error = $43f18c0047822054$export$ed527bf60f6e05f2();
    let message = $43f18c0047822054$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($43f18c0047822054$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $43f18c0047822054$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$DefaultErrorComponent, null);
var $43f18c0047822054$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $43f18c0047822054$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($43f18c0047822054$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $43f18c0047822054$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $43f18c0047822054$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && unstable_onError ? (error, errorInfo)=>{
        unstable_onError(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $43f18c0047822054$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $43f18c0047822054$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $43f18c0047822054$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $43f18c0047822054$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($43f18c0047822054$export$2eeee58951ff3c1c);
    $43f18c0047822054$export$f5708dca728d7177(ctx, $43f18c0047822054$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $43f18c0047822054$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($43f18c0047822054$export$315e3ffb01f217);
    $43f18c0047822054$export$f5708dca728d7177(state, $43f18c0047822054$var$getDataRouterConsoleError(hookName));
    return state;
}
function $43f18c0047822054$var$useRouteContext(hookName) {
    let route = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    $43f18c0047822054$export$f5708dca728d7177(route, $43f18c0047822054$var$getDataRouterConsoleError(hookName));
    return route;
}
function $43f18c0047822054$var$useCurrentRouteId(hookName) {
    let route = $43f18c0047822054$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $43f18c0047822054$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $43f18c0047822054$var$useRouteId() {
    return $43f18c0047822054$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $43f18c0047822054$export$d0fd4b7106de2769() {
    let state = $43f18c0047822054$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $43f18c0047822054$export$600dc272ed516c15() {
    let dataRouterContext = $43f18c0047822054$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $43f18c0047822054$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $43f18c0047822054$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $43f18c0047822054$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$43f18c0047822054$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $43f18c0047822054$export$1448a5050d252c4d() {
    let state = $43f18c0047822054$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $43f18c0047822054$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $43f18c0047822054$export$fd5d37484eab868d(routeId) {
    let state = $43f18c0047822054$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $43f18c0047822054$export$fdc00f3f26066d5e() {
    let state = $43f18c0047822054$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $43f18c0047822054$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $43f18c0047822054$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($43f18c0047822054$var$RouteErrorContext);
    let state = $43f18c0047822054$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $43f18c0047822054$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $43f18c0047822054$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($43f18c0047822054$var$AwaitContext);
    return value?._data;
}
function $43f18c0047822054$export$17f53340677d5831() {
    let value = $acw62.useContext($43f18c0047822054$var$AwaitContext);
    return value?._error;
}
var $43f18c0047822054$var$blockerId = 0;
function $43f18c0047822054$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $43f18c0047822054$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $43f18c0047822054$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $43f18c0047822054$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $43f18c0047822054$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$43f18c0047822054$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $43f18c0047822054$export$386d57f03f0b2883;
}
function $43f18c0047822054$var$useNavigateStable() {
    let { router: router } = $43f18c0047822054$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $43f18c0047822054$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $43f18c0047822054$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $43f18c0047822054$var$warning(activeRef.current, $43f18c0047822054$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $43f18c0047822054$var$alreadyWarned = {};
function $43f18c0047822054$var$warningOnce(key, cond, message) {
    if (!cond && !$43f18c0047822054$var$alreadyWarned[key]) {
        $43f18c0047822054$var$alreadyWarned[key] = true;
        $43f18c0047822054$var$warning(false, message);
    }
}
function $43f18c0047822054$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $43f18c0047822054$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $43f18c0047822054$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $43f18c0047822054$var$alreadyWarned2 = {};
function $43f18c0047822054$export$5b28268982f175ba(condition, message) {
    if (!condition && !$43f18c0047822054$var$alreadyWarned2[message]) {
        $43f18c0047822054$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $43f18c0047822054$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($43f18c0047822054$export$945fecf35a8ef089) {
            if (route.element) $43f18c0047822054$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($43f18c0047822054$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $43f18c0047822054$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($43f18c0047822054$export$945fecf35a8ef089) {
            if (route.errorElement) $43f18c0047822054$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $43f18c0047822054$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $43f18c0047822054$export$f30f7e456d254e83(routes, opts) {
    return $43f18c0047822054$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $43f18c0047822054$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $43f18c0047822054$export$e2fd2c03906469db,
        mapRouteProperties: $43f18c0047822054$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $43f18c0047822054$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $43f18c0047822054$var$shallowDiff(a, b) {
    if (a === b) return false;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return true;
    for (let key of aKeys){
        if (a[key] !== b[key]) return true;
    }
    return false;
}
function $43f18c0047822054$export$b23aa17f1e546c5e({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let [revalidating, startRevalidation] = $acw62.useTransition();
    let [state, setState] = $acw62.useState(router.state);
    router.__setPendingRerender = (promise)=>startRevalidation(// @ts-expect-error - need react 19 types for this to be async
        async ()=>{
            const rerender = await promise;
            startRevalidation(()=>{
                rerender();
            });
        });
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    $acw62.useLayoutEffect(()=>{
        return router.subscribe((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
            newState.fetchers.forEach((fetcher, key)=>{
                if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
            });
            deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
            const diff = $43f18c0047822054$var$shallowDiff(state, newState);
            if (!diff) return;
            if (flushSync) {
                if (reactDomFlushSyncImpl) reactDomFlushSyncImpl(()=>setState(newState));
                else setState(newState);
            } else $acw62.startTransition(()=>{
                setState(newState);
            });
        });
    }, [
        router,
        reactDomFlushSyncImpl,
        state
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$315e3ffb01f217.Provider, {
        value: {
            ...state,
            revalidation: revalidating ? "loading" : state.revalidation
        }
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    }))))), null);
}
function $43f18c0047822054$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let logErrorsAndSetState = $acw62.useCallback((newState)=>{
        setStateImpl((prevState)=>{
            if (newState.errors && unstable_onError) Object.entries(newState.errors).forEach(([routeId, error])=>{
                if (prevState.errors?.[routeId] !== error) unstable_onError(error, {
                    location: newState.location,
                    params: newState.matches[0]?.params ?? {}
                });
            });
            return newState;
        });
    }, [
        unstable_onError
    ]);
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $43f18c0047822054$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $43f18c0047822054$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            else $acw62.startTransition(()=>logErrorsAndSetState(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        logErrorsAndSetState
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $43f18c0047822054$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $acw62.startTransition(()=>logErrorsAndSetState(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        logErrorsAndSetState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
var $43f18c0047822054$var$MemoizedDataRoutes = $acw62.memo($43f18c0047822054$var$DataRoutes);
function $43f18c0047822054$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $43f18c0047822054$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $43f18c0047822054$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $43f18c0047822054$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $43f18c0047822054$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $43f18c0047822054$export$f5708dca728d7177($43f18c0047822054$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    $43f18c0047822054$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    let { pathname: locationPathname } = $43f18c0047822054$export$45d76561a5302f2b();
    let navigate = $43f18c0047822054$export$9770f232ac06a008();
    let path = $43f18c0047822054$var$resolveTo(to, $43f18c0047822054$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $43f18c0047822054$export$910ae8079b2c2852(props) {
    return $43f18c0047822054$export$a3be3530d8e40d0b(props.context);
}
function $43f18c0047822054$export$e7b0ac011bb776c6(props) {
    $43f18c0047822054$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $43f18c0047822054$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $43f18c0047822054$export$f5708dca728d7177(!$43f18c0047822054$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $43f18c0047822054$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $43f18c0047822054$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $43f18c0047822054$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $43f18c0047822054$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $43f18c0047822054$export$5d3fca4a98652595($43f18c0047822054$export$16da398f5434bdec(children), location);
}
function $43f18c0047822054$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($43f18c0047822054$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($43f18c0047822054$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches?.[0]?.params || {},
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$ResolveAwait, null, children));
}
var $43f18c0047822054$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $43f18c0047822054$var$ResolveAwait({ children: children }) {
    let data2 = $43f18c0047822054$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $43f18c0047822054$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $43f18c0047822054$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $43f18c0047822054$export$f5708dca728d7177(element.type === $43f18c0047822054$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $43f18c0047822054$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $43f18c0047822054$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $43f18c0047822054$export$9b5b6d122dea0c88 = $43f18c0047822054$export$16da398f5434bdec;
function $43f18c0047822054$export$daf73786167a7f72(matches) {
    return $43f18c0047822054$var$_renderMatches(matches);
}
function $43f18c0047822054$var$useRouteComponentProps() {
    return {
        params: $43f18c0047822054$export$99eaa27ddbbb95ef(),
        loaderData: $43f18c0047822054$export$1448a5050d252c4d(),
        actionData: $43f18c0047822054$export$fdc00f3f26066d5e(),
        matches: $43f18c0047822054$export$2378eb7f5ff86053()
    };
}
function $43f18c0047822054$export$6c4f3826290c37af({ children: children }) {
    const props = $43f18c0047822054$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $43f18c0047822054$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $43f18c0047822054$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $43f18c0047822054$var$useHydrateFallbackProps() {
    return {
        params: $43f18c0047822054$export$99eaa27ddbbb95ef(),
        loaderData: $43f18c0047822054$export$1448a5050d252c4d(),
        actionData: $43f18c0047822054$export$fdc00f3f26066d5e()
    };
}
function $43f18c0047822054$export$f8cff34f39c1932a({ children: children }) {
    const props = $43f18c0047822054$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $43f18c0047822054$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $43f18c0047822054$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $43f18c0047822054$var$useErrorBoundaryProps() {
    return {
        params: $43f18c0047822054$export$99eaa27ddbbb95ef(),
        loaderData: $43f18c0047822054$export$1448a5050d252c4d(),
        actionData: $43f18c0047822054$export$fdc00f3f26066d5e(),
        error: $43f18c0047822054$export$ed527bf60f6e05f2()
    };
}
function $43f18c0047822054$export$e5afde5c4b6d747b({ children: children }) {
    const props = $43f18c0047822054$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $43f18c0047822054$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $43f18c0047822054$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $43f18c0047822054$var$defaultMethod = "get";
var $43f18c0047822054$var$defaultEncType = "application/x-www-form-urlencoded";
function $43f18c0047822054$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $43f18c0047822054$var$isButtonElement(object) {
    return $43f18c0047822054$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $43f18c0047822054$var$isFormElement(object) {
    return $43f18c0047822054$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $43f18c0047822054$var$isInputElement(object) {
    return $43f18c0047822054$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $43f18c0047822054$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $43f18c0047822054$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$43f18c0047822054$var$isModifiedEvent(event);
}
function $43f18c0047822054$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $43f18c0047822054$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $43f18c0047822054$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $43f18c0047822054$var$_formDataSupportsSubmitter = null;
function $43f18c0047822054$var$isFormDataSubmitterSupported() {
    if ($43f18c0047822054$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $43f18c0047822054$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $43f18c0047822054$var$_formDataSupportsSubmitter = true;
    }
    return $43f18c0047822054$var$_formDataSupportsSubmitter;
}
var $43f18c0047822054$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $43f18c0047822054$var$getFormEncType(encType) {
    if (encType != null && !$43f18c0047822054$var$supportedFormEncTypes.has(encType)) {
        $43f18c0047822054$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$43f18c0047822054$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $43f18c0047822054$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($43f18c0047822054$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $43f18c0047822054$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $43f18c0047822054$var$defaultMethod;
        encType = $43f18c0047822054$var$getFormEncType(target.getAttribute("enctype")) || $43f18c0047822054$var$defaultEncType;
        formData = new FormData(target);
    } else if ($43f18c0047822054$var$isButtonElement(target) || $43f18c0047822054$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $43f18c0047822054$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $43f18c0047822054$var$defaultMethod;
        encType = $43f18c0047822054$var$getFormEncType(target.getAttribute("formenctype")) || $43f18c0047822054$var$getFormEncType(form.getAttribute("enctype")) || $43f18c0047822054$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$43f18c0047822054$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($43f18c0047822054$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $43f18c0047822054$var$defaultMethod;
        action = null;
        encType = $43f18c0047822054$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $43f18c0047822054$var$HOLE = -1;
var $43f18c0047822054$var$NAN = -2;
var $43f18c0047822054$var$NEGATIVE_INFINITY = -3;
var $43f18c0047822054$var$NEGATIVE_ZERO = -4;
var $43f18c0047822054$var$NULL = -5;
var $43f18c0047822054$var$POSITIVE_INFINITY = -6;
var $43f18c0047822054$var$UNDEFINED = -7;
var $43f18c0047822054$var$TYPE_BIGINT = "B";
var $43f18c0047822054$var$TYPE_DATE = "D";
var $43f18c0047822054$var$TYPE_ERROR = "E";
var $43f18c0047822054$var$TYPE_MAP = "M";
var $43f18c0047822054$var$TYPE_NULL_OBJECT = "N";
var $43f18c0047822054$var$TYPE_PROMISE = "P";
var $43f18c0047822054$var$TYPE_REGEXP = "R";
var $43f18c0047822054$var$TYPE_SET = "S";
var $43f18c0047822054$var$TYPE_SYMBOL = "Y";
var $43f18c0047822054$var$TYPE_URL = "U";
var $43f18c0047822054$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $43f18c0047822054$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $43f18c0047822054$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $43f18c0047822054$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $43f18c0047822054$var$UNDEFINED;
    if (input === null) return $43f18c0047822054$var$NULL;
    if (Number.isNaN(input)) return $43f18c0047822054$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $43f18c0047822054$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $43f18c0047822054$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $43f18c0047822054$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $43f18c0047822054$var$stringify.call(this, input, index);
    return index;
}
function $43f18c0047822054$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$43f18c0047822054$var$flatten.call(this, k)}":${$43f18c0047822054$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$43f18c0047822054$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$43f18c0047822054$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$43f18c0047822054$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$43f18c0047822054$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $43f18c0047822054$var$flatten.call(this, input2[i]) : $43f18c0047822054$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$43f18c0047822054$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$43f18c0047822054$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$43f18c0047822054$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$43f18c0047822054$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$43f18c0047822054$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$43f18c0047822054$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$43f18c0047822054$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $43f18c0047822054$var$flatten.call(this, k),
                                    $43f18c0047822054$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$43f18c0047822054$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$43f18c0047822054$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$43f18c0047822054$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$43f18c0047822054$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($43f18c0047822054$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$43f18c0047822054$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$43f18c0047822054$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $43f18c0047822054$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $43f18c0047822054$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $43f18c0047822054$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $43f18c0047822054$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $43f18c0047822054$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $43f18c0047822054$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $43f18c0047822054$var$hydrate.call(this, startIndex);
}
function $43f18c0047822054$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $43f18c0047822054$var$UNDEFINED:
                set(void 0);
                continue;
            case $43f18c0047822054$var$NULL:
                set(null);
                continue;
            case $43f18c0047822054$var$NAN:
                set(NaN);
                continue;
            case $43f18c0047822054$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $43f18c0047822054$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $43f18c0047822054$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $43f18c0047822054$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $43f18c0047822054$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $43f18c0047822054$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $43f18c0047822054$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $43f18c0047822054$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $43f18c0047822054$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $43f18c0047822054$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $43f18c0047822054$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $43f18c0047822054$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $43f18c0047822054$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $43f18c0047822054$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $43f18c0047822054$var$globalObj && $43f18c0047822054$var$globalObj[errorType] ? new $43f18c0047822054$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $43f18c0047822054$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $43f18c0047822054$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $43f18c0047822054$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $43f18c0047822054$var$Deferred2();
    const reader = readable.pipeThrough($43f18c0047822054$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $43f18c0047822054$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $43f18c0047822054$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $43f18c0047822054$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $43f18c0047822054$var$unflatten.call(this, line)
    };
}
async function $43f18c0047822054$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $43f18c0047822054$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $43f18c0047822054$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $43f18c0047822054$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $43f18c0047822054$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $43f18c0047822054$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $43f18c0047822054$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $43f18c0047822054$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$43f18c0047822054$var$TYPE_PROMISE}${deferredId}:[["${$43f18c0047822054$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$43f18c0047822054$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$43f18c0047822054$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $43f18c0047822054$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$43f18c0047822054$var$TYPE_ERROR}${deferredId}:[["${$43f18c0047822054$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$43f18c0047822054$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$43f18c0047822054$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $43f18c0047822054$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $43f18c0047822054$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $43f18c0047822054$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $43f18c0047822054$export$4cf11838cdc2a8a8(html) {
    return html.replace($43f18c0047822054$var$ESCAPE_REGEX, (match)=>$43f18c0047822054$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $43f18c0047822054$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $43f18c0047822054$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $43f18c0047822054$var$SingleFetchNoResultError = class extends Error {
};
var $43f18c0047822054$export$ae9272e641ead836 = 202;
var $43f18c0047822054$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $43f18c0047822054$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$43f18c0047822054$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $43f18c0047822054$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $43f18c0047822054$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $43f18c0047822054$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $43f18c0047822054$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $43f18c0047822054$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $43f18c0047822054$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $43f18c0047822054$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $43f18c0047822054$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $43f18c0047822054$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $43f18c0047822054$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $43f18c0047822054$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $43f18c0047822054$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($43f18c0047822054$export$3f1eb41d9a6a6a27(result.result) || $43f18c0047822054$export$972111febbeef05b(result.result) || $43f18c0047822054$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $43f18c0047822054$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $43f18c0047822054$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $43f18c0047822054$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $43f18c0047822054$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$43f18c0047822054$var$createDeferred2());
    let singleFetchDfd = $43f18c0047822054$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $43f18c0047822054$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $43f18c0047822054$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $43f18c0047822054$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $43f18c0047822054$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $43f18c0047822054$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $43f18c0047822054$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $43f18c0047822054$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $43f18c0047822054$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $43f18c0047822054$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $43f18c0047822054$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $43f18c0047822054$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $43f18c0047822054$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $43f18c0047822054$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $43f18c0047822054$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $43f18c0047822054$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $43f18c0047822054$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $43f18c0047822054$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($43f18c0047822054$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $43f18c0047822054$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $43f18c0047822054$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($43f18c0047822054$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$43f18c0047822054$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $43f18c0047822054$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $43f18c0047822054$export$4023ad4ecd4126a2(body, global) {
    return $43f18c0047822054$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $43f18c0047822054$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$43f18c0047822054$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $43f18c0047822054$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $43f18c0047822054$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $43f18c0047822054$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $43f18c0047822054$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $43f18c0047822054$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $43f18c0047822054$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $43f18c0047822054$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $43f18c0047822054$var$getModuleLinkHrefs(matches, manifest);
    return $43f18c0047822054$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $43f18c0047822054$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $43f18c0047822054$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $43f18c0047822054$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($43f18c0047822054$var$prefetchStyleLink));
}
async function $43f18c0047822054$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$43f18c0047822054$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$43f18c0047822054$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$43f18c0047822054$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($43f18c0047822054$var$prefetchStyleLink));
}
async function $43f18c0047822054$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $43f18c0047822054$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $43f18c0047822054$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $43f18c0047822054$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $43f18c0047822054$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $43f18c0047822054$var$dedupeLinkDescriptors(links.flat(1).filter($43f18c0047822054$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $43f18c0047822054$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $43f18c0047822054$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $43f18c0047822054$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $43f18c0047822054$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $43f18c0047822054$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $43f18c0047822054$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$43f18c0047822054$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($43f18c0047822054$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $43f18c0047822054$var$_isPreloadSupported;
function $43f18c0047822054$var$isPreloadSupported() {
    if ($43f18c0047822054$var$_isPreloadSupported !== void 0) return $43f18c0047822054$var$_isPreloadSupported;
    let el = document.createElement("link");
    $43f18c0047822054$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $43f18c0047822054$var$_isPreloadSupported;
}
function $43f18c0047822054$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $43f18c0047822054$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $43f18c0047822054$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $43f18c0047822054$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $43f18c0047822054$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $43f18c0047822054$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$RemixRootDefaultErrorBoundary, {
            error: $43f18c0047822054$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $43f18c0047822054$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $43f18c0047822054$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $43f18c0047822054$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$43f18c0047822054$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $43f18c0047822054$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $43f18c0047822054$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $43f18c0047822054$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $43f18c0047822054$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $43f18c0047822054$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $43f18c0047822054$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $43f18c0047822054$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $43f18c0047822054$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $43f18c0047822054$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $43f18c0047822054$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $43f18c0047822054$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $43f18c0047822054$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $43f18c0047822054$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$43f18c0047822054$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $43f18c0047822054$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $43f18c0047822054$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $43f18c0047822054$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $43f18c0047822054$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $43f18c0047822054$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $43f18c0047822054$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $43f18c0047822054$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $43f18c0047822054$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $43f18c0047822054$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $43f18c0047822054$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $43f18c0047822054$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $43f18c0047822054$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $43f18c0047822054$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $43f18c0047822054$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $43f18c0047822054$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $43f18c0047822054$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $43f18c0047822054$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $43f18c0047822054$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $43f18c0047822054$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $43f18c0047822054$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $43f18c0047822054$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $43f18c0047822054$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $43f18c0047822054$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $43f18c0047822054$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $43f18c0047822054$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $43f18c0047822054$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $43f18c0047822054$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $43f18c0047822054$var$nextPaths = /* @__PURE__ */ new Set();
var $43f18c0047822054$var$discoveredPathsMaxSize = 1e3;
var $43f18c0047822054$var$discoveredPaths = /* @__PURE__ */ new Set();
var $43f18c0047822054$var$URL_LIMIT = 7680;
function $43f18c0047822054$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $43f18c0047822054$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $43f18c0047822054$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $43f18c0047822054$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$43f18c0047822054$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($43f18c0047822054$var$discoveredPaths.has(path)) return;
        await $43f18c0047822054$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $43f18c0047822054$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$43f18c0047822054$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$43f18c0047822054$var$discoveredPaths.has(pathname)) $43f18c0047822054$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($43f18c0047822054$var$nextPaths.keys()).filter((path)=>{
                if ($43f18c0047822054$var$discoveredPaths.has(path)) {
                    $43f18c0047822054$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $43f18c0047822054$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $43f18c0047822054$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $43f18c0047822054$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $43f18c0047822054$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $43f18c0047822054$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($43f18c0047822054$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $43f18c0047822054$var$URL_LIMIT) {
        $43f18c0047822054$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($43f18c0047822054$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($43f18c0047822054$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($43f18c0047822054$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$43f18c0047822054$var$addToFifoQueue(p, $43f18c0047822054$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $43f18c0047822054$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $43f18c0047822054$var$addToFifoQueue(path, queue) {
    if (queue.size >= $43f18c0047822054$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $43f18c0047822054$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $43f18c0047822054$var$useDataRouterContext2() {
    let context = $acw62.useContext($43f18c0047822054$export$2eeee58951ff3c1c);
    $43f18c0047822054$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $43f18c0047822054$var$useDataRouterStateContext() {
    let context = $acw62.useContext($43f18c0047822054$export$315e3ffb01f217);
    $43f18c0047822054$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $43f18c0047822054$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$43f18c0047822054$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $43f18c0047822054$var$useFrameworkContext() {
    let context = $acw62.useContext($43f18c0047822054$export$208d6a3bc3aa62bd);
    $43f18c0047822054$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $43f18c0047822054$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($43f18c0047822054$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $43f18c0047822054$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $43f18c0047822054$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $43f18c0047822054$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $43f18c0047822054$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $43f18c0047822054$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $43f18c0047822054$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $43f18c0047822054$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$43f18c0047822054$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $43f18c0047822054$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $43f18c0047822054$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $43f18c0047822054$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $43f18c0047822054$var$useDataRouterStateContext();
    let matches = $43f18c0047822054$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$43f18c0047822054$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$43f18c0047822054$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$43f18c0047822054$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$43f18c0047822054$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $43f18c0047822054$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $43f18c0047822054$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$43f18c0047822054$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $43f18c0047822054$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $43f18c0047822054$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $43f18c0047822054$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $43f18c0047822054$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $43f18c0047822054$var$useFrameworkContext();
    let { basename: basename } = $43f18c0047822054$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $43f18c0047822054$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$43f18c0047822054$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$43f18c0047822054$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $43f18c0047822054$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$43f18c0047822054$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $43f18c0047822054$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $43f18c0047822054$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $43f18c0047822054$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $43f18c0047822054$var$useDataRouterStateContext();
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let _matches = $43f18c0047822054$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$43f18c0047822054$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $43f18c0047822054$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $43f18c0047822054$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $43f18c0047822054$var$isHydrated = false;
function $43f18c0047822054$export$3be068dde909e563() {
    $43f18c0047822054$var$isHydrated = true;
}
function $43f18c0047822054$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $43f18c0047822054$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $43f18c0047822054$var$useDataRouterContext2();
    let { matches: routerMatches } = $43f18c0047822054$var$useDataRouterStateContext();
    let isRSCRouterContext = $43f18c0047822054$var$useIsRSCRouterContext();
    let enableFogOfWar = $43f18c0047822054$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $43f18c0047822054$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $43f18c0047822054$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $43f18c0047822054$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($43f18c0047822054$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $43f18c0047822054$var$isHydrated || isRSCRouterContext ? [] : $43f18c0047822054$var$dedupe(manifest.entry.imports.concat($43f18c0047822054$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $43f18c0047822054$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $43f18c0047822054$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $43f18c0047822054$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $43f18c0047822054$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $43f18c0047822054$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $43f18c0047822054$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($43f18c0047822054$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $43f18c0047822054$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $43f18c0047822054$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $43f18c0047822054$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$ff0bf87698939488, null) : null)));
}
var $43f18c0047822054$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($43f18c0047822054$var$isBrowser) window.__reactRouterVersion = "7.9.6";
} catch (e) {}
function $43f18c0047822054$export$1f3f55432a00e06d(routes, opts) {
    return $43f18c0047822054$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $43f18c0047822054$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $43f18c0047822054$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $43f18c0047822054$export$9269a41d8c4635e,
        hydrationRouteProperties: $43f18c0047822054$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $43f18c0047822054$export$1ba7ed8a3a7b3765(routes, opts) {
    return $43f18c0047822054$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $43f18c0047822054$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $43f18c0047822054$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $43f18c0047822054$export$9269a41d8c4635e,
        hydrationRouteProperties: $43f18c0047822054$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $43f18c0047822054$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $43f18c0047822054$var$deserializeErrors(state.errors)
    };
    return state;
}
function $43f18c0047822054$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $43f18c0047822054$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $43f18c0047822054$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $43f18c0047822054$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $43f18c0047822054$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $43f18c0047822054$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $43f18c0047822054$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$43f18c0047822054$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $43f18c0047822054$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $43f18c0047822054$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $43f18c0047822054$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($43f18c0047822054$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $43f18c0047822054$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $43f18c0047822054$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $43f18c0047822054$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $43f18c0047822054$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $43f18c0047822054$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $43f18c0047822054$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$43f18c0047822054$export$a6c7ac8248d6e38a.displayName = "Link";
var $43f18c0047822054$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $43f18c0047822054$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($43f18c0047822054$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $43f18c0047822054$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $43f18c0047822054$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$43f18c0047822054$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $43f18c0047822054$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $43f18c0047822054$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $43f18c0047822054$export$47c85c6e3a081d3();
    let formAction = $43f18c0047822054$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $43f18c0047822054$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$43f18c0047822054$export$a7fed597f4b8afd8.displayName = "Form";
function $43f18c0047822054$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($43f18c0047822054$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let matches = $43f18c0047822054$export$2378eb7f5ff86053();
    $43f18c0047822054$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $43f18c0047822054$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $43f18c0047822054$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$43f18c0047822054$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $43f18c0047822054$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $43f18c0047822054$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($43f18c0047822054$export$2eeee58951ff3c1c);
    $43f18c0047822054$export$f5708dca728d7177(ctx, $43f18c0047822054$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $43f18c0047822054$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($43f18c0047822054$export$315e3ffb01f217);
    $43f18c0047822054$export$f5708dca728d7177(state, $43f18c0047822054$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $43f18c0047822054$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $43f18c0047822054$export$9770f232ac06a008();
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let path = $43f18c0047822054$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($43f18c0047822054$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $43f18c0047822054$export$fe53371bee54353d(location) === $43f18c0047822054$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $43f18c0047822054$export$f1a78c17382fe22a(defaultInit) {
    $43f18c0047822054$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($43f18c0047822054$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $43f18c0047822054$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $43f18c0047822054$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $43f18c0047822054$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $43f18c0047822054$var$fetcherId = 0;
var $43f18c0047822054$var$getUniqueFetcherId = ()=>`__${String(++$43f18c0047822054$var$fetcherId)}__`;
function $43f18c0047822054$export$47c85c6e3a081d3() {
    let { router: router } = $43f18c0047822054$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let currentRouteId = $43f18c0047822054$var$useRouteId();
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $43f18c0047822054$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $43f18c0047822054$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $43f18c0047822054$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    $43f18c0047822054$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$43f18c0047822054$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $43f18c0047822054$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $43f18c0047822054$export$fe53371bee54353d(path);
}
function $43f18c0047822054$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $43f18c0047822054$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $43f18c0047822054$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($43f18c0047822054$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($43f18c0047822054$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $43f18c0047822054$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $43f18c0047822054$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $43f18c0047822054$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $43f18c0047822054$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $43f18c0047822054$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let unstable_reset = $acw62.useCallback((opts)=>router.resetFetcher(fetcherKey, opts), [
        router,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $43f18c0047822054$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            unstable_reset: unstable_reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        unstable_reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $43f18c0047822054$export$fa996778a3a31087() {
    let state = $43f18c0047822054$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $43f18c0047822054$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $43f18c0047822054$var$savedScrollPositions = {};
function $43f18c0047822054$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $43f18c0047822054$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $43f18c0047822054$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $43f18c0047822054$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $43f18c0047822054$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($43f18c0047822054$export$3044ab7fdabeaee6);
    let location = $43f18c0047822054$export$45d76561a5302f2b();
    let matches = $43f18c0047822054$export$2378eb7f5ff86053();
    let navigation = $43f18c0047822054$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $43f18c0047822054$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $43f18c0047822054$var$getScrollRestorationKey(location, matches, basename, getKey);
            $43f18c0047822054$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $43f18c0047822054$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($43f18c0047822054$var$savedScrollPositions));
        } catch (error) {
            $43f18c0047822054$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $43f18c0047822054$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $43f18c0047822054$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($43f18c0047822054$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$43f18c0047822054$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $43f18c0047822054$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $43f18c0047822054$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $43f18c0047822054$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $43f18c0047822054$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $43f18c0047822054$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $43f18c0047822054$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($43f18c0047822054$export$3681f408decb40d1);
    $43f18c0047822054$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $43f18c0047822054$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $43f18c0047822054$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $43f18c0047822054$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $43f18c0047822054$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $43f18c0047822054$export$81336c211d5ff295(path.pathname, nextPath) != null || $43f18c0047822054$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $43f18c0047822054$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $43f18c0047822054$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $43f18c0047822054$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $43f18c0047822054$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $43f18c0047822054$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $43f18c0047822054$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $43f18c0047822054$var$serializeErrors(context.errors)
        };
        let json = $43f18c0047822054$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $acw62.createElement($43f18c0047822054$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $43f18c0047822054$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $43f18c0047822054$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $43f18c0047822054$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($43f18c0047822054$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $43f18c0047822054$var$getStatelessNavigator() {
    return {
        createHref: $43f18c0047822054$var$createHref,
        encodeLocation: $43f18c0047822054$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $43f18c0047822054$export$69163f0b72ec60d9(routes, opts) {
    return $43f18c0047822054$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $43f18c0047822054$export$9269a41d8c4635e
    });
}
function $43f18c0047822054$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $43f18c0047822054$export$87cb1a9238dc3fba(routes, $43f18c0047822054$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $43f18c0047822054$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $43f18c0047822054$var$createHref,
        encodeLocation: $43f18c0047822054$var$encodeLocation,
        getFetcher () {
            return $43f18c0047822054$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $43f18c0047822054$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $43f18c0047822054$var$createHref(to) {
    return typeof to === "string" ? to : $43f18c0047822054$export$fe53371bee54353d(to);
}
function $43f18c0047822054$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $43f18c0047822054$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $43f18c0047822054$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $43f18c0047822054$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $43f18c0047822054$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $43f18c0047822054$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $43f18c0047822054$var$htmlEscape(str) {
    return str.replace($43f18c0047822054$var$ESCAPE_REGEX2, (match)=>$43f18c0047822054$var$ESCAPE_LOOKUP2[match]);
}




const $f8409e0880c5cb17$export$66b32f6f30eb4b4 = {
    home: {
        path: '/'
    },
    oleshky: {
        path: '/oleshky'
    },
    reel: {
        path: '/reel'
    },
    leftBank: {
        path: '/left-bank'
    },
    action: {
        path: '/action'
    },
    witnesses: {
        path: '/witnesses'
    },
    rallies: {
        path: '/rallies'
    },
    help: {
        path: '/help'
    },
    resources: {
        path: '/resources'
    }
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $673ff3dfc4a496de$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $673ff3dfc4a496de$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$673ff3dfc4a496de$var$PATH_KEY]: path } = selector($673ff3dfc4a496de$var$createProxy());
    return path.join(opts?.keySeparator ?? '.');
}
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
const $673ff3dfc4a496de$var$shouldHandleAsObject = (res)=>!$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
        const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $673ff3dfc4a496de$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$673ff3dfc4a496de$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($673ff3dfc4a496de$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$673ff3dfc4a496de$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $673ff3dfc4a496de$var$regexSafe(this.escape(val)) : $673ff3dfc4a496de$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($673ff3dfc4a496de$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $673ff3dfc4a496de$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($673ff3dfc4a496de$var$getCleanedCode(l), o)(v);
class $673ff3dfc4a496de$var$Formatter {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $673ff3dfc4a496de$var$createCachedFormatter : $673ff3dfc4a496de$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $673ff3dfc4a496de$var$noop) {
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $673ff3dfc4a496de$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($673ff3dfc4a496de$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $673ff3dfc4a496de$var$I18n(options, callback);
        instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $673ff3dfc4a496de$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg) && $cfb6e0167e0b350d$var$alreadyWarned[msg]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg)) $cfb6e0167e0b350d$var$alreadyWarned[msg] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;


const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $acffcb171536f8e9$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $acffcb171536f8e9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $acffcb171536f8e9$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${escapedString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $acw62.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.props.ref ?? c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
const $acffcb171536f8e9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $acw62.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
    }
    return (0, $acw62.createElement)(Componentized, {
        key: componentKey
    });
};
const $acffcb171536f8e9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$acffcb171536f8e9$var$fixComponentProps(c, index, translation));
const $acffcb171536f8e9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $acffcb171536f8e9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $acffcb171536f8e9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $acffcb171536f8e9$var$generateArrayComponents(components, translation);
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(components)) return $acffcb171536f8e9$var$generateObjectComponents(components, translation);
    (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $acffcb171536f8e9$var$isComponentsMap = (object)=>{
    if (!(0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || tOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $673ff3dfc4a496de$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $acffcb171536f8e9$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($acffcb171536f8e9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $acffcb171536f8e9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


class $e0c19337b294ccec$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e0c19337b294ccec$export$aa9e222d9ffc5d1b);
    }
}


const $1ddf6027fecc0115$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $1ddf6027fecc0115$var$entityPattern = new RegExp(Object.keys($1ddf6027fecc0115$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $1ddf6027fecc0115$export$5cfeaa4af6841c8f = (text)=>text.replace($1ddf6027fecc0115$var$entityPattern, (match)=>$1ddf6027fecc0115$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $5f107391742a83a7$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $acw62 = parcelRequire("acw62");



const $54962d9d09845ed9$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, ...children);
};
const $54962d9d09845ed9$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5f107391742a83a7$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $1ddf6027fecc0115$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $54962d9d09845ed9$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $e917e4d32765654d$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $54962d9d09845ed9$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, translation);
    }
}
$e917e4d32765654d$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $60cfc2270f17f8cc$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $e917e4d32765654d$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$60cfc2270f17f8cc$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));




const $3765cebd031b52c0$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    return Array.isArray(k) ? k[k.length - 1] : k;
};
const $3765cebd031b52c0$var$notReadySnapshot = {
    t: $3765cebd031b52c0$var$notReadyT,
    ready: false
};
const $3765cebd031b52c0$var$dummySubscribe = ()=>()=>{};
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $acw62.useMemo)(()=>({
            ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const namespaces = (0, $acw62.useMemo)(()=>{
        const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
        return (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(nsOrContext) ? [
            nsOrContext
        ] : nsOrContext || [
            'translation'
        ];
    }, [
        ns,
        defaultNSFromContext,
        i18n
    ]);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $acw62.useRef)(0);
    const subscribe = (0, $acw62.useCallback)((callback)=>{
        if (!i18n) return $3765cebd031b52c0$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $acw62.useRef)();
    const getSnapshot = (0, $acw62.useCallback)(()=>{
        if (!i18n) return $3765cebd031b52c0$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $acw62.useState)(0);
    const { t: t, ready: ready } = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $acw62.useRef)(null);
    const wrapperLangRef = (0, $acw62.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $acw62.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const arr = [
            t,
            i18nWrapper,
            ready
        ];
        arr.t = t;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
    });
    return ret;
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';



const $eddcd00bbabb9acd$export$2092376fd002e13 = [
    {
        code: 'en',
        label: 'English',
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        code: 'uk',
        label: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        flag: "\uD83C\uDDFA\uD83C\uDDE6"
    },
    {
        code: 'de',
        label: 'Deutsch',
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    {
        code: 'fr',
        label: "Fran\xe7ais",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        code: 'es',
        label: "Espa\xf1ol",
        flag: "\uD83C\uDDEA\uD83C\uDDF8"
    },
    {
        code: 'da',
        label: 'Dansk',
        flag: "\uD83C\uDDE9\uD83C\uDDF0"
    },
    {
        code: 'pl',
        label: 'Polski',
        flag: "\uD83C\uDDF5\uD83C\uDDF1"
    },
    {
        code: 'it',
        label: 'Italiano',
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    }
];
// Feature-flagged languages: only shown when the matching localStorage item is
// set to 'true' (e.g. localStorage.setItem('enableChinese', 'true'), then reload).
const $eddcd00bbabb9acd$var$FLAGGED_LANGUAGES = [
    {
        code: 'zh',
        label: "\u4E2D\u6587",
        flag: "\uD83C\uDDE8\uD83C\uDDF3",
        flagKey: 'enableChinese'
    }
];
function $eddcd00bbabb9acd$var$getAvailableLanguages() {
    const enabled = $eddcd00bbabb9acd$var$FLAGGED_LANGUAGES.filter((lang)=>{
        try {
            return localStorage.getItem(lang.flagKey) === 'true';
        } catch  {
            return false;
        }
    }).map((lang)=>({
            code: lang.code,
            label: lang.label,
            flag: lang.flag
        }));
    return [
        ...$eddcd00bbabb9acd$export$2092376fd002e13,
        ...enabled
    ];
}
function $eddcd00bbabb9acd$export$2e2bcd8739ae039() {
    const { i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const location = (0, $43f18c0047822054$export$45d76561a5302f2b)();
    const navigate = (0, $43f18c0047822054$export$9770f232ac06a008)();
    const [searchParams] = (0, $43f18c0047822054$export$f1a78c17382fe22a)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [languages] = (0, $acw62.useState)($eddcd00bbabb9acd$var$getAvailableLanguages);
    const urlLang = searchParams.get('lang');
    const isWitnessesPage = location.pathname.startsWith('/witnesses');
    (0, $acw62.useEffect)(()=>{
        if (!urlLang) return;
        const isAllowed = languages.some((l)=>l.code === urlLang);
        if (isAllowed) i18n.changeLanguage(urlLang);
        else {
            const fallback = languages[0].code;
            i18n.changeLanguage(fallback);
        }
    }, [
        location.pathname
    ]);
    // close on any click outside (e.g. on the mobile nav menu)
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const close = (e)=>{
            if (!ref.current?.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', close);
        return ()=>document.removeEventListener('mousedown', close);
    }, [
        open
    ]);
    function changeLang(langCode) {
        i18n.changeLanguage(langCode);
        const params = new URLSearchParams(searchParams);
        params.set('lang', langCode);
        navigate(`${location.pathname}?${params.toString()}`, {
            replace: true
        });
        setOpen(false);
    }
    const currentLang = languages.find((l)=>l.code === i18n.language) || languages[0];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        className: "relative inline-block text-left",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: isWitnessesPage,
                onClick: ()=>setOpen(!open),
                className: "flex items-center gap-2 border px-2 py-1 rounded-lg shadow-sm hover:bg-gray-100 my-1 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: currentLang.flag
                })
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute right-0 mt-2 bg-white shadow-xl p-2 z-50",
                children: languages.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>changeLang(lang.code),
                        className: "w-full flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: lang.flag
                        })
                    }, lang.code))
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");




const $7b76ad298314b8cd$var$SITE = 'https://humansafari.org';
// pages kept out of search results
const $7b76ad298314b8cd$var$NOINDEX = [
    (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).reel.path
];
// Open Graph locale per language
const $7b76ad298314b8cd$var$OG_LOCALES = {
    en: 'en_US',
    uk: 'uk_UA',
    de: 'de_DE',
    fr: 'fr_FR',
    es: 'es_ES',
    da: 'da_DK',
    pl: 'pl_PL',
    it: 'it_IT',
    zh: 'zh_CN'
};
// address of a page in a language: English has no ?lang, the others are reached with ?lang=xx
const $7b76ad298314b8cd$var$pageUrl = (path, lang)=>lang === 'en' ? `${$7b76ad298314b8cd$var$SITE}${path}` : `${$7b76ad298314b8cd$var$SITE}${path}?lang=${lang}`;
// finds the head tag matching `selector`, creating it if it's missing, and sets an attribute on it
function $7b76ad298314b8cd$var$setHeadTag(tag, selector, attrs) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement(tag);
        document.head.appendChild(el);
    }
    Object.entries(attrs).forEach(([key, value])=>el.setAttribute(key, value));
}
function $7b76ad298314b8cd$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { pathname: pathname } = (0, $43f18c0047822054$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        const page = Object.entries((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4)).find(([, route])=>route.path === pathname)?.[0];
        if (!page || !i18n.exists(`seo.${page}.title`)) return;
        const lang = i18n.language;
        const isPublic = (0, $eddcd00bbabb9acd$export$2092376fd002e13).some((l)=>l.code === lang);
        const title = t(`seo.${page}.title`);
        const description = t(`seo.${page}.description`);
        const url = $7b76ad298314b8cd$var$pageUrl(pathname, isPublic ? lang : 'en');
        document.title = title;
        document.documentElement.lang = lang;
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[name="description"]', {
            name: 'description',
            content: description
        });
        $7b76ad298314b8cd$var$setHeadTag('link', 'link[rel="canonical"]', {
            rel: 'canonical',
            href: url
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[name="robots"]', {
            name: 'robots',
            content: $7b76ad298314b8cd$var$NOINDEX.includes(pathname) ? 'noindex' : 'index, follow'
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[property="og:title"]', {
            property: 'og:title',
            content: title
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[property="og:description"]', {
            property: 'og:description',
            content: description
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[property="og:url"]', {
            property: 'og:url',
            content: url
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[property="og:locale"]', {
            property: 'og:locale',
            content: $7b76ad298314b8cd$var$OG_LOCALES[lang] ?? 'en_US'
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[name="twitter:title"]', {
            name: 'twitter:title',
            content: title
        });
        $7b76ad298314b8cd$var$setHeadTag('meta', 'meta[name="twitter:description"]', {
            name: 'twitter:description',
            content: description
        });
        // the same page in every public language, plus x-default for everyone else
        document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el)=>el.remove());
        const alternates = [
            ...(0, $eddcd00bbabb9acd$export$2092376fd002e13).map((l)=>[
                    l.code,
                    $7b76ad298314b8cd$var$pageUrl(pathname, l.code)
                ]),
            [
                'x-default',
                $7b76ad298314b8cd$var$pageUrl(pathname, 'en')
            ]
        ];
        alternates.forEach(([hreflang, href])=>{
            const link = document.createElement('link');
            link.rel = 'alternate';
            link.hreflang = hreflang;
            link.href = href;
            document.head.appendChild(link);
        });
    }, [
        pathname,
        i18n,
        i18n.language,
        t
    ]);
    return null;
}




var $acw62 = parcelRequire("acw62");
// Feature flag: the Oleshky rally tab and the mobile hamburger menu show by default.
// Set localStorage.enableOleshkyNav = 'false' to see the old navbar without them.
function $161422b2c27d7a41$var$isOleshkyNavEnabled() {
    try {
        return localStorage.getItem('enableOleshkyNav') !== 'false';
    } catch  {
        return true;
    }
}
function $161422b2c27d7a41$export$c84671f46d6a1ca() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const location = (0, $43f18c0047822054$export$45d76561a5302f2b)();
    const search = location.search || '';
    const [showOleshky] = (0, $acw62.useState)($161422b2c27d7a41$var$isOleshkyNavEnabled);
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    const menuRef = (0, $acw62.useRef)(null);
    // close the mobile menu on any click outside it (e.g. on the language selector)
    (0, $acw62.useEffect)(()=>{
        if (!menuOpen) return;
        const close = (e)=>{
            if (!menuRef.current?.contains(e.target)) setMenuOpen(false);
        };
        document.addEventListener('mousedown', close);
        return ()=>document.removeEventListener('mousedown', close);
    }, [
        menuOpen
    ]);
    if (location.pathname.startsWith('/do-more')) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$444b3ab0cb9aec40), {
        to: `${(0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).witnesses.path}${search}`,
        replace: true
    });
    const tabClass = (path)=>{
        const isActive = location.pathname.startsWith(path);
        return `py-2 md:px-10 lowercase border border-white hover:bg-blue-50 text-center${isActive ? ' text-blue-700' : ''}`;
    };
    const tabs = [
        ...showOleshky ? [
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).oleshky.path,
                label: 'navbar.oleshky'
            }
        ] : [],
        {
            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).help.path,
            label: 'navbar.help'
        },
        {
            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).leftBank.path,
            label: 'navbar.leftBank'
        },
        {
            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).action.path,
            label: 'navbar.action'
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen w-full text-gray-900 flex flex-col text-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b76ad298314b8cd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: "w-full flex justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative w-full lg:max-w-5xl flex items-center px-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: `flex gap-4 ${showOleshky ? 'flex-1 min-w-0' : 'w-full'} justify-evenly font-bold align-middle text-center items-center`,
                            children: [
                                tabs.map((tab, i)=>// on tablet and smaller, only the first tab stays; the rest move into the menu
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: `${tab.path}${search}`,
                                        className: `${tabClass(tab.path)}${showOleshky && i > 0 ? ' hidden lg:block' : ''}`,
                                        children: t(tab.label)
                                    }, tab.path)),
                                showOleshky && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    ref: menuRef,
                                    className: "relative lg:hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            onClick: ()=>setMenuOpen(!menuOpen),
                                            "aria-label": t('navbar.menu'),
                                            "aria-expanded": menuOpen,
                                            className: "flex flex-col justify-center gap-1.5 px-2 py-2 hover:bg-blue-50 cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "block w-6 h-0.5 bg-gray-900"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "block w-6 h-0.5 bg-gray-900"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "block w-6 h-0.5 bg-gray-900"
                                                })
                                            ]
                                        }),
                                        menuOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute left-1/2 -translate-x-1/2 mt-2 bg-white shadow-xl p-2 z-50 flex flex-col min-w-48",
                                            children: tabs.map((tab)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: `${tab.path}${search}`,
                                                    className: `${tabClass(tab.path)} px-4 whitespace-nowrap`,
                                                    children: t(tab.label)
                                                }, tab.path))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: showOleshky ? 'shrink-0 flex items-center lg:absolute lg:inset-y-0 lg:right-4' : 'absolute inset-y-0 right-4 flex items-center',
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eddcd00bbabb9acd$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
                className: "mt-auto w-full text-center text-md pt-16 pb-32 px-6 bg-gray-200 space-y-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-xl",
                    children: [
                        t('footer.contact'),
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "text-blue-700 underline",
                            href: `mailto:${t('help.actionEmail')}`,
                            children: t('help.actionEmail')
                        })
                    ]
                })
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");


var $a5362d704e65c175$exports = {};
$a5362d704e65c175$exports = import.meta.resolve("iKZXJ");




var $acw62 = parcelRequire("acw62");
function $08f6df7db6f8e162$export$448332262467e042(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
    return array;
}
function $08f6df7db6f8e162$export$aeac9af295f08eee(items, key, after) {
    const groups = new Map();
    for (const item of $08f6df7db6f8e162$export$448332262467e042([
        ...items
    ])){
        const k = key(item);
        groups.set(k, [
            ...groups.get(k) ?? [],
            item
        ]);
    }
    const result = [];
    let last = after;
    while(result.length < items.length){
        const remaining = items.length - result.length;
        const options = [
            ...groups.entries()
        ].filter(([, g])=>g.length > 0);
        const pool = options.filter(([k])=>k !== last);
        const candidates = pool.length ? pool : options;
        const forced = candidates.find(([, g])=>g.length * 2 > remaining);
        let pick = forced;
        if (!pick) {
            let r = Math.random() * candidates.reduce((sum, [, g])=>sum + g.length, 0);
            pick = candidates.find(([, g])=>(r -= g.length) < 0) ?? candidates[candidates.length - 1];
        }
        const [k, g] = pick;
        result.push(g.pop());
        last = k;
    }
    return result;
}
function $08f6df7db6f8e162$export$978e30a0fb8610d8() {
    const w = window.innerWidth;
    if (w >= 1024) return 4 // lg
    ;
    if (w >= 768) return 3 // md
    ;
    if (w >= 640) return 2 // sm
    ;
    return 1;
}




var $acw62 = parcelRequire("acw62");

var $7af4302066907ae3$exports = {};
$7af4302066907ae3$exports = import.meta.resolve("9e2wP");


var $6cea37889f767640$exports = {};
$6cea37889f767640$exports = import.meta.resolve("4BuGm");


// small icon for known social links; anything else shows 🔗
const $919ac793d7ddcaf0$var$linkIcons = [
    {
        host: 'facebook.com',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
        labelKey: 'help.facebook'
    },
    {
        host: 'instagram.com',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
        labelKey: 'help.instagram'
    }
];
function $919ac793d7ddcaf0$export$2e2bcd8739ae039({ src: src, city: city, label: label, author: author, link: link, height: height, rally: rally, downloadable: downloadable }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ref = (0, $acw62.useRef)(null);
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const ns = rally?.citiesI18n ?? 'cities';
    const monthShortKey = rally?.days.find((d)=>d.cities.includes(city))?.monthShortKey ?? 'home.dec';
    const day = t(`${ns}.${city}.day`);
    const linkIcon = link ? $919ac793d7ddcaf0$var$linkIcons.find(({ host: host })=>link.includes(host)) : undefined;
    (0, $acw62.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: '100px'
        });
        if (ref.current) observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        className: `
        relative
        w-full
        overflow-hidden
        rounded-sm
        group
        ${height ?? 'aspect-3/4'}
      `,
        children: [
            isVisible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: src,
                alt: label ? t(label) : city !== 'none' ? `${t(`${ns}.${city}.city`)} \u{2013} ${t(`${ns}.${city}.location`)}` : author ?? '',
                className: " w-full h-full object-contain transition-opacity duration-300 "
            }),
            downloadable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: src,
                // save as the original file name, without the build hash (e.g. "London.0dff0907.jpg" -> "London.jpg")
                download: decodeURIComponent(src.split('/').pop() ?? '').replace(/\.[0-9a-f]{8}(\.\w+)$/, '$1'),
                "aria-label": t('rallies.downloadPoster'),
                title: t('rallies.downloadPoster'),
                className: "absolute top-2 right-2 z-10 rounded-full bg-white/90 p-2 text-gray-900 shadow-md hover:bg-white cursor-pointer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    className: "h-5 w-5",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M12 3v12"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "m7 10 5 5 5-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M5 21h14"
                        })
                    ]
                })
            }),
            (label || author || city !== 'none') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: " absolute inset-0 bg-black/0  group-hover:bg-black/60 transition-colors duration-300 flex flex-col items-center justify-center p-2 ",
                children: [
                    ...label ? [
                        t(label)
                    ] : city !== 'none' ? [
                        t(`${ns}.${city}.city`),
                        [
                            `${t(`home.${day}`)} ${t(monthShortKey)}`,
                            t(`${ns}.${city}.cleanTime`)
                        ].filter(Boolean).join(': '),
                        t(`${ns}.${city}.location`)
                    ] : [],
                    ...author ? [
                        t('rallies.artBy', {
                            name: author
                        })
                    ] : []
                ].map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: " text-white text-lg font-semibold opacity-0  group-hover:opacity-100 transition-opacity duration-300 ",
                        children: [
                            line,
                            link && i === 0 && // only clickable while the overlay is showing
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "aria-label": linkIcon ? t(linkIcon.labelKey) : link,
                                className: "inline-block align-middle ml-2 pointer-events-none group-hover:pointer-events-auto hover:opacity-70",
                                children: linkIcon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: linkIcon.icon,
                                    alt: t(linkIcon.labelKey),
                                    className: "h-4 w-4"
                                }) : "\uD83D\uDD17"
                            })
                        ]
                    }, line))
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
const $eaf484d6590b790e$var$Slideshow = ({ images: images, interval: interval = 600, startDelay: startDelay = 5000, startIndex: startIndex = 0 })=>{
    const [currentIndex, setCurrentIndex] = (0, $acw62.useState)(()=>Math.min(startIndex, images.length - 1));
    (0, $acw62.useEffect)(()=>{
        if (images.length <= 1) return;
        let intervalId = null;
        const timeoutId = window.setTimeout(()=>{
            intervalId = window.setInterval(()=>{
                setCurrentIndex((prev)=>(prev + 1) % images.length);
            }, interval);
        }, startDelay);
        return ()=>{
            clearTimeout(timeoutId);
            if (intervalId !== null) clearInterval(intervalId);
        };
    }, [
        images.length,
        interval,
        startDelay
    ]);
    return(// <div className='my-30'>
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "relative w-full overflow-hidden rounded-sm aspect-2/2 px-3",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: images[currentIndex],
            alt: `Slide ${currentIndex + 1}`,
            className: "w-full h-full object-contain transition-opacity duration-500"
        })
    }));
};
var $eaf484d6590b790e$export$2e2bcd8739ae039 = $eaf484d6590b790e$var$Slideshow;


function $d4dd29408e01e545$export$2e2bcd8739ae039(props) {
    const { images: images, collapseToFirstRow: collapseToFirstRow = false } = props;
    const [expanded, setExpanded] = (0, $acw62.useState)(!collapseToFirstRow);
    const [columns, setColumns] = (0, $acw62.useState)(1);
    (0, $acw62.useEffect)(()=>{
        const update = ()=>setColumns((0, $08f6df7db6f8e162$export$978e30a0fb8610d8)());
        update();
        window.addEventListener('resize', update);
        return ()=>window.removeEventListener('resize', update);
    }, []);
    const visibleImages = expanded ? images : images.slice(0, columns);
    function handleToggle() {
        if (expanded) {
            const el = document.getElementById('rally-schedule');
            if (el) el.scrollIntoView();
        }
        setExpanded((v)=>!v);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        id: `${props.id}-gallery`,
        className: props.bare ? 'w-full' : 'flex flex-col gap-10 px-6 md:px-20 py-25 bg-gray-50 text-center text-xl md:text-2xl leading-relaxed opacity-90 items-center',
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: props.bare ? 'w-full relative' : 'w-full px-4 py-12 relative',
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: " grid gap-4 grid-cols-1  sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 ",
                    children: visibleImages.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: visibleImages.map((img, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $919ac793d7ddcaf0$export$2e2bcd8739ae039), {
                                src: img.src,
                                city: img.city,
                                label: img.label,
                                author: img.author,
                                link: img.link,
                                height: props.height,
                                rally: props.rally,
                                downloadable: props.downloadable
                            }, `${img.city}-${i}`))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaf484d6590b790e$export$2e2bcd8739ae039), {
                        images: props.images.map((img)=>img.src),
                        interval: 1500
                    })
                }),
                collapseToFirstRow && images.length > columns && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `${expanded ? 'sticky' : ''} bottom-4 mt-8 flex justify-center`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: handleToggle,
                        className: " rounded-full bg-blue-800 text-white px-6 py-3 text-sm md:text-base shadow-lg hover:bg-blue-700 cursor-pointer transition ",
                        children: expanded ? 'See less' : 'See more'
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $b3526dbaa5fbb8d2$exports = {};
$b3526dbaa5fbb8d2$exports = import.meta.resolve("9EYdg");


var $93664ad0439e5b99$exports = {};
$93664ad0439e5b99$exports = import.meta.resolve("fXc0V");


var $5fb9610575ae15cb$exports = {};
$5fb9610575ae15cb$exports = import.meta.resolve("dIpwd");


var $298764a04bae36d6$exports = {};
$298764a04bae36d6$exports = import.meta.resolve("3dyeW");


var $d6650192ff1579c0$exports = {};
$d6650192ff1579c0$exports = import.meta.resolve("kdFrN");


var $8c6b7c2923cf4907$exports = {};
$8c6b7c2923cf4907$exports = import.meta.resolve("XccIv");


var $dc8fd757abe0c183$exports = {};
$dc8fd757abe0c183$exports = import.meta.resolve("2mECi");


var $6d4533be1ab09c37$exports = {};
$6d4533be1ab09c37$exports = import.meta.resolve("3O28n");


var $922b660dc729b644$exports = {};
$922b660dc729b644$exports = import.meta.resolve("7DYXE");


var $6e6ebe7c4245c6db$exports = {};
$6e6ebe7c4245c6db$exports = import.meta.resolve("a1n9g");


var $4758237ab4c171de$exports = {};
$4758237ab4c171de$exports = import.meta.resolve("1fJOX");


var $7c712d292e21e143$exports = {};
$7c712d292e21e143$exports = import.meta.resolve("agSfN");


var $184e84ad82b89ad7$exports = {};
$184e84ad82b89ad7$exports = import.meta.resolve("1h8DY");


var $d6d19a0db563f1d9$exports = {};
$d6d19a0db563f1d9$exports = import.meta.resolve("kIdvw");


var $93d08a737443de41$exports = {};
$93d08a737443de41$exports = import.meta.resolve("53Pk2");


var $115f4a62a2c95386$exports = {};
$115f4a62a2c95386$exports = import.meta.resolve("3nsgX");


var $af61231d7f2e4443$exports = {};
$af61231d7f2e4443$exports = import.meta.resolve("ixz9Y");


var $8ef80515129ed385$exports = {};
$8ef80515129ed385$exports = import.meta.resolve("alo8E");


var $5b5e77b45ef21073$exports = {};
$5b5e77b45ef21073$exports = import.meta.resolve("hUBRS");


var $3759e289ffd0e156$exports = {};
$3759e289ffd0e156$exports = import.meta.resolve("6I5bJ");


var $881c8076317ecfb2$exports = {};
$881c8076317ecfb2$exports = import.meta.resolve("1uyya");


var $ebba445cb6251bcc$exports = {};
$ebba445cb6251bcc$exports = import.meta.resolve("7DRvU");


var $1d8d88c8337b82b8$exports = {};
$1d8d88c8337b82b8$exports = import.meta.resolve("e27ZE");


var $c241f4856038a51b$exports = {};
$c241f4856038a51b$exports = import.meta.resolve("jy6ZK");


var $2720cb18a3936350$exports = {};
$2720cb18a3936350$exports = import.meta.resolve("gL95c");


var $af85db91877790d4$exports = {};
$af85db91877790d4$exports = import.meta.resolve("ai8Iq");


var $25699a273ebf888b$exports = {};
$25699a273ebf888b$exports = import.meta.resolve("8o2qg");


var $a6d1237fbbac0f55$exports = {};
$a6d1237fbbac0f55$exports = import.meta.resolve("f0juj");


var $7bb5ccedc43e0097$exports = {};
$7bb5ccedc43e0097$exports = import.meta.resolve("jENGx");


var $68908720c275ccbf$exports = {};
$68908720c275ccbf$exports = import.meta.resolve("dCYD0");


var $e97b1d077bcf48a8$exports = {};
$e97b1d077bcf48a8$exports = import.meta.resolve("eo9Am");


var $4c9f67fa5cda8fdb$exports = {};
$4c9f67fa5cda8fdb$exports = import.meta.resolve("ioIsf");


const $755bfc0689a8b67c$export$6c746a5570b8b35c = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d6d19a0db563f1d9$exports))),
        city: 'hamburg'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a6d1237fbbac0f55$exports))),
        city: 'seattle'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1d8d88c8337b82b8$exports))),
        city: 'munich'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($115f4a62a2c95386$exports))),
        city: 'izumo'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7c712d292e21e143$exports))),
        city: 'edinburgh'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3526dbaa5fbb8d2$exports))),
        city: 'alicante'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e97b1d077bcf48a8$exports))),
        city: 'vienna'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fb9610575ae15cb$exports))),
        city: 'berlin'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af85db91877790d4$exports))),
        city: 'paris'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c241f4856038a51b$exports))),
        city: 'newYork13'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7bb5ccedc43e0097$exports))),
        city: 'fortWorth'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($881c8076317ecfb2$exports))),
        city: 'manchester'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4c9f67fa5cda8fdb$exports))),
        city: 'none'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af61231d7f2e4443$exports))),
        city: 'leipzig'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($184e84ad82b89ad7$exports))),
        city: 'edinburgh'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ef80515129ed385$exports))),
        city: 'london'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($68908720c275ccbf$exports))),
        city: 'sanAndres'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8c6b7c2923cf4907$exports))),
        city: 'bonn'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($93d08a737443de41$exports))),
        city: 'izumo14'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($922b660dc729b644$exports))),
        city: 'dallas'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3759e289ffd0e156$exports))),
        city: 'malaga'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5b5e77b45ef21073$exports))),
        city: 'losAngeles'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($298764a04bae36d6$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2720cb18a3936350$exports))),
        city: 'ottawa12'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4758237ab4c171de$exports))),
        city: 'denver'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ebba445cb6251bcc$exports))),
        city: 'milan'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c241f4856038a51b$exports))),
        city: 'newYork13'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6d4533be1ab09c37$exports))),
        city: 'chicago'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($93664ad0439e5b99$exports))),
        city: 'barcelona'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($25699a273ebf888b$exports))),
        city: 'paris'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d6650192ff1579c0$exports))),
        city: 'bonn'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dc8fd757abe0c183$exports))),
        city: 'bremen'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6e6ebe7c4245c6db$exports))),
        city: 'theHague'
    }
];
const $755bfc0689a8b67c$export$f03f7c19d8f50e16 = {
    alicante: {
        img: 'ALICANTE',
        country: 'spain',
        name: 'Alicante',
        link: 'https://www.facebook.com/events/1445194540289283/'
    },
    barcelona: {
        img: 'BARCELONA',
        country: 'spain',
        name: 'Barcelona',
        link: 'https://www.instagram.com/reel/DR6_30DjHIF/?igsh=ZDh5cnY4ZTdkNjVm'
    },
    berkeley: {
        country: 'usa',
        name: 'Berkeley',
        link: ''
    },
    berlin: {
        img: 'BERLIN',
        country: 'germany',
        name: 'Berlin',
        link: 'https://www.instagram.com/p/DSAxceHiIKU/'
    },
    bettendorf: {
        country: 'usa',
        name: 'Bettendorf, Iowa',
        link: 'https://www.facebook.com/groups/1607064723004168/posts/2614847065559257/'
    },
    birmingham: {
        img: 'BIRMINGHAM',
        country: 'unitedKingdom',
        name: 'Birmingham',
        link: ''
    },
    bonn: {
        img: 'BONN',
        country: 'germany',
        name: 'Bonn',
        link: 'https://www.facebook.com/groups/osteuropaforumbonn/posts/1407165524309389/'
    },
    bremen: {
        img: 'BREMEN',
        country: 'germany',
        name: 'Bremen',
        link: ''
    },
    budapest: {
        country: 'hungary',
        name: 'Budapest',
        link: ''
    },
    chicago: {
        country: 'usa',
        name: 'Chicago',
        link: 'https://www.instagram.com/p/DSGrLP1EfM6/'
    },
    copenhagen: {
        country: 'denmark',
        name: 'Copenhagen',
        link: 'https://facebook.com/events/s/stop-human-safari-save-kherson/1220516253279753/'
    },
    dallas: {
        img: 'DALLAS',
        country: 'usa',
        name: 'Dallas',
        link: 'https://www.facebook.com/events/1641318096831798/'
    },
    denver: {
        img: 'DENVER',
        country: 'usa',
        name: 'Denver',
        link: 'https://www.facebook.com/events/3741812956114656/'
    },
    edinburgh: {
        img: 'EDINBURGH',
        country: 'unitedKingdom',
        name: 'Edinburgh',
        link: 'https://www.facebook.com/photo?fbid=122236786634168922&set=a.122110901120168922'
    },
    fortWorth: {
        img: 'TEXAS',
        country: 'usa',
        name: 'Fort Worth',
        link: 'https://www.facebook.com/events/1869858713900974/'
    },
    hamburg: {
        country: 'germany',
        name: 'Hamburg',
        link: 'https://x.com/Vilni_De_Ua/status/2001313438358810792'
    },
    houghton: {
        country: 'usa',
        name: 'Houghton, Michigan',
        link: 'https://www.facebook.com/events/1507904243656188/'
    },
    helsinki: {
        country: 'finland',
        name: 'Helsinki',
        link: 'https://ukrainians.fi/fi/stop-human-safari-16-12-klo-17-narinkkatori-hki/'
    },
    izumo14: {
        country: 'japan',
        name: 'Izumo',
        link: ''
    },
    izumo20: {
        country: 'japan',
        name: 'Izumo',
        link: ''
    },
    kamloops: {
        country: 'canada',
        name: 'Kamloops',
        link: ''
    },
    kyiv: {
        country: 'ukraine',
        name: 'Kyiv',
        link: ''
    },
    leipzig: {
        country: 'germany',
        name: 'Leipzig',
        link: 'https://www.instagram.com/p/DSHsHavjG7u/'
    },
    london: {
        img: 'LONDON',
        country: 'unitedKingdom',
        name: 'London',
        link: 'https://www.eventbrite.com/e/screening-of-a-documentary-film-kherson-human-safari-tickets-1977283934475'
    },
    losAngeles: {
        img: 'LOS_ANGELES',
        country: 'usa',
        name: 'Los Angeles',
        link: 'https://facebook.com/events/s/stop-human-safari-save-kherson/25245573365101413'
    },
    malaga: {
        img: 'MALAGA',
        country: 'spain',
        name: "M\xe1laga",
        link: ''
    },
    manchester: {
        img: 'MANCHESTER',
        country: 'unitedKingdom',
        name: 'Manchester',
        link: 'https://www.instagram.com/p/DSF6kebjJhZ/'
    },
    milan: {
        img: 'MILAN',
        country: 'italy',
        name: 'Milan',
        link: 'https://x.com/liberioltre/status/1998660593386246617'
    },
    munich: {
        img: 'MUNICH',
        country: 'germany',
        name: 'Munich',
        link: 'https://www.facebook.com/events/2599048053801906/'
    },
    newYork13: {
        img: 'NEW_YORK',
        country: 'usa',
        name: 'New York',
        link: 'https://www.instagram.com/p/DSJNpfWEfU7/'
    },
    newYork14: {
        img: 'NEW_YORK',
        country: 'usa',
        name: 'New York',
        link: ''
    },
    nienburg: {
        country: 'germany',
        name: 'Nienburg (Weser)',
        link: ''
    },
    oslo: {
        country: 'norway',
        name: 'Oslo',
        link: ''
    },
    ostersund: {
        country: 'sweden',
        name: "\xd6stersund",
        link: 'https://www.facebook.com/events/1902872407329570/'
    },
    ottawa12: {
        img: 'OTTAWA',
        country: 'canada',
        name: 'Ottawa',
        link: 'https://www.facebook.com/RussianEmbassyProtesters/posts/pfbid02r26HLr1xa6gaKqhQnNPEBpaN2agXMck7FP4MgsL1Pa1ytRAxcUqGrFtWnNp59pLHl'
    },
    ottawa13: {
        img: 'OTTAWA',
        country: 'canada',
        name: 'Ottawa',
        link: 'https://www.facebook.com/RussianEmbassyProtesters/photos/eventstop-human-safari-save-kherson-global-rally-fri-dec-12-1230pm-russian-embas/856291767332584/'
    },
    paris: {
        img: (0, (/*@__PURE__*/$parcel$interopDefault($af85db91877790d4$exports))),
        country: 'france',
        name: 'Paris',
        link: 'https://www.facebook.com/groups/pour.lukraine/posts/4385483298395331/'
    },
    plovdiv: {
        country: 'bulgaria',
        name: 'Plovdiv',
        link: ''
    },
    prague: {
        country: 'czechia',
        name: 'Prague',
        link: 'https://www.facebook.com/events/868528178989820?active_tab=about'
    },
    rosendal: {
        country: 'southAfrica',
        name: 'Rosendal',
        link: ''
    },
    sanAndres: {
        country: 'spain',
        name: "San Andr\xe9s, Tenerife",
        link: ''
    },
    sanDiego: {
        country: 'usa',
        name: 'San Diego',
        link: 'https://www.facebook.com/story.php?story_fbid=pfbid0NA7LaipmEpGqz4DDrvdY28z97L6FWXtzxbUFxLvQThge6jsNVgARDVnXb8PeptMWl&id=100078779928673&mibextid=wwXIfr&_rdr'
    },
    sanFrancisco: {
        img: 'SAN_FRANCISCO',
        country: 'usa',
        name: 'San Francisco',
        link: 'https://www.facebook.com/events/s/stop-human-safari-save-kherson/1552004906063989/'
    },
    schwerin: {
        country: 'germany',
        name: 'Schwerin',
        link: ''
    },
    seattle: {
        img: 'SEATTLE',
        country: 'usa',
        name: 'Seattle',
        link: 'https://facebook.com/events/s/worldwide-rally-stop-the-human/1562930834831737/'
    },
    svetiVlas: {
        country: 'bulgaria',
        name: 'Sveti Vlas',
        link: ''
    },
    sydney: {
        country: 'australia',
        name: 'Sydney',
        link: 'https://www.facebook.com/groups/Ukrainians.sydney/posts/25211112641845055/'
    },
    tallinn: {
        country: 'estonia',
        name: 'Tallinn',
        link: 'https://www.facebook.com/groups/659010032770800/posts/1210717964266668/'
    },
    tarragona: {
        country: 'spain',
        name: 'Tarragona',
        link: 'https://www.instagram.com/ucranianos_de_tarragona?igsh=MW9tbjJwcGxhZzIwbQ=='
    },
    tbilisi: {
        country: 'georgia',
        name: 'Tbilisi',
        link: ''
    },
    theHague: {
        img: 'DEN_HAAG',
        country: 'netherlands',
        name: 'The Hague',
        link: 'https://indigo4ua.com/save-kherson/'
    },
    tranas: {
        country: 'sweden',
        name: "Tran\xe5s",
        link: 'https://www.facebook.com/events/827112923446998/'
    },
    vienna: {
        img: 'VIENNA',
        country: 'austria',
        name: 'Vienna',
        link: 'https://www.instagram.com/p/DR1xkHhjPjY/?img_index=1'
    },
    washingtonDC: {
        country: 'usa',
        name: 'Washington, D.C.',
        link: 'https://www.facebook.com/events/s/standwithukraineeveryday/823001877182013/'
    },
    wroclaw: {
        country: 'poland',
        name: 'Wroclaw',
        link: ''
    },
    mexicoCity: {
        country: 'mexico',
        name: 'Mexico City',
        link: ''
    }
};
const $755bfc0689a8b67c$export$b1efef5b7170e6ff = [
    'budapest',
    'svetiVlas'
];
const $755bfc0689a8b67c$export$defa5e4142b28eea = [
    'bettendorf'
];
const $755bfc0689a8b67c$export$d677a69846a6f688 = [
    'london',
    'ottawa12'
];
const $755bfc0689a8b67c$export$35b3abc391b9abc9 = [
    'alicante',
    'berkeley',
    'birmingham',
    'dallas',
    'edinburgh',
    'kamloops',
    'leipzig',
    'malaga',
    'manchester',
    'nienburg',
    'ostersund',
    'ottawa13',
    'paris',
    'prague',
    'rosendal',
    'sanAndres',
    'schwerin',
    'seattle',
    'sydney',
    'tallinn',
    'tranas'
];
const $755bfc0689a8b67c$export$5bdf90b049d46ef4 = [
    'barcelona',
    'berlin',
    'bonn',
    'bremen',
    'chicago',
    'copenhagen',
    'denver',
    'fortWorth',
    'houghton',
    'izumo14',
    'kyiv',
    'losAngeles',
    'mexicoCity',
    'milan',
    'munich',
    // actually also on the 14th, not a mistake
    'newYork14',
    'newYork13',
    'oslo',
    'plovdiv',
    'sanDiego',
    'sanFrancisco',
    'tarragona',
    'tbilisi',
    'theHague',
    'vienna',
    'washingtonDC',
    'wroclaw'
];
const $755bfc0689a8b67c$export$ac930b69ddcd481c = [
    'helsinki'
];
const $755bfc0689a8b67c$export$a76370ba1e8be322 = [
    'hamburg',
    'izumo20'
];





function $ec4b77ae4b0ba8de$var$CityOG({ city: city, rally: rally }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ns = rally?.citiesI18n ?? 'cities';
    const link = (rally?.cities ?? (0, $755bfc0689a8b67c$export$f03f7c19d8f50e16))[city]?.link || null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
        className: "list-none",
        children: [
            link ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                href: link,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "inline-flex items-center space-x-1 active:opacity-70 transition-opacity",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-bold hover:underline",
                        children: t(`${ns}.${city}.time`)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "\uD83D\uDD17"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-bold",
                children: t(`${ns}.${city}.time`)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-sm font-semibold text-blue-900",
                children: t(`${ns}.${city}.location`)
            })
        ]
    }, city);
}
var $ec4b77ae4b0ba8de$export$2e2bcd8739ae039 = $ec4b77ae4b0ba8de$var$CityOG;


function $1475da1823ba6eb0$export$9fa0acc09cd94b92() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "py-10 w-full grid grid-cols-1 md:grid-cols-2 gap-10 justify-center mb-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "text-4xl md:text-5xl font-medium mb-8 underline",
                                children: [
                                    t('home.schedule11'),
                                    " ",
                                    t('home.december')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-4 opacity-90 text-center text-2xl",
                                children: (0, $755bfc0689a8b67c$export$defa5e4142b28eea).map((city)=>// <City key={city} city={city} />
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec4b77ae4b0ba8de$export$2e2bcd8739ae039), {
                                        city: city
                                    }, city))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "text-4xl md:text-5xl font-medium mb-8 underline",
                                children: [
                                    t('home.schedule12'),
                                    " ",
                                    t('home.december')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-4 opacity-90 text-center text-2xl",
                                children: (0, $755bfc0689a8b67c$export$d677a69846a6f688).map((city)=>// <City key={city} city={city} />
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec4b77ae4b0ba8de$export$2e2bcd8739ae039), {
                                        city: city
                                    }, city))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full grid grid-cols-1 md:grid-cols-2 gap-10 gap-y-20 justify-center mb-10",
                children: [
                    {
                        title: 'home.schedule13',
                        cities: (0, $755bfc0689a8b67c$export$35b3abc391b9abc9)
                    },
                    {
                        title: 'home.schedule14',
                        cities: (0, $755bfc0689a8b67c$export$5bdf90b049d46ef4)
                    },
                    {
                        title: 'home.schedule16',
                        cities: (0, $755bfc0689a8b67c$export$ac930b69ddcd481c)
                    },
                    {
                        title: 'home.schedule20',
                        cities: (0, $755bfc0689a8b67c$export$a76370ba1e8be322)
                    }
                ].map((group, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "text-4xl md:text-5xl font-medium underline",
                                children: [
                                    t(group.title),
                                    " ",
                                    t('home.december')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-4 opacity-90 text-center text-2xl",
                                children: group.cities.map((city)=>// <City key={city} city={city} />
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec4b77ae4b0ba8de$export$2e2bcd8739ae039), {
                                        city: city
                                    }, city))
                            })
                        ]
                    }, i))
            })
        ]
    });
}





const $8c35c3c6dfd7a237$export$11e5f5d465bd5a50 = [
    ...(0, $755bfc0689a8b67c$export$defa5e4142b28eea),
    ...(0, $755bfc0689a8b67c$export$d677a69846a6f688),
    ...(0, $755bfc0689a8b67c$export$35b3abc391b9abc9),
    ...(0, $755bfc0689a8b67c$export$5bdf90b049d46ef4),
    ...(0, $755bfc0689a8b67c$export$ac930b69ddcd481c),
    ...(0, $755bfc0689a8b67c$export$a76370ba1e8be322)
];
function $8c35c3c6dfd7a237$export$270c028aad0bbc1(cityKeys) {
    const countries = {};
    cityKeys.forEach((key)=>{
        const cityObj = (0, $755bfc0689a8b67c$export$f03f7c19d8f50e16)[key];
        if (!cityObj) return;
        const country = cityObj.country || 'Other';
        if (!countries[country]) countries[country] = [];
        countries[country].push(key);
    });
    // sort cities inside each country
    Object.keys(countries).forEach((country)=>{
        countries[country].sort((a, b)=>a.localeCompare(b));
    });
    // return countries in alphabetical order
    const sorted = {};
    Object.keys(countries).sort((a, b)=>a.localeCompare(b)).forEach((country)=>{
        sorted[country] = countries[country];
    });
    return sorted;
}
const $8c35c3c6dfd7a237$export$a188e271553f9211 = $8c35c3c6dfd7a237$export$270c028aad0bbc1($8c35c3c6dfd7a237$export$11e5f5d465bd5a50);
function $8c35c3c6dfd7a237$export$8397059e2b491561(cityKeys) {
    const countries = {};
    cityKeys.forEach((key)=>{
        const cityObj = (0, $755bfc0689a8b67c$export$f03f7c19d8f50e16)[key];
        if (!cityObj) return;
        const country = cityObj.country || 'Other';
        if (!countries[country]) countries[country] = [];
        countries[country].push(key);
    });
    // sort cities inside each country
    Object.keys(countries).forEach((country)=>{
        countries[country].sort((a, b)=>a.localeCompare(b));
    });
    // create array of [country, cityKeys] and sort by city count descending
    const sortedByCount = Object.entries(countries).sort((a, b)=>b[1].length - a[1].length);
    // zig-zag: odd index first, then even index
    const zigzag = {};
    const odd = [];
    const even = [];
    sortedByCount.forEach(([country, keys], index)=>{
        if (index % 2 === 0) odd.push([
            country,
            keys
        ]);
        else even.push([
            country,
            keys
        ]);
    });
    [
        ...odd,
        ...even
    ].forEach(([country, keys])=>{
        zigzag[country] = keys;
    });
    return zigzag;
}
const $8c35c3c6dfd7a237$export$d0a822cab3735a44 = $8c35c3c6dfd7a237$export$8397059e2b491561($8c35c3c6dfd7a237$export$11e5f5d465bd5a50);
function $8c35c3c6dfd7a237$export$bf12af26a1077753(cityKeys, cities = (0, $755bfc0689a8b67c$export$f03f7c19d8f50e16)) {
    const countries = {};
    cityKeys.forEach((key)=>{
        const cityObj = cities[key];
        if (!cityObj) return;
        const country = cityObj.country || 'Other';
        if (!countries[country]) countries[country] = [];
        countries[country].push(key);
    });
    // sort cities inside each country alphabetically
    Object.keys(countries).forEach((country)=>{
        countries[country].sort((a, b)=>a.localeCompare(b));
    });
    // sort countries by number of cities descending
    const sorted = {};
    Object.entries(countries).sort(([, aCities], [, bCities])=>bCities.length - aCities.length).forEach(([country, cities])=>{
        sorted[country] = cities;
    });
    return sorted;
}
const $8c35c3c6dfd7a237$export$9dec74656aeabcda = $8c35c3c6dfd7a237$export$bf12af26a1077753($8c35c3c6dfd7a237$export$11e5f5d465bd5a50);



var $ebd42efdf2b1dab9$exports = {};
$ebd42efdf2b1dab9$exports = import.meta.resolve("bQ0M8");


var $4342cae017280531$exports = {};
$4342cae017280531$exports = import.meta.resolve("kzflT");


var $9c2ad197a9b1b5c0$exports = {};
$9c2ad197a9b1b5c0$exports = import.meta.resolve("hdbnD");


var $31fc33da031b707b$exports = {};
$31fc33da031b707b$exports = import.meta.resolve("1K7ES");


var $56317762ca879e5a$exports = {};
$56317762ca879e5a$exports = import.meta.resolve("irGgC");


var $1b0779c9b5145edd$exports = {};
$1b0779c9b5145edd$exports = import.meta.resolve("jNNVX");


var $c93d7b603364a7fb$exports = {};
$c93d7b603364a7fb$exports = import.meta.resolve("eoTgG");


var $bed6c18556d24dee$exports = {};
$bed6c18556d24dee$exports = import.meta.resolve("4fCox");


var $d0d77e39954d4bc1$exports = {};
$d0d77e39954d4bc1$exports = import.meta.resolve("2q9Qt");


var $4c323a6825837d7b$exports = {};
$4c323a6825837d7b$exports = import.meta.resolve("1TeUV");


var $12636dec618a0d2b$exports = {};
$12636dec618a0d2b$exports = import.meta.resolve("ea0BI");


var $f016565fdf46a8f5$exports = {};
$f016565fdf46a8f5$exports = import.meta.resolve("5EB81");


var $39abe6f7ed83f9b3$exports = {};
$39abe6f7ed83f9b3$exports = import.meta.resolve("56c1v");


var $5f198a1da7c4a2cf$exports = {};
$5f198a1da7c4a2cf$exports = import.meta.resolve("jXApB");


var $e4c55fc4c1ab7029$exports = {};
$e4c55fc4c1ab7029$exports = import.meta.resolve("e7xht");


var $1145e38bb1ca3181$exports = {};
$1145e38bb1ca3181$exports = import.meta.resolve("1YLuh");


var $1bc65f0c16447202$exports = {};
$1bc65f0c16447202$exports = import.meta.resolve("iGhop");


var $99c15091d6e01f7c$exports = {};
$99c15091d6e01f7c$exports = import.meta.resolve("59fVD");


var $ae302941f68a4d5d$exports = {};
$ae302941f68a4d5d$exports = import.meta.resolve("f89OK");


var $88db2afce3c47be1$exports = {};
$88db2afce3c47be1$exports = import.meta.resolve("c73cc");


var $43199b87c55da371$exports = {};
$43199b87c55da371$exports = import.meta.resolve("lvhxz");


var $a6bf71274a462a81$exports = {};
$a6bf71274a462a81$exports = import.meta.resolve("2bqQm");


var $0ecddfc04b77afd6$exports = {};
$0ecddfc04b77afd6$exports = import.meta.resolve("9HSSK");


var $168c6451526ab206$exports = {};
$168c6451526ab206$exports = import.meta.resolve("7phN1");


var $8f45c1f6f5dfdfb8$exports = {};
$8f45c1f6f5dfdfb8$exports = import.meta.resolve("4y4Zy");


var $bc0528cb3e6cccfc$exports = {};
$bc0528cb3e6cccfc$exports = import.meta.resolve("7V1SF");


var $262f6a2eaa629bcc$exports = {};
$262f6a2eaa629bcc$exports = import.meta.resolve("799cl");


var $bdfe7649f21a235f$exports = {};
$bdfe7649f21a235f$exports = import.meta.resolve("82bsP");


var $b4e28bbf5b3572f9$exports = {};
$b4e28bbf5b3572f9$exports = import.meta.resolve("5oMva");


var $ff558489af78b43d$exports = {};
$ff558489af78b43d$exports = import.meta.resolve("3eRzR");


var $715de4020879c13b$exports = {};
$715de4020879c13b$exports = import.meta.resolve("2Ephl");


var $4b55474483ee4fe6$exports = {};
$4b55474483ee4fe6$exports = import.meta.resolve("8cMaq");


var $448d868e12b9e156$exports = {};
$448d868e12b9e156$exports = import.meta.resolve("fZdij");


var $74609b72386d5bc2$exports = {};
$74609b72386d5bc2$exports = import.meta.resolve("dUncg");


var $370b41245752f66c$exports = {};
$370b41245752f66c$exports = import.meta.resolve("cvR2N");


var $21a1db734ca81aca$exports = {};
$21a1db734ca81aca$exports = import.meta.resolve("lxv6f");


var $6ca7cb7682332eb1$exports = {};
$6ca7cb7682332eb1$exports = import.meta.resolve("lvRha");


var $2e6cca79e84b66ce$exports = {};
$2e6cca79e84b66ce$exports = import.meta.resolve("5jWyP");


var $e904cf3247617a2a$exports = {};
$e904cf3247617a2a$exports = import.meta.resolve("25fxU");


var $8f5cd7ba58fdd289$exports = {};
$8f5cd7ba58fdd289$exports = import.meta.resolve("5SOGs");


var $80a86a0c84cb8193$exports = {};
$80a86a0c84cb8193$exports = import.meta.resolve("bSJ6J");


var $fd8420c0abac9afa$exports = {};
$fd8420c0abac9afa$exports = import.meta.resolve("fLnTI");


var $6f68be75b90711b3$exports = {};
$6f68be75b90711b3$exports = import.meta.resolve("3uSVF");


var $0de19a28d6779a67$exports = {};
$0de19a28d6779a67$exports = import.meta.resolve("gKzva");


var $50308dd112587d24$exports = {};
$50308dd112587d24$exports = import.meta.resolve("9NGTv");


var $507f94fa468d6e2a$exports = {};
$507f94fa468d6e2a$exports = import.meta.resolve("6LzkP");


var $7e1be5d4ca3cf9d1$exports = {};
$7e1be5d4ca3cf9d1$exports = import.meta.resolve("8ebQr");


var $f90a2c0f5c011c90$exports = {};
$f90a2c0f5c011c90$exports = import.meta.resolve("gaFkH");


var $a66e7f67aeb74423$exports = {};
$a66e7f67aeb74423$exports = import.meta.resolve("aD1ei");


var $77620ada69a6d022$exports = {};
$77620ada69a6d022$exports = import.meta.resolve("2ZQw6");


var $b4e351109e862867$exports = {};
$b4e351109e862867$exports = import.meta.resolve("ibTS7");


var $daf26d3725876934$exports = {};
$daf26d3725876934$exports = import.meta.resolve("1bjJa");


var $6e740a869ca2adb3$exports = {};
$6e740a869ca2adb3$exports = import.meta.resolve("labQT");


var $b6e00842d7074f11$exports = {};
$b6e00842d7074f11$exports = import.meta.resolve("5QfZc");


var $ca5f6beb64f79d10$exports = {};
$ca5f6beb64f79d10$exports = import.meta.resolve("idp29");


var $d67fa63792cdcb24$exports = {};
$d67fa63792cdcb24$exports = import.meta.resolve("iQt52");


var $d30a323f90f74e8a$exports = {};
$d30a323f90f74e8a$exports = import.meta.resolve("j7jO3");


var $af8037de80c51141$exports = {};
$af8037de80c51141$exports = import.meta.resolve("1DijW");


var $fede9c020c6b8d4a$exports = {};
$fede9c020c6b8d4a$exports = import.meta.resolve("i38GB");


var $c5ab868d1bdea6cf$exports = {};
$c5ab868d1bdea6cf$exports = import.meta.resolve("jCegI");


var $fb8133833acea4a2$exports = {};
$fb8133833acea4a2$exports = import.meta.resolve("98MjO");


var $e01f8a402de92518$exports = {};
$e01f8a402de92518$exports = import.meta.resolve("jI85J");


var $6cbb8bb003317f64$exports = {};
$6cbb8bb003317f64$exports = import.meta.resolve("6dnJ5");


var $6c9b5e5b0798fe3e$exports = {};
$6c9b5e5b0798fe3e$exports = import.meta.resolve("7ertv");


var $a7b0a01e2ccd2079$exports = {};
$a7b0a01e2ccd2079$exports = import.meta.resolve("KII2Q");


var $6cc5ee70edfc34fd$exports = {};
$6cc5ee70edfc34fd$exports = import.meta.resolve("9MqwT");


var $660f16e8fe9b5204$exports = {};
$660f16e8fe9b5204$exports = import.meta.resolve("5o7Ei");


var $478fab765d66d75b$exports = {};
$478fab765d66d75b$exports = import.meta.resolve("3QtWv");


var $5350d435beb0f93a$exports = {};
$5350d435beb0f93a$exports = import.meta.resolve("iYaK8");


var $69c021eb1c4f9087$exports = {};
$69c021eb1c4f9087$exports = import.meta.resolve("gPYXL");


var $a82b1f53c8c57745$exports = {};
$a82b1f53c8c57745$exports = import.meta.resolve("9vOBq");


var $a785ee56774e9006$exports = {};
$a785ee56774e9006$exports = import.meta.resolve("hOYPC");


var $f9c546c9614c8d66$exports = {};
$f9c546c9614c8d66$exports = import.meta.resolve("8fYzb");


var $1ac99ed0e76378f9$exports = {};
$1ac99ed0e76378f9$exports = import.meta.resolve("b96mV");


var $49c7f7e9de9dcfed$exports = {};
$49c7f7e9de9dcfed$exports = import.meta.resolve("6dt27");


var $df25d6c4f66827b1$exports = {};
$df25d6c4f66827b1$exports = import.meta.resolve("a5iis");


var $cbcab2cd0cc613cc$exports = {};
$cbcab2cd0cc613cc$exports = import.meta.resolve("eQYb4");


var $e143b97a70154709$exports = {};
$e143b97a70154709$exports = import.meta.resolve("9kYm0");


var $7d2f49e7de793766$exports = {};
$7d2f49e7de793766$exports = import.meta.resolve("grKof");


var $f27e6f7f19e3a0ac$exports = {};
$f27e6f7f19e3a0ac$exports = import.meta.resolve("6TEtD");


var $b3225cf106587a39$exports = {};
$b3225cf106587a39$exports = import.meta.resolve("gVCQv");


var $a5f9dcb92e3892cc$exports = {};
$a5f9dcb92e3892cc$exports = import.meta.resolve("2wEzS");


var $42df14db800c80b8$exports = {};
$42df14db800c80b8$exports = import.meta.resolve("bomMz");


var $93e01b0e51855b74$exports = {};
$93e01b0e51855b74$exports = import.meta.resolve("aUiGb");


var $201622a65af5967b$exports = {};
$201622a65af5967b$exports = import.meta.resolve("4W0iu");


var $904cf5d2cc6cbbe6$exports = {};
$904cf5d2cc6cbbe6$exports = import.meta.resolve("IaBf8");


var $22deac0a5ed54206$exports = {};
$22deac0a5ed54206$exports = import.meta.resolve("apKcc");


var $d69d9ff3fa73ad81$exports = {};
$d69d9ff3fa73ad81$exports = import.meta.resolve("5C88M");


var $a63371a1b9dc44c9$exports = {};
$a63371a1b9dc44c9$exports = import.meta.resolve("027DN");


var $3073cfabd1c2b402$exports = {};
$3073cfabd1c2b402$exports = import.meta.resolve("iDzoO");


var $f7a1ef672d487160$exports = {};
$f7a1ef672d487160$exports = import.meta.resolve("dVQaN");


var $7621f2fd31360eaa$exports = {};
$7621f2fd31360eaa$exports = import.meta.resolve("73IMg");


var $5f8f32e34fbb99ad$exports = {};
$5f8f32e34fbb99ad$exports = import.meta.resolve("5puEN");



const $b06743023139191a$export$3b2217e45a573556 = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4342cae017280531$exports))),
        city: 'alicante',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9c2ad197a9b1b5c0$exports))),
        city: 'barcelona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($31fc33da031b707b$exports))),
        city: 'barcelona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($56317762ca879e5a$exports))),
        city: 'barcelona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1b0779c9b5145edd$exports))),
        city: 'berlin',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c93d7b603364a7fb$exports))),
        city: 'berlin',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bed6c18556d24dee$exports))),
        city: 'berlin',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d0d77e39954d4bc1$exports))),
        city: 'bettendorf',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4c323a6825837d7b$exports))),
        city: 'birmingham',
        country: 'unitedKingdom'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($12636dec618a0d2b$exports))),
        city: 'birmingham',
        country: 'unitedKingdom'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f016565fdf46a8f5$exports))),
        city: 'bremen',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($39abe6f7ed83f9b3$exports))),
        city: 'chicago',
        country: 'united states'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5f198a1da7c4a2cf$exports))),
        city: 'copenhagen',
        country: 'denmark'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e4c55fc4c1ab7029$exports))),
        city: 'copenhagen',
        country: 'denmark'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1145e38bb1ca3181$exports))),
        city: 'copenhagen',
        country: 'denmark'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1bc65f0c16447202$exports))),
        city: 'dallas',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($99c15091d6e01f7c$exports))),
        city: 'denver',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ae302941f68a4d5d$exports))),
        city: 'edinburgh',
        country: 'united kingdom'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($88db2afce3c47be1$exports))),
        city: 'edinburgh',
        country: 'united kingdom'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($43199b87c55da371$exports))),
        city: 'fortWorth',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a6bf71274a462a81$exports))),
        city: 'fortWorth',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0ecddfc04b77afd6$exports))),
        city: 'helsinki',
        country: 'finland'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($168c6451526ab206$exports))),
        city: 'helsinki',
        country: 'finland'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8f45c1f6f5dfdfb8$exports))),
        city: 'helsinki',
        country: 'finland'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bc0528cb3e6cccfc$exports))),
        city: 'helsinki',
        country: 'finland'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($262f6a2eaa629bcc$exports))),
        city: 'izumo14',
        country: 'japan'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bdfe7649f21a235f$exports))),
        city: 'izumo20',
        country: 'japan'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4e28bbf5b3572f9$exports))),
        city: 'kamloops',
        country: 'canada'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff558489af78b43d$exports))),
        city: 'kyiv',
        country: 'ukraine'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($715de4020879c13b$exports))),
        city: 'kyiv',
        country: 'ukraine'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4b55474483ee4fe6$exports))),
        city: 'kyiv',
        country: 'ukraine'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($448d868e12b9e156$exports))),
        city: 'leipzig',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($74609b72386d5bc2$exports))),
        city: 'leipzig',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($370b41245752f66c$exports))),
        city: 'london',
        country: 'unitedKingdom'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($21a1db734ca81aca$exports))),
        city: 'losAngeles',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6ca7cb7682332eb1$exports))),
        city: 'losAngeles',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2e6cca79e84b66ce$exports))),
        city: 'losAngeles',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e904cf3247617a2a$exports))),
        city: 'manchester',
        country: 'unitedKingdom'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8f5cd7ba58fdd289$exports))),
        city: 'milan',
        country: 'italy'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($80a86a0c84cb8193$exports))),
        city: 'milan',
        country: 'italy'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fd8420c0abac9afa$exports))),
        city: 'munich',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6f68be75b90711b3$exports))),
        city: 'munich',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0de19a28d6779a67$exports))),
        city: 'munich',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($50308dd112587d24$exports))),
        city: 'munich',
        country: 'germany'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($507f94fa468d6e2a$exports))),
        city: 'newYork13',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7e1be5d4ca3cf9d1$exports))),
        city: 'newYork13',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f90a2c0f5c011c90$exports))),
        city: 'ostersund',
        country: 'sweden'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a66e7f67aeb74423$exports))),
        city: 'ostersund',
        country: 'sweden'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($77620ada69a6d022$exports))),
        city: 'oslo',
        country: 'norway'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4e351109e862867$exports))),
        city: 'oslo',
        country: 'norway'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($daf26d3725876934$exports))),
        city: 'ottawa12',
        country: 'canada'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ca5f6beb64f79d10$exports))),
        city: 'ottawa12',
        country: 'canada'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d67fa63792cdcb24$exports))),
        city: 'ottawa12',
        country: 'canada'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6e740a869ca2adb3$exports))),
        city: 'ottawa13',
        country: 'canada'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b6e00842d7074f11$exports))),
        city: 'ottawa13',
        country: 'canada'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d30a323f90f74e8a$exports))),
        city: 'paris',
        country: 'france'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af8037de80c51141$exports))),
        city: 'paris',
        country: 'france'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fede9c020c6b8d4a$exports))),
        city: 'plovdiv',
        country: 'bulgaria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c5ab868d1bdea6cf$exports))),
        city: 'plovdiv',
        country: 'bulgaria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fb8133833acea4a2$exports))),
        city: 'prague',
        country: 'czechia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e01f8a402de92518$exports))),
        city: 'prague',
        country: 'czechia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6cbb8bb003317f64$exports))),
        city: 'rosendal',
        country: 'southAfrica'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c9b5e5b0798fe3e$exports))),
        city: 'sanAndres',
        country: 'colombia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a7b0a01e2ccd2079$exports))),
        city: 'sanAndres',
        country: 'colombia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6cc5ee70edfc34fd$exports))),
        city: 'seattle',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($660f16e8fe9b5204$exports))),
        city: 'seattle',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($478fab765d66d75b$exports))),
        city: 'sanFrancisco',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5350d435beb0f93a$exports))),
        city: 'sanFrancisco',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($69c021eb1c4f9087$exports))),
        city: 'sydney',
        country: 'australia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a82b1f53c8c57745$exports))),
        city: 'sydney',
        country: 'australia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a785ee56774e9006$exports))),
        city: 'sydney',
        country: 'australia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f9c546c9614c8d66$exports))),
        city: 'tallinn',
        country: 'estonia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1ac99ed0e76378f9$exports))),
        city: 'tarragona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($49c7f7e9de9dcfed$exports))),
        city: 'tarragona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($df25d6c4f66827b1$exports))),
        city: 'tarragona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cbcab2cd0cc613cc$exports))),
        city: 'tarragona',
        country: 'spain'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e143b97a70154709$exports))),
        city: 'tbilisi',
        country: 'georgia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7d2f49e7de793766$exports))),
        city: 'tbilisi',
        country: 'georgia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f27e6f7f19e3a0ac$exports))),
        city: 'tbilisi',
        country: 'georgia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3225cf106587a39$exports))),
        city: 'tbilisi',
        country: 'georgia'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5f9dcb92e3892cc$exports))),
        city: 'theHague',
        country: 'netherlands'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($42df14db800c80b8$exports))),
        city: 'tranas',
        country: 'sweden'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($93e01b0e51855b74$exports))),
        city: 'vienna',
        country: 'austria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($201622a65af5967b$exports))),
        city: 'vienna',
        country: 'austria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($904cf5d2cc6cbbe6$exports))),
        city: 'vienna',
        country: 'austria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($22deac0a5ed54206$exports))),
        city: 'vienna',
        country: 'austria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d69d9ff3fa73ad81$exports))),
        city: 'vienna',
        country: 'austria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a63371a1b9dc44c9$exports))),
        city: 'vienna',
        country: 'austria'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3073cfabd1c2b402$exports))),
        city: 'washingtonDC',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f7a1ef672d487160$exports))),
        city: 'washingtonDC',
        country: 'usa'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7621f2fd31360eaa$exports))),
        city: 'wroclaw',
        country: 'poland'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5f8f32e34fbb99ad$exports))),
        city: 'wroclaw',
        country: 'poland'
    }
];
const $b06743023139191a$export$ee5f96e597047257 = (0, $08f6df7db6f8e162$export$448332262467e042)($b06743023139191a$export$3b2217e45a573556);


var $8b374f03ecee7ecd$exports = {};
$8b374f03ecee7ecd$exports = import.meta.resolve("keu84");


var $97dd106a458c6a41$exports = {};
$97dd106a458c6a41$exports = import.meta.resolve("jnzSw");


var $86a3e6d4d774f5fc$exports = {};
$86a3e6d4d774f5fc$exports = import.meta.resolve("A8o16");


var $9dd1ce3b61fbeb7c$exports = {};
$9dd1ce3b61fbeb7c$exports = import.meta.resolve("2vP32");


var $07d45924db81358b$exports = {};
$07d45924db81358b$exports = import.meta.resolve("35ZfT");


var $b971889e6ceb8bad$exports = {};
$b971889e6ceb8bad$exports = import.meta.resolve("abXl5");


var $8cb7d2dda82f1fe5$exports = {};
$8cb7d2dda82f1fe5$exports = import.meta.resolve("4vmzs");


var $7e41f172f076f15b$exports = {};
$7e41f172f076f15b$exports = import.meta.resolve("02Hk3");


var $988328bcc7717df6$exports = {};
$988328bcc7717df6$exports = import.meta.resolve("7ozw8");


var $377f22c248e133c6$exports = {};
$377f22c248e133c6$exports = import.meta.resolve("lDBLm");


var $c846322429567618$exports = {};
$c846322429567618$exports = import.meta.resolve("czm99");


var $8d394747d58ae81d$exports = {};
$8d394747d58ae81d$exports = import.meta.resolve("2jZ07");


var $4a4da23bf1032ee1$exports = {};
$4a4da23bf1032ee1$exports = import.meta.resolve("7FtkQ");


var $091077dd285d78b1$exports = {};
$091077dd285d78b1$exports = import.meta.resolve("bzAg8");


var $bb96d1dfff516b8f$exports = {};
$bb96d1dfff516b8f$exports = import.meta.resolve("cGEco");


var $4b740433ab9b224a$exports = {};
$4b740433ab9b224a$exports = import.meta.resolve("4Z950");


var $782460c6767d7748$exports = {};
$782460c6767d7748$exports = import.meta.resolve("k4nJ5");


var $aaa7f73f1abca09a$exports = {};
$aaa7f73f1abca09a$exports = import.meta.resolve("7TX57");


var $3d16594662af1409$exports = {};
$3d16594662af1409$exports = import.meta.resolve("hSNXN");


var $9ed1ea662931d4a5$exports = {};
$9ed1ea662931d4a5$exports = import.meta.resolve("j5h7Z");


var $d02c25d2e390a266$exports = {};
$d02c25d2e390a266$exports = import.meta.resolve("4xbpC");


var $f906f5caad0b0484$exports = {};
$f906f5caad0b0484$exports = import.meta.resolve("ePBEJ");


var $f05f6f5089396ec9$exports = {};
$f05f6f5089396ec9$exports = import.meta.resolve("4I7vl");


var $53be6159af3b7443$exports = {};
$53be6159af3b7443$exports = import.meta.resolve("e9bB2");


var $af42de04a894c655$exports = {};
$af42de04a894c655$exports = import.meta.resolve("8gYCT");



var $ee132edc9898def2$exports = {};
$ee132edc9898def2$exports = import.meta.resolve("3xfSS");


var $9eb2063971b9a100$exports = {};
$9eb2063971b9a100$exports = import.meta.resolve("cMUem");


var $1d781b8ec522f032$exports = {};
$1d781b8ec522f032$exports = import.meta.resolve("9zz8M");


var $5095c3615c4a8a52$exports = {};
$5095c3615c4a8a52$exports = import.meta.resolve("1jnHn");


var $b9ee420abfa6d07c$exports = {};
$b9ee420abfa6d07c$exports = import.meta.resolve("lPT8x");


// Posters by named artists. Also shown, in their own order, in the Download graphics section (artPosters).
const $45ed955dd045a702$var$stopDroneSiege = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($ebd42efdf2b1dab9$exports))),
    city: 'none',
    label: 'rallies.oleshky2026.posterStopSiege',
    author: 'Zarina Zabrisky'
};
const $45ed955dd045a702$var$noRoadOut = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($ee132edc9898def2$exports))),
    city: 'none',
    label: 'rallies.oleshky2026.posterNoRoadOut',
    author: 'Oleksandra Kniga'
};
const $45ed955dd045a702$var$humanitarianCatastrophe = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($b9ee420abfa6d07c$exports))),
    city: 'none',
    label: 'rallies.oleshky2026.posterHumanitarianCatastrophe',
    author: 'Oleksiy Kustovsky'
};
const $45ed955dd045a702$var$oleshky = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eb2063971b9a100$exports))),
    city: 'none',
    author: 'Stas Kolotov'
};
const $45ed955dd045a702$var$oleshky2 = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($1d781b8ec522f032$exports))),
    city: 'none',
    author: 'Stas Kolotov'
};
const $45ed955dd045a702$var$oleshkyStopDroneSiege = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($5095c3615c4a8a52$exports))),
    city: 'none',
    author: 'Stas Kolotov'
};
const $45ed955dd045a702$export$8b1550977f062599 = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4b740433ab9b224a$exports))),
        city: 'dublin'
    },
    $45ed955dd045a702$var$noRoadOut,
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8d394747d58ae81d$exports))),
        city: 'munich'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8cb7d2dda82f1fe5$exports))),
        city: 'londonOct1',
        link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f906f5caad0b0484$exports))),
        city: 'chicago'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7e41f172f076f15b$exports))),
        city: 'budapest'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c846322429567618$exports))),
        city: 'kiel'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($53be6159af3b7443$exports))),
        city: 'malaga'
    },
    $45ed955dd045a702$var$humanitarianCatastrophe,
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9dd1ce3b61fbeb7c$exports))),
        city: 'munich'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b971889e6ceb8bad$exports))),
        city: 'londonSep29',
        link: 'https://www.instagram.com/p/Ddz2YmYMQ8b/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aaa7f73f1abca09a$exports))),
        city: 'brussels'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($97dd106a458c6a41$exports))),
        city: 'edinburgh'
    },
    $45ed955dd045a702$var$oleshkyStopDroneSiege,
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4a4da23bf1032ee1$exports))),
        city: 'manchester'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($377f22c248e133c6$exports))),
        city: 'kiel'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($782460c6767d7748$exports))),
        city: 'dublinOct11',
        link: 'https://www.instagram.com/p/DePMFG1uVvE/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3d16594662af1409$exports))),
        city: 'gdansk'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d02c25d2e390a266$exports))),
        city: 'ottawa'
    },
    $45ed955dd045a702$var$oleshky2,
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f05f6f5089396ec9$exports))),
        city: 'dresden'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($86a3e6d4d774f5fc$exports))),
        city: 'vienna'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af42de04a894c655$exports))),
        city: 'chicagoOct4',
        link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
    },
    $45ed955dd045a702$var$oleshky,
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($988328bcc7717df6$exports))),
        city: 'hamburg'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ed1ea662931d4a5$exports))),
        city: 'nantes'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($091077dd285d78b1$exports))),
        city: 'paris'
    },
    $45ed955dd045a702$var$stopDroneSiege,
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8b374f03ecee7ecd$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bb96d1dfff516b8f$exports))),
        city: 'lyon'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($07d45924db81358b$exports))),
        city: 'london'
    }
];
const $45ed955dd045a702$export$fe1003df9da4792 = [
    $45ed955dd045a702$var$oleshky,
    $45ed955dd045a702$var$noRoadOut,
    $45ed955dd045a702$var$oleshkyStopDroneSiege,
    $45ed955dd045a702$var$stopDroneSiege,
    $45ed955dd045a702$var$oleshky2
];



var $3e86fa75c8e516f2$exports = {};
$3e86fa75c8e516f2$exports = import.meta.resolve("8ZT2M");


var $3e6aeae198f5bf6e$exports = {};
$3e6aeae198f5bf6e$exports = import.meta.resolve("5a3d1");


var $7ae1a22645765d2a$exports = {};
$7ae1a22645765d2a$exports = import.meta.resolve("aV6hu");


var $52a9ce5f89cb22b7$exports = {};
$52a9ce5f89cb22b7$exports = import.meta.resolve("blyYe");


var $e3d6f0c7ffb9765f$exports = {};
$e3d6f0c7ffb9765f$exports = import.meta.resolve("3oLI5");


var $e5d457b64fde2e2d$exports = {};
$e5d457b64fde2e2d$exports = import.meta.resolve("eP49d");


var $fe529666afeee9b1$exports = {};
$fe529666afeee9b1$exports = import.meta.resolve("ia91l");


var $726634890d72db15$exports = {};
$726634890d72db15$exports = import.meta.resolve("61aTo");


var $32a81dcf5333d7d6$exports = {};
$32a81dcf5333d7d6$exports = import.meta.resolve("8yFCw");


var $0fe04965a63f2c3e$exports = {};
$0fe04965a63f2c3e$exports = import.meta.resolve("7d8Yh");


var $3d6fe441350c8bdc$exports = {};
$3d6fe441350c8bdc$exports = import.meta.resolve("e4Slf");


var $a3709e89e2adec9f$exports = {};
$a3709e89e2adec9f$exports = import.meta.resolve("lXc1U");


var $d79c5404b1d61fa6$exports = {};
$d79c5404b1d61fa6$exports = import.meta.resolve("75QuG");


var $47671070605c27a4$exports = {};
$47671070605c27a4$exports = import.meta.resolve("8kja1");


var $dc90db171d17cb59$exports = {};
$dc90db171d17cb59$exports = import.meta.resolve("l9YeJ");


var $0d871627f7a3d3d8$exports = {};
$0d871627f7a3d3d8$exports = import.meta.resolve("2nLsm");


var $123042f01ac92ef4$exports = {};
$123042f01ac92ef4$exports = import.meta.resolve("j3TaF");


var $d83683c12e56b2a0$exports = {};
$d83683c12e56b2a0$exports = import.meta.resolve("2dIMx");


var $3d5d81a0f1c6bbef$exports = {};
$3d5d81a0f1c6bbef$exports = import.meta.resolve("bFuSK");


var $4e46bca308580bae$exports = {};
$4e46bca308580bae$exports = import.meta.resolve("iMbZz");


var $f9169e900bfc8c19$exports = {};
$f9169e900bfc8c19$exports = import.meta.resolve("4gqQg");


var $13d1230ba13e822d$exports = {};
$13d1230ba13e822d$exports = import.meta.resolve("bzvaI");


var $04db79e38871018a$exports = {};
$04db79e38871018a$exports = import.meta.resolve("8XIcM");


var $8a0cf1fc50398b6c$exports = {};
$8a0cf1fc50398b6c$exports = import.meta.resolve("893jw");


var $70fe278e4f3cdd5f$exports = {};
$70fe278e4f3cdd5f$exports = import.meta.resolve("99Lmq");


var $ab6d846e8e3f47d6$exports = {};
$ab6d846e8e3f47d6$exports = import.meta.resolve("cL9p3");


var $08ab8d01dfda1252$exports = {};
$08ab8d01dfda1252$exports = import.meta.resolve("kN2gf");


var $3a7772c051aba660$exports = {};
$3a7772c051aba660$exports = import.meta.resolve("2gqOs");


var $c4991fe9ee44b449$exports = {};
$c4991fe9ee44b449$exports = import.meta.resolve("3q2WB");


var $351f7dda37f4fc3d$exports = {};
$351f7dda37f4fc3d$exports = import.meta.resolve("zj4N0");


var $52a61a81d85736e7$exports = {};
$52a61a81d85736e7$exports = import.meta.resolve("cQcrB");


var $be525c2bda171991$exports = {};
$be525c2bda171991$exports = import.meta.resolve("ACZZI");


var $5d43083ac7a798d9$exports = {};
$5d43083ac7a798d9$exports = import.meta.resolve("bcdXQ");


var $9feddf01e0ea352f$exports = {};
$9feddf01e0ea352f$exports = import.meta.resolve("emsku");


var $02c7e7c31577e643$exports = {};
$02c7e7c31577e643$exports = import.meta.resolve("5fY25");


var $71eac074937ee6b5$exports = {};
$71eac074937ee6b5$exports = import.meta.resolve("acv3Y");


var $016b5ca8da8d7be6$exports = {};
$016b5ca8da8d7be6$exports = import.meta.resolve("deoKR");


var $cdb4a9b345f3bc7c$exports = {};
$cdb4a9b345f3bc7c$exports = import.meta.resolve("8uLI8");


var $bf01f1704ace6106$exports = {};
$bf01f1704ace6106$exports = import.meta.resolve("hSH2H");


var $6ef96ea72a216921$exports = {};
$6ef96ea72a216921$exports = import.meta.resolve("k2pR1");


var $5fef89497fa9211c$exports = {};
$5fef89497fa9211c$exports = import.meta.resolve("2GiEO");


var $7f3c928d8bdf3da5$exports = {};
$7f3c928d8bdf3da5$exports = import.meta.resolve("16pIp");


var $ca490ba21ff24ee4$exports = {};
$ca490ba21ff24ee4$exports = import.meta.resolve("2Cazj");


var $66d2d0bc87da7b36$exports = {};
$66d2d0bc87da7b36$exports = import.meta.resolve("19FFR");


var $d3f0edaa40f00ada$exports = {};
$d3f0edaa40f00ada$exports = import.meta.resolve("eoL9R");


var $63a675386c001f3d$exports = {};
$63a675386c001f3d$exports = import.meta.resolve("gm5DV");


var $136f4f912be866c5$exports = {};
$136f4f912be866c5$exports = import.meta.resolve("7rFSS");


var $c595d8bfcec9c65d$exports = {};
$c595d8bfcec9c65d$exports = import.meta.resolve("kB0LV");


var $e749f182d4cc2a8f$exports = {};
$e749f182d4cc2a8f$exports = import.meta.resolve("1aor5");


var $62a30361f774bf66$exports = {};
$62a30361f774bf66$exports = import.meta.resolve("luJq8");


var $9b905f2a12dd149b$exports = {};
$9b905f2a12dd149b$exports = import.meta.resolve("c91yv");


var $ac91e4be9589eaf8$exports = {};
$ac91e4be9589eaf8$exports = import.meta.resolve("kmA4q");


var $251b73ac0c4ecf9d$exports = {};
$251b73ac0c4ecf9d$exports = import.meta.resolve("haJlb");


var $b09bb55c44623781$exports = {};
$b09bb55c44623781$exports = import.meta.resolve("ccRM5");


var $2fe65b12ef04b0c7$exports = {};
$2fe65b12ef04b0c7$exports = import.meta.resolve("g7fFp");


var $6124084f3f3f6b29$exports = {};
$6124084f3f3f6b29$exports = import.meta.resolve("eUs8R");


var $e87f0fea544e9e9c$exports = {};
$e87f0fea544e9e9c$exports = import.meta.resolve("e9U5n");


var $bf655e8d28cee71a$exports = {};
$bf655e8d28cee71a$exports = import.meta.resolve("hysYy");


var $82d1d4055e5fc142$exports = {};
$82d1d4055e5fc142$exports = import.meta.resolve("RgTBn");


var $801a02b48faf3230$exports = {};
$801a02b48faf3230$exports = import.meta.resolve("15ke8");


var $7dcdb945b5192734$exports = {};
$7dcdb945b5192734$exports = import.meta.resolve("5xJPg");


var $c3d9accb6d385881$exports = {};
$c3d9accb6d385881$exports = import.meta.resolve("7eTVS");


var $079e13091b48c6be$exports = {};
$079e13091b48c6be$exports = import.meta.resolve("a2SuP");


var $2e1ebdecd380f6a3$exports = {};
$2e1ebdecd380f6a3$exports = import.meta.resolve("7kikD");


var $af5e8f2bf9ab8f6a$exports = {};
$af5e8f2bf9ab8f6a$exports = import.meta.resolve("9EuLT");


var $79716a39e253706e$exports = {};
$79716a39e253706e$exports = import.meta.resolve("8ee9n");


var $4b09253953d9b4f9$exports = {};
$4b09253953d9b4f9$exports = import.meta.resolve("dkNQn");


var $adb1b934d454631b$exports = {};
$adb1b934d454631b$exports = import.meta.resolve("dAa3p");


var $2bf4c19cb31861c2$exports = {};
$2bf4c19cb31861c2$exports = import.meta.resolve("cwwgh");


var $73b730d01bdb849f$exports = {};
$73b730d01bdb849f$exports = import.meta.resolve("54xOy");


var $a29ab15e9c7f9209$exports = {};
$a29ab15e9c7f9209$exports = import.meta.resolve("lS4fm");


var $11c886eb8f08a10e$exports = {};
$11c886eb8f08a10e$exports = import.meta.resolve("bOdkd");


var $39ca68cdae3e7d4d$exports = {};
$39ca68cdae3e7d4d$exports = import.meta.resolve("hwcEw");


var $a4a6ceeed3efd43b$exports = {};
$a4a6ceeed3efd43b$exports = import.meta.resolve("lPe1x");


var $fdd64da1169b7712$exports = {};
$fdd64da1169b7712$exports = import.meta.resolve("4boeu");


var $a12f0c972f70b368$exports = {};
$a12f0c972f70b368$exports = import.meta.resolve("bxhT4");


var $458548afe3cac40e$exports = {};
$458548afe3cac40e$exports = import.meta.resolve("gplUc");


var $cd962b4c401eb967$exports = {};
$cd962b4c401eb967$exports = import.meta.resolve("2ffGq");


var $1d6547e55bddf7b5$exports = {};
$1d6547e55bddf7b5$exports = import.meta.resolve("kTyIY");


var $4212d7d9db3752db$exports = {};
$4212d7d9db3752db$exports = import.meta.resolve("jxam7");


var $849895a3746fbb1e$exports = {};
$849895a3746fbb1e$exports = import.meta.resolve("27Jww");


var $75d8daa45221738b$exports = {};
$75d8daa45221738b$exports = import.meta.resolve("ftd2W");


var $3e000232797c586c$exports = {};
$3e000232797c586c$exports = import.meta.resolve("ia89N");


var $056fed3b24e18ea2$exports = {};
$056fed3b24e18ea2$exports = import.meta.resolve("aESb8");


var $5d605b90cfb193ff$exports = {};
$5d605b90cfb193ff$exports = import.meta.resolve("3q6pV");


var $d07238e389b74c1c$exports = {};
$d07238e389b74c1c$exports = import.meta.resolve("48wQb");


var $6fbcc01b80e7e3d5$exports = {};
$6fbcc01b80e7e3d5$exports = import.meta.resolve("1v0ns");


var $17fa1fea8e5448d6$exports = {};
$17fa1fea8e5448d6$exports = import.meta.resolve("8hSBK");


var $a6c5c6030258797c$exports = {};
$a6c5c6030258797c$exports = import.meta.resolve("3pFFA");


var $37210cee733ee54c$exports = {};
$37210cee733ee54c$exports = import.meta.resolve("bTjMa");


var $fc1c6799e61d583b$exports = {};
$fc1c6799e61d583b$exports = import.meta.resolve("2RvxW");


var $bfaeeea074610037$exports = {};
$bfaeeea074610037$exports = import.meta.resolve("zqNhh");


var $a62ea2b9e170a511$exports = {};
$a62ea2b9e170a511$exports = import.meta.resolve("gzTrq");


var $393a9c66e8ed73aa$exports = {};
$393a9c66e8ed73aa$exports = import.meta.resolve("ckbXO");


var $ef4f15f96ae4b302$exports = {};
$ef4f15f96ae4b302$exports = import.meta.resolve("1hfWZ");


var $a2bae93bd2686991$exports = {};
$a2bae93bd2686991$exports = import.meta.resolve("eIdhJ");


var $7cb1c24bd5b73386$exports = {};
$7cb1c24bd5b73386$exports = import.meta.resolve("ez17T");


var $7f0461dd2ef43c5f$exports = {};
$7f0461dd2ef43c5f$exports = import.meta.resolve("8UDfd");


var $7127f75feaadb246$exports = {};
$7127f75feaadb246$exports = import.meta.resolve("77EaE");


var $7f40e68f5c7474f3$exports = {};
$7f40e68f5c7474f3$exports = import.meta.resolve("3eTnB");


var $c09440e63b1d0107$exports = {};
$c09440e63b1d0107$exports = import.meta.resolve("60phY");


var $383dabd7efccb7ba$exports = {};
$383dabd7efccb7ba$exports = import.meta.resolve("kXzAS");


var $2445ae22f53a948d$exports = {};
$2445ae22f53a948d$exports = import.meta.resolve("jumNP");


var $9f413f9263aaebc6$exports = {};
$9f413f9263aaebc6$exports = import.meta.resolve("fS54c");


var $6b0d5629568a2ca0$exports = {};
$6b0d5629568a2ca0$exports = import.meta.resolve("7w9GY");


var $09a6f4d9eca25f9f$exports = {};
$09a6f4d9eca25f9f$exports = import.meta.resolve("oCCyG");


var $23b6ee05355c621b$exports = {};
$23b6ee05355c621b$exports = import.meta.resolve("cnwFc");


var $c71c23592c194730$exports = {};
$c71c23592c194730$exports = import.meta.resolve("lFzUG");


var $504f3259ec7a67ad$exports = {};
$504f3259ec7a67ad$exports = import.meta.resolve("hOJmX");


var $735e6d0aaf1e2191$exports = {};
$735e6d0aaf1e2191$exports = import.meta.resolve("l75Ft");


var $c78d9b037734718c$exports = {};
$c78d9b037734718c$exports = import.meta.resolve("bT9yg");


var $85d5b071926f0996$exports = {};
$85d5b071926f0996$exports = import.meta.resolve("asutR");


var $31a8bd6d6a07d971$exports = {};
$31a8bd6d6a07d971$exports = import.meta.resolve("d9X2A");


var $4b299a381370dd11$exports = {};
$4b299a381370dd11$exports = import.meta.resolve("4qnR6");


var $fed424c1ffa09299$exports = {};
$fed424c1ffa09299$exports = import.meta.resolve("kHOoq");


var $32f8abe8e612320e$exports = {};
$32f8abe8e612320e$exports = import.meta.resolve("jG6Fk");


var $6393bccbfdd11837$exports = {};
$6393bccbfdd11837$exports = import.meta.resolve("4ICA9");


var $7aab18dbae4a08d6$exports = {};
$7aab18dbae4a08d6$exports = import.meta.resolve("fD7bl");


// Photos from the October 2026 Oleshky demos (/oleshky). `link` shows as a small icon next to the city name.
// Shown in random order, like the December 2025 gallery, with photos from the same city kept apart.
const $718431ec8bf53c72$var$photos = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3e86fa75c8e516f2$exports))),
        city: 'sydney',
        link: 'https://www.facebook.com/groups/591069340942727'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3e6aeae198f5bf6e$exports))),
        city: 'paris',
        link: 'https://www.facebook.com/uniondesukrainiensdefrance'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ae1a22645765d2a$exports))),
        city: 'paris',
        link: 'https://www.facebook.com/uniondesukrainiensdefrance'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($52a9ce5f89cb22b7$exports))),
        city: 'parisSep30',
        link: 'https://www.facebook.com/uniondesukrainiensdefrance'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e3d6f0c7ffb9765f$exports))),
        city: 'parisSep30',
        link: 'https://www.facebook.com/uniondesukrainiensdefrance'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5d457b64fde2e2d$exports))),
        city: 'parisSep30',
        link: 'https://www.facebook.com/uniondesukrainiensdefrance'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fe529666afeee9b1$exports))),
        city: 'manchester',
        link: 'https://www.instagram.com/mcrstandswithua/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($726634890d72db15$exports))),
        city: 'manchester',
        link: 'https://www.instagram.com/mcrstandswithua/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($32a81dcf5333d7d6$exports))),
        city: 'manchester',
        link: 'https://www.instagram.com/mcrstandswithua/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fe04965a63f2c3e$exports))),
        city: 'lyon',
        link: 'https://liberteua.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3d6fe441350c8bdc$exports))),
        city: 'lyon',
        link: 'https://liberteua.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a3709e89e2adec9f$exports))),
        city: 'lyon',
        link: 'https://liberteua.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d79c5404b1d61fa6$exports))),
        city: 'lyon',
        link: 'https://liberteua.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($47671070605c27a4$exports))),
        city: 'lyon',
        link: 'https://liberteua.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dc90db171d17cb59$exports))),
        city: 'lyon',
        link: 'https://liberteua.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0d871627f7a3d3d8$exports))),
        city: 'edinburgh',
        link: 'https://www.ukrainianvictorycampaign.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($123042f01ac92ef4$exports))),
        city: 'edinburgh',
        link: 'https://www.ukrainianvictorycampaign.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d83683c12e56b2a0$exports))),
        city: 'edinburgh',
        link: 'https://www.ukrainianvictorycampaign.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3d5d81a0f1c6bbef$exports))),
        city: 'edinburgh',
        link: 'https://www.ukrainianvictorycampaign.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4e46bca308580bae$exports))),
        city: 'edinburgh',
        link: 'https://www.ukrainianvictorycampaign.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f9169e900bfc8c19$exports))),
        city: 'edinburgh',
        link: 'https://www.ukrainianvictorycampaign.com/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($13d1230ba13e822d$exports))),
        city: 'brussels',
        link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($04db79e38871018a$exports))),
        city: 'brussels',
        link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a0cf1fc50398b6c$exports))),
        city: 'brussels',
        link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70fe278e4f3cdd5f$exports))),
        city: 'brussels',
        link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ab6d846e8e3f47d6$exports))),
        city: 'brussels',
        link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($08ab8d01dfda1252$exports))),
        city: 'brussels',
        link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3a7772c051aba660$exports))),
        city: 'london',
        link: 'https://www.instagram.com/p/DdrmhWyscPX/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c4991fe9ee44b449$exports))),
        city: 'london',
        link: 'https://www.instagram.com/p/DdrmhWyscPX/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($351f7dda37f4fc3d$exports))),
        city: 'london',
        link: 'https://www.instagram.com/p/DdrmhWyscPX/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($52a61a81d85736e7$exports))),
        city: 'london',
        link: 'https://www.instagram.com/p/DdrmhWyscPX/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($be525c2bda171991$exports))),
        city: 'londonSep29',
        link: 'https://www.instagram.com/kartonky.london/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5d43083ac7a798d9$exports))),
        city: 'londonOct1',
        link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf01f1704ace6106$exports))),
        city: 'vienna',
        link: 'https://www.instagram.com/p/DdrVBDXiIJE/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6ef96ea72a216921$exports))),
        city: 'vienna',
        link: 'https://www.instagram.com/p/DdrVBDXiIJE/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fef89497fa9211c$exports))),
        city: 'vienna',
        link: 'https://www.instagram.com/p/DdrVBDXiIJE/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f3c928d8bdf3da5$exports))),
        city: 'vienna',
        link: 'https://www.instagram.com/p/DdrVBDXiIJE/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ca490ba21ff24ee4$exports))),
        city: 'vienna',
        link: 'https://www.instagram.com/p/DdrVBDXiIJE/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66d2d0bc87da7b36$exports))),
        city: 'gdansk',
        link: 'https://www.instagram.com/zjednoczeni_gdansk/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d3f0edaa40f00ada$exports))),
        city: 'gdansk',
        link: 'https://www.instagram.com/zjednoczeni_gdansk/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($63a675386c001f3d$exports))),
        city: 'gdansk',
        link: 'https://www.instagram.com/zjednoczeni_gdansk/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($136f4f912be866c5$exports))),
        city: 'gdansk',
        link: 'https://www.instagram.com/zjednoczeni_gdansk/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c595d8bfcec9c65d$exports))),
        city: 'gdansk',
        link: 'https://www.instagram.com/zjednoczeni_gdansk/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e749f182d4cc2a8f$exports))),
        city: 'gdansk',
        link: 'https://www.instagram.com/zjednoczeni_gdansk/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62a30361f774bf66$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9b905f2a12dd149b$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac91e4be9589eaf8$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($251b73ac0c4ecf9d$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b09bb55c44623781$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2fe65b12ef04b0c7$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6124084f3f3f6b29$exports))),
        city: 'budapest',
        link: 'https://www.facebook.com/events/786615894546731/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e87f0fea544e9e9c$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf655e8d28cee71a$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($82d1d4055e5fc142$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($801a02b48faf3230$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7dcdb945b5192734$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3d9accb6d385881$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($079e13091b48c6be$exports))),
        city: 'munich',
        link: 'https://www.instagram.com/p/DdbrQbKDazu/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2e1ebdecd380f6a3$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af5e8f2bf9ab8f6a$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($79716a39e253706e$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4b09253953d9b4f9$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($adb1b934d454631b$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bf4c19cb31861c2$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($73b730d01bdb849f$exports))),
        city: 'ottawa',
        link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a29ab15e9c7f9209$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($11c886eb8f08a10e$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($39ca68cdae3e7d4d$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a4a6ceeed3efd43b$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fdd64da1169b7712$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a12f0c972f70b368$exports))),
        city: 'birmingham'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($75d8daa45221738b$exports))),
        city: 'hamburg',
        link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3e000232797c586c$exports))),
        city: 'hamburg',
        link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($056fed3b24e18ea2$exports))),
        city: 'hamburg',
        link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5d605b90cfb193ff$exports))),
        city: 'hamburg',
        link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d07238e389b74c1c$exports))),
        city: 'hamburg',
        link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6fbcc01b80e7e3d5$exports))),
        city: 'hamburg',
        link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($17fa1fea8e5448d6$exports))),
        city: 'chicagoOct4',
        link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a6c5c6030258797c$exports))),
        city: 'chicagoOct4',
        link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($37210cee733ee54c$exports))),
        city: 'chicagoOct4',
        link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fc1c6799e61d583b$exports))),
        city: 'chicagoOct4',
        link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bfaeeea074610037$exports))),
        city: 'chicagoOct4',
        link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a62ea2b9e170a511$exports))),
        city: 'malaga',
        link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($393a9c66e8ed73aa$exports))),
        city: 'malaga',
        link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ef4f15f96ae4b302$exports))),
        city: 'malaga',
        link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a2bae93bd2686991$exports))),
        city: 'malaga',
        link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7cb1c24bd5b73386$exports))),
        city: 'malaga',
        link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f0461dd2ef43c5f$exports))),
        city: 'malaga',
        link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7127f75feaadb246$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f40e68f5c7474f3$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c09440e63b1d0107$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($383dabd7efccb7ba$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2445ae22f53a948d$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9f413f9263aaebc6$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6b0d5629568a2ca0$exports))),
        city: 'plovdiv',
        link: 'https://www.facebook.com/events/1129021009797960/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($09a6f4d9eca25f9f$exports))),
        city: 'nantes',
        link: 'https://www.facebook.com/events/1140799082236549'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($23b6ee05355c621b$exports))),
        city: 'nantes',
        link: 'https://www.facebook.com/events/1140799082236549'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c71c23592c194730$exports))),
        city: 'nantes',
        link: 'https://www.facebook.com/events/1140799082236549'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($504f3259ec7a67ad$exports))),
        city: 'nantes',
        link: 'https://www.facebook.com/events/1140799082236549'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($735e6d0aaf1e2191$exports))),
        city: 'nantes',
        link: 'https://www.facebook.com/events/1140799082236549'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c78d9b037734718c$exports))),
        city: 'nantes',
        link: 'https://www.facebook.com/events/1140799082236549'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($85d5b071926f0996$exports))),
        city: 'dublin',
        link: 'https://www.instagram.com/p/Ddw3XcVuHit/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($31a8bd6d6a07d971$exports))),
        city: 'dublin',
        link: 'https://www.instagram.com/p/Ddw3XcVuHit/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4b299a381370dd11$exports))),
        city: 'oslo'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fed424c1ffa09299$exports))),
        city: 'oslo'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($32f8abe8e612320e$exports))),
        city: 'oslo'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6393bccbfdd11837$exports))),
        city: 'oslo'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7aab18dbae4a08d6$exports))),
        city: 'oslo'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9feddf01e0ea352f$exports))),
        city: 'londonSep29',
        link: 'https://www.instagram.com/kartonky.london/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($02c7e7c31577e643$exports))),
        city: 'londonOct3',
        link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($71eac074937ee6b5$exports))),
        city: 'londonOct3',
        link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($016b5ca8da8d7be6$exports))),
        city: 'londonOct3',
        link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cdb4a9b345f3bc7c$exports))),
        city: 'londonOct3',
        link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($458548afe3cac40e$exports))),
        city: 'leipzig'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cd962b4c401eb967$exports))),
        city: 'leipzig'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1d6547e55bddf7b5$exports))),
        city: 'leipzig'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4212d7d9db3752db$exports))),
        city: 'leipzig'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($849895a3746fbb1e$exports))),
        city: 'leipzig'
    }
];
// First row (shown before "see more"), always in this order; then the rest in random order; then the
// photos that always go last. Photos in `hiddenSrcs` aren't shown (the files are kept).
const $718431ec8bf53c72$var$firstRowSrcs = [
    (0, (/*@__PURE__*/$parcel$interopDefault($d83683c12e56b2a0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fed424c1ffa09299$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($66d2d0bc87da7b36$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($31a8bd6d6a07d971$exports)))
];
const $718431ec8bf53c72$var$lastSrcs = [];
const $718431ec8bf53c72$var$hiddenSrcs = [
    (0, (/*@__PURE__*/$parcel$interopDefault($7ae1a22645765d2a$exports)))
];
const $718431ec8bf53c72$var$shown = $718431ec8bf53c72$var$photos.filter((photo)=>!$718431ec8bf53c72$var$hiddenSrcs.includes(photo.src));
const $718431ec8bf53c72$var$firstRow = $718431ec8bf53c72$var$firstRowSrcs.flatMap((src)=>$718431ec8bf53c72$var$shown.filter((photo)=>photo.src === src));
// the city without a date suffix (londonSep29 -> london), so photos from different days of the
// same city are kept apart too
const $718431ec8bf53c72$var$baseCity = (city)=>city.replace(/(Sep|Oct)\d+$/, '');
const $718431ec8bf53c72$export$922418035ff6c3f8 = [
    ...$718431ec8bf53c72$var$firstRow,
    ...(0, $08f6df7db6f8e162$export$aeac9af295f08eee)($718431ec8bf53c72$var$shown.filter((photo)=>!$718431ec8bf53c72$var$firstRowSrcs.includes(photo.src) && !$718431ec8bf53c72$var$lastSrcs.includes(photo.src)), (photo)=>$718431ec8bf53c72$var$baseCity(photo.city), $718431ec8bf53c72$var$baseCity($718431ec8bf53c72$var$firstRow[$718431ec8bf53c72$var$firstRow.length - 1].city)),
    ...$718431ec8bf53c72$var$shown.filter((photo)=>$718431ec8bf53c72$var$lastSrcs.includes(photo.src))
];



const $83d2be3c4829d3b5$export$767269638e142e2e = {
    host: 'vimeo',
    id: '1238705872',
    fallback: {
        host: 'drive',
        id: '1QF5OpHV7AzPNfODDbjmADQKd3MsUUZqg'
    }
};
const $83d2be3c4829d3b5$export$f33c501800aa1c3c = [
    {
        i18n: true,
        title: 'leftBank.documentaryTitle',
        links: [],
        video: $83d2be3c4829d3b5$export$767269638e142e2e
    },
    {
        title: 'New York Times',
        links: [
            {
                label: 'Trapped in a Kill Zone, a Ukrainian City Is Beginning to Starve',
                href: 'https://www.nytimes.com/2026/10/05/world/europe/oleshky-ukraine-russia-war-food.html',
                date: '05/10/2026'
            }
        ]
    },
    {
        title: 'Desk Russie',
        links: [
            {
                label: "La ville prise en otage. Olechky l\u2019insoumise, c\u2019est l\u2019Ukraine !",
                href: 'https://desk-russie.eu/2026/10/04/la-ville-prise-en-otage-olechky-linsoumise-cest-lukraine.html',
                date: '04/10/2026'
            }
        ]
    },
    {
        title: 'UK Government (OSCE)',
        links: [
            {
                label: 'Humanitarian situation in Oleshky: UK statement to the OSCE',
                href: 'https://www.gov.uk/government/speeches/humanitarian-situation-in-oleshky-uk-statement-to-the-osce',
                date: '02/10/2026'
            }
        ]
    },
    {
        title: 'CEPA',
        links: [
            {
                label: "Russia: A Menu of Death in Ukraine\u2019s Small Towns",
                href: 'https://cepa.org/article/russia-a-menu-of-death-in-ukraines-small-towns/',
                date: '01/10/2026'
            }
        ]
    },
    {
        title: 'France 2 / franceinfo',
        links: [
            {
                label: '"Il y a des gens qui meurent tout simplement de faim" : Olechky, une ville ukrainienne au bord de la famine',
                href: 'https://www.franceinfo.fr/monde/europe/manifestations-en-ukraine/il-y-a-des-gens-qui-meurent-tout-simplement-de-faim-oleshky-une-ville-ukrainienne-au-bord-de-la-famine_8216992.html',
                date: '30/09/2026'
            }
        ]
    },
    {
        title: 'Holodomor Museum',
        links: [
            {
                label: 'Statement on the humanitarian situation in the temporarily occupied town of Oleshky',
                href: 'https://holodomormuseum.org.ua/en/novyny/statement-on-the-humanitarian-situation-in-the-temporarily-occupied-town-of-oleshky-and-adjacent-territorial-communities-in-kherson-region/',
                date: '15/09/2026'
            }
        ]
    },
    {
        title: 'BBC',
        links: [
            {
                label: 'Eating garden weeds to survive in Russian-occupied city cut off from food and water',
                href: 'https://www.bbc.com/news/articles/c60qxywdx4vvo',
                date: '23/09/2026'
            }
        ]
    },
    {
        title: 'DW',
        links: [
            {
                label: 'Ukraine-Krieg: Warnung vor Hungersnot in Oleschky',
                href: 'https://www.dw.com/de/ukraine-krieg-warnung-vor-hungersnot-in-oleschky/a-79366794',
                date: '23/09/2026'
            }
        ]
    },
    {
        title: 'ABC News',
        links: [
            {
                label: "'The blockade is complete': Locals flee occupied south Ukraine as hunger deepens",
                href: 'https://abcnews.com/International/horror-movie-ukraines-oleshky-faces-catastrophe-russian-occupation/story?id=136685568',
                date: '25/09/2026'
            }
        ]
    },
    {
        title: 'Council of Europe Commissioner for Human Rights',
        links: [
            {
                label: 'Ukraine: the rapidly deteriorating humanitarian crisis in Oleshky demands attention and action',
                href: 'https://www.coe.int/it/web/commissioner/-/ukraine-the-rapidly-deteriorating-humanitarian-crisis-in-oleshky-demands-attention-and-action'
            }
        ]
    },
    {
        i18n: true,
        title: 'leftBank.meidasTitle',
        links: [
            {
                label: 'leftBank.meidasVideo',
                href: 'https://www.youtube.com/watch?v=cl56_G0irSY',
                date: '26/06/2026'
            },
            {
                label: 'leftBank.meidasArticle',
                href: 'https://www.meidasplus.com/p/the-kherson-region-how-russia-uses',
                date: '02/07/2026'
            }
        ]
    },
    {
        i18n: true,
        title: 'leftBank.kyivPostTitle',
        links: [
            {
                label: 'leftBank.kyivPostArticle',
                href: 'https://www.kyivpost.com/post/79055',
                date: '26/06/2026'
            }
        ]
    },
    {
        title: 'Euromaidan Press',
        links: [
            {
                label: "Mined in, starved out, hunted from above\u2014life in the towns Russia demands at the peace table",
                href: 'https://euromaidanpress.com/2026/03/16/mined-in-starved-out-hunted-from-above-life-in-the-towns-russia-demands-at-the-peace-table/',
                date: '16/03/2026'
            }
        ]
    },
    {
        title: 'Meidas Touch',
        links: [
            {
                label: 'Besieged Oleshki: Humanitarian Collapse Under Russian Control',
                href: 'https://www.meidasplus.com/p/besieged-oleshki-humanitarian-collapse',
                date: '26/03/2026'
            }
        ]
    },
    {
        title: 'Jake Broe Show',
        links: [
            {
                label: 'Zarina Zabrisky: The Russian Occupation Crisis | Jake Broe Podcast (E044)',
                href: 'https://www.youtube.com/watch?v=oJGCtjcU9iw',
                date: '11/04/2026'
            }
        ]
    },
    {
        title: 'Kyiv Independent',
        links: [
            {
                label: "Nearly 2,000 Ukrainian civilians trapped in Russian-occupied Kherson Oblast town facing 'humanitarian catastrophe'",
                href: 'https://kyivindependent.com/humanitarian-catastrophe-nearly-2-000-ukrainian-civilians-trapped-in-russian-occupied-oleshky-with-no-way-to-evacuate-little-food/',
                date: '15/04/2026'
            }
        ]
    },
    {
        title: "BILD / Julian R\xf6pcke",
        links: [
            {
                label: 'Putins Besatzer nehmen ganze Stadt als Geisel',
                href: 'https://www.bild.de/politik/ausland-und-internationales/putins-besatzer-nehmen-ganze-stadt-als-geisel-menschen-werden-zu-schutzschilden-69e233c8dc420b7f69a88bc8',
                date: '19/04/2026'
            }
        ]
    },
    {
        title: 'Deutsche Welle',
        links: [
            {
                label: 'Hunger in Oleshky: Ukraine asks for evacuation',
                href: 'https://www.dw.com/en/hunger-in-oleshky-ukraine-asks-for-evacuation/a-77395744',
                date: '06/06/2026'
            }
        ]
    },
    {
        title: 'The Times',
        links: [
            {
                label: "Four years of horror in Ukraine's \u2018forgotten Bucha\u2019",
                href: 'https://www.thetimes.com/world/russia-ukraine-war/article/four-years-horror-ukraine-war-oleshky-bucha-2wqk036cd',
                date: '18/06/2026'
            }
        ]
    }
];



const $64eb78d2855f6aef$var$dec = {
    monthKey: 'home.december',
    monthShortKey: 'home.dec'
};
const $64eb78d2855f6aef$export$90f7fc6f788ba308 = {
    id: 'december2025',
    path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).action.path,
    i18n: 'home',
    citiesI18n: 'cities',
    hashtags: '#HumansAreNotTargets #StopHumanSafari #SaveKherson',
    infoKeys: [
        'home.infoText'
    ],
    image: (0, (/*@__PURE__*/$parcel$interopDefault($a5362d704e65c175$exports))),
    cities: (0, $755bfc0689a8b67c$export$f03f7c19d8f50e16),
    days: [
        {
            dayKey: 'schedule11',
            ...$64eb78d2855f6aef$var$dec,
            cities: (0, $755bfc0689a8b67c$export$defa5e4142b28eea)
        },
        {
            dayKey: 'schedule12',
            ...$64eb78d2855f6aef$var$dec,
            cities: (0, $755bfc0689a8b67c$export$d677a69846a6f688)
        },
        {
            dayKey: 'schedule13',
            ...$64eb78d2855f6aef$var$dec,
            cities: (0, $755bfc0689a8b67c$export$35b3abc391b9abc9)
        },
        {
            dayKey: 'schedule14',
            ...$64eb78d2855f6aef$var$dec,
            cities: (0, $755bfc0689a8b67c$export$5bdf90b049d46ef4)
        },
        {
            dayKey: 'schedule16',
            ...$64eb78d2855f6aef$var$dec,
            cities: (0, $755bfc0689a8b67c$export$ac930b69ddcd481c)
        },
        {
            dayKey: 'schedule20',
            ...$64eb78d2855f6aef$var$dec,
            cities: (0, $755bfc0689a8b67c$export$a76370ba1e8be322)
        }
    ],
    photos: (0, $b06743023139191a$export$ee5f96e597047257),
    posters: (0, $755bfc0689a8b67c$export$6c746a5570b8b35c)
};
const $64eb78d2855f6aef$export$67f75aef892f4e8c = {
    id: 'oleshky2026',
    path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).oleshky.path,
    i18n: 'rallies.oleshky2026',
    citiesI18n: 'rallies.oleshky2026.cities',
    hashtags: '#StopDroneSiege #SaveOleshky #SafePassageNow',
    infoKeys: [
        'rallies.oleshky2026.infoText1',
        'rallies.oleshky2026.infoText2'
    ],
    image: (0, (/*@__PURE__*/$parcel$interopDefault($ebd42efdf2b1dab9$exports))),
    imageAltKey: 'rallies.oleshky2026.imageAlt',
    video: (0, $83d2be3c4829d3b5$export$767269638e142e2e),
    cities: {
        edinburgh: {
            country: 'unitedKingdom',
            name: 'Edinburgh',
            link: 'https://www.instagram.com/p/DdpegPvM4yD/'
        },
        birmingham: {
            country: 'unitedKingdom',
            name: 'Birmingham',
            link: ''
        },
        gdansk: {
            country: 'poland',
            name: "Gda\u0144sk",
            link: 'https://www.instagram.com/zjednoczeni_gdansk/'
        },
        nantes: {
            country: 'france',
            name: 'Nantes',
            link: 'https://www.facebook.com/events/1140799082236549'
        },
        nantesOct31: {
            country: 'france',
            name: 'Nantes',
            link: 'https://www.facebook.com/events/1140799082236549'
        },
        ottawa: {
            country: 'canada',
            name: 'Ottawa',
            link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/'
        },
        budapest: {
            country: 'hungary',
            name: 'Budapest',
            link: 'https://www.facebook.com/events/786615894546731/'
        },
        oslo: {
            country: 'norway',
            name: 'Oslo',
            link: ''
        },
        leipzig: {
            country: 'germany',
            name: 'Leipzig',
            link: ''
        },
        kiel: {
            country: 'germany',
            name: 'Kiel',
            link: 'https://www.instagram.com/p/Dd8xS2eN8TJ/'
        },
        hamburg: {
            country: 'germany',
            name: 'Hamburg',
            link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655'
        },
        plovdiv: {
            country: 'bulgaria',
            name: 'Plovdiv',
            link: 'https://www.facebook.com/events/1129021009797960/'
        },
        malaga: {
            country: 'spain',
            name: "M\xe1laga",
            link: 'https://www.instagram.com/p/Dd3f_mANd8F/'
        },
        dresden: {
            country: 'germany',
            name: 'Dresden',
            link: 'https://www.instagram.com/p/Dd3TSa3itOw/'
        },
        chicago: {
            country: 'usa',
            name: 'Chicago',
            link: 'https://www.instagram.com/p/DdrsY54hYnK/'
        },
        chicagoOct4: {
            country: 'usa',
            name: 'Chicago',
            link: 'https://www.instagram.com/p/Dd22g_4RXi5/'
        },
        chicagoOct11: {
            country: 'usa',
            name: 'Chicago',
            link: 'https://www.instagram.com/p/DdrsY54hYnK/'
        },
        chicagoOct18: {
            country: 'usa',
            name: 'Chicago',
            link: 'https://www.instagram.com/p/DdrsY54hYnK/'
        },
        brussels: {
            country: 'belgium',
            name: 'Brussels',
            link: 'https://www.instagram.com/p/Ddon6ADDdSq/'
        },
        dublin: {
            country: 'ireland',
            name: 'Dublin',
            link: 'https://www.instagram.com/p/Ddw3XcVuHit/'
        },
        dublinOct11: {
            country: 'ireland',
            name: 'Dublin',
            link: 'https://www.instagram.com/p/DePMFG1uVvE/'
        },
        dublinOct25: {
            country: 'ireland',
            name: 'Dublin',
            link: 'https://www.instagram.com/p/DekQ82El3F4/'
        },
        lyon: {
            country: 'france',
            name: 'Lyon',
            link: 'https://www.instagram.com/p/DdtxKa9F9Dv/'
        },
        paris: {
            country: 'france',
            name: 'Paris',
            link: 'https://www.facebook.com/uniondesukrainiensdefrance'
        },
        parisSep30: {
            country: 'france',
            name: 'Paris',
            link: 'https://www.facebook.com/uniondesukrainiensdefrance'
        },
        sydney: {
            country: 'australia',
            name: 'Sydney',
            link: 'https://www.facebook.com/groups/Ukrainians.sydney/permalink/28344744821815139/'
        },
        manchester: {
            country: 'unitedKingdom',
            name: 'Manchester',
            link: 'https://www.instagram.com/p/DdoCIrsu0Ot/'
        },
        vienna: {
            country: 'austria',
            name: 'Vienna',
            link: 'https://www.instagram.com/p/DdrVBDXiIJE/'
        },
        munich: {
            country: 'germany',
            name: 'Munich',
            link: 'https://www.instagram.com/p/DdbrQbKDazu/'
        },
        london: {
            country: 'unitedKingdom',
            name: 'London',
            link: 'https://www.instagram.com/p/DdrmhWyscPX/'
        },
        londonSep29: {
            country: 'unitedKingdom',
            name: 'London',
            link: 'https://www.instagram.com/kartonky.london/'
        },
        londonOct9: {
            country: 'unitedKingdom',
            name: 'London',
            link: 'https://www.instagram.com/kartonky.london/'
        },
        londonOct10: {
            country: 'unitedKingdom',
            name: 'London',
            link: 'https://www.instagram.com/kartonky.london/'
        },
        londonOct1: {
            country: 'unitedKingdom',
            name: 'London',
            link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
        },
        londonOct3: {
            country: 'unitedKingdom',
            name: 'London',
            link: 'https://www.instagram.com/p/Dd6KMBZMPC4/'
        }
    },
    days: [
        {
            dayKey: 'schedule26',
            monthKey: 'home.september',
            monthShortKey: 'home.sep',
            cities: [
                'sydney',
                'edinburgh',
                'manchester',
                'paris'
            ]
        },
        {
            dayKey: 'schedule27',
            monthKey: 'home.september',
            monthShortKey: 'home.sep',
            cities: [
                'vienna',
                'london',
                'lyon',
                'gdansk',
                'chicago'
            ]
        },
        {
            dayKey: 'schedule28',
            monthKey: 'home.september',
            monthShortKey: 'home.sep',
            cities: [
                'brussels'
            ]
        },
        {
            dayKey: 'schedule29',
            monthKey: 'home.september',
            monthShortKey: 'home.sep',
            cities: [
                'londonSep29'
            ]
        },
        {
            dayKey: 'schedule30',
            monthKey: 'home.september',
            monthShortKey: 'home.sep',
            cities: [
                'parisSep30',
                'budapest'
            ]
        },
        {
            dayKey: 'schedule1',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'londonOct1'
            ]
        },
        {
            dayKey: 'schedule2',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'ottawa'
            ],
            stackWithPrevious: true
        },
        {
            dayKey: 'schedule3',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'birmingham',
                'munich',
                'nantes',
                'malaga',
                'plovdiv',
                'londonOct3',
                'hamburg',
                'oslo'
            ]
        },
        {
            dayKey: 'schedule4',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'dublin',
                'chicagoOct4',
                'dresden',
                'kiel'
            ]
        },
        {
            dayKey: 'schedule5',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'leipzig'
            ],
            stackWithPrevious: true
        },
        {
            dayKey: 'schedule9',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'londonOct9'
            ]
        },
        {
            dayKey: 'schedule10',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'londonOct10'
            ]
        },
        {
            dayKey: 'schedule11',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'chicagoOct11',
                'dublinOct11'
            ]
        },
        {
            dayKey: 'schedule18',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'chicagoOct18'
            ]
        },
        {
            dayKey: 'schedule25',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'dublinOct25'
            ]
        },
        {
            dayKey: 'schedule31',
            monthKey: 'home.october',
            monthShortKey: 'home.oct',
            cities: [
                'nantesOct31'
            ]
        }
    ],
    demands: {
        titleKey: 'rallies.oleshky2026.demandsTitle',
        itemKeys: [
            1,
            2,
            3,
            4
        ].map((n)=>`rallies.oleshky2026.demand${n}`)
    },
    photos: (0, $718431ec8bf53c72$export$922418035ff6c3f8),
    posters: (0, $45ed955dd045a702$export$8b1550977f062599),
    resources: (0, $83d2be3c4829d3b5$export$f33c501800aa1c3c)
};
const $64eb78d2855f6aef$export$15686ef4744e140a = [
    $64eb78d2855f6aef$export$90f7fc6f788ba308,
    $64eb78d2855f6aef$export$67f75aef892f4e8c
];
function $64eb78d2855f6aef$export$253cf7de989dd90b(rally) {
    return rally.days.flatMap((day)=>day.cities);
}





function $aac1df04b09870bf$var$City({ city: city, rally: rally }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ns = rally?.citiesI18n ?? 'cities';
    const link = (rally?.cities ?? (0, $755bfc0689a8b67c$export$f03f7c19d8f50e16))[city]?.link || null;
    const day = t(`${ns}.${city}.day`);
    const location = t(`${ns}.${city}.location`);
    const cleanTime = t(`${ns}.${city}.cleanTime`);
    const monthShortKey = rally?.days.find((d)=>d.cities.includes(city))?.monthShortKey ?? 'home.dec';
    // no time for this city (e.g. not announced): just the date, without a trailing comma
    const dayAndTime = `${t(`home.${day}`)} ${t(monthShortKey)}${cleanTime ? `, ${cleanTime}` : ''}`;
    const locationText = location ? location : 'TBC';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
        className: "list-none py-2",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid grid-cols-[1fr_2fr] gap-x-4 items-start",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "font-bold justify-start text-left",
                    children: link ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "text-left hover:underline cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-xl",
                                children: [
                                    t(`${ns}.${city}.city`),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "\uD83D\uDD17"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xl text-left",
                        children: t(`${ns}.${city}.city`)
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-right",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-sm font-semibold text-blue-900",
                            children: dayAndTime
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-sm text-blue-900",
                            children: locationText
                        })
                    ]
                })
            ]
        })
    }, city);
}
var $aac1df04b09870bf$export$2e2bcd8739ae039 = $aac1df04b09870bf$var$City;


function $62941abad52190fe$export$b33f41d0b11df887({ rally: rally }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const grouped = rally ? (0, $8c35c3c6dfd7a237$export$bf12af26a1077753)((0, $64eb78d2855f6aef$export$253cf7de989dd90b)(rally), rally.cities) : (0, $8c35c3c6dfd7a237$export$9dec74656aeabcda);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full px-6 py-10 columns-1 lg:columns-2 gap-30 bg-gray-100 text-blue-600",
        children: Object.entries(grouped).map(([country, cityKeys])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "break-inside-avoid mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-4xl md:text-5xl text-center font-medium mb-6 underline",
                        children: t(`countries.${country}`)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        children: cityKeys.map((cityKey)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aac1df04b09870bf$export$2e2bcd8739ae039), {
                                city: cityKey,
                                rally: rally
                            }, cityKey))
                    })
                ]
            }, country))
    });
}





function $f1c4e915c05defd1$export$6f72d662f8bd9f10({ rally: rally }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    // one grid cell per day, except days marked stackWithPrevious, which share the previous day's cell
    const cells = rally.days.reduce((acc, day)=>{
        if (day.stackWithPrevious && acc.length) acc[acc.length - 1].push(day);
        else acc.push([
            day
        ]);
        return acc;
    }, []);
    const cols = cells.length > 1 ? 'md:grid-cols-2' : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `py-10 w-full grid grid-cols-1 ${cols} gap-10 gap-y-20 justify-center mb-10`,
        children: cells.map((days)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col items-center gap-20",
                children: days.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "text-4xl md:text-5xl font-medium underline",
                                children: [
                                    t(`home.${day.dayKey}`),
                                    " ",
                                    t(day.monthKey)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-4 opacity-90 text-center text-2xl",
                                children: day.cities.map((city)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec4b77ae4b0ba8de$export$2e2bcd8739ae039), {
                                        city: city,
                                        rally: rally
                                    }, city))
                            })
                        ]
                    }, `${day.monthKey}-${day.dayKey}`))
            }, `${days[0].monthKey}-${days[0].dayKey}`))
    });
}




var $acw62 = parcelRequire("acw62");

const $142a25725882f9fc$var$FORMSPREE_URL = 'https://formspree.io/f/mnpngwwr';
// submissions faster than this after the form appears are treated as bots
const $142a25725882f9fc$var$MIN_FILL_MS = 4000;
const $142a25725882f9fc$var$EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
// international format: + country code, then 7–15 digits in total (E.164); spaces, dashes, dots and brackets allowed
const $142a25725882f9fc$var$PHONE = /^\+[1-9]\d{6,14}$/;
// a town or city name, optionally with country: letters in any script, spaces, hyphens, apostrophes,
// dots, commas and brackets; no digits, so e.g. "Saint-Denis", "L'Aquila", "Kyiv, Ukraine", "Östersund"
const $142a25725882f9fc$var$PLACE = /^\p{L}[\p{L}\p{M}\s'’.,()-]{1,79}$/u;
// start hours in 24h format: 00:00 … 23:00
const $142a25725882f9fc$var$HOURS = Array.from({
    length: 24
}, (_, h)=>`${String(h).padStart(2, '0')}:00`);
// every date from today to 31 October (end of the Oleshky demo period), as dd/mm
function $142a25725882f9fc$var$upcomingDates() {
    const dates = [];
    const day = new Date();
    day.setHours(0, 0, 0, 0);
    const last = new Date(day.getFullYear(), 9, 31) // months are 0-based: 9 = October
    ;
    while(day <= last){
        const dd = String(day.getDate()).padStart(2, '0');
        const mm = String(day.getMonth() + 1).padStart(2, '0');
        dates.push(`${dd}/${mm}`);
        day.setDate(day.getDate() + 1);
    }
    return dates;
}
function $142a25725882f9fc$var$isValidPlace(value) {
    return $142a25725882f9fc$var$PLACE.test(value.trim());
}
function $142a25725882f9fc$var$isValidContact(value) {
    const v = value.trim();
    return $142a25725882f9fc$var$EMAIL.test(v) || $142a25725882f9fc$var$PHONE.test(v.replace(/[\s\-.()]/g, ''));
}
function $142a25725882f9fc$export$3054ddd9d3fdd8aa() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [status, setStatus] = (0, $acw62.useState)('idle');
    const [shownAt] = (0, $acw62.useState)(()=>Date.now());
    async function handleSubmit(e) {
        e.preventDefault();
        const form = e.currentTarget;
        // spam: the hidden honeypot was filled in, or the form was sent too fast for a person.
        // Pretend it worked so bots get no signal, and send nothing.
        const honeypot = form.elements.namedItem('_gotcha');
        if (honeypot.value || Date.now() - shownAt < $142a25725882f9fc$var$MIN_FILL_MS) {
            setStatus('sent');
            return;
        }
        const where = form.elements.namedItem('where');
        if (!$142a25725882f9fc$var$isValidPlace(where.value)) {
            where.setCustomValidity(t('rallies.addDemo.whereInvalid'));
            where.reportValidity();
            return;
        }
        const contact = form.elements.namedItem('contact');
        if (!$142a25725882f9fc$var$isValidContact(contact.value)) {
            contact.setCustomValidity(t('rallies.addDemo.contactInvalid'));
            contact.reportValidity();
            return;
        }
        setStatus('sending');
        try {
            const res = await fetch($142a25725882f9fc$var$FORMSPREE_URL, {
                method: 'POST',
                body: new FormData(form),
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!res.ok) throw new Error(String(res.status));
            form.reset();
            setStatus('sent');
        } catch  {
            setStatus('error');
        }
    }
    const inputClass = 'w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-blue-700';
    // an empty required dropdown is :invalid, so its placeholder shows in placeholder grey
    const pickerClass = `${inputClass} invalid:text-gray-400`;
    return(// heading in a left column beside the form on tablet and up; stacked on mobile
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-28 mx-auto w-full max-w-5xl flex flex-col md:flex-row md:items-start gap-2 md:gap-6 text-left text-gray-900",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-lg font-semibold text-center md:text-left md:w-40 md:shrink-0 md:pt-1.5",
                children: t('rallies.addDemo.title')
            }),
            status === 'sent' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "flex-1 text-base text-center md:text-left md:pt-1.5 opacity-80",
                children: t('rallies.addDemo.thanks')
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                // where / date / time / contact in one row, then message + submit
                className: "flex-1 grid grid-cols-1 md:grid-cols-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "_subject",
                        value: "New demo submission - humansafari.org"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: "_gotcha",
                        tabIndex: -1,
                        autoComplete: "off",
                        "aria-hidden": "true",
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        name: "where",
                        required: true,
                        onInput: (e)=>e.currentTarget.setCustomValidity(''),
                        "aria-label": t('rallies.addDemo.where'),
                        placeholder: t('rallies.addDemo.where'),
                        className: inputClass
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        name: "date",
                        required: true,
                        defaultValue: "",
                        "aria-label": t('rallies.addDemo.date'),
                        title: t('rallies.addDemo.date'),
                        className: pickerClass,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                disabled: true,
                                children: t('rallies.addDemo.datePlaceholder')
                            }),
                            $142a25725882f9fc$var$upcomingDates().map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: d,
                                    className: "text-gray-900",
                                    children: d
                                }, d))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        name: "time",
                        required: true,
                        defaultValue: "",
                        "aria-label": t('rallies.addDemo.time'),
                        title: t('rallies.addDemo.time'),
                        className: pickerClass,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: "",
                                disabled: true,
                                children: t('rallies.addDemo.time')
                            }),
                            $142a25725882f9fc$var$HOURS.map((h)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: h,
                                    className: "text-gray-900",
                                    children: h
                                }, h))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        name: "contact",
                        required: true,
                        // clear the custom error as soon as the user edits the field
                        onInput: (e)=>e.currentTarget.setCustomValidity(''),
                        "aria-label": t('rallies.addDemo.contact'),
                        placeholder: t('rallies.addDemo.contact'),
                        className: inputClass
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                        name: "message",
                        rows: 2,
                        required: true,
                        // more than 50 characters
                        minLength: 51,
                        "aria-label": t('rallies.addDemo.message'),
                        placeholder: t('rallies.addDemo.message'),
                        className: `${inputClass} md:col-span-3`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "submit",
                        disabled: status === 'sending',
                        className: "justify-self-center self-center rounded-full bg-blue-800 text-white px-8 py-1.5 text-base hover:bg-blue-700 cursor-pointer transition disabled:opacity-60",
                        children: status === 'sending' ? t('rallies.addDemo.sending') : t('rallies.addDemo.submit')
                    }),
                    status === 'error' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-center text-red-700 md:col-span-4",
                        children: t('rallies.addDemo.error')
                    })
                ]
            })
        ]
    }));
}



function $b3c9eaf6afd8474b$var$Events({ rally: rally }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [view, setView] = (0, $acw62.useState)(()=>{
        if (typeof window !== 'undefined' && window.innerWidth < 768) return 'countries';
        return 'cities';
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        id: "rally-schedule",
        "aria-labelledby": "event-schedule-heading",
        className: "w-full px-6 md:px-20 pb-25 pt-10 justify-center bg-gray-100 text-center text-blue-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-center my-6 px-8",
                children: [
                    view === 'cities' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>setView('countries'),
                        className: " rounded-full bg-blue-800 text-white px-6 py-3 shadow-lg hover:bg-blue-700 cursor-pointer transition",
                        children: t('byCountry')
                    }),
                    view === 'countries' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>setView('cities'),
                        className: " rounded-full bg-blue-800 text-white px-6 py-3 shadow-lg hover:bg-blue-700 cursor-pointer transition",
                        children: t('byDate')
                    })
                ]
            }),
            view === 'cities' && (rally ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1c4e915c05defd1$export$6f72d662f8bd9f10), {
                rally: rally
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1475da1823ba6eb0$export$9fa0acc09cd94b92), {})),
            view === 'countries' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62941abad52190fe$export$b33f41d0b11df887), {
                rally: rally
            }),
            rally && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $142a25725882f9fc$export$3054ddd9d3fdd8aa), {})
        ]
    });
}
var $b3c9eaf6afd8474b$export$2e2bcd8739ae039 = $b3c9eaf6afd8474b$var$Events;






function $546163da95c84112$export$e9a269813a6315a4() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-10 px-6 md:px-20 py-25 bg-gray-100 text-center text-xl md:text-2xl leading-relaxed opacity-90 items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-4xl md:text-5xl font-medium",
                children: t('resources.title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3 max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block text-2xl",
                        children: t('resources.linkLibraryTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: t('resources.linkLibraryDesc')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://linktr.ee/Kherson_Human_Safari",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600 break-all",
                        children: "https://linktr.ee/Kherson_Human_Safari"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3 max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block text-2xl",
                        children: t('resources.truthHoundsTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://truth-hounds.org/en/cases/killzone-how-russian-drones-are-devastating-the-river-dnipros-right-bank/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600 break-all",
                        children: t('resources.truthHoundsDesc')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3 max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block text-2xl",
                        children: t('resources.hrwTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://www.hrw.org/report/2025/06/03/hunted-from-above/russias-use-of-drones-to-attack-civilians-in-kherson-ukraine",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600",
                        children: t('resources.hrwDesc')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3 max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block text-2xl",
                        children: t('resources.unReportsTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/coiukraine/a-hrc-59-crp2-en.pdf",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600 block",
                        children: t('resources.report1')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://www.ohchr.org/en/hr-bodies/hrc/iicihr-ukraine/reports/report-independent-international-commission-inquiry-ukraine-un-general-assembly-a80497",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600 block",
                        children: t('resources.report3')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/coiukraine/a-80-497-advance-unedited-version-en.pdf",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600",
                        children: t('resources.guidelines')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3 max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block text-2xl",
                        children: t('resources.wikipediaTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://en.wikipedia.org/wiki/Human_safari_(terror_campaign)",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600 block",
                        children: t('resources.english')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-3 max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block text-2xl",
                        children: t('resources.documentaryTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://www.khersonhumansafari.com",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "underline text-blue-600",
                        children: "www.khersonhumansafari.com"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
const $0ffd4c3fecb4f056$var$LazyVideo = ({ src: src, className: className })=>{
    const videoRef = (0, $acw62.useRef)(null);
    const [shouldLoad, setShouldLoad] = (0, $acw62.useState)(false);
    const [isMuted, setIsMuted] = (0, $acw62.useState)(true);
    const [isPlaying, setIsPlaying] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                setShouldLoad(true);
                observer.disconnect();
            }
        }, {
            rootMargin: '200px'
        });
        if (videoRef.current) observer.observe(videoRef.current);
        return ()=>observer.disconnect();
    }, []);
    function toggleMute() {
        if (!videoRef.current) return;
        const nextMuted = !isMuted;
        videoRef.current.muted = nextMuted;
        setIsMuted(nextMuted);
    }
    function togglePlay() {
        if (!videoRef.current) return;
        if (videoRef.current.paused) {
            videoRef.current.play();
            setIsPlaying(true);
        } else {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                ref: videoRef,
                autoPlay: true,
                muted: true,
                loop: true,
                playsInline: true,
                preload: "none",
                className: className,
                children: shouldLoad && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("source", {
                    src: src,
                    type: "video/mp4"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute -bottom-15 sm:bottom-5 right-0 sm:right-4 flex gap-2 z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: togglePlay,
                        "aria-label": isPlaying ? 'Pause video' : 'Play video',
                        className: "rounded-full text-3xl px-4 py-2 text-white cursor-pointer shadow border bg-black/70",
                        children: isPlaying ? "\u23F8" : "\u25B6\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: toggleMute,
                        "aria-label": isMuted ? 'Unmute video' : 'Mute video',
                        className: `rounded-full text-3xl px-4 py-2 text-white cursor-pointer shadow border ${isMuted ? 'bg-green-500' : 'bg-blue-800'}`,
                        children: isMuted ? "\uD83D\uDD0A" : "\uD83D\uDD07"
                    })
                ]
            })
        ]
    });
};
var $0ffd4c3fecb4f056$export$2e2bcd8739ae039 = $0ffd4c3fecb4f056$var$LazyVideo;



var $6a12d69287a15943$exports = {};
$6a12d69287a15943$exports = import.meta.resolve("kp5wS");


function $654963a7c7838280$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const location = (0, $43f18c0047822054$export$45d76561a5302f2b)();
    const navigate = (0, $43f18c0047822054$export$9770f232ac06a008)();
    const sizeClass1 = i18n.language === 'fr' || i18n.language === 'da' ? `wrap-break-word inline-block text-4xl sm:text-6xl md:text-6xl lg:text-7xl xl:text-9xl` : 'text-6xl md:text-8xl xl:text-9xl';
    (0, $acw62.useEffect)(()=>{
        if (location.state?.scrollToId) {
            const element = document.getElementById(location.state.scrollToId);
            if (element) {
                const isMobile = window.matchMedia('(max-width: 768px)').matches;
                const offset = isMobile ? window.innerHeight * 0.1 : window.innerHeight * 0.8;
                const top = element.getBoundingClientRect().top + window.scrollY + offset;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
            }
            navigate(location.pathname, {
                replace: true,
                state: {}
            });
        }
    }, [
        location.state,
        navigate,
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen w-full text-gray-900 flex flex-col text-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "flex flex-col justify-center items-center w-full min-h-[75vh] text-center px-4 bg-gray-100 pb-10 pt-4 gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-base opacity-60",
                        children: [
                            t('action.intro'),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$a6c7ac8248d6e38a), {
                                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).help.path,
                                className: "text-blue-600 underline",
                                children: t('action.helpLink')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ffd4c3fecb4f056$export$2e2bcd8739ae039), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6a12d69287a15943$exports))),
                        className: "w-full max-w-2xl object-cover align-middle cursor-pointer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-left md:text-center font-medium opacity-90 mb-4 wrap-break-word flex flex-col gap-4 text-6xl md:text-7xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: t('home.heroStop')
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "bg-black p-[0.5px] w-[80%] md:self-center"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('home.heroSave')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `inline-flex ${sizeClass1} font-semibold flex-wrap text-right items-center justify-end md:text-center text-blue-500 gap-4 mb-3`,
                        dangerouslySetInnerHTML: {
                            __html: t('home.worldwideRally')
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-3xl md:text-4xl mt-12 font-semibold mb-3 uppercase",
                        children: [
                            t('home.heroTitle1'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            t('home.heroTitle2')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg opacity-80",
                        children: "#HumansAreNotTargets #StopHumanSafari #SaveKherson"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "px-6 md:px-20 py-12 pb-20 text-center text-2xl leading-relaxed opacity-90 bg-gray-50 flex flex-col justify-center items-center md:flex-row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5362d704e65c175$exports))),
                        alt: "human safari drone",
                        className: "pb-8 md:pb-0 md:w-[50%]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "px-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "home.infoText",
                            components: {
                                bold: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {})
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-blue-800 w-full text-gray-100 p-3 uppercase flex justify-center text-center text-xl md:text-2xl font-bold",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>{
                        const el = document.getElementById('posters-gallery');
                        if (el) el.scrollIntoView({
                            behavior: 'smooth'
                        });
                    },
                    className: "rounded-full text-blue-800 bg-white px-6 py-3 shadow-lg hover:bg-blue-700 cursor-pointer transition",
                    children: t('home.seeGallery')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd29408e01e545$export$2e2bcd8739ae039), {
                id: "rallies",
                images: (0, $b06743023139191a$export$ee5f96e597047257),
                collapseToFirstRow: true,
                height: "aspect-2/2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3c9eaf6afd8474b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                "aria-labelledby": "un-recommendations-heading",
                className: "flex flex-col gap-8 md:gap-12 px-6 py-25 bg-gray-50 text-center text-md md:text-xl leading-relaxed opacity-90",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        id: "un-recommendations-heading",
                        className: "text-4xl md:text-5xl font-medium",
                        children: t('home.recommendationsTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "bold underline pb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    className: "text-2xl",
                                    children: t('home.recommendationsRussia')
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "mb-2 text-2xl leading-relaxed",
                                        children: t('home.rusRec1')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        className: "mb-2 text-2xl leading-relaxed",
                                        children: [
                                            t('home.rusRec2'),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "mb-2 text-2xl leading-relaxed",
                                        children: t('home.rusRec3')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "bold underline pb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    className: "text-2xl",
                                    children: t('home.recommendationsUNStates')
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "mb-2 text-2xl leading-relaxed",
                                        children: t('home.statesRec1')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "mb-2 text-2xl leading-relaxed",
                                        children: t('home.statesRec2')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $546163da95c84112$export$e9a269813a6315a4), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd29408e01e545$export$2e2bcd8739ae039), {
                id: "posters",
                images: (0, $755bfc0689a8b67c$export$6c746a5570b8b35c),
                downloadable: true
            })
        ]
    });
}








function $27e80ec559955030$export$2e2bcd8739ae039({ groups: groups, subKey: subKey }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-6 w-full max-w-5xl",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold",
                        children: t('follow.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "opacity-70",
                        children: t(subKey)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-8",
                children: groups.map(({ labelKey: labelKey, sources: sources })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6",
                        children: [
                            labelKey && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold",
                                children: t(labelKey)
                            }),
                            sources.map(({ key: key, langKeys: langKeys, links: links })=>{
                                const name = t(`follow.${key}.name`);
                                const list = langKeys.map((langKey)=>t(langKey)).join(t('follow.langSeparator'));
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-base opacity-70",
                                            children: t(`follow.${key}.desc`)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center gap-3 mt-1",
                                            children: [
                                                links.map(({ asset: asset, labelKey: linkLabelKey, href: href })=>{
                                                    const label = t(linkLabelKey);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: href,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        "aria-label": `${name} \u{2014} ${label}`,
                                                        className: "opacity-100 hover:opacity-50 transition",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            src: asset,
                                                            alt: label,
                                                            className: "h-6 w-6"
                                                        })
                                                    }, linkLabelKey);
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm opacity-60",
                                                    children: t(langKeys.length === 1 ? 'follow.language' : 'follow.languages', {
                                                        list: list
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, key);
                            })
                        ]
                    }, labelKey ?? 'main'))
            })
        ]
    });
}





function $2e657e135fac042e$export$bd58e0403794477c({ id: id, images: images }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-6 w-full max-w-5xl",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold",
                        children: t('leftBank.downloadTitle')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "opacity-70",
                        children: t('leftBank.downloadSub')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd29408e01e545$export$2e2bcd8739ae039), {
                id: id,
                images: images,
                downloadable: true,
                bare: true
            })
        ]
    });
}




function $b486a488ff0df712$export$3a8051bd9fdfcc83({ orgs: orgs, introKey: introKey }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-8 w-full max-w-5xl",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold",
                        children: t('help.donate')
                    }),
                    introKey && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "opacity-70",
                        children: t(introKey)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-8 w-full",
                children: orgs.map(({ key: key, img: img, donateUrl: donateUrl, socialLinks: socialLinks, noteKey: noteKey, descKey: descKey })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 bg-white p-6 rounded-lg shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-stretch gap-3 w-full",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: img,
                                        alt: t(`help.${key}.name`),
                                        className: "flex-1 min-w-0 h-32 object-contain rounded bg-gray-100"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: donateUrl,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "shrink-0 bg-blue-700 text-white px-4 rounded-md font-bold hover:bg-blue-800 transition flex items-center justify-center",
                                        children: t('help.donate')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-xl font-semibold",
                                children: t(`help.${key}.name`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-base opacity-80",
                                children: t(descKey ?? `help.${key}.desc`)
                            }),
                            noteKey && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "rounded-md bg-yellow-100 px-3 py-2 text-base font-semibold",
                                children: t(noteKey)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex gap-3 mt-auto",
                                children: socialLinks.map(({ asset: asset, labelKey: labelKey, href: href })=>{
                                    const label = t(labelKey);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: href,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": label,
                                        className: "opacity-100 hover:opacity-50 transition",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: asset,
                                            alt: label,
                                            className: "h-6 w-6"
                                        })
                                    }, labelKey);
                                })
                            })
                        ]
                    }, key))
            })
        ]
    });
}


var $ee546d8dd55165f4$exports = {};
$ee546d8dd55165f4$exports = import.meta.resolve("6wCGl");




var $84056e99848adef8$exports = {};
$84056e99848adef8$exports = import.meta.resolve("8VNT4");


var $2f9ce109cf59676d$exports = {};
$2f9ce109cf59676d$exports = import.meta.resolve("caZlK");


const $024044fcaf567dee$var$ENGLISH = 'follow.lang.english';
const $024044fcaf567dee$var$GERMAN = 'follow.lang.german';
const $024044fcaf567dee$var$UKRAINIAN = 'follow.lang.ukrainian';
const $024044fcaf567dee$var$zabrisky = {
    key: 'zabrisky',
    langKeys: [
        $024044fcaf567dee$var$ENGLISH
    ],
    links: [
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
            labelKey: 'help.website',
            href: 'https://euromaidanpress.com/author/zarinazabrisky/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
            labelKey: 'help.facebook',
            href: 'https://www.facebook.com/zarina.zabrisky'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
            labelKey: 'help.x',
            href: 'https://x.com/ZarinaZabrisky'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
            labelKey: 'help.instagram',
            href: 'https://www.instagram.com/zarinazabrisky/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($2f9ce109cf59676d$exports))),
            labelKey: 'help.youtube',
            href: 'https://www.youtube.com/channel/UC5clrA08fbAPLl5F5Vxlfwg'
        }
    ]
};
const $024044fcaf567dee$var$naber = {
    key: 'naber',
    langKeys: [
        $024044fcaf567dee$var$GERMAN
    ],
    links: [
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
            labelKey: 'help.website',
            href: 'https://www.welt.de/autor/ibrahim-naber/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
            labelKey: 'help.x',
            href: 'https://x.com/IbraNaber'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
            labelKey: 'help.instagram',
            href: 'https://www.instagram.com/ibranaber/'
        }
    ]
};
const $024044fcaf567dee$var$kelley = {
    key: 'kelley',
    langKeys: [
        $024044fcaf567dee$var$ENGLISH
    ],
    links: [
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
            labelKey: 'help.website',
            href: 'https://brendankelley.substack.com/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
            labelKey: 'help.instagram',
            href: 'https://www.instagram.com/kelley2276/'
        }
    ]
};
const $024044fcaf567dee$var$localPress = {
    labelKey: 'follow.localPress',
    sources: [
        {
            key: 'vgoru',
            langKeys: [
                $024044fcaf567dee$var$UKRAINIAN
            ],
            links: [
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
                    labelKey: 'help.website',
                    href: 'https://vgoru.org/'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
                    labelKey: 'help.facebook',
                    href: 'https://www.facebook.com/vgoru/'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
                    labelKey: 'help.x',
                    href: 'https://x.com/vgorunews'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($2f9ce109cf59676d$exports))),
                    labelKey: 'help.youtube',
                    href: 'https://www.youtube.com/channel/UCtb5EkOIT-DfTGiMaN8G8Ug'
                }
            ]
        },
        {
            key: 'suspilne',
            langKeys: [
                $024044fcaf567dee$var$UKRAINIAN
            ],
            links: [
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
                    labelKey: 'help.website',
                    href: 'https://suspilne.media/kherson/'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
                    labelKey: 'help.instagram',
                    href: 'https://www.instagram.com/suspilne.kherson/'
                }
            ]
        },
        {
            key: 'most',
            langKeys: [
                $024044fcaf567dee$var$UKRAINIAN,
                $024044fcaf567dee$var$ENGLISH
            ],
            links: [
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
                    labelKey: 'help.website',
                    href: 'https://most.ks.ua/'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
                    labelKey: 'help.facebook',
                    href: 'https://www.facebook.com/mostnews'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
                    labelKey: 'help.x',
                    href: 'https://x.com/most_ks_ua'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
                    labelKey: 'help.instagram',
                    href: 'https://www.instagram.com/most.ks.ua/'
                },
                {
                    asset: (0, (/*@__PURE__*/$parcel$interopDefault($2f9ce109cf59676d$exports))),
                    labelKey: 'help.youtube',
                    href: 'https://www.youtube.com/channel/UC9jfJ4UB7rS0IcOuC5NukUA'
                }
            ]
        }
    ]
};
const $024044fcaf567dee$export$fb792e516a64c904 = [
    {
        sources: [
            $024044fcaf567dee$var$zabrisky,
            $024044fcaf567dee$var$naber,
            $024044fcaf567dee$var$kelley
        ]
    },
    $024044fcaf567dee$var$localPress
];
const $024044fcaf567dee$export$a9017f0eaf7977f6 = [
    {
        sources: [
            $024044fcaf567dee$var$zabrisky
        ]
    }
];


var $6adf749502a066f7$exports = {};
$6adf749502a066f7$exports = import.meta.resolve("gDRgY");





var $d08fdd2250a6544c$exports = {};
$d08fdd2250a6544c$exports = import.meta.resolve("fuMRR");



const $22e5f27b2168a7b1$export$fa70b3b9c9c04244 = {
    key: 'fellas',
    img: (0, (/*@__PURE__*/$parcel$interopDefault($6adf749502a066f7$exports))),
    donateUrl: 'https://fellas4europe.org/spenden/',
    socialLinks: [
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
            labelKey: 'help.website',
            href: 'https://fellas4europe.org/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
            labelKey: 'help.facebook',
            href: 'https://www.facebook.com/p/Fellas4Europe-eV-100092421167989/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
            labelKey: 'help.instagram',
            href: 'https://www.instagram.com/fellas4europe/'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($d08fdd2250a6544c$exports))),
            labelKey: 'help.bluesky',
            href: 'https://bsky.app/profile/fellas4europe.bsky.social'
        },
        {
            asset: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
            labelKey: 'help.x',
            href: 'https://x.com/fellas4europe'
        }
    ]
};


const $d4e326393afeafd4$export$212d0b5f06f89c2f = [
    {
        title: 'Kyiv Post',
        links: [
            {
                label: "\u2018Unrestricted Permission to Kill\u2019: Inside Kherson\u2019s Drone War",
                href: 'https://www.kyivpost.com/interviews/85144',
                date: '27/09/2026'
            },
            {
                label: "Ukraine Suffers More Civilian Deaths in 8 Months of 2026 Than All of 2025 \u2013 UN",
                href: 'https://www.kyivpost.com/post/84741',
                date: '17/09/2026'
            },
            {
                label: "\u2018Human Safari\u2019: How Kherson Became a Hunting Ground for Russian Drones",
                href: 'https://www.kyivpost.com/post/83134',
                date: '28/08/2026'
            }
        ]
    },
    {
        title: 'The Chenab Times',
        links: [
            {
                label: 'Ukrainian City Endures Intense Shelling as US Peace Efforts Continue',
                href: 'https://thechenabtimes.com/2026/09/15/ukrainian-city-endures-intense-shelling-as-us-peace-efforts-continue/',
                date: '15/09/2026'
            }
        ]
    },
    {
        title: 'ABC News',
        links: [
            {
                label: "'The basement saved me': Frontline Ukrainian city under fire amid US peace push",
                href: 'https://abcnews.com/International/basement-saved-frontline-ukrainian-city-fire-amid-us/story?id=136336860',
                date: '15/09/2026'
            }
        ]
    },
    {
        title: 'Le Parisien',
        links: [
            {
                label: "Kherson : dans l\u2019enfer du \xab safari humain \xbb, l\u2019appel pressant \xe0 l\u2019\xe9vacuation",
                href: 'https://www.leparisien.fr/international/ukraine/kherson-dans-lenfer-du-safari-humain-lappel-pressant-a-levacuation-28-08-2026-D4MBX7JCB5HX7ALWCJZWKDTFDM.php',
                date: '28/08/2026'
            },
            {
                label: '"Safari humain" : la menace d\xe9passe les fronti\xe8res ukrainiennes',
                href: 'https://youtu.be/uf9WcKgw1ag',
                date: '13/08/2026'
            }
        ]
    },
    {
        title: 'Newsweek',
        links: [
            {
                label: "Bombs, Bodies and Barbecues: Independence Day on Ukraine\u2019s Frontline",
                href: 'https://www.newsweek.com/ukraine-independence-day-kherson-frontline-12359186',
                date: '28/08/2026'
            }
        ]
    },
    {
        title: 'France 24',
        links: [
            {
                label: "\u2018Not an isolated incident\u2019: Russian drones stalk Ukraine\u2019s civilians in \u2018human safaris\u2019",
                href: 'https://www.france24.com/en/europe/20260825-not-an-isolated-incident-russian-drones-stalk-ukraine-civilians-human-safaris',
                date: '25/08/2026'
            }
        ]
    },
    {
        title: 'The Sun',
        links: [
            {
                label: "Inside Ukraine\u2019s eerie \u2018drone tunnel\u2019 where \u2018human safari\u2019 slaughter is so intense that kids learn how to save parents",
                href: 'https://www.thesun.co.uk/news/40083665/ukraine-drone-tunnel-slaughter-children-save-parents/',
                date: '23/08/2026'
            },
            {
                label: "How Russian public is paying drone pilots to carry out sick \u2018human safari\u2019 attacks on innocent Ukrainian civilians",
                href: 'https://www.thesun.co.uk/news/39973440/putin-human-safari-russia-ukraine-drone-war/',
                date: '08/08/2026'
            }
        ]
    },
    {
        title: 'Euromaidan Press',
        links: [
            {
                label: 'Russia hunted civilians by drone in Kherson. Victims are suing the US firm they say helped connect the attackers',
                href: 'https://euromaidanpress.com/2026/08/15/russia-hunted-civilians-by-drone-in-kherson-victims-are-suing-the-us-firm-they-say-helped-connect-the-attackers/',
                date: '15/08/2026'
            },
            {
                label: 'In Kherson, the children still train under the drones',
                href: 'https://euromaidanpress.com/2026/07/31/khersons-bombed-out-boxers-asked-to-keep-russia-out-world-boxing-just-let-it-in/',
                date: '31/07/2026'
            }
        ]
    },
    {
        title: 'BILD',
        links: [
            {
                label: "Russia's manhunt can hit anyone at any time",
                href: 'https://www.bild.de/politik/ausland-und-internationales/human-safari-so-gezielt-macht-russland-mit-drohnen-jagd-auf-zivilisten-6a79b39de22753e756e9bb1d',
                date: '11/08/2026'
            }
        ]
    },
    {
        title: 'Times of India',
        links: [
            {
                label: 'Man & drone: On the battlefield, and off it, to attack civilians',
                href: 'https://timesofindia.indiatimes.com/blogs/toi-edit-page/man-drone-on-tthe-battlefield-and-off-it-to-attack-civilians/',
                date: '10/08/2026'
            },
            {
                label: "Drones hunting humans: Inside Russia's 'Human Safari' in Ukraine",
                href: 'https://timesofindia.indiatimes.com/toi-blogs/beyond-borders/drones-hunting-humans-inside-russias-human-safari-in-ukraine/articleshow/133068709.cms',
                date: '09/08/2026'
            }
        ]
    },
    {
        title: 'RFE/RL',
        links: [
            {
                label: "Ukrainians In Kherson 'Hunted' Daily By Russian Drones",
                href: 'https://www.rferl.org/a/ukraine-kherson-russian-drones-human-safari/33822793.html',
                date: '06/08/2026'
            }
        ]
    },
    {
        title: 'Byline Times',
        links: [
            {
                label: 'Two Years On, the World Witnesses Human Safari in Kherson',
                href: 'https://bylinetimes.com/2026/08/05/two-years-on-the-world-witnesses-human-safari-in-kherson/',
                date: '05/08/2026'
            },
            {
                label: "Russian Drones Set Fire to Ukraine's Agricultural Heartland",
                href: 'https://www.bylinesupplement.com/p/russian-drones-set-fire-to-ukraines',
                date: '09/07/2026'
            }
        ]
    },
    {
        title: 'The Atlantic',
        links: [
            {
                label: "Putin\u2019s Human Safari Is the Dystopian Future of War",
                href: 'https://www.theatlantic.com/ideas/2026/08/ukraine-russia-war-drones/688183/?gift=hVZeG3M9DnxL4CekrWGK39caRyLWbez08zFBsWDwWOM',
                date: '05/08/2026'
            }
        ]
    },
    {
        title: 'Fox News',
        links: [
            {
                label: "Terrifying 'human safaris' on display in shocking video that reveals depths of Russia's deadly campaign",
                href: 'https://www.foxnews.com/world/terrifying-human-safaris-display-shocking-video-reveals-depths-russias-deadly-campaign',
                date: '05/08/2026'
            }
        ]
    },
    {
        title: 'taz',
        links: [
            {
                label: 'Menschenjagd mit Drohnen',
                href: 'https://taz.de/Krieg-in-der-Ukraine/!6201922/',
                date: '05/08/2026'
            }
        ]
    },
    {
        title: 'Reuters',
        links: [
            {
                label: 'Ukraine accuses Russia of war crime after video shows drone attacking vegetable seller in Kherson',
                href: 'https://www.reuters.com/world/europe/ukraine-accuses-russia-war-crime-after-video-shows-drone-hunting-market-vendor-2026-08-04/',
                date: '04/08/2026'
            }
        ]
    },
    {
        title: 'BBC',
        links: [
            {
                label: "Ukrainian vegetable seller targeted in 'human safari' drone attack",
                href: 'https://www.bbc.com/news/videos/clye173d533o',
                date: '04/08/2026'
            }
        ]
    },
    {
        title: 'The Times',
        links: [
            {
                label: "Russian drone hounds Ukrainian market vendor in \u2018human safari\u2019",
                href: 'https://www.thetimes.com/world/russia-ukraine-war/article/russia-targeting-civilians-drone-chases-man-bh2znkxlc',
                date: '04/08/2026'
            }
        ]
    },
    {
        title: 'New York Post',
        links: [
            {
                label: "Russian drone hunts, taunts street vendor in Ukraine\u2019s \u2018human safari zone\u2019 in disturbing video",
                href: 'https://nypost.com/2026/08/04/world-news/russian-drone-hunts-taunts-street-vendor-in-ukraines-human-safari-zone/',
                date: '04/08/2026'
            }
        ]
    }
];






var $acw62 = parcelRequire("acw62");
// autoplay: Vimeo starts playing straight away, muted (browsers only allow autoplay without sound).
// Drive's player can't autoplay, so the fallback always waits for a click.
const $d1dfd2e7347482b7$var$embedUrl = ({ host: host, id: id }, autoplay = false)=>host === 'vimeo' ? `https://player.vimeo.com/video/${id}${autoplay ? '?autoplay=1&muted=1' : ''}` : `https://drive.google.com/file/d/${id}/preview`;
// Vimeo's oEmbed reply has `domain_status_code: 403` when the video's privacy settings don't allow
// embedding on the requesting page's domain (the browser sends it as the referrer), and is a 404
// for private or deleted videos. An embeddable video has no domain_status_code, or 200.
async function $d1dfd2e7347482b7$var$canEmbedVimeo(id, signal) {
    const url = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${id}`)}`;
    const res = await fetch(url, {
        signal: signal
    });
    if (!res.ok) return false;
    const data = await res.json();
    return data.domain_status_code === undefined || data.domain_status_code === 200;
}
// Picks the video to show: a Vimeo video with a fallback is checked first, and is null while checking.
function $d1dfd2e7347482b7$var$usePlayableVideo(video) {
    const fallback = video.host === 'vimeo' ? video.fallback : undefined;
    // result of the Vimeo check, for the video id it was made for
    const [checked, setChecked] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!fallback) return;
        const controller = new AbortController();
        $d1dfd2e7347482b7$var$canEmbedVimeo(video.id, controller.signal).then((ok)=>setChecked({
                id: video.id,
                ok: ok
            })).catch(()=>{
            if (!controller.signal.aborted) setChecked({
                id: video.id,
                ok: false
            });
        });
        return ()=>controller.abort();
    }, [
        video.id,
        fallback
    ]);
    if (!fallback) return video;
    if (checked?.id !== video.id) return null;
    return checked.ok ? video : fallback;
}
const $d1dfd2e7347482b7$var$EmbeddedVideo = ({ video: video, title: title, autoplay: autoplay = false, className: // width classes; defaults to a centred, capped width
className = 'max-w-2xl mx-auto' })=>{
    const playable = $d1dfd2e7347482b7$var$usePlayableVideo(video);
    return(// Drive: taller on mobile, its player adds a title bar above the video there, which would cut off the bottom
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `${playable?.host === 'drive' ? 'aspect-square md:aspect-video' : 'aspect-video'} w-full ${className}`,
        children: playable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
            src: $d1dfd2e7347482b7$var$embedUrl(playable, autoplay),
            title: title,
            className: "w-full h-full rounded-lg",
            allow: "autoplay; fullscreen; picture-in-picture",
            allowFullScreen: true
        }) : // placeholder of the same size while checking Vimeo, so the page doesn't jump
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "w-full h-full rounded-lg bg-gray-200 animate-pulse"
        })
    }));
};
var $d1dfd2e7347482b7$export$2e2bcd8739ae039 = $d1dfd2e7347482b7$var$EmbeddedVideo;


function $73a3fd57dc35ac40$export$7639867049e23dd5({ groups: groups }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: groups.map(({ title: title, links: links, i18n: i18n, video: video }, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: i18n ? t(title) : title
                    }),
                    video && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1dfd2e7347482b7$export$2e2bcd8739ae039), {
                        video: video,
                        title: i18n ? t(title) : title
                    }),
                    links.map(({ label: label, href: href, date: date })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "text-blue-600 underline",
                            children: [
                                i18n ? t(label) : label,
                                date && ` (${date})`
                            ]
                        }, href))
                ]
            }, i))
    });
}




var $acw62 = parcelRequire("acw62");

/** Tailwind's `sm` breakpoint — below it the grid becomes a single-item carousel */ const $f30551934a861baa$var$DESKTOP_QUERY = '(min-width: 640px)';
const $f30551934a861baa$var$DESKTOP_PER_PAGE = 3;
/**
 * On desktop tiles always take a third of the row, so a partial page stays
 * centred: a six column grid lets one item start at column 3, two at column 2
 * and three at column 1, each spanning two columns. Mobile shows one per page,
 * full width, so it needs none of this.
 */ const $f30551934a861baa$var$COL_START = [
    '',
    'sm:col-start-3',
    'sm:col-start-2',
    'sm:col-start-1'
];
function $f30551934a861baa$var$useIsDesktop() {
    const [isDesktop, setIsDesktop] = (0, $acw62.useState)(()=>window.matchMedia($f30551934a861baa$var$DESKTOP_QUERY).matches);
    (0, $acw62.useEffect)(()=>{
        const query = window.matchMedia($f30551934a861baa$var$DESKTOP_QUERY);
        const sync = ()=>setIsDesktop(query.matches);
        sync();
        query.addEventListener('change', sync);
        return ()=>query.removeEventListener('change', sync);
    }, []);
    return isDesktop;
}
function $f30551934a861baa$export$2e2bcd8739ae039({ items: items, className: className }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [openIndex, setOpenIndex] = (0, $acw62.useState)(null);
    const [offset, setOffset] = (0, $acw62.useState)(0);
    const perPage = $f30551934a861baa$var$useIsDesktop() ? $f30551934a861baa$var$DESKTOP_PER_PAGE : 1;
    const close = (0, $acw62.useCallback)(()=>setOpenIndex(null), []);
    const navigate = (0, $acw62.useCallback)((step)=>setOpenIndex((i)=>i === null ? i : (i + step + items.length) % items.length), [
        items.length
    ]);
    if (items.length === 0) return null;
    // A carousel with nowhere to go needs no arrows
    const paged = items.length > perPage;
    const windowSize = Math.min(perPage, items.length);
    // The window advances one item at a time and wraps, so the arrows shift the
    // row along rather than flipping to a whole new set
    const indices = Array.from({
        length: windowSize
    }, (_, i)=>(offset + i) % items.length);
    const go = (step)=>setOffset((o)=>(o + step + items.length) % items.length);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `w-full ${className ?? ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-1 sm:gap-2",
                children: [
                    paged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f30551934a861baa$var$Arrow, {
                        direction: "prev",
                        label: t('media.previous'),
                        onClick: ()=>go(-1)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid min-w-0 flex-1 grid-cols-1 gap-2 sm:grid-cols-6 sm:gap-3",
                        children: indices.map((mediaIndex, index)=>{
                            const item = items[mediaIndex];
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setOpenIndex(mediaIndex),
                                "aria-label": item.description ? t(item.description) : t('media.view'),
                                className: [
                                    index === 0 ? $f30551934a861baa$var$COL_START[windowSize] : '',
                                    'relative aspect-square cursor-pointer overflow-hidden rounded-sm sm:col-span-2',
                                    'border border-gray-300 bg-gray-100 shadow-sm transition hover:opacity-90',
                                    'focus:outline-none focus:ring-2 focus:ring-blue-700'
                                ].join(' '),
                                children: [
                                    item.thumb || item.type === 'image' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: item.thumb ?? item.src,
                                        alt: item.description ? t(item.description) : '',
                                        loading: "lazy",
                                        decoding: "async",
                                        className: "h-full w-full object-cover"
                                    }) : // No thumbnail to stand in, so fall back to the clip's own first
                                    // frame — metadata only, never the whole file
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                                        src: `${item.src}#t=0.1`,
                                        muted: true,
                                        playsInline: true,
                                        preload: "metadata",
                                        tabIndex: -1,
                                        "aria-hidden": "true",
                                        className: "h-full w-full object-cover"
                                    }),
                                    item.type === 'video' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "pointer-events-none absolute inset-0 flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "flex h-11 w-11 items-center justify-center rounded-full bg-black/60",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                viewBox: "0 0 24 24",
                                                "aria-hidden": "true",
                                                className: "ml-0.5 h-5 w-5 fill-white",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M8 5v14l11-7z"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, item.src);
                        })
                    }),
                    paged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f30551934a861baa$var$Arrow, {
                        direction: "next",
                        label: t('media.next'),
                        onClick: ()=>go(1)
                    })
                ]
            }),
            openIndex !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f30551934a861baa$var$MediaModal, {
                item: items[openIndex],
                count: items.length,
                onClose: close,
                onNavigate: navigate
            })
        ]
    });
}
function $f30551934a861baa$var$Arrow({ direction: direction, label: label, onClick: onClick, onDark: onDark = false }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        "aria-label": label,
        className: [
            'flex h-11 w-8 shrink-0 cursor-pointer items-center justify-center self-center sm:w-11',
            'focus:outline-none focus:ring-2',
            onDark ? 'focus:ring-white' : 'focus:ring-blue-700'
        ].join(' '),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            fill: "none",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            // In the modal nothing sits behind the chevrons but the photo, so there
            // they carry their own shadow to stay visible over a pale frame
            style: onDark ? {
                filter: 'drop-shadow(0 1px 3px rgb(0 0 0 / 0.9))'
            } : undefined,
            className: `h-7 w-7 ${onDark ? 'stroke-white' : 'stroke-blue-700'}`,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: direction === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'
            })
        })
    });
}
function $f30551934a861baa$var$MediaModal({ item: item, count: count, onClose: onClose, onNavigate: onNavigate }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const closeRef = (0, $acw62.useRef)(null);
    const videoRef = (0, $acw62.useRef)(null);
    // Tagged with the src it was measured from, so stepping to the next item
    // drops the previous ratio during render rather than in an effect. Only a
    // fallback: anything with a known aspect is sized before it loads.
    const [measured, setMeasured] = (0, $acw62.useState)(null);
    const aspect = item.aspect ?? (measured?.src === item.src ? measured.ratio : null);
    const canNavigate = count > 1;
    const isDesktop = $f30551934a861baa$var$useIsDesktop();
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === 'Escape') return onClose();
            // The native video controls seek with the arrow keys, so while one has
            // focus they keep them
            if (event.target?.tagName === 'VIDEO') return;
            if (event.key === 'ArrowLeft') onNavigate(-1);
            if (event.key === 'ArrowRight') onNavigate(1);
        };
        document.addEventListener('keydown', onKeyDown);
        const previousOverflow = document.body.style.overflow;
        const previouslyFocused = document.activeElement;
        document.body.style.overflow = 'hidden';
        closeRef.current?.focus();
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = previousOverflow;
            previouslyFocused?.focus?.();
        };
    }, [
        onClose,
        onNavigate
    ]);
    (0, $acw62.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        // Opening the modal is a user gesture, so sound is normally allowed. Where
        // a browser refuses it anyway, start muted rather than not at all — the
        // controls carry an unmute toggle.
        video.muted = false;
        video.play().catch(()=>{
            video.muted = true;
            video.play().catch(()=>{});
        });
    }, [
        item.src
    ]);
    const stopClose = (event)=>event.stopPropagation();
    const media = (className)=>item.type === 'video' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
            ref: videoRef,
            src: item.src,
            poster: item.thumb,
            controls: true,
            playsInline: true,
            onLoadedMetadata: (event)=>{
                const el = event.currentTarget;
                if (el.videoHeight) setMeasured({
                    src: item.src,
                    ratio: el.videoWidth / el.videoHeight
                });
            },
            className: className
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: item.src,
            alt: item.description ? t(item.description) : '',
            onLoad: (event)=>{
                const el = event.currentTarget;
                if (el.naturalHeight) setMeasured({
                    src: item.src,
                    ratio: el.naturalWidth / el.naturalHeight
                });
            },
            className: className
        });
    const caption = item.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            t(item.description),
            (item.credit || item.date) && " \u2014 ",
            item.credit && (item.creditHref ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: item.creditHref,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "underline underline-offset-2",
                children: t(item.credit)
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: t(item.credit)
            })),
            item.credit && item.date && ', ',
            item.date
        ]
    });
    const prevArrow = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f30551934a861baa$var$Arrow, {
        direction: "prev",
        label: t('media.previous'),
        onDark: true,
        onClick: (event)=>{
            event.stopPropagation();
            onNavigate(-1);
        }
    });
    const nextArrow = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f30551934a861baa$var$Arrow, {
        direction: "next",
        label: t('media.next'),
        onDark: true,
        onClick: (event)=>{
            event.stopPropagation();
            onNavigate(1);
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": item.description ? t(item.description) : t('media.view'),
        onClick: onClose,
        // Sized by `inset-0` rather than `vh`, which overshoots the visible area
        // on mobile while the browser chrome is showing. Insets clear the notch.
        style: {
            paddingTop: 'env(safe-area-inset-top)',
            paddingBottom: 'env(safe-area-inset-bottom)'
        },
        className: "fixed inset-0 z-50 flex flex-col overflow-hidden bg-gray-900/90",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex w-full shrink-0 justify-end p-2 sm:p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    ref: closeRef,
                    type: "button",
                    onClick: onClose,
                    "aria-label": t('media.close'),
                    className: [
                        'flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center',
                        'rounded-full bg-white text-blue-700 shadow-sm hover:bg-blue-50 transition',
                        'focus:outline-none focus:ring-2 focus:ring-white'
                    ].join(' '),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        fill: "none",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        className: "h-5 w-5 stroke-current",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M5 5l14 14M19 5L5 19"
                        })
                    })
                })
            }),
            isDesktop ? // min-h-0 / min-w-0 let the media shrink to the leftover space rather
            // than forcing the row to overflow
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-h-0 min-w-0 flex-1 items-stretch gap-2 px-3 pb-3",
                children: [
                    canNavigate && prevArrow,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex min-h-0 min-w-0 flex-1 items-center justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figure", {
                            onClick: stopClose,
                            style: aspect ? {
                                aspectRatio: String(aspect)
                            } : undefined,
                            className: "relative flex max-h-full max-w-full items-center justify-center",
                            children: [
                                media('max-h-full max-w-full rounded-sm object-contain'),
                                aspect && caption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("figcaption", {
                                    // The bar is barely there, so the shadow — not the background
                                    // — is what keeps the text legible over a bright or busy frame
                                    style: {
                                        textShadow: '0 1px 3px rgb(0 0 0 / 0.9), 0 0 8px rgb(0 0 0 / 0.6)'
                                    },
                                    className: [
                                        // Video keeps its bottom edge clear for the native controls
                                        item.type === 'video' ? 'top-0 rounded-t-sm' : 'bottom-0 rounded-b-sm',
                                        'absolute inset-x-0 bg-white/10 backdrop-blur-sm',
                                        'px-3 py-2 text-left text-lg leading-snug text-white'
                                    ].join(' '),
                                    children: caption
                                })
                            ]
                        })
                    }),
                    canNavigate && nextArrow
                ]
            }) : // Stacked so the media owns the full width — nothing competes with it
            // horizontally, and the caption and arrows sit underneath
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex min-h-0 min-w-0 flex-1 flex-col items-center justify-center gap-3 overflow-hidden px-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figure", {
                            onClick: stopClose,
                            className: "flex w-full min-w-0 max-w-[calc(100vw-1rem)] shrink-0 flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: aspect ? {
                                        aspectRatio: String(aspect)
                                    } : undefined,
                                    className: "max-h-[55dvh] w-full max-w-[calc(100vw-1rem)] shrink-0",
                                    children: media('h-full w-full rounded-sm object-contain')
                                }),
                                caption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("figcaption", {
                                    // Capped like the media above it, and allowed to break mid-word so
                                    // no long token can push the box past the screen
                                    className: [
                                        'w-full min-w-0 max-w-[calc(100vw-1rem)] shrink-0 break-words',
                                        'text-left text-base leading-snug text-white'
                                    ].join(' '),
                                    children: caption
                                })
                            ]
                        })
                    }),
                    canNavigate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex shrink-0 items-center justify-center gap-10 px-2 pt-2 pb-3",
                        children: [
                            prevArrow,
                            nextArrow
                        ]
                    })
                ]
            })
        ]
    });
}


var $795d2c2c6e8c3a9e$exports = {};
$795d2c2c6e8c3a9e$exports = import.meta.resolve("6P5Qb");


var $f1b38d9cc4b521d7$exports = {};
$f1b38d9cc4b521d7$exports = import.meta.resolve("7w7av");


var $6f1abaa5ed449143$exports = {};
$6f1abaa5ed449143$exports = import.meta.resolve("eaqOE");


var $b1147cb9e80137f3$exports = {};
$b1147cb9e80137f3$exports = import.meta.resolve("8QNsK");


var $e466da13e9fe6528$exports = {};
$e466da13e9fe6528$exports = import.meta.resolve("DdZn9");


var $0e32aa59755c96ad$exports = {};
$0e32aa59755c96ad$exports = import.meta.resolve("2NDZY");


var $24885469cec44200$exports = {};
$24885469cec44200$exports = import.meta.resolve("eCxnK");


var $bbe97ffbe30c0cf1$exports = {};
$bbe97ffbe30c0cf1$exports = import.meta.resolve("ce29p");


var $a52846135b270fc1$exports = {};
$a52846135b270fc1$exports = import.meta.resolve("7RILp");


var $46b393a54d5ace4d$exports = {};
$46b393a54d5ace4d$exports = import.meta.resolve("dumoF");


var $1de3a8d8eae8101a$exports = {};
$1de3a8d8eae8101a$exports = import.meta.resolve("jZ3rX");


var $eb9fffda25b97483$exports = {};
$eb9fffda25b97483$exports = import.meta.resolve("jUIfE");


var $99389c4d49300af2$exports = {};
$99389c4d49300af2$exports = import.meta.resolve("a3dKN");


var $f56e4903b7748171$exports = {};
$f56e4903b7748171$exports = import.meta.resolve("8DUAx");


const $1411b2c03284534e$export$9454039917822fe7 = [
    {
        type: 'video',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($795d2c2c6e8c3a9e$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($bbe97ffbe30c0cf1$exports))),
        aspect: 1280 / 720,
        date: '2026.08.04',
        description: 'media.fruitSellerDescription',
        credit: 'media.khersonPoliceCredit',
        creditHref: 'https://t.me/khersonpolice'
    },
    {
        type: 'image',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0e32aa59755c96ad$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($99389c4d49300af2$exports))),
        aspect: 4942 / 3295,
        description: 'media.burntCarDescription',
        credit: 'media.antypenkoCredit'
    },
    {
        type: 'image',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6f1abaa5ed449143$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($46b393a54d5ace4d$exports))),
        aspect: 904 / 1205,
        date: '2026.08.20',
        description: 'media.busAttackDescription',
        credit: 'media.khersonPoliceCredit',
        creditHref: 'https://t.me/khersonpolice'
    },
    {
        type: 'video',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f1b38d9cc4b521d7$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($a52846135b270fc1$exports))),
        aspect: 1,
        date: '2026.08.02',
        description: 'media.bridgeAttackDescription',
        credit: 'media.telegramChannelCredit'
    },
    {
        type: 'image',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b1147cb9e80137f3$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($1de3a8d8eae8101a$exports))),
        aspect: 2252 / 1501,
        description: 'media.fpvDroneDescription',
        credit: 'media.andrushenkoCredit'
    },
    {
        type: 'image',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($24885469cec44200$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($f56e4903b7748171$exports))),
        aspect: 1.5,
        description: 'media.antiDroneNetsDescription',
        credit: 'media.antypenkoCredit'
    },
    {
        type: 'image',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e466da13e9fe6528$exports))),
        thumb: (0, (/*@__PURE__*/$parcel$interopDefault($eb9fffda25b97483$exports))),
        aspect: 1.5,
        description: 'media.firefighterDescription',
        credit: 'media.andrushenkoCredit'
    }
];


var $79d76e12037f63b2$exports = {};
$79d76e12037f63b2$exports = import.meta.resolve("fPoVf");


var $87c93d431d994be6$exports = {};
$87c93d431d994be6$exports = import.meta.resolve("84Uhl");









// Download graphics section
const $4852070c8e8f69aa$var$graphics = [
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4c9f67fa5cda8fdb$exports))),
        city: 'none'
    },
    {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5362d704e65c175$exports))),
        city: 'none'
    }
];
const $4852070c8e8f69aa$var$shareLinks = {
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=https://humansafari.org',
    x: 'https://twitter.com/intent/tweet?text=%23StopHumanSafari%20Russian%20drones%20hunt%20civilians%20in%20Kherson.%20This%20war%20crime%20must%20stop%3A%20https%3A%2F%2Fhumansafari.org%20%23HumansAreNotTargets%20%23SaveKherson',
    bluesky: 'https://bsky.app/intent/compose?text=%23StopHumanSafari%20Russian%20drones%20hunt%20civilians%20in%20Kherson.%20This%20war%20crime%20must%20stop%3A%20https%3A%2F%2Fhumansafari.org%20%23HumansAreNotTargets%20%23SaveKherson'
};
const $4852070c8e8f69aa$var$orgs = [
    (0, $22e5f27b2168a7b1$export$fa70b3b9c9c04244),
    {
        key: 'ahs',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($79d76e12037f63b2$exports))),
        donateUrl: 'https://www.gofundme.com/f/save-kherson-civilians-from-human-safari',
        socialLinks: [
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
                labelKey: 'help.website',
                href: 'https://stophumansafari.com/?utm_source=humansafari'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
                labelKey: 'help.instagram',
                href: 'https://www.instagram.com/anti_human_safari/'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($d08fdd2250a6544c$exports))),
                labelKey: 'help.bluesky',
                href: 'https://bsky.app/profile/did:plc:6npazd7klynj55fuvmpcwrbm'
            }
        ]
    },
    {
        key: 'khs',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($87c93d431d994be6$exports))),
        donateUrl: 'https://khersonhumansafari.com/#card-yu9s7p992kfsik8',
        socialLinks: [
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
                labelKey: 'help.website',
                href: 'https://khersonhumansafari.com/#card-yu9s7p992kfsik8'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
                labelKey: 'help.facebook',
                href: 'https://www.facebook.com/profile.php?id=61577795517851'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
                labelKey: 'help.instagram',
                href: 'https://www.instagram.com/khersonhumansafari/'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($d08fdd2250a6544c$exports))),
                labelKey: 'help.bluesky',
                href: 'https://bsky.app/profile/khersonhumansafari.bsky.social'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
                labelKey: 'help.x',
                href: 'https://x.com/KhersonHS2025'
            }
        ]
    }
];
// Kherson reporting. Titles are the publications' own, so they are not translated.
const $4852070c8e8f69aa$var$reportingItems = [
    {
        publication: 'Kyiv Post',
        title: "Sadistic 'Human Safari': Russia's Drone Warfare in Kherson",
        byline: 'Zarina Zabrisky, 2024.10.08',
        href: 'https://www.kyivpost.com/analysis/40206'
    },
    {
        publication: 'Euromaidan Press',
        title: "Inside Human Safari: the film that captures Russia's drones hunting Ukrainians like prey",
        byline: 'Kostiantyn Doroshenko, 2025.08.22',
        href: 'https://euromaidanpress.com/2025/08/22/the-film-showing-how-russias-killer-drones-turned-ukraine-into-a-human-safari/'
    },
    {
        publication: 'Kyiv Independent',
        title: "Inside Russia's everyday manhunt of Ukrainians in Kherson",
        byline: 'Francis Farrell and Sasha Maslov, 2026.03.06',
        href: 'https://kyivindependent.com/postcards-from-kherson-the-city-where-russian-drones-hunt-civilians-every-day/'
    },
    {
        publication: 'Business Insider',
        title: "Russia is turning Kherson into a 'human safari' as its drones hunt civilians",
        byline: 'Ibrahim Naber, 2026.08.12',
        href: 'https://www.businessinsider.com/kherson-ukraine-human-safari-russia-drones-civilians-2026-8'
    },
    {
        publication: 'Tagesschau / ARD',
        title: 'Cherson: Leben mit der russischen Menschenjagd',
        byline: 'Rebecca Barth, 2026.08.24',
        href: 'https://www.tagesschau.de/ausland/europa/ukraine-cherson-130.html'
    },
    {
        publication: 'Kyiv Post',
        title: "Inside Kherson's Red Zone: A Kyiv Post Special Report",
        byline: 'Korbinian Leo Kramer, 2026.08.27',
        href: 'https://www.kyivpost.com/post/82823'
    },
    {
        publication: 'Kyiv Post',
        title: 'In Kherson, the Front Line Runs Through Everyday Life',
        byline: 'Korbinian Leo Kramer, 2026.08.28',
        href: 'https://www.kyivpost.com/post/83134'
    }
];
function $4852070c8e8f69aa$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full text-gray-900 flex flex-col text-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "px-6 md:px-20 py-16 bg-gray-100 flex flex-col items-center gap-16",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-center max-w-2xl flex flex-col gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl md:text-5xl font-bold",
                                children: t('help.pageTitle')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg opacity-70",
                                children: t('help.sectionIntro')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg opacity-70",
                                children: t('help.sectionIntro2')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-lg opacity-70",
                                children: [
                                    t('help.sectionIntro3'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: t('help.sectionIntroBold')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f30551934a861baa$export$2e2bcd8739ae039), {
                        items: (0, $1411b2c03284534e$export$9454039917822fe7),
                        className: "max-w-3xl"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl font-bold",
                                children: t('help.step3Title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "opacity-80",
                                children: [
                                    t('help.step3Para'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "#StopHumanSafari #SaveKherson"
                                    }),
                                    ' ',
                                    t('help.step3ParaPost')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold",
                                children: t('help.shareTitle')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-4 flex-col md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $4852070c8e8f69aa$var$shareLinks.facebook,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2",
                                        children: [
                                            t('help.share', {
                                                platform: ''
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
                                                alt: t('help.facebook'),
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $4852070c8e8f69aa$var$shareLinks.x,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2",
                                        children: [
                                            t('help.share', {
                                                platform: ''
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
                                                alt: t('help.x'),
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $4852070c8e8f69aa$var$shareLinks.bluesky,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2",
                                        children: [
                                            t('help.share', {
                                                platform: ''
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d08fdd2250a6544c$exports))),
                                                alt: t('help.bluesky'),
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "opacity-60",
                                children: "#StopHumanSafari #SaveKherson"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl font-bold",
                                children: t('help.step2Title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc ml-6 flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium",
                                                children: t('help.step2Bullet1')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 opacity-80",
                                                children: [
                                                    t('help.filmScreening'),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: "https://www.khersonhumansafari.com",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        className: "text-blue-600 underline",
                                                        children: "khersonhumansafari.com"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 opacity-80",
                                                children: [
                                                    t('help.organise'),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        className: "text-blue-700 underline",
                                                        href: `mailto:${t('help.email')}`,
                                                        children: t('help.email')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium",
                                                children: t('help.step2Bullet2')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 opacity-80",
                                                children: [
                                                    t('help.publicActionLead'),
                                                    ' ',
                                                    t('help.reachOutPre'),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        className: "text-blue-700 underline",
                                                        href: `mailto:${t('help.actionEmail')}`,
                                                        children: t('help.reachOut')
                                                    }),
                                                    ' ',
                                                    t('help.reachOutPost')
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium",
                                                children: t('help.step2Bullet3')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-1 opacity-80",
                                                children: [
                                                    t('help.newsCoverageLead'),
                                                    ' ',
                                                    t('help.putInTouchPre'),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        className: "text-blue-700 underline",
                                                        href: `mailto:${t('help.actionEmail')}`,
                                                        children: t('help.putInTouch')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b486a488ff0df712$export$3a8051bd9fdfcc83), {
                        orgs: $4852070c8e8f69aa$var$orgs,
                        introKey: "help.donateIntro"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl font-bold",
                                children: t('help.policyTitle')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "opacity-80",
                                children: t('help.policyBody')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "opacity-80",
                                children: [
                                    t('help.policyHelp'),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: `mailto:${t('help.actionEmail')}`,
                                        className: "text-blue-600 underline",
                                        children: [
                                            t('help.getInTouch'),
                                            " \u2192"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27e80ec559955030$export$2e2bcd8739ae039), {
                        groups: (0, $024044fcaf567dee$export$fb792e516a64c904),
                        subKey: "follow.subHumanSafari"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold",
                                        children: t('help.inform')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "opacity-70",
                                        children: t('help.informSub')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.linkLibraryTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-base opacity-70",
                                                children: t('resources.linkLibraryDesc')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://linktr.ee/Kherson_Human_Safari",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline break-all",
                                                children: "https://linktr.ee/Kherson_Human_Safari"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.humanSafariMapTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-base opacity-70",
                                                children: t('resources.humanSafariMapDesc')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://maps.tochnyi.info/humansafari/",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline break-all",
                                                children: "https://maps.tochnyi.info/humansafari"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.truthHoundsTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://truth-hounds.org/en/cases/killzone-how-russian-drones-are-devastating-the-river-dnipros-right-bank/",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: t('resources.truthHoundsDesc')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.hrwTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://www.hrw.org/report/2025/06/03/hunted-from-above/russias-use-of-drones-to-attack-civilians-in-kherson-ukraine",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: t('resources.hrwDesc')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.unReportsTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/coiukraine/a-hrc-59-crp2-en.pdf",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline block",
                                                children: t('resources.report1')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://www.ohchr.org/en/hr-bodies/hrc/iicihr-ukraine/reports/report-independent-international-commission-inquiry-ukraine-un-general-assembly-a80497",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline block",
                                                children: t('resources.report3')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/coiukraine/a-80-497-advance-unedited-version-en.pdf",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: t('resources.guidelines')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.wikipediaTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://en.wikipedia.org/wiki/Human_safari_(terror_campaign)",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: t('resources.english')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('help.disdict.title')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://disdict.org/warcrimes/humansafari",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: t('help.disdict.link')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t('resources.documentaryTitle')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://www.khersonhumansafari.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: "www.khersonhumansafari.com"
                                            })
                                        ]
                                    }),
                                    $4852070c8e8f69aa$var$reportingItems.map(({ publication: publication, title: title, byline: byline, href: href })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: publication
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: href,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-blue-600 underline",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm opacity-60",
                                                    children: byline
                                                })
                                            ]
                                        }, href)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a3fd57dc35ac40$export$7639867049e23dd5), {
                                        groups: (0, $d4e326393afeafd4$export$212d0b5f06f89c2f)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e657e135fac042e$export$bd58e0403794477c), {
                        id: "kherson-graphics",
                        images: $4852070c8e8f69aa$var$graphics
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "flex justify-center items-center py-12 bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $43f18c0047822054$export$a6c7ac8248d6e38a), {
                    to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).action.path,
                    className: "text-blue-700 underline text-xl",
                    children: [
                        t('help.howItStarted'),
                        " \u2192"
                    ]
                })
            })
        ]
    });
}












// Petitions about Oleshky, listed under "Sign" on the left bank (Drone Siege) page.
// `titleKey`: translation key of the title (under leftBank.petitions); `by`: who runs the petition,
// shown after the link as plain text
const $b4406d76d54b94aa$export$a9ad23f087102ebe = [
    {
        titleKey: 'leftBank.petitions.euParliament',
        href: 'https://www.europarl.europa.eu/petitions/en/petition/subscription/subscriptionById/form/39495'
    },
    {
        titleKey: 'leftBank.petitions.ukParliament',
        href: 'https://petition.parliament.uk/petitions/782668'
    }
];




var $c6a5d83940991f88$exports = {};
$c6a5d83940991f88$exports = import.meta.resolve("2Ddhd");







const $c4c81c5232ae489e$var$shareLinks = {
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=https://humansafari.org',
    x: 'https://twitter.com/intent/tweet?text=%23StopDroneSiege%20Russian%20drones%20besiege%206%2C000%20civilians%20in%20Oleshky.%20This%20war%20crime%20must%20stop%3A%20https%3A%2F%2Fhumansafari.org%20%23HumansAreNotTargets%20%23SaveOleshky%20%23SafePassageNow',
    bluesky: 'https://bsky.app/intent/compose?text=%23StopDroneSiege%20Russian%20drones%20besiege%206%2C000%20civilians%20in%20Oleshky.%20This%20war%20crime%20must%20stop%3A%20https%3A%2F%2Fhumansafari.org%20%23HumansAreNotTargets%20%23SaveOleshky%20%23SafePassageNow'
};
const $c4c81c5232ae489e$var$orgs = [
    {
        key: 'kryla',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($c6a5d83940991f88$exports))),
        donateUrl: 'https://www.kryla.foundation/#donate',
        socialLinks: [
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($ee546d8dd55165f4$exports))),
                labelKey: 'help.website',
                href: 'https://www.kryla.foundation/'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
                labelKey: 'help.facebook',
                href: 'https://www.facebook.com/KRYLA.CF'
            },
            {
                asset: (0, (/*@__PURE__*/$parcel$interopDefault($6cea37889f767640$exports))),
                labelKey: 'help.instagram',
                href: 'https://www.instagram.com/kryla_cf'
            }
        ]
    },
    // food relief: donors write "Food for Cherson" as the reference
    {
        ...(0, $22e5f27b2168a7b1$export$fa70b3b9c9c04244),
        descKey: 'help.fellas.foodDesc',
        noteKey: 'help.fellas.foodNote'
    }
];
function $c4c81c5232ae489e$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full text-gray-900 flex flex-col text-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "px-6 md:px-20 py-16 bg-gray-100 flex flex-col items-center gap-16",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-center max-w-2xl flex flex-col gap-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl md:text-5xl font-bold",
                                children: t('leftBank.pageTitle')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg opacity-70",
                                children: t('leftBank.para1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-lg opacity-70",
                                children: [
                                    t('leftBank.para2'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: t('leftBank.callToHelp')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl font-bold",
                                children: t('help.step3Title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "opacity-80",
                                children: [
                                    t('help.step3Para'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "#StopDroneSiege #SaveOleshky #SafePassageNow"
                                    }),
                                    ' ',
                                    t('leftBank.tellPost')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "font-semibold",
                                children: t('help.shareTitle')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-4 flex-col md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $c4c81c5232ae489e$var$shareLinks.facebook,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2",
                                        children: [
                                            t('help.share', {
                                                platform: ''
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7af4302066907ae3$exports))),
                                                alt: t('help.facebook'),
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $c4c81c5232ae489e$var$shareLinks.x,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2",
                                        children: [
                                            t('help.share', {
                                                platform: ''
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($84056e99848adef8$exports))),
                                                alt: t('help.x'),
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $c4c81c5232ae489e$var$shareLinks.bluesky,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2",
                                        children: [
                                            t('help.share', {
                                                platform: ''
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d08fdd2250a6544c$exports))),
                                                alt: t('help.bluesky'),
                                                className: "h-5 w-5"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "opacity-60",
                                children: "#StopDroneSiege #SaveOleshky #SafePassageNow"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl font-bold",
                                children: t('help.step2Title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "list-disc ml-6 flex flex-col gap-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: t('help.step2Bullet2')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "mt-1 opacity-80",
                                            children: [
                                                t('leftBank.publicActionLead'),
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$a6c7ac8248d6e38a), {
                                                    to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).oleshky.path,
                                                    className: "text-blue-700 underline",
                                                    children: t('leftBank.organiseAction')
                                                }),
                                                ' ',
                                                t('help.reachOutPre'),
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    className: "text-blue-700 underline",
                                                    href: `mailto:${t('help.actionEmail')}`,
                                                    children: t('help.reachOut')
                                                }),
                                                ' ',
                                                t('help.reachOutPost')
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b486a488ff0df712$export$3a8051bd9fdfcc83), {
                        orgs: $c4c81c5232ae489e$var$orgs,
                        introKey: "leftBank.donateIntro"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl font-bold",
                                children: t('help.policyTitle')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "opacity-80",
                                children: t('leftBank.policyBody')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "opacity-80",
                                children: [
                                    t('help.policyHelp'),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: `mailto:${t('help.actionEmail')}`,
                                        className: "text-blue-600 underline",
                                        children: [
                                            t('help.getInTouch'),
                                            " \u2192"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold",
                                        children: t('leftBank.signTitle')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "opacity-70",
                                        children: t('leftBank.signSub')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "list-disc ml-6 flex flex-col gap-2",
                                children: (0, $b4406d76d54b94aa$export$a9ad23f087102ebe).map(({ titleKey: titleKey, href: href, by: by })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: href,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-blue-600 underline",
                                                children: t(titleKey)
                                            }),
                                            by && ` \u{2013} ${t('leftBank.petitionBy', {
                                                name: by
                                            })}`
                                        ]
                                    }, href))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27e80ec559955030$export$2e2bcd8739ae039), {
                        groups: (0, $024044fcaf567dee$export$a9017f0eaf7977f6),
                        subKey: "follow.subDroneSiege"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-6 w-full max-w-5xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-2xl font-bold",
                                        children: t('help.inform')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "opacity-70",
                                        children: t('help.informSub')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-col gap-6",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a3fd57dc35ac40$export$7639867049e23dd5), {
                                    groups: (0, $83d2be3c4829d3b5$export$f33c501800aa1c3c)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e657e135fac042e$export$bd58e0403794477c), {
                        id: "art-posters",
                        images: (0, $45ed955dd045a702$export$fe1003df9da4792)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "flex justify-center items-center py-12 bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $43f18c0047822054$export$a6c7ac8248d6e38a), {
                    to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).action.path,
                    className: "text-blue-700 underline text-xl",
                    children: [
                        t('help.howItStarted'),
                        " \u2192"
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");









function $0ab5936f55ae3d41$export$4ba5ea103d06cb16({ groups: groups }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-10 px-6 md:px-20 py-25 bg-gray-100 text-center text-xl md:text-2xl leading-relaxed opacity-90 items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "text-4xl md:text-5xl font-medium",
                children: t('resources.title')
            }),
            groups.map(({ title: title, links: links, i18n: i18n, video: video }, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-3 max-w-4xl w-full mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "block text-2xl",
                            children: i18n ? t(title) : title
                        }),
                        video && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1dfd2e7347482b7$export$2e2bcd8739ae039), {
                            video: video,
                            title: i18n ? t(title) : title
                        }),
                        links.map(({ label: label, href: href, date: date })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                href: href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "underline text-blue-600 block",
                                children: [
                                    i18n ? t(label) : label,
                                    date && ` (${date})`
                                ]
                            }, href))
                    ]
                }, i))
        ]
    });
}




function $b7c84c4d87b8ae2d$export$dc97fa9d20bd2eb1() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "aria-labelledby": "un-recommendations-heading",
        className: "flex flex-col gap-8 md:gap-12 px-6 py-25 bg-gray-50 text-center text-md md:text-xl leading-relaxed opacity-90",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                id: "un-recommendations-heading",
                className: "text-4xl md:text-5xl font-medium",
                children: t('home.recommendationsTitle')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "bold underline pb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            className: "text-2xl",
                            children: t('home.recommendationsRussia')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "mb-2 text-2xl leading-relaxed",
                                children: t('home.rusRec1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "mb-2 text-2xl leading-relaxed",
                                children: [
                                    t('home.rusRec2'),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "mb-2 text-2xl leading-relaxed",
                                children: t('home.rusRec3')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        className: "bold underline pb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            className: "text-2xl",
                            children: t('home.recommendationsUNStates')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "mb-2 text-2xl leading-relaxed",
                                children: t('home.statesRec1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "mb-2 text-2xl leading-relaxed",
                                children: t('home.statesRec2')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $154fc9a48cee8a82$export$343fd3c1fa89086({ titleKey: titleKey, itemKeys: itemKeys }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "aria-labelledby": "rally-demands-heading",
        className: "flex flex-col gap-8 md:gap-12 px-6 py-25 bg-gray-50 text-center text-md md:text-xl leading-relaxed opacity-90",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                id: "rally-demands-heading",
                className: "text-4xl md:text-5xl font-medium",
                children: t(titleKey)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "list-disc list-inside max-w-4xl mx-auto",
                children: itemKeys.map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "mb-2 text-2xl leading-relaxed",
                        children: t(key)
                    }, key))
            })
        ]
    });
}


function $fa597985fce3d520$export$2e2bcd8739ae039({ rally: rally }) {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const location = (0, $43f18c0047822054$export$45d76561a5302f2b)();
    const navigate = (0, $43f18c0047822054$export$9770f232ac06a008)();
    const sizeClass1 = i18n.language === 'fr' || i18n.language === 'da' ? `wrap-break-word inline-block text-4xl sm:text-6xl md:text-6xl lg:text-7xl xl:text-9xl` : 'text-6xl md:text-8xl xl:text-9xl';
    (0, $acw62.useEffect)(()=>{
        if (location.state?.scrollToId) {
            const element = document.getElementById(location.state.scrollToId);
            if (element) {
                const isMobile = window.matchMedia('(max-width: 768px)').matches;
                const offset = isMobile ? window.innerHeight * 0.1 : window.innerHeight * 0.8;
                const top = element.getBoundingClientRect().top + window.scrollY + offset;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
            }
            navigate(location.pathname, {
                replace: true,
                state: {}
            });
        }
    }, [
        location.state,
        navigate,
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen w-full text-gray-900 flex flex-col text-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "flex flex-col justify-center items-center w-full min-h-[75vh] text-center px-4 bg-gray-100 pb-10 pt-4 gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-left md:text-center font-medium opacity-90 mb-4 wrap-break-word flex flex-col gap-4 text-6xl md:text-7xl",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: t(`${rally.i18n}.heroStop`)
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "bg-black p-[0.5px] w-[80%] md:self-center"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t(`${rally.i18n}.heroSave`)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: `inline-flex ${sizeClass1} font-semibold flex-wrap text-right items-center justify-end md:text-center text-blue-500 gap-4 mb-3`,
                        dangerouslySetInnerHTML: {
                            __html: t(`${rally.i18n}.worldwideRally`)
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-3xl md:text-4xl mt-12 font-semibold mb-3 uppercase",
                        children: t(`${rally.i18n}.heroDate`)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-lg opacity-80",
                        children: rally.hashtags
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "px-6 md:px-20 py-12 pb-20 text-center text-2xl leading-relaxed opacity-90 bg-gray-50 flex flex-col justify-center items-center lg:flex-row",
                children: [
                    rally.video ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-full pb-8 lg:pb-0 lg:w-[50%] shrink-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1dfd2e7347482b7$export$2e2bcd8739ae039), {
                            video: rally.video,
                            title: t('leftBank.documentaryTitle'),
                            className: "",
                            autoplay: true
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: rally.image,
                        alt: rally.imageAltKey ? t(rally.imageAltKey) : 'human safari drone',
                        className: "pb-8 lg:pb-0 lg:w-[50%]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "px-4",
                        children: rally.infoKeys.map((key, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                children: [
                                    i > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        i18nKey: key,
                                        components: {
                                            bold: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {})
                                        }
                                    })
                                ]
                            }, key))
                    })
                ]
            }),
            !!rally.posters?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-blue-800 w-full text-gray-100 p-3 uppercase flex justify-center text-center text-xl md:text-2xl font-bold",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>{
                        const el = document.getElementById('posters-gallery');
                        if (el) el.scrollIntoView({
                            behavior: 'smooth'
                        });
                    },
                    className: "rounded-full text-blue-800 bg-white px-6 py-3 shadow-lg hover:bg-blue-700 cursor-pointer transition",
                    children: t(`${rally.i18n}.seeGallery`)
                })
            }),
            rally.photos && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd29408e01e545$export$2e2bcd8739ae039), {
                id: "rallies",
                images: rally.photos,
                rally: rally,
                collapseToFirstRow: true,
                height: "aspect-2/2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3c9eaf6afd8474b$export$2e2bcd8739ae039), {
                rally: rally
            }),
            rally.demands ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $154fc9a48cee8a82$export$343fd3c1fa89086), {
                titleKey: rally.demands.titleKey,
                itemKeys: rally.demands.itemKeys
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7c84c4d87b8ae2d$export$dc97fa9d20bd2eb1), {}),
            rally.resources ? // skip the video already shown at the top of the page
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ab5936f55ae3d41$export$4ba5ea103d06cb16), {
                groups: rally.resources.filter((g)=>!g.video || g.video.id !== rally.video?.id)
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $546163da95c84112$export$e9a269813a6315a4), {}),
            !!rally.posters?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd29408e01e545$export$2e2bcd8739ae039), {
                id: "posters",
                images: rally.posters,
                rally: rally,
                downloadable: true
            })
        ]
    });
}





var $306bdf8fabfd0d9f$exports = {};
$306bdf8fabfd0d9f$exports = import.meta.resolve("31s5F");


function $05adfc043380d736$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-screen w-full flex-col items-center justify-center gap-4 bg-white py-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b76ad298314b8cd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($306bdf8fabfd0d9f$exports))),
                controls: true,
                playsInline: true,
                className: "w-[420px] max-w-full outline outline-gray-200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: (0, (/*@__PURE__*/$parcel$interopDefault($306bdf8fabfd0d9f$exports))),
                download: "oleshky-reel.mp4",
                className: "rounded-full bg-blue-800 px-6 py-3 text-white shadow-lg transition hover:bg-blue-700",
                children: t('rallies.reel.download')
            })
        ]
    });
}






function $cd93687958c8007e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $43f18c0047822054$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                    path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).reel.path,
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05adfc043380d736$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                    path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).home.path,
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $161422b2c27d7a41$export$c84671f46d6a1ca), {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$444b3ab0cb9aec40), {
                                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).oleshky.path,
                                replace: true
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).oleshky.path,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa597985fce3d520$export$2e2bcd8739ae039), {
                                rally: (0, $64eb78d2855f6aef$export$67f75aef892f4e8c)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).leftBank.path,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4c81c5232ae489e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).action.path,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654963a7c7838280$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: "/home",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$444b3ab0cb9aec40), {
                                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).action.path,
                                replace: true
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).help.path,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4852070c8e8f69aa$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).rallies.path,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd29408e01e545$export$2e2bcd8739ae039), {
                                id: "gallery",
                                images: (0, $b06743023139191a$export$ee5f96e597047257),
                                height: "aspect-2/2"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).resources.path,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $546163da95c84112$export$e9a269813a6315a4), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f18c0047822054$export$444b3ab0cb9aec40), {
                                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).home.path,
                                replace: true
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $880c561c4717b40d$exports = {};
$880c561c4717b40d$exports = JSON.parse('{"home":{"heroStop":"STOP HUMAN SAFARI","heroSave":"SAVE KHERSON","heroTitle1":"Humans","heroTitle2":"Are Not Targets","heroDate":"December 13, 14","worldwideRally":"Worldwide Rally","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"Since summer 2024, Russian military use small drones to hunt, kill and terrorise civilians on the streets of Kherson and other frontline cities in Ukraine. <bold>Human safari must stop. YOU can help.</bold> Join thousands around the world to demand this war crime stops.","seeGallery":"See worldwide posters","comingSoon":"Locations coming soon","december":"December","dec":"Dec","october":"October","oct":"Oct","september":"September","sep":"Sep","schedule9":"9th","schedule10":"10th","schedule11":"11th","schedule12":"12th","schedule13":"13th","schedule14":"14th","schedule16":"16th","schedule18":"18th","schedule20":"20th","schedule1":"1st","schedule2":"2nd","schedule3":"3rd","schedule4":"4th","schedule5":"5th","schedule25":"25th","schedule26":"26th","schedule27":"27th","schedule28":"28th","schedule29":"29th","schedule30":"30th","schedule31":"31st","scheduleTBC":"Confirming date...","recommendationsTitle":"Recommendations of the UN Commission","recommendationsRussia":"The Commission recommends that the Russian Federation:","rusRec1":"(a) Immediately end the drone attacks targeting civilians and civilian objects","rusRec2":"(b) Immediately stop all acts that spread terror among the civilian population","rusRec3":"(c) Ensure that all perpetrators involved in drone attacks targeting civilians are held accountable","recommendationsUNStates":"The Commission recommends that other States and regional and international organizations: ","statesRec1":"(a) Contribute both financially and with technical advice to the Government of Ukraine and to civil society organisations, for the provision of comprehensive support for victims and their families;","statesRec2":"(b) For third States whose territory is the destination of persons deported from the occupied territories, undertake necessary efforts together with Ukrainian consular services to support these persons.","reference":"Reference","linkUN":"UN Commission: Russia\'s \\"human safari\\" in Ukraine is a crime against humanity","linkGuidelines":"UN Guidelines","linkWiki":"Wikipedia"},"witnesses":{"title":" We are collecting eyewitness accounts!","email":"If you are from Kherson, Nikopol, Zaporizhzhia, Sumy, or the frontline areas of Donbas and have witnessed a \u201Chuman safari\u201D firsthand, please send us your stories to \uD83D\uDCE7 <mail>khersonhumansafari@gmail.com</mail>, subject: \u201Chuman safari.\u201D","type":" If you witnessed the death of a friend or neighbor in a drone attack and wish to share your account, please indicate \u201Ceyewitness\u201D; if you were personally attacked, please indicate \u201Csurvivor.\u201D","requirements":"<b>What we need:</b> city/location, date of attack, short story (3\u20136 sentences; factual, first-person).","honesty":"Be honest, concise, and avoid including sensitive military positions \u2014 you may remain anonymous.","media":"<b>Photos/videos?</b> Write \u201CPhotos/videos available\u201D. Do not attach files \u2014 we will contact you if visuals are needed.","consent":"<b>Consent for publication:</b> \u201CI agree for this story to be published publicly on the HumanSafari.org website.\u201D"},"resources":{"title":"Key Resources","linkLibraryTitle":"Link Library","linkLibraryDesc":"200 Articles, Reports, Interviews, Firsthand Testimony, and Media Coverage","humanSafariMapTitle":"Tochnyi Human Safari map","humanSafariMapDesc":"An interactive map of Human Safari attacks in Kherson, compiled from open-source reports by local authorities and from attack footage geolocated by the Tochnyi team.","truthHoundsTitle":"Truth Hounds Report","truthHoundsDesc":"Killzone: How Russian Drones Are Devastating the River Dnipro\u2019s Right Bank","hrwTitle":"Human Rights Watch Report on Drone Attacks in Kherson","hrwDesc":"HRW Report","unReportsTitle":"UN Human Rights Council Reports","report1":"UN Report #1","report3":"UN Report #3","guidelines":"UN Guidelines","wikipediaTitle":"Wikipedia","english":"English","french":"French","documentaryTitle":"Documentary","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13th-14th Dec","eyewitnesses":"accounts","rallies":"photos","help":"deoccupied Kherson","leftBank":"occupied Kherson","action":"Dec \'25","oleshky":"global demo - Oleshky","menu":"Menu"},"leftBank":{"pageTitle":"Drone Siege","para1":"An acute humanitarian emergency affects 6,000 civilians trapped under a drone siege in occupied Oleshky, Hola Prystan, Stara Zburivka, and Nova Zburivka - occupied Kherson region. In Oleshky 1,200 - 2,000. The occupying authority is obligated to support them - instead they are used as human shields by the russian forces, to hide behind this population while carrying out Human Safari attacks on the opposite bank. Systematic obstruction of evacuation and humanitarian access is reported by Ukrainian authorities and humanitarian actors.","para2":"Civilians lack food, water, medical care, medicines, electricity, gas, and communications. Roads are heavily mined and drone activity restricts movement. No vehicles have been able to enter or leave since 26 May. Fuel and food supplies are nearly exhausted.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"Video: Kherson and Oleshky: Witnessing Genocide (12 min watch)","meidasArticle":"Article: The Kherson Region: How Russia Uses Civilians as a Tool of War (5 min read)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Article: Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate (7 min read)","tellPost":"and tell others about the Drone Siege","callToHelp":"YOU can help. Here\'s how","donateIntro":"These are initiatives which provide high-impact and targeted help directly to people who have fled from or, where it\'s possible, are trapped in Oleshky.","signTitle":"Sign","signSub":"petitions","petitionBy":"by {{name}}","petitions":{"euParliament":"European Parliament \u2013 Petition No 1439/2026 on establishing a humanitarian evacuation corridor for civilians trapped under siege in Russian-occupied Oleshky, Ukraine","ukParliament":"UK Parliament \u2013 Seek to introduce a UK-led humanitarian aid corridor to Oleshky in Ukraine"},"publicActionLead":"Point the spotlight on the Drone Siege where you are.","organiseAction":"Organise an action.","policyBody":"The Ukrainian authorities are in consultations with the International Committee of the Red Cross on establishing a humanitarian evacuation corridor from occupied settlements in the Kherson region and securing humanitarian access for food, water, medicine, fuel, and medical assistance. As of early June, no functioning evacuation corridor or sustained humanitarian access mechanism is in place.","documentaryTitle":"Oleshky, short documentary","downloadTitle":"Download","downloadSub":"graphics"},"footer":{"addCityText":"To add your city, send an email to: ","organiseText":"Add your demo - get in touch:","contact":"Contact:"},"byCountry":"view by country","byDate":"view by date","countries":{"australia":"Australia","austria":"Austria","bulgaria":"Bulgaria","canada":"Canada","czechia":"Czechia","denmark":"Denmark","estonia":"Estonia","finland":"Finland","france":"France","georgia":"Georgia","germany":"Germany","hungary":"Hungary","italy":"Italy","japan":"Japan","mexico":"Mexico","netherlands":"Netherlands","norway":"Norway","poland":"Poland","romania":"Romania","spain":"Spain","sweden":"Sweden","southAfrica":"South Africa","ukraine":"Ukraine","unitedKingdom":"United Kingdom","usa":"USA","ireland":"Ireland","belgium":"Belgium"},"cities":{"alicante":{"city":"Alicante","country":"Spain","time":"Alicante - Spain, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcelona","country":"Spain","time":"Barcelona - Spain, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"USA","time":"Berkeley - USA, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berlin","country":"Germany","time":"Berlin - Germany, 12:00","location":"Tempelhofer Feld, entry Leinstr./corner of Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"USA","time":"Bettendorf - USA, 17:30 - Film Screening","location":"Bettendorf Public Library","cleanTime":"17:30 - Film Screening","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"United Kingdom","time":"Birmingham - United Kingdom, 14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Germany","time":"Bonn - Germany, 14:00 - 16:00","location":"Poststra\xdfe, in front of the Hauptbahnhof","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Bremen","country":"Germany","time":"Bremen - Germany, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapest","country":"Hungary","time":"Budapest - Hungary, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Constan\u021Ba","country":"Romania","time":"Constan\u021Ba - Romania, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"Copenhagen","country":"Denmark","time":"Copenhagen - Denmark, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"USA","time":"Dallas - USA, 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"USA","time":"Denver - USA, 12:00","location":"Colorado Capitol Building, West Steps","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"Edinburgh","country":"United Kingdom","time":"Edinburgh - United Kingdom, 13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"USA","time":"Fort Worth - USA, 14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Hamburg","country":"Germany","time":"Hamburg - Germany, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"USA","time":"Houghton, Michigan - USA, 15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finland","time":"Helsinki - Finland, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Japan","time":"Izumo - Japan, 13:00","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Japan","time":"Izumo - Japan","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops, BC","country":"Canada","time":"Kamloops, BC - Canada, 15:00 - 16:00","location":"City Hall","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kyiv","country":"Ukraine","time":"Kyiv - Ukraine, 17:00-18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Leipzig","country":"Germany","time":"Leipzig - Germany, 12:00 - 13:00","location":"Willy Brandt Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 18:30 - Film Screening","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - Film Screening","day":"schedule12"},"losAngeles":{"city":"Los Angeles","country":"USA","time":"Los Angeles - USA, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"M\xe1laga","country":"Spain","time":"M\xe1laga - Spain, 18:00 - Film Screening","location":"Maydan - Centro Historico Cultural Ukraniano","cleanTime":"18:00 - Film Screening","day":"schedule13"},"manchester":{"city":"Manchester","country":"United Kingdom","time":"Manchester - United Kingdom, 14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Mexico City","country":"Mexico","time":"Mexico City - Mexico, 11:00","location":"Alameda Central. \\"Americas\\" fountain (between Hemiciclo Ju\xe1rez and Kiosk)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Milan","country":"Italy","time":"Milan - Italy, 15:00","location":"The Duomo di Milano","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"Munich","country":"Germany","time":"Munich - Germany, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"New York","country":"USA","time":"New York - USA, 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"New York","country":"USA","time":"New York - USA, 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"Nienburg (Weser)","country":"Germany","time":"Nienburg (Weser) - Germany, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Norway","time":"Oslo - Norway, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Sweden","time":"\xd6stersund - Sweden, 11:00 - 14:00","location":"Stortorget (Main Square)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"russian Embassy","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:00","location":"US Embassy","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Paris","country":"France","time":"Paris - France, 15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (march)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"Plovdiv","country":"Bulgaria","time":"Plovdiv - Bulgaria, 16:00 - 17:00","location":"by the Levski House","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Prague","country":"Czechia","time":"Prague - Czechia, 14:00","location":"Palack\xe9ho Square","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"South Africa","time":"Rosendal - South Africa, 11:00","location":"South African Police Service offices","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Tenerife","country":"Spain","time":"San Andr\xe9s, Tenerife - Spain, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"USA","time":"San Diego - USA, 14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"USA","time":"San Francisco - USA, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Germany","time":"Schwerin - Germany, 19:00 - Film Screening","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - Film Screening","day":"schedule13"},"seattle":{"city":"Seattle","country":"USA","time":"Seattle - USA, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sveti Vlas","country":"Bulgaria","time":"Sveti Vlas - Bulgaria, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"Sydney","country":"Australia","time":"Sydney - Australia, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallinn","country":"Estonia","time":"Tallinn - Estonia, 15:00 - Film Screening and Rally","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - Film Screening and Rally","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Spain","time":"Tarragona - Spain, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"The Hague","country":"Netherlands","time":"The Hague - Netherlands, 13:00 - 15:00","location":"In front of the Peace Palace / ICC","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tbilisi","country":"Georgia","time":"Tbilisi - Georgia, 21:00","location":"Tbilisi","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Sweden","time":"Tran\xe5s - Sweden, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Vienna","country":"Austria","time":"Vienna - Austria, 16:00 - 18:00","location":"Stock im Eisen Platz (next to Stephansdom)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Washington, D.C.","country":"USA","time":"Washington, D.C. - USA, 12:30 - 13:30","location":"The White House","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Poland","time":"Wroc\u0142aw - Poland, 13:00","location":"Freedom Square (direction People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"To get in touch:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Share on {{platform}}","website":"Website","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","donate":"Donate","donateIntro":"These are initiatives which provide high-impact and targeted help directly to protect Kherson civilians from Human Safari.","shareTitle":"Spread the word","filmScreening":"Organise a screening of documentary film Kherson Human Safari:","howItStarted":"How it started","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, journalist and filmmaker, led the worldwide rally and directed the documentary film Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Civilian protection for Kherson streets \u2014 protecting civilians from drone attacks.","foodDesc":"Food relief.","foodNote":"When you donate, write \u201CFood for Cherson\u201D as the reference."},"ahs":{"name":"Anti Human Safari Project","desc":"Drone detectors and protective vests for volunteers and emergency services in Kherson."},"pageTitle":"Stop Human Safari","sectionIntro":"Since summer 2024, Russian military use small drones to hunt, kill and terrorise civilians on the streets of Kherson and other frontline cities in Ukraine.","sectionIntro2":"A systematic and deliberate murder campaign, the Russian drone operators post the footage of their victims openly in Telegram channels to brag. The UN recognised Human Safari as an ongoing war crime in May 2025.","sectionIntro3":"Too little is being done. Human Safari must stop.","sectionIntroBold":"YOU can help. Here\'s how","step2Title":"Organise","step3Title":"Tell people","step3Para":"Use the hashtags","step3ParaPost":"and tell others about Human Safari","instagram":"Instagram","step2Bullet1":"a film screening","step2Bullet2":"a public action","step2Bullet3":"news coverage","publicActionLead":"Point the spotlight on Human Safari where you are.","reachOutPre":"You can","reachOut":"reach out","reachOutPost":"for ideas and resources","newsCoverageLead":"via your media contacts. Tell them about Human Safari and the risk to all future and current areas of conflict.","putInTouchPre":"You can also","putInTouch":"put us directly in touch","inform":"Inform","informSub":"yourself and others","policyTitle":"Policy","policyBody":"The proposed LORA Act (Liability for Operators and Responsible Authorities Act) would establish sanctions across the full chain of responsibility \u2014 from Russian FPV operators and commanders to senior military leadership, as well as manufacturers and suppliers enabling drone production and deployment against civilians.","policyHelp":"You can help on a policy level?","getInTouch":"Get in touch","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"kryla":{"name":"Kryla Foundation","desc":"Support them to pay for accommodation and basic supplies for Oleshky residents."}},"action":{"intro":"We started with a worldwide demonstration. Now you can:","helpLink":"help here"},"accounts":{"heading":"Accounts"},"media":{"close":"Close","view":"View media","previous":"Previous","next":"Next","andrushenkoCredit":"Oleksandr Andrushenko, photo correspondent for the outlet Vgoru","khersonPoliceCredit":"from @khersonpolice","antypenkoCredit":"Ivan Antypenko, photojournalist from Kherson","telegramChannelCredit":"posted by the Russian Human Safari Telegram channel \u201Cfrom Mariupol to the Carpathians\u201D","fruitSellerDescription":"Fruit seller chased by fibre-optic drone","burntCarDescription":"Burnt-out car in Kherson","bridgeAttackDescription":"Teenage boy murdered by an FPV drone under a bridge in Kherson","busAttackDescription":"One of many FPV drone attacks on public transport","fpvDroneDescription":"FPV drone out on Human Safari","antiDroneNetsDescription":"Kherson street covered by nets against Human Safari drones","firefighterDescription":"Firefighter extinguishes a car after a Human Safari strike, victim lies behind"},"follow":{"title":"Follow","subHumanSafari":"quality sources reporting from Kherson and about Human Safari","subDroneSiege":"quality sources reporting from Kherson and about the Drone Siege","localPress":"local Ukrainian-language press","lang":{"english":"English","german":"German","ukrainian":"Ukrainian"},"language":"Language: {{list}}","languages":"Languages: {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"US journalist and filmmaker based in Kherson, reporting for Byline Times and Euromaidan Press; director of the documentary Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"Chief reporter for the German newspaper Die Welt; reports periodically on Human Safari in Kherson."},"kelley":{"name":"Brendan Kelley","desc":"Writes Kherson Weekly, a running record of Russian drone attacks on civilians in Kherson and the surrounding villages."},"vgoru":{"name":"Vgoru","desc":"Independent media platform from Kherson region, reporting on life under attack and in occupation."},"suspilne":{"name":"Suspilne Kherson","desc":"The Kherson newsroom of Ukraine\'s public broadcaster."},"most":{"name":"MOST","desc":"Local Kherson news agency covering the city and the region."}},"rallies":{"oleshky2026":{"heroStop":"STOP DRONE SIEGE","heroSave":"SAVE OLESHKY","worldwideRally":"Worldwide Demo","heroDate":"October","infoText1":"Thousands of civilians are trapped under drone siege in Oleshky, Hola Prystan, Stara Zburivka and Nova Zburivka. They are used as human shields by Russian forces hiding behind them to carry out Human Safari drone attacks on the opposite bank.","infoText2":"The crisis is acute - lack of food, water, medical care, medicines, electricity, gas, and communications. Roads are heavily mined and drone activity restricts movement. <bold>YOU can help. Join thousands around the world to demand the drone siege stops.</bold>","imageAlt":"A starving dog among human bones in ruined Oleshky, under a red sky full of drones, with the words Stop Russian Drone Siege","demandsTitle":"We call for:","demand1":"safe and effective humanitarian corridors to Oleshky and other affected communities.","demand2":"immediate humanitarian relief and assistance for victims of human safari attacks.","demand3":"appropriate sanctions against individuals and supply chains responsible for attacks targeting civilians.","demand4":"steps to deter the use of small drones to systematically target and terrorise civilians in Kherson, Ukraine, and elsewhere.","cities":{"edinburgh":{"city":"Edinburgh","country":"United Kingdom","time":"Edinburgh - United Kingdom, 14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"United Kingdom","time":"Birmingham - United Kingdom, 14:00 - 16:00","location":"Opposite the Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Vienna","country":"Austria","time":"Vienna - Austria, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"Munich","country":"Germany","time":"Munich - Germany, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"Manchester","country":"United Kingdom","time":"Manchester - United Kingdom, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"Sydney","country":"Australia","time":"Sydney - Australia, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Paris","country":"France","time":"Paris - France, 15:30 - 18:30","location":"From Saint Volodymyr church to Place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Paris","country":"France","time":"Paris - France, 18:00","location":"Rambuteau metro","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lyon","country":"France","time":"Lyon - France, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dublin","country":"Ireland","time":"Dublin - Ireland, 13:00","location":"The GPO","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Brussels","country":"Belgium","time":"Brussels - Belgium, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Brussels (Schuman Roundabout)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"Russian Embassy, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"France","time":"Nantes - France, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Gda\u0144sk","country":"Poland","time":"Gda\u0144sk - Poland, 18:30 - 19:30","location":"D\u0142ugi Targ, next to the Neptune Fountain","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Dresden","country":"Germany","time":"Dresden - Germany, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"M\xe1laga","country":"Spain","time":"M\xe1laga - Spain, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"Plovdiv","country":"Bulgaria","time":"Plovdiv - Bulgaria, 17:00","location":"Main street (Glavnata), by the Kamenitza steps / the \\"Together\\" sign","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapest","country":"Hungary","time":"Budapest - Hungary, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (St Stephen\'s Square)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Hamburg","country":"Germany","time":"Hamburg - Germany, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, by Pier 1, 20359 Hamburg","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kiel","country":"Germany","time":"Kiel - Germany, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Norway","time":"Oslo - Norway","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Leipzig","country":"Germany","time":"Leipzig - Germany, 17:00 - 18:00","location":"Main station (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"London","country":"United Kingdom","time":"London - United Kingdom, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dublin","country":"Ireland","time":"Dublin - Ireland, 13:00","location":"The GPO","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dublin","country":"Ireland","time":"Dublin - Ireland, 14:00","location":"The GPO","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"France","time":"Nantes - France, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Stop Russian Drone Siege","posterNoRoadOut":"The roads in and out of Oleshky are blocked","posterHumanitarianCatastrophe":"Oleshky. A humanitarian catastrophe under occupation","seeGallery":"See / download posters"},"artBy":"Art: {{name}}","downloadPoster":"Download poster","reel":{"download":"Download video (MP4)"},"addDemo":{"title":"add your demo","where":"where: town/city","contact":"email/number","message":"message: who you represent, your demo is confirmed or WIP, link to online announcement, any other details","submit":"Submit","sending":"Sending\u2026","thanks":"Thank you! We\'ll be in touch.","error":"Something went wrong. Please try again.","contactInvalid":"Please enter a valid email, or a phone number with country code (e.g. +44 7700 900123).","date":"date","time":"start time (local)","whereInvalid":"Please enter a town or city name, e.g. Paris or Kyiv, Ukraine.","datePlaceholder":"date: dd/mm"}},"seo":{"oleshky":{"title":"Stop Drone Siege \u2014 Save Oleshky | Worldwide Demos","description":"Russian drones besiege thousands of civilians in occupied Oleshky, Ukraine, cut off from food, water and medicine. Find a demo near you and demand safe passage."},"leftBank":{"title":"Drone Siege of Oleshky and Occupied Kherson Region","description":"Thousands of civilians are trapped under a Russian drone siege in occupied Oleshky, Hola Prystan and nearby villages. Learn what is happening and how you can help."},"help":{"title":"Stop Human Safari \u2014 Russian Drones Hunting Civilians in Kherson","description":"Russian drones hunt civilians in Kherson, Ukraine. Learn about the Human Safari war crime and how you can help stop it."},"action":{"title":"December 2025 Worldwide Rally \u2014 Stop Human Safari, Save Kherson","description":"Photos, posters and places from the December 2025 worldwide rally against Russian drone attacks on civilians in Kherson, Ukraine."},"rallies":{"title":"Rally Photos \u2014 Stop Human Safari","description":"Photos from rallies around the world against Russian drone attacks on civilians in Kherson, Ukraine."},"resources":{"title":"Human Safari Resources \u2014 Reports, Articles and Testimony","description":"Reports, articles, interviews and eyewitness testimony on Russian drone attacks on civilians in Kherson, Ukraine."},"reel":{"title":"Save Oleshky \u2014 Demo Video","description":"Video of the worldwide Save Oleshky demos, October 2026."}}}');


var $324b75d4c5497ecc$exports = {};
$324b75d4c5497ecc$exports = JSON.parse('{"home":{"heroStop":"\u0417\u0423\u041F\u0418\u041D\u0418\u041C\u041E HUMAN SAFARI","heroSave":"\u0412\u0420\u042F\u0422\u0423\u0419\u0422\u0415 \u0425\u0415\u0420\u0421\u041E\u041D","heroDate":"13, 14 \u0433\u0440\u0443\u0434\u043D\u044F","worldwideRally":"\u0441\u0432\u0456\u0442\u043E\u0432\u0430 \u0430\u043A\u0446\u0456\u044F","heroTitle1":"\u041B\u044E\u0434\u0438","heroTitle2":"\u2014 \u043D\u0435 \u043C\u0456\u0448\u0435\u043D\u0456.","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"\u0417 \u043B\u0456\u0442\u0430 2024 \u0440\u043E\u043A\u0443 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0432\u0456\u0439\u0441\u044C\u043A\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C \u043C\u0430\u043B\u0456 \u0434\u0440\u043E\u043D\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u044E\u0432\u0430\u043D\u043D\u044F, \u0432\u0431\u0438\u0432\u0441\u0442\u0432 \u0456 \u0442\u0435\u0440\u043E\u0440\u0443 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044F \u043D\u0430 \u0432\u0443\u043B\u0438\u0446\u044F\u0445 \u0425\u0435\u0440\u0441\u043E\u043D\u0430 \u0442\u0430 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u0438\u0444\u0440\u043E\u043D\u0442\u043E\u0432\u0438\u0445 \u043C\u0456\u0441\u0442 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. <bold>\u0421\u0430\u0444\u0430\u0440\u0456 \u043D\u0430 \u043B\u044E\u0434\u0435\u0439 \u043C\u0430\u0454 \u043F\u0440\u0438\u043F\u0438\u043D\u0438\u0442\u0438\u0441\u044F. \u0412\u0418 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438.</bold> \u041F\u0440\u0438\u0454\u0434\u043D\u0443\u0439\u0442\u0435\u0441\u044C \u0434\u043E \u0442\u0438\u0441\u044F\u0447 \u043B\u044E\u0434\u0435\u0439 \u043F\u043E \u0432\u0441\u044C\u043E\u043C\u0443 \u0441\u0432\u0456\u0442\u0443, \u0449\u043E\u0431 \u0432\u0438\u043C\u0430\u0433\u0430\u0442\u0438 \u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438 \u0446\u0435\u0439 \u0432\u043E\u0454\u043D\u043D\u0438\u0439 \u0437\u043B\u043E\u0447\u0438\u043D.","seeGallery":"\u041F\u043B\u0430\u043A\u0430\u0442\u0438 \u0437 \u0443\u0441\u044C\u043E\u0433\u043E \u0441\u0432\u0456\u0442\u0443","comingSoon":"\u041B\u043E\u043A\u0430\u0446\u0456\u0457 \u0437\u2019\u044F\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C","december":"\u0433\u0440\u0443\u0434\u043D\u044F","dec":"\u0433\u0440\u0443\u0434.","october":"\u0436\u043E\u0432\u0442\u043D\u044F","oct":"\u0436\u043E\u0432\u0442.","september":"\u0432\u0435\u0440\u0435\u0441\u043D\u044F","sep":"\u0432\u0435\u0440.","schedule9":"9","schedule10":"10","schedule11":"11","schedule12":"12","schedule13":"13","schedule14":"14","schedule16":"16","schedule18":"18","schedule20":"20","schedule1":"1","schedule2":"2","schedule3":"3","schedule4":"4","schedule5":"5","schedule25":"25","schedule26":"26","schedule27":"27","schedule28":"28","schedule29":"29","schedule30":"30","schedule31":"31","scheduleTBC":"\u0414\u0430\u0442\u0430 \u0443\u0442\u043E\u0447\u043D\u044E\u0454\u0442\u044C\u0441\u044F...","recommendationsTitle":"\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u0457 \u041A\u043E\u043C\u0456\u0441\u0456\u0457 \u041E\u041E\u041D","recommendationsRussia":"\u041A\u043E\u043C\u0456\u0441\u0456\u044F \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0454 \u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0456\u0457:","rusRec1":"(a) \u041D\u0435\u0433\u0430\u0439\u043D\u043E \u043F\u0440\u0438\u043F\u0438\u043D\u0438\u0442\u0438 \u0430\u0442\u0430\u043A\u0438 \u0434\u0440\u043E\u043D\u0456\u0432, \u0441\u043F\u0440\u044F\u043C\u043E\u0432\u0430\u043D\u0456 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0442\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0456 \u043E\u0431\'\u0454\u043A\u0442\u0438","rusRec2":"(b) \u041D\u0435\u0433\u0430\u0439\u043D\u043E \u043F\u0440\u0438\u043F\u0438\u043D\u0438\u0442\u0438 \u0432\u0441\u0456 \u0434\u0456\u0457, \u0449\u043E \u043F\u043E\u0448\u0438\u0440\u044E\u044E\u0442\u044C \u0442\u0435\u0440\u043E\u0440 \u0441\u0435\u0440\u0435\u0434 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044F","rusRec3":"(c) \u0417\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0438\u0442\u0438, \u0449\u043E\u0431 \u0443\u0441\u0456 \u0432\u0438\u043D\u043D\u0456 \u0443 \u0430\u0442\u0430\u043A\u0430\u0445 \u0434\u0440\u043E\u043D\u0456\u0432 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0431\u0443\u043B\u0438 \u043F\u0440\u0438\u0442\u044F\u0433\u043D\u0443\u0442\u0456 \u0434\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0456","recommendationsUNStates":"\u041A\u043E\u043C\u0456\u0441\u0456\u044F \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0454 \u0456\u043D\u0448\u0438\u043C \u0434\u0435\u0440\u0436\u0430\u0432\u0430\u043C \u0442\u0430 \u0440\u0435\u0433\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u043C \u0456 \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u043C \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044F\u043C:","statesRec1":"(a) \u041D\u0430\u0434\u0430\u0442\u0438 \u0444\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0443 \u0442\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0443 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0443 \u0443\u0440\u044F\u0434\u0443 \u0423\u043A\u0440\u0430\u0457\u043D\u0438 \u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044F\u043C \u0433\u0440\u043E\u043C\u0430\u0434\u044F\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0443\u0441\u043F\u0456\u043B\u044C\u0441\u0442\u0432\u0430 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438 \u043F\u043E\u0441\u0442\u0440\u0430\u0436\u0434\u0430\u043B\u0438\u043C \u0442\u0430 \u0457\u0445\u043D\u0456\u043C \u0440\u043E\u0434\u0438\u043D\u0430\u043C;","statesRec2":"(b) \u0414\u043B\u044F \u0442\u0440\u0435\u0442\u0456\u0445 \u0434\u0435\u0440\u0436\u0430\u0432, \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u044F \u044F\u043A\u0438\u0445 \u0454 \u043F\u0443\u043D\u043A\u0442\u043E\u043C \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u0441\u0456\u0431, \u0434\u0435\u043F\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u0438\u0445 \u0437 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0438\u0445 \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u0439, \u0432\u0436\u0438\u0442\u0438 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u0445 \u0437\u0430\u0445\u043E\u0434\u0456\u0432 \u0440\u0430\u0437\u043E\u043C \u0437 \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0438\u043C\u0438 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0441\u044C\u043A\u0438\u043C\u0438 \u0441\u043B\u0443\u0436\u0431\u0430\u043C\u0438 \u0434\u043B\u044F \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u0446\u0438\u0445 \u043E\u0441\u0456\u0431."},"resources":{"title":"\u041A\u043B\u044E\u0447\u043E\u0432\u0456 \u0440\u0435\u0441\u0443\u0440\u0441\u0438","linkLibraryTitle":"\u0411\u0456\u0431\u043B\u0456\u043E\u0442\u0435\u043A\u0430 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u044C","linkLibraryDesc":"200 \u0441\u0442\u0430\u0442\u0435\u0439, \u0437\u0432\u0456\u0442\u0456\u0432, \u0456\u043D\u0442\u0435\u0440\u0432\u2019\u044E, \u0441\u0432\u0456\u0434\u0447\u0435\u043D\u044C \u043E\u0447\u0435\u0432\u0438\u0434\u0446\u0456\u0432 \u0442\u0430 \u043C\u0435\u0434\u0456\u0430-\u043F\u043E\u043A\u0440\u0438\u0442\u0442\u044F","humanSafariMapTitle":"\u041C\u0430\u043F\u0430 \xab\u043B\u044E\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0430\u0444\u0430\u0440\u0456\xbb \u0432\u0456\u0434 Tochnyi","humanSafariMapDesc":"\u0406\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0430 \u043C\u0430\u043F\u0430 \u0430\u0442\u0430\u043A \xab\u043B\u044E\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0430\u0444\u0430\u0440\u0456\xbb \u0432 \u0425\u0435\u0440\u0441\u043E\u043D\u0456, \u0437\u0456\u0431\u0440\u0430\u043D\u0430 \u0437 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0445 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C \u043C\u0456\u0441\u0446\u0435\u0432\u043E\u0457 \u0432\u043B\u0430\u0434\u0438 \u0442\u0430 \u0437 \u0432\u0456\u0434\u0435\u043E \u0430\u0442\u0430\u043A, \u044F\u043A\u0456 \u0433\u0435\u043E\u043B\u043E\u043A\u0443\u0432\u0430\u043B\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 Tochnyi.","truthHoundsTitle":"\u0417\u0432\u0456\u0442 Truth Hounds","truthHoundsDesc":"Killzone: \u042F\u043A \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0434\u0440\u043E\u043D\u0438 \u043D\u0438\u0449\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u0439 \u0431\u0435\u0440\u0435\u0433 \u0440\u0456\u0447\u043A\u0438 \u0414\u043D\u0456\u043F\u0440\u043E","hrwTitle":"\u0417\u0432\u0456\u0442 Human Rights Watch \u043F\u0440\u043E \u0430\u0442\u0430\u043A\u0438 \u0434\u0440\u043E\u043D\u0456\u0432 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456","hrwDesc":"HRW \u0417\u0432\u0456\u0442","unReportsTitle":"\u0417\u0432\u0456\u0442\u0438 \u0420\u0430\u0434\u0438 \u041E\u041E\u041D \u0437 \u043F\u0440\u0430\u0432 \u043B\u044E\u0434\u0438\u043D\u0438","report1":"\u0417\u0432\u0456\u0442 \u041E\u041E\u041D #1","report3":"\u0417\u0432\u0456\u0442 \u041E\u041E\u041D #3","guidelines":"\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u0457 \u041E\u041E\u041D","wikipediaTitle":"\u0412\u0456\u043A\u0456\u043F\u0435\u0434\u0456\u044F","english":"\u0410\u043D\u0433\u043B\u0456\u0439\u0441\u044C\u043A\u0430","french":"\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0430","documentaryTitle":"\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u0444\u0456\u043B\u044C\u043C","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13-14 \u0433\u0440\u0443\u0434\u043D\u044F","eyewitnesses":"\u0421\u0432\u0456\u0434\u043A\u0438","rallies":"\u0444\u043E\u0442\u043E","help":"\u0434\u0435\u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0430 \u0425\u0435\u0440\u0441\u043E\u043D\u0449\u0438\u043D\u0430","leftBank":"\u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0430 \u0425\u0435\u0440\u0441\u043E\u043D\u0449\u0438\u043D\u0430","action":"\u0433\u0440\u0443\u0434\u043D\u044F \'25","oleshky":"\u0433\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0430 \u0430\u043A\u0446\u0456\u044F - \u041E\u043B\u0435\u0448\u043A\u0438","menu":"\u041C\u0435\u043D\u044E"},"leftBank":{"pageTitle":"\u0414\u0440\u043E\u043D\u043E\u0432\u0430 \u043E\u0431\u043B\u043E\u0433\u0430","para1":"\u0413\u043E\u0441\u0442\u0440\u0430 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u0430 \u043A\u0440\u0438\u0437\u0430 \u043E\u0445\u043E\u043F\u0438\u043B\u0430 6000 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445, \u044F\u043A\u0456 \u043E\u043F\u0438\u043D\u0438\u043B\u0438\u0441\u044F \u0432 \u043F\u0430\u0441\u0442\u0446\u0456 \u0434\u0440\u043E\u043D\u043E\u0432\u043E\u0457 \u043E\u0431\u043B\u043E\u0433\u0438 \u0432 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0438\u0445 \u041E\u043B\u0435\u0448\u043A\u0430\u0445, \u0413\u043E\u043B\u0456\u0439 \u041F\u0440\u0438\u0441\u0442\u0430\u043D\u0456, \u0421\u0442\u0430\u0440\u0456\u0439 \u0417\u0431\u0443\u0440\'\u0457\u0432\u0446\u0456 \u0442\u0430 \u041D\u043E\u0432\u0456\u0439 \u0417\u0431\u0443\u0440\'\u0457\u0432\u0446\u0456 - \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0430 \u0425\u0435\u0440\u0441\u043E\u043D\u0449\u0438\u043D\u0430. \u0412 \u041E\u043B\u0435\u0448\u043A\u0430\u0445 1200 - 2000. \u041E\u043A\u0443\u043F\u0430\u0446\u0456\u0439\u043D\u0430 \u0432\u043B\u0430\u0434\u0430 \u0437\u043E\u0431\u043E\u0432\'\u044F\u0437\u0430\u043D\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0442\u0438 \u0457\u0445 - \u043D\u0430\u0442\u043E\u043C\u0456\u0441\u0442\u044C \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0432\u0456\u0439\u0441\u044C\u043A\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C \u0457\u0445 \u044F\u043A \u0436\u0438\u0432\u0438\u0439 \u0449\u0438\u0442, \u0449\u043E\u0431 \u0445\u043E\u0432\u0430\u0442\u0438\u0441\u044F \u0437\u0430 \u0446\u0438\u043C \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044F\u043C, \u0437\u0434\u0456\u0439\u0441\u043D\u044E\u044E\u0447\u0438 \u0430\u0442\u0430\u043A\u0438 \xab\u043B\u044E\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0430\u0444\u0430\u0440\u0456\xbb \u043D\u0430 \u043F\u0440\u043E\u0442\u0438\u043B\u0435\u0436\u043D\u043E\u043C\u0443 \u0431\u0435\u0440\u0435\u0437\u0456. \u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 \u0432\u043B\u0430\u0434\u0430 \u0442\u0430 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u0456 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u044F\u044E\u0442\u044C \u043F\u0440\u043E \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043F\u0435\u0440\u0435\u0448\u043A\u043E\u0434\u0436\u0430\u043D\u043D\u044F \u0435\u0432\u0430\u043A\u0443\u0430\u0446\u0456\u0457 \u0442\u0430 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u043E\u043C\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u0443.","para2":"\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0456 \u043D\u0435 \u043C\u0430\u044E\u0442\u044C \u0457\u0436\u0456, \u0432\u043E\u0434\u0438, \u043C\u0435\u0434\u0438\u0447\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438, \u043B\u0456\u043A\u0456\u0432, \u0435\u043B\u0435\u043A\u0442\u0440\u0438\u043A\u0438, \u0433\u0430\u0437\u0443 \u0442\u0430 \u0437\u0432\'\u044F\u0437\u043A\u0443. \u0414\u043E\u0440\u043E\u0433\u0438 \u0433\u0443\u0441\u0442\u043E \u0437\u0430\u043C\u0456\u043D\u043E\u0432\u0430\u043D\u0456, \u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u0434\u0440\u043E\u043D\u0456\u0432 \u043E\u0431\u043C\u0435\u0436\u0443\u0454 \u043F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F. \u0406\u0437 26 \u0442\u0440\u0430\u0432\u043D\u044F \u0436\u043E\u0434\u0435\u043D \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C \u043D\u0435 \u0437\u043C\u0456\u0433 \u0430\u043D\u0456 \u0432\'\u0457\u0445\u0430\u0442\u0438, \u0430\u043D\u0456 \u0432\u0438\u0457\u0445\u0430\u0442\u0438. \u0417\u0430\u043F\u0430\u0441\u0438 \u043F\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u043E\u043B\u044C\u0441\u0442\u0432\u0430 \u043C\u0430\u0439\u0436\u0435 \u0432\u0438\u0447\u0435\u0440\u043F\u0430\u043D\u0456.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"\u0412\u0456\u0434\u0435\u043E: \xabKherson and Oleshky: Witnessing Genocide\xbb (12 \u0445\u0432)","meidasArticle":"\u0421\u0442\u0430\u0442\u0442\u044F: \xabThe Kherson Region: How Russia Uses Civilians as a Tool of War\xbb (5 \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"\u0421\u0442\u0430\u0442\u0442\u044F: \xabGlobal Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate\xbb (7 \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F)","tellPost":"\u0456 \u0440\u043E\u0437\u043F\u043E\u0432\u0456\u0434\u0430\u0439\u0442\u0435 \u0456\u043D\u0448\u0438\u043C \u043F\u0440\u043E \u0414\u0440\u043E\u043D\u043E\u0432\u0443 \u043E\u0431\u043B\u043E\u0433\u0443","callToHelp":"\u0412\u0418 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041E\u0441\u044C \u044F\u043A","donateIntro":"\u0426\u0435 \u0456\u043D\u0456\u0446\u0456\u0430\u0442\u0438\u0432\u0438, \u044F\u043A\u0456 \u043D\u0430\u0434\u0430\u044E\u0442\u044C \u0434\u0456\u0454\u0432\u0443 \u0439 \u0430\u0434\u0440\u0435\u0441\u043D\u0443 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0443 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u043B\u044E\u0434\u044F\u043C, \u0449\u043E \u0432\u0438\u0457\u0445\u0430\u043B\u0438 \u0437 \u041E\u043B\u0435\u0448\u043E\u043A \u0430\u0431\u043E, \u0434\u0435 \u0446\u0435 \u043C\u043E\u0436\u043B\u0438\u0432\u043E, \u0437\u0430\u043B\u0438\u0448\u0430\u044E\u0442\u044C\u0441\u044F \u0442\u0430\u043C \u0443 \u043F\u0430\u0441\u0442\u0446\u0456.","signTitle":"\u041F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C","signSub":"\u043F\u0435\u0442\u0438\u0446\u0456\u0457","petitionBy":"\u0432\u0456\u0434 {{name}}","petitions":{"euParliament":"\u0404\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0430\u0440\u043B\u0430\u043C\u0435\u043D\u0442 \u2013 \u041F\u0435\u0442\u0438\u0446\u0456\u044F \u2116 1439/2026 \u0449\u043E\u0434\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0434\u043E\u0440\u0443 \u0434\u043B\u044F \u0435\u0432\u0430\u043A\u0443\u0430\u0446\u0456\u0457 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445, \u044F\u043A\u0456 \u043E\u043F\u0438\u043D\u0438\u043B\u0438\u0441\u044F \u0432 \u043E\u0431\u043B\u043E\u0437\u0456 \u0432 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0438\u0445 \u0440\u043E\u0441\u0456\u0454\u044E \u041E\u043B\u0435\u0448\u043A\u0430\u0445","ukParliament":"\u041F\u0430\u0440\u043B\u0430\u043C\u0435\u043D\u0442 \u0412\u0435\u043B\u0438\u043A\u043E\u0457 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u0457 \u2013 \u0417\u0430\u043F\u0440\u043E\u0432\u0430\u0434\u0438\u0442\u0438 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u0438\u0439 \u043A\u043E\u0440\u0438\u0434\u043E\u0440 \u0434\u043E \u041E\u043B\u0435\u0448\u043E\u043A \u043F\u0456\u0434 \u043F\u0440\u043E\u0432\u043E\u0434\u043E\u043C \u0412\u0435\u043B\u0438\u043A\u043E\u0457 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u0457"},"publicActionLead":"\u041F\u0440\u0438\u0432\u0435\u0440\u0442\u0430\u0439\u0442\u0435 \u0443\u0432\u0430\u0433\u0443 \u0434\u043E \u0434\u0440\u043E\u043D\u043E\u0432\u043E\u0457 \u043E\u0431\u043B\u043E\u0433\u0438 \u0442\u0430\u043C, \u0434\u0435 \u0432\u0438 \u0454.","organiseAction":"\u041E\u0440\u0433\u0430\u043D\u0456\u0437\u0443\u0439\u0442\u0435 \u0430\u043A\u0446\u0456\u044E.","policyBody":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 \u0432\u043B\u0430\u0434\u0430 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u0457 \u0437 \u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u043C \u043A\u043E\u043C\u0456\u0442\u0435\u0442\u043E\u043C \u0427\u0435\u0440\u0432\u043E\u043D\u043E\u0433\u043E \u0425\u0440\u0435\u0441\u0442\u0430 \u0449\u043E\u0434\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0434\u043E\u0440\u0443 \u0434\u043B\u044F \u0435\u0432\u0430\u043A\u0443\u0430\u0446\u0456\u0457 \u0437 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0438\u0445 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0445 \u043F\u0443\u043D\u043A\u0442\u0456\u0432 \u0425\u0435\u0440\u0441\u043E\u043D\u0441\u044C\u043A\u043E\u0457 \u043E\u0431\u043B\u0430\u0441\u0442\u0456 \u0442\u0430 \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043B\u044F \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043D\u043D\u044F \u0457\u0436\u0456, \u0432\u043E\u0434\u0438, \u043B\u0456\u043A\u0456\u0432, \u043F\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0430 \u043C\u0435\u0434\u0438\u0447\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438. \u0421\u0442\u0430\u043D\u043E\u043C \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A \u0447\u0435\u0440\u0432\u043D\u044F \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u0434\u0456\u044E\u0447\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0434\u043E\u0440\u0443 \u0435\u0432\u0430\u043A\u0443\u0430\u0446\u0456\u0457 \u0447\u0438 \u0441\u0442\u0430\u043B\u043E\u0433\u043E \u043C\u0435\u0445\u0430\u043D\u0456\u0437\u043C\u0443 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u043D\u0435\u043C\u0430\u0454.","documentaryTitle":"\u041E\u043B\u0435\u0448\u043A\u0438, \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u0444\u0456\u043B\u044C\u043C","downloadTitle":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438","downloadSub":"\u0433\u0440\u0430\u0444\u0456\u043A\u0430"},"footer":{"addCityText":"\u0429\u043E\u0431 \u0434\u043E\u0434\u0430\u0442\u0438 \u0441\u0432\u043E\u0454 \u043C\u0456\u0441\u0442\u043E, \u043D\u0430\u0434\u0456\u0448\u043B\u0456\u0442\u044C \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0430: ","organiseText":"\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u044E \u0430\u043A\u0446\u0456\u044E - \u0437\u0432\'\u044F\u0436\u0456\u0442\u044C\u0441\u044F \u0437 \u043D\u0430\u043C\u0438:","contact":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442:"},"witnesses":{"title":" \u041C\u0438 \u0437\u0431\u0438\u0440\u0430\u0454\u043C\u043E \u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F!","email":"\u042F\u043A\u0449\u043E \u0432\u0438 \u0437 \u0425\u0435\u0440\u0441\u043E\u043D\u0430, \u041D\u0456\u043A\u043E\u043F\u043E\u043B\u044F, \u0417\u0430\u043F\u043E\u0440\u0456\u0436\u0436\u044F, \u0421\u0443\u043C \u0447\u0438 \u043F\u0440\u0438\u0444\u0440\u043E\u043D\u0442\u043E\u0432\u0438\u0445 \u0440\u0430\u0439\u043E\u043D\u0456\u0432 \u0414\u043E\u043D\u0431\u0430\u0441\u0443 \u0456 \u0431\u0430\u0447\u0438\u043B\u0438 \u201C\u043B\u044E\u0434\u0441\u044C\u043A\u0435 \u0441\u0430\u0444\u0430\u0440\u0456\u201D \u043D\u0430 \u0432\u043B\u0430\u0441\u043D\u0456 \u043E\u0447\u0456, \u043D\u0430\u0434\u0456\u0448\u043B\u0456\u0442\u044C \u043D\u0430\u043C \u0441\u0432\u043E\u0457 \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u043D\u0430 \uD83D\uDCE7 <mail>khersonhumansafari@gmail.com</mail>, \u0442\u0435\u043C\u0430 \u043B\u0438\u0441\u0442\u0430: \u201C\u0441\u0430\u0444\u0430\u0440\u0456 \u043D\u0430 \u043B\u044E\u0434\u0435\u0439\u201D.","type":" \u042F\u043A\u0449\u043E \u0432\u0438 \u0441\u0442\u0430\u043B\u0438 \u0441\u0432\u0456\u0434\u043A\u043E\u043C \u0437\u0430\u0433\u0438\u0431\u0435\u043B\u0456 \u0434\u0440\u0443\u0433\u0430 \u0430\u0431\u043E \u0441\u0443\u0441\u0456\u0434\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0430\u0442\u0430\u043A\u0438 \u0434\u0440\u043E\u043D\u0430 \u0456 \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0432\u043E\u0454\u044E \u0440\u043E\u0437\u043F\u043E\u0432\u0456\u0434\u0434\u044E, \u0432\u043A\u0430\u0436\u0456\u0442\u044C \xab\u0441\u0432\u0456\u0434\u043E\u043A\xbb; \u044F\u043A\u0449\u043E \u0432\u0438 \u0431\u0443\u043B\u0438 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0430\u0442\u0430\u043A\u043E\u0432\u0430\u043D\u0456 \u2014 \u0432\u043A\u0430\u0436\u0456\u0442\u044C \xab\u0432\u0438\u0436\u0438\u0432\u0448\u0438\u0439\xbb.","requirements":"<b>\u0429\u043E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E:</b> \u043C\u0456\u0441\u0442\u043E/\u043B\u043E\u043A\u0430\u0446\u0456\u044F, \u0434\u0430\u0442\u0430 \u0430\u0442\u0430\u043A\u0438, \u043A\u043E\u0440\u043E\u0442\u043A\u0430 \u0456\u0441\u0442\u043E\u0440\u0456\u044F (3\u20136 \u0440\u0435\u0447\u0435\u043D\u044C, \u0444\u0430\u043A\u0442\u0438, \u0432\u0456\u0434 \u043F\u0435\u0440\u0448\u043E\u0457 \u043E\u0441\u043E\u0431\u0438).","honesty":"\u0411\u0443\u0434\u044C\u0442\u0435 \u0447\u0435\u0441\u043D\u0456, \u0441\u0442\u0438\u0441\u043B\u043E, \u0431\u0435\u0437 \u0441\u0435\u043A\u0440\u0435\u0442\u0456\u0432 \u0432\u0456\u0439\u0441\u044C\u043A\u043E\u0432\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u2014 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u043B\u0438\u0448\u0430\u0442\u0438\u0441\u044F \u0430\u043D\u043E\u043D\u0456\u043C\u043D\u0438\u043C.","media":"<b>\u0424\u043E\u0442\u043E/\u0432\u0456\u0434\u0435\u043E?</b> \u041F\u0438\u0448\u0456\u0442\u044C \u201C\u0424\u043E\u0442\u043E/\u0432\u0456\u0434\u0435\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456\u201D, \u0444\u0430\u0439\u043B\u0438 \u043D\u0435 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0439\u0442\u0435 \u2014 \u043C\u0438 \u0441\u0430\u043C\u0456 \u043F\u043E\u043F\u0440\u043E\u0441\u0438\u043C\u043E.","consent":"<b>\u0417\u0433\u043E\u0434\u0430 \u043D\u0430 \u043F\u0443\u0431\u043B\u0456\u043A\u0430\u0446\u0456\u044E:</b> \u201C\u042F \u043F\u043E\u0433\u043E\u0434\u0436\u0443\u044E\u0441\u044F, \u0449\u043E\u0431 \u0446\u044F \u0456\u0441\u0442\u043E\u0440\u0456\u044F \u0431\u0443\u043B\u0430 \u043E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u0430 \u043F\u0443\u0431\u043B\u0456\u0447\u043D\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 HumanSafari.org\u201D"},"byCountry":"\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0437\u0430 \u043A\u0440\u0430\u0457\u043D\u043E\u044E","byDate":"\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0437\u0430 \u0434\u0430\u0442\u043E\u044E","countries":{"australia":"\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F","austria":"\u0410\u0432\u0441\u0442\u0440\u0456\u044F","bulgaria":"\u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F","canada":"\u041A\u0430\u043D\u0430\u0434\u0430","czechia":"\u0427\u0435\u0445\u0456\u044F","denmark":"\u0414\u0430\u043D\u0456\u044F","estonia":"\u0415\u0441\u0442\u043E\u043D\u0456\u044F","finland":"\u0424\u0456\u043D\u043B\u044F\u043D\u0434\u0456\u044F","france":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","georgia":"\u0413\u0440\u0443\u0437\u0456\u044F","germany":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","hungary":"\u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430","italy":"\u0406\u0442\u0430\u043B\u0456\u044F","japan":"\u042F\u043F\u043E\u043D\u0456\u044F","mexico":"\u041C\u0435\u043A\u0441\u0438\u043A\u0430","netherlands":"\u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0438","norway":"\u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F","poland":"\u041F\u043E\u043B\u044C\u0449\u0430","romania":"\u0420\u0443\u043C\u0443\u043D\u0456\u044F","spain":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","sweden":"\u0428\u0432\u0435\u0446\u0456\u044F","southAfrica":"\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u0410\u0444\u0440\u0438\u043A\u0430","ukraine":"\u0423\u043A\u0440\u0430\u0457\u043D\u0430","unitedKingdom":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","usa":"\u0421\u0428\u0410","ireland":"\u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F","belgium":"\u0411\u0435\u043B\u044C\u0433\u0456\u044F"},"cities":{"alicante":{"city":"\u0410\u043B\u0456\u043A\u0430\u043D\u0442\u0435","country":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","time":"\u0410\u043B\u0456\u043A\u0430\u043D\u0442\u0435 - \u0406\u0441\u043F\u0430\u043D\u0456\u044F, 16:00 - 17:00","location":"\u0410\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u043E \u043B\u0430 \u041A\u043E\u043D\u0447\u0430, \u0415\u043A\u0441\u043F\u043B\u0430\u043D\u0430\u0434\u0430 \u0434\u0435 \u0415\u0441\u043F\u0430\u043D\u044C\u044F","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"\u0411\u0430\u0440\u0441\u0435\u043B\u043E\u043D\u0430","country":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","time":"\u0411\u0430\u0440\u0441\u0435\u043B\u043E\u043D\u0430 - \u0406\u0441\u043F\u0430\u043D\u0456\u044F, 12:00 - 14:00","location":"\u041F\u043B\u043E\u0449\u0430 \u0421\u0430\u043D\u0442-\u0416\u0430\u0443\u043C\u0435","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"\u0411\u0435\u0440\u043A\u043B\u0456","country":"\u0421\u0428\u0410","time":"\u0411\u0435\u0440\u043A\u043B\u0456 - \u0421\u0428\u0410, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"\u0411\u0435\u0440\u043B\u0456\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0411\u0435\u0440\u043B\u0456\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 12:00","location":"\u0422\u0435\u043C\u043F\u0435\u043B\u044C\u0433\u043E\u0444\u0435\u0440 \u0424\u0435\u043B\u044C\u0434, \u0432\u0445\u0456\u0434 \u041B\u0435\u0456\u043D\u0448\u0442\u0440\u0430\u0441\u0435 / \u043A\u0443\u0442 \u041E\u0440\u0434\u0435\u0440\u0448\u0442\u0440\u0430\u0441\u0435","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"\u0411\u0435\u0442\u0442\u0435\u043D\u0434\u043E\u0440\u0444","country":"\u0421\u0428\u0410","time":"\u0411\u0435\u0442\u0442\u0435\u043D\u0434\u043E\u0440\u0444 - \u0421\u0428\u0410, 17:30 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","location":"\u041F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u0431\u0456\u0431\u043B\u0456\u043E\u0442\u0435\u043A\u0430 \u0411\u0435\u0442\u0442\u0435\u043D\u0434\u043E\u0440\u0444\u0430","cleanTime":"17:30 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","day":"schedule11"},"birmingham":{"city":"\u0411\u0456\u0440\u043C\u0456\u043D\u0433\u0435\u043C","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u0411\u0456\u0440\u043C\u0456\u043D\u0433\u0435\u043C - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 14:00 - 15:30","location":"\u0411\u0443\u0434\u0438\u043D\u043E\u043A \u0411\u0430\u0441\u043A\u0435\u0440\u0432\u0456\u043B\u044C, \u041A\u0435\u043C\u0431\u0440\u0438\u0434\u0436 \u0421\u0442\u0440\u0456\u0442","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"\u0411\u043E\u043D\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0411\u043E\u043D\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 14:00 - 16:00","location":"\u041F\u043E\u0448\u0442\u0448\u0442\u0440\u0430\u0441\u0435, \u043F\u0435\u0440\u0435\u0434 \u0413\u043E\u043B\u043E\u0432\u043D\u0438\u043C \u0432\u043E\u043A\u0437\u0430\u043B\u043E\u043C","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"\u0411\u0440\u0435\u043C\u0435\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0411\u0440\u0435\u043C\u0435\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 15:00 - 18:00","location":"\u041F\u043B\u043E\u0449\u0430 \u043F\u0435\u0440\u0435\u0434 \u0432\u043E\u043A\u0437\u0430\u043B\u043E\u043C (Bahnhofsvorplatz)","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"\u0411\u0443\u0434\u0430\u043F\u0435\u0448\u0442","country":"\u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430","time":"\u0411\u0443\u0434\u0430\u043F\u0435\u0448\u0442 - \u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"\u0427\u0438\u043A\u0430\u0433\u043E","country":"\u0421\u0428\u0410","time":"\u0427\u0438\u043A\u0430\u0433\u043E - \u0421\u0428\u0410, 13:00 - 15:00","location":"410 N. Michigan ave. (\u0411\u0443\u0434\u0456\u0432\u043B\u044F Wrigley)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"\u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0446\u0430","country":"\u0420\u0443\u043C\u0443\u043D\u0456\u044F","time":"\u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0446\u0430 - \u0420\u0443\u043C\u0443\u043D\u0456\u044F, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"\u041A\u043E\u043F\u0435\u043D\u0433\u0430\u0433\u0435\u043D","country":"\u0414\u0430\u043D\u0456\u044F","time":"\u041A\u043E\u043F\u0435\u043D\u0433\u0430\u0433\u0435\u043D - \u0414\u0430\u043D\u0456\u044F, 14:00","location":"\u0410\u043A\u0441\u0435\u043B\u044C\u0442\u043E\u0440\u0432","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"\u0414\u0430\u043B\u043B\u0430\u0441","country":"\u0421\u0428\u0410","time":"\u0414\u0430\u043B\u043B\u0430\u0441 - \u0421\u0428\u0410, 12:00 - 13:00","location":"\u041F\u043B\u043E\u0449\u0430 \u043C\u0456\u0441\u044C\u043A\u043E\u0457 \u0440\u0430\u0442\u0443\u0448\u0456 \u0414\u0430\u043B\u043B\u0430\u0441\u0430","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"\u0414\u0435\u043D\u0432\u0435\u0440","country":"\u0421\u0428\u0410","time":"\u0414\u0435\u043D\u0432\u0435\u0440 - \u0421\u0428\u0410, 12:00","location":"\u0411\u0443\u0434\u0456\u0432\u043B\u044F \u041A\u0430\u043F\u0456\u0442\u043E\u043B\u0456\u044E \u0448\u0442\u0430\u0442\u0443 \u041A\u043E\u043B\u043E\u0440\u0430\u0434\u043E, \u0437\u0430\u0445\u0456\u0434\u043D\u0456 \u0441\u0445\u043E\u0434\u0438","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"\u0415\u0434\u0456\u043D\u0431\u0443\u0440\u0433","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u0415\u0434\u0456\u043D\u0431\u0443\u0440\u0433 - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 13:00 - 15:00","location":"\u041C\u043E\u043D\u0443\u043C\u0435\u043D\u0442 \u0433\u0435\u0440\u0446\u043E\u0433\u0430 \u0412\u0435\u043B\u043B\u0456\u043D\u0433\u0442\u043E\u043D\u0430","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"\u0424\u043E\u0440\u0442-\u0412\u043E\u0440\u0442","country":"\u0421\u0428\u0410","time":"\u0424\u043E\u0440\u0442-\u0412\u043E\u0440\u0442 - \u0421\u0428\u0410, 14:00 - 15:00","location":"\u0421\u0443\u0434 \u043E\u043A\u0440\u0443\u0433\u0443 \u0422\u0430\u0440\u0440\u0430\u043D\u0442","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"\u0413\u0430\u043C\u0431\u0443\u0440\u0433","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0413\u0430\u043C\u0431\u0443\u0440\u0433 - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"\u0413\u043E\u0443\u0442\u043E\u043D, \u041C\u0456\u0447\u0438\u0433\u0430\u043D","country":"\u0421\u0428\u0410","time":"\u0413\u043E\u0443\u0442\u043E\u043D, \u041C\u0456\u0447\u0438\u0433\u0430\u043D - \u0421\u0428\u0410, 15:00","location":"\u041F\u043E\u0440\u0442\u0435\u0439\u0434\u0436-\u041B\u0435\u0439\u043A \u041B\u0456\u0444\u0442-\u0411\u0440\u0456\u0434\u0436","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"\u0413\u0435\u043B\u044C\u0441\u0456\u043D\u043A\u0456","country":"\u0424\u0456\u043D\u043B\u044F\u043D\u0434\u0456\u044F","time":"\u0413\u0435\u043B\u044C\u0441\u0456\u043D\u043A\u0456 - \u0424\u0456\u043D\u043B\u044F\u043D\u0434\u0456\u044F, 17:00 - 18:00","location":"\u041F\u043B\u043E\u0449\u0430 \u041D\u0430\u0440\u0456\u043D\u043A\u0430\u0442\u043E\u0440\u0456","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"\u0406\u0434\u0437\u0443\u043C\u043E","country":"\u042F\u043F\u043E\u043D\u0456\u044F","time":"\u0406\u0434\u0437\u0443\u043C\u043E - \u042F\u043F\u043E\u043D\u0456\u044F, 13:00","location":"\u0421\u0432\u044F\u0442\u0438\u043D\u044F \u0406\u0434\u0437\u0443\u043C\u043E \u0422\u0430\u0439\u0441\u044F, 195 \u041A\u0456\u0446\u0443\u043A\u0456\u0445\u0456\u0433\u0430\u0448\u0456, \u0422\u0430\u0439\u0448\u0430\u0447\u043E","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"\u0406\u0434\u0437\u0443\u043C\u043E","country":"\u042F\u043F\u043E\u043D\u0456\u044F","time":"\u0406\u0434\u0437\u0443\u043C\u043E - \u042F\u043F\u043E\u043D\u0456\u044F","location":"\u0421\u0432\u044F\u0442\u0438\u043D\u044F \u0406\u0434\u0437\u0443\u043C\u043E \u0422\u0430\u0439\u0441\u044F, 195 \u041A\u0456\u0446\u0443\u043A\u0456\u0445\u0456\u0433\u0430\u0448\u0456, \u0422\u0430\u0439\u0448\u0430\u0447\u043E","cleanTime":"","day":"schedule20"},"kamloops":{"city":"\u041A\u0435\u043C\u043B\u0443\u043F\u0441","country":"\u041A\u0430\u043D\u0430\u0434\u0430","time":"\u041A\u0435\u043C\u043B\u0443\u043F\u0441 - \u041A\u0430\u043D\u0430\u0434\u0430, 15:00 - 16:00","location":"\u041C\u0456\u0441\u044C\u043A\u0430 \u0420\u0430\u0442\u0443\u0448\u0430","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"\u041A\u0438\u0457\u0432","country":"\u0423\u043A\u0440\u0430\u0457\u043D\u0430","time":"\u041A\u0438\u0457\u0432 - \u0423\u043A\u0440\u0430\u0457\u043D\u0430, 17:00 - 18:00","location":"\u041C\u0430\u0439\u0434\u0430\u043D \u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0456","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"\u041B\u0435\u0439\u043F\u0446\u0438\u0433","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u041B\u0435\u0439\u043F\u0446\u0438\u0433 - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 12:00 - 13:00","location":"\u0412\u0456\u043B\u043B\u0456-\u0411\u0440\u0430\u043D\u0434\u0442-\u041F\u043B\u0430\u0446","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 18:30 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","location":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0438\u0439 \u0414\u0456\u043C, 154 Holland Park Avenue","cleanTime":"18:30 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","day":"schedule12"},"losAngeles":{"city":"\u041B\u043E\u0441-\u0410\u043D\u0434\u0436\u0435\u043B\u0435\u0441","country":"\u0421\u0428\u0410","time":"\u041B\u043E\u0441-\u0410\u043D\u0434\u0436\u0435\u043B\u0435\u0441 - \u0421\u0428\u0410, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"\u041C\u0430\u043B\u0430\u0433\u0430","country":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","time":"\u041C\u0430\u043B\u0430\u0433\u0430 - \u0406\u0441\u043F\u0430\u043D\u0456\u044F, 18:00 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","location":"\u041C\u0430\u0439\u0434\u0430\u043D - \u0406\u0441\u0442\u043E\u0440\u0438\u043A\u043E-\u043A\u0443\u043B\u044C\u0442\u0443\u0440\u043D\u0438\u0439 \u0446\u0435\u043D\u0442\u0440 \u0423\u043A\u0440\u0430\u0457\u043D\u0438","cleanTime":"18:00 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","day":"schedule13"},"manchester":{"city":"\u041C\u0430\u043D\u0447\u0435\u0441\u0442\u0435\u0440","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041C\u0430\u043D\u0447\u0435\u0441\u0442\u0435\u0440 - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 14:00 - 15:30","location":"\u041F\u043B\u043E\u0449\u0430 \u0421\u0432. \u041F\u0435\u0442\u0440\u0430, \u043C\u0435\u043C\u043E\u0440\u0456\u0430\u043B \u0415\u043C\u043C\u0435\u043B\u0456\u043D \u041F\u0430\u043D\u043A\u0445\u0435\u0440\u0441\u0442","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"\u041C\u0435\u0445\u0456\u043A\u043E","country":"\u041C\u0435\u043A\u0441\u0438\u043A\u0430","time":"\u041C\u0435\u0445\u0456\u043A\u043E - \u041C\u0435\u043A\u0441\u0438\u043A\u0430, 11:00","location":"\u0410\u043B\u0430\u043C\u0435\u0434\u0430 \u0421\u0435\u043D\u0442\u0440\u0430\u043B. \u0424\u043E\u043D\u0442\u0430\u043D \xab\u0410\u043C\u0435\u0440\u0438\u043A\u0430\xbb (\u043C\u0456\u0436 Hemiciclo Ju\xe1rez \u0442\u0430 \u043A\u0456\u043E\u0441\u043A\u043E\u043C)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"\u041C\u0456\u043B\u0430\u043D","country":"\u0406\u0442\u0430\u043B\u0456\u044F","time":"\u041C\u0456\u043B\u0430\u043D - \u0406\u0442\u0430\u043B\u0456\u044F, 15:00","location":"\u0421\u043E\u0431\u043E\u0440 \u0414\u0443\u043E\u043C\u043E","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"\u041C\u044E\u043D\u0445\u0435\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u041C\u044E\u043D\u0445\u0435\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 17:00 - 19:00","location":"\u041E\u0434\u0435\u043E\u043D\u0441\u043F\u043B\u0430\u0446","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"\u041D\u044C\u044E-\u0419\u043E\u0440\u043A","country":"\u0421\u0428\u0410","time":"\u041D\u044C\u044E-\u0419\u043E\u0440\u043A - \u0421\u0428\u0410, 16:00","location":"\u0422\u0430\u0439\u043C\u0441-\u0421\u043A\u0432\u0435\u0440","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"\u041D\u044C\u044E-\u0419\u043E\u0440\u043A","country":"\u0421\u0428\u0410","time":"\u041D\u044C\u044E-\u0419\u043E\u0440\u043A - \u0421\u0428\u0410, 13:00 - 14:00","location":"\u0422\u0430\u0439\u043C\u0441-\u0421\u043A\u0432\u0435\u0440","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"\u041D\u0456\u0454\u043D\u0431\u0443\u0440\u0433 (\u0412\u0435\u0437\u0435\u0440)","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u041D\u0456\u0454\u043D\u0431\u0443\u0440\u0433 (\u0412\u0435\u0437\u0435\u0440) - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 17:00","location":"\u0428\u0442\u0435\u0442\u0442\u0456\u043D\u0435\u0440-\u0448\u0442\u0440\u0430\u0441\u0441\u0435, 2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"\u041E\u0441\u043B\u043E","country":"\u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F","time":"\u041E\u0441\u043B\u043E - \u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\u0415\u0441\u0442\u0435\u0440\u0441\u0443\u043D\u0434","country":"\u0428\u0432\u0435\u0446\u0456\u044F","time":"\u0415\u0441\u0442\u0435\u0440\u0441\u0443\u043D\u0434 - \u0428\u0432\u0435\u0446\u0456\u044F, 11:00 - 14:00","location":"Stortorget (\u0413\u043E\u043B\u043E\u0432\u043D\u0430 \u043F\u043B\u043E\u0449\u0430)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"\u041E\u0442\u0442\u0430\u0432\u0430","country":"\u041A\u0430\u043D\u0430\u0434\u0430","time":"\u041E\u0442\u0442\u0430\u0432\u0430 - \u041A\u0430\u043D\u0430\u0434\u0430, 12:30 - 13:30","location":"\u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0435 \u043F\u043E\u0441\u043E\u043B\u044C\u0441\u0442\u0432\u043E","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"\u041E\u0442\u0442\u0430\u0432\u0430","country":"\u041A\u0430\u043D\u0430\u0434\u0430","time":"\u041E\u0442\u0442\u0430\u0432\u0430 - \u041A\u0430\u043D\u0430\u0434\u0430, 12:00","location":"\u041F\u043E\u0441\u043E\u043B\u044C\u0441\u0442\u0432\u043E \u0421\u0428\u0410","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"\u041F\u0430\u0440\u0438\u0436","country":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","time":"\u041F\u0430\u0440\u0438\u0436 - \u0424\u0440\u0430\u043D\u0446\u0456\u044F, 15:30","location":"\u041F\u043B\u043E\u0449\u0430 \u0422\u0430\u0440\u0430\u0441\u0430 \u0428\u0435\u0432\u0447\u0435\u043D\u043A\u0430 -> \u0424\u043E\u043D\u0442\u0430\u043D \u0421\u0435\u043D-\u041C\u0456\u0448\u0435\u043B\u044C (\u043C\u0430\u0440\u0448)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"\u041F\u043B\u043E\u0432\u0434\u0456\u0432","country":"\u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F","time":"\u041F\u043B\u043E\u0432\u0434\u0456\u0432 - \u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F, 16:00 - 17:00","location":"\u0411\u0456\u043B\u044F \u0431\u0443\u0434\u0438\u043D\u043A\u0443 \u041B\u0435\u0432\u0441\u043A\u0456","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"\u041F\u0440\u0430\u0433\u0430","country":"\u0427\u0435\u0445\u0456\u044F","time":"\u041F\u0440\u0430\u0433\u0430 - \u0427\u0435\u0445\u0456\u044F, 14:00","location":"\u041F\u043B\u043E\u0449\u0430 \u041F\u0430\u043B\u0430\u0446\u043A\u0435ho","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"\u0420\u043E\u0437\u0435\u043D\u0434\u0430\u043B\u044C","country":"\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u0410\u0444\u0440\u0438\u043A\u0430","time":"\u0420\u043E\u0437\u0435\u043D\u0434\u0430\u043B\u044C - \u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u0410\u0444\u0440\u0438\u043A\u0430, 11:00","location":"\u041E\u0444\u0456\u0441\u0438 \u043F\u043E\u043B\u0456\u0446\u0456\u0457 \u041F\u0456\u0432\u0434\u0435\u043D\u043D\u043E\u0457 \u0410\u0444\u0440\u0438\u043A\u0438","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"\u0421\u0430\u043D-\u0410\u043D\u0434\u0440\u0435\u0441, \u0422\u0435\u043D\u0435\u0440\u0456\u0444\u0435","country":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","time":"\u0421\u0430\u043D-\u0410\u043D\u0434\u0440\u0435\u0441, \u0422\u0435\u043D\u0435\u0440\u0456\u0444\u0435 - \u0406\u0441\u043F\u0430\u043D\u0456\u044F, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"\u0421\u0430\u043D-\u0414\u0456\u0454\u0433\u043E","country":"\u0421\u0428\u0410","time":"\u0421\u0430\u043D-\u0414\u0456\u0454\u0433\u043E - \u0421\u0428\u0410, 14:00 - 16:00","location":"\u0421\u0442\u0430\u0442\u0443\u044F \u0415\u043B\u044C \u0421\u0456\u0434, \u0411\u0430\u043B\u044C\u0431\u043E\u0430 \u041F\u0430\u0440\u043A","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"\u0421\u0430\u043D-\u0424\u0440\u0430\u043D\u0446\u0438\u0441\u043A\u043E","country":"\u0421\u0428\u0410","time":"\u0421\u0430\u043D-\u0424\u0440\u0430\u043D\u0446\u0438\u0441\u043A\u043E - \u0421\u0428\u0410, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"\u0428\u0432\u0435\u0440\u0456\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0428\u0432\u0435\u0440\u0456\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 19:00 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443","day":"schedule13"},"seattle":{"city":"\u0421\u0456\u0435\u0442\u043B","country":"\u0421\u0428\u0410","time":"\u0421\u0456\u0435\u0442\u043B - \u0421\u0428\u0410, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"\u0421\u0432\u0435\u0442\u0456 \u0412\u043B\u0430\u0441","country":"\u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F","time":"\u0421\u0432\u0435\u0442\u0456 \u0412\u043B\u0430\u0441 - \u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"\u0421\u0456\u0434\u043D\u0435\u0439","country":"\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F","time":"\u0421\u0456\u0434\u043D\u0435\u0439 - \u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F, 14:00","location":"\u0420\u0430\u0442\u0443\u0448\u0430 \u0421\u0456\u0434\u043D\u0435\u044F","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"\u0422\u0430\u043B\u043B\u0456\u043D\u043D","country":"\u0415\u0441\u0442\u043E\u043D\u0456\u044F","time":"\u0422\u0430\u043B\u043B\u0456\u043D\u043D - \u0415\u0441\u0442\u043E\u043D\u0456\u044F, 15:00 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443 \u0442\u0430 \u043C\u0456\u0442\u0438\u043D\u0433","location":"\u041A\u0456\u043D\u043E\u0442\u0435\u0430\u0442\u0440 S\xf5prus, Vana-Posti tn.8","cleanTime":"15:00 - \u041F\u043E\u043A\u0430\u0437 \u0444\u0456\u043B\u044C\u043C\u0443 \u0442\u0430 \u043C\u0456\u0442\u0438\u043D\u0433","day":"schedule13"},"tarragona":{"city":"\u0422\u0430\u0440\u0440\u0430\u0433\u043E\u043D\u0430","country":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","time":"\u0422\u0430\u0440\u0440\u0430\u0433\u043E\u043D\u0430 - \u0406\u0441\u043F\u0430\u043D\u0456\u044F, 18:30","location":"\u0411\u0430\u043B\u043A\u043E \u041C\u0435\u0434\u0456\u0442\u0435\u0440\u0430\u043D\u0456","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"\u0413\u0430\u0430\u0433\u0430","country":"\u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0438","time":"\u0413\u0430\u0430\u0433\u0430 - \u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0438, 13:00 - 15:00","location":"\u041F\u0435\u0440\u0435\u0434 \u041F\u0430\u043B\u0430\u0446\u043E\u043C \u041C\u0438\u0440\u0443 / \u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u043A\u0440\u0438\u043C\u0456\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0443\u0434","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"\u0422\u0431\u0456\u043B\u0456\u0441\u0456","country":"\u0413\u0440\u0443\u0437\u0456\u044F","time":"\u0422\u0431\u0456\u043B\u0456\u0441\u0456 - \u0413\u0440\u0443\u0437\u0456\u044F, 21:00","location":"\u0422\u0431\u0456\u043B\u0456\u0441\u0456","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"\u0422\u0440\u0430\u043D\u0430\u0441","country":"\u0428\u0432\u0435\u0446\u0456\u044F","time":"\u0422\u0440\u0430\u043D\u0430\u0441 - \u0428\u0432\u0435\u0446\u0456\u044F, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"\u0412\u0456\u0434\u0435\u043D\u044C","country":"\u0410\u0432\u0441\u0442\u0440\u0456\u044F","time":"\u0412\u0456\u0434\u0435\u043D\u044C - \u0410\u0432\u0441\u0442\u0440\u0456\u044F, 16:00 - 18:00","location":"Stock im Eisen Platz (\u043F\u043E\u0440\u0443\u0447 \u0437\u0456 \u0428\u0442\u0435\u0444\u0430\u043D\u0441\u0434\u043E\u043C\u043E\u043C)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"\u0412\u0430\u0448\u0438\u043D\u0433\u0442\u043E\u043D, D.C.","country":"\u0421\u0428\u0410","time":"\u0412\u0430\u0448\u0438\u043D\u0433\u0442\u043E\u043D, D.C. - \u0421\u0428\u0410, 12:30 - 13:30","location":"\u0411\u0456\u043B\u0438\u0439 \u0434\u0456\u043C","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"\u0412\u0440\u043E\u0446\u043B\u0430\u0432","country":"\u041F\u043E\u043B\u044C\u0449\u0430","time":"\u0412\u0440\u043E\u0446\u043B\u0430\u0432 - \u041F\u043E\u043B\u044C\u0449\u0430, 13:00","location":"\u041F\u043B\u043E\u0449\u0430 \u0421\u0432\u043E\u0431\u043E\u0434\u0438 (\u0443 \u043D\u0430\u043F\u0440\u044F\u043C\u043A\u0443 \u041D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u043C\u0443\u0437\u0438\u0447\u043D\u043E\u0433\u043E \u0444\u043E\u0440\u0443\u043C\u0443)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"\u041E\u0440\u0433\u0430\u043D\u0456\u0437\u0443\u0439\u0442\u0435\u0441\u044C! \u0429\u043E\u0431 \u0434\u043E\u0434\u0430\u0442\u0438 \u0441\u0432\u043E\u0454 \u043C\u0456\u0441\u0442\u043E, \u043D\u0430\u0434\u0456\u0448\u043B\u0456\u0442\u044C \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 \u043D\u0430:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"\u041F\u043E\u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043D\u0430 {{platform}}","website":"\u0412\u0435\u0431\u0441\u0430\u0439\u0442","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","khs":{"name":"Kherson Human Safari","desc":"\u0417\u0430\u0440\u0438\u043D\u0430 \u0417\u0430\u0431\u0440\u0438\u0446\u044C\u043A\u0430, \u0436\u0443\u0440\u043D\u0430\u043B\u0456\u0441\u0442\u043A\u0430 \u0442\u0430 \u043A\u0456\u043D\u043E\u0440\u0435\u0436\u0438\u0441\u0435\u0440\u043A\u0430, \u043E\u0447\u043E\u043B\u0438\u043B\u0430 \u0432\u0441\u0435\u0441\u0432\u0456\u0442\u043D\u044E \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0456\u044E \u0442\u0430 \u0437\u043D\u044F\u043B\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u0444\u0456\u043B\u044C\u043C Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"\u0417\u0430\u0445\u0438\u0441\u0442 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0434\u043B\u044F \u0432\u0443\u043B\u0438\u0446\u044C \u0425\u0435\u0440\u0441\u043E\u043D\u0430 \u2014 \u0437\u0430\u0445\u0438\u0441\u0442 \u043C\u0438\u0440\u043D\u0438\u0445 \u0436\u0438\u0442\u0435\u043B\u0456\u0432 \u0432\u0456\u0434 \u0430\u0442\u0430\u043A \u0434\u0440\u043E\u043D\u0456\u0432.","foodDesc":"\u041F\u0440\u043E\u0434\u043E\u0432\u043E\u043B\u044C\u0447\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430.","foodNote":"\u041F\u0456\u0434 \u0447\u0430\u0441 \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u0438 \u0432\u043A\u0430\u0436\u0456\u0442\u044C \u0443 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u0456 \u043F\u043B\u0430\u0442\u0435\u0436\u0443 \xabFood for Cherson\xbb."},"ahs":{"name":"\u041F\u0440\u043E\u0454\u043A\u0442 Anti Human Safari","desc":"\u0414\u0435\u0442\u0435\u043A\u0442\u043E\u0440\u0438 \u0434\u0440\u043E\u043D\u0456\u0432 \u0442\u0430 \u0437\u0430\u0445\u0438\u0441\u043D\u0456 \u0436\u0438\u043B\u0435\u0442\u0438 \u0434\u043B\u044F \u0432\u043E\u043B\u043E\u043D\u0442\u0435\u0440\u0456\u0432 \u0442\u0430 \u0441\u043B\u0443\u0436\u0431 \u0435\u043A\u0441\u0442\u0440\u0435\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438 \u0432 \u0425\u0435\u0440\u0441\u043E\u043D\u0456."},"pageTitle":"\u0417\u0443\u043F\u0438\u043D\u0456\u043C\u043E Human Safari","sectionIntro":"\u0417 \u043B\u0456\u0442\u0430 2024 \u0440\u043E\u043A\u0443 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0432\u0456\u0439\u0441\u044C\u043A\u043E\u0432\u0456 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C \u043C\u0430\u043B\u0456 \u0434\u0440\u043E\u043D\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u044E\u0432\u0430\u043D\u043D\u044F, \u0432\u0431\u0438\u0432\u0441\u0442\u0432 \u0442\u0430 \u0442\u0435\u0440\u043E\u0440\u0438\u0437\u0443\u0432\u0430\u043D\u043D\u044F \u043C\u0438\u0440\u043D\u0438\u0445 \u0436\u0438\u0442\u0435\u043B\u0456\u0432 \u043D\u0430 \u0432\u0443\u043B\u0438\u0446\u044F\u0445 \u0425\u0435\u0440\u0441\u043E\u043D\u0430 \u0442\u0430 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u0438\u0444\u0440\u043E\u043D\u0442\u043E\u0432\u0438\u0445 \u043C\u0456\u0441\u0442 \u0423\u043A\u0440\u0430\u0457\u043D\u0438.","sectionIntro2":"\u0426\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0447\u043D\u0430 \u0439 \u0443\u043C\u0438\u0441\u043D\u0430 \u043A\u0430\u043C\u043F\u0430\u043D\u0456\u044F \u0432\u0431\u0438\u0432\u0441\u0442\u0432: \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0438 \u0434\u0440\u043E\u043D\u0456\u0432 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E \u043F\u0443\u0431\u043B\u0456\u043A\u0443\u044E\u0442\u044C \u0432\u0456\u0434\u0435\u043E \u0441\u0432\u043E\u0457\u0445 \u0436\u0435\u0440\u0442\u0432 \u0443 Telegram-\u043A\u0430\u043D\u0430\u043B\u0430\u0445, \u0449\u043E\u0431 \u043F\u043E\u0445\u0438\u0437\u0443\u0432\u0430\u0442\u0438\u0441\u044F. \u0423 \u0442\u0440\u0430\u0432\u043D\u0456 2025 \u0440\u043E\u043A\u0443 \u041E\u041E\u041D \u0432\u0438\u0437\u043D\u0430\u043B\u0430 Human Safari \u0442\u0440\u0438\u0432\u0430\u044E\u0447\u0438\u043C \u0432\u043E\u0454\u043D\u043D\u0438\u043C \u0437\u043B\u043E\u0447\u0438\u043D\u043E\u043C.","sectionIntro3":"\u0420\u043E\u0431\u0438\u0442\u044C\u0441\u044F \u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u043E. Human Safari \u0442\u0440\u0435\u0431\u0430 \u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438.","sectionIntroBold":"\u0412\u0418 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041E\u0441\u044C \u044F\u043A","step2Title":"\u041E\u0440\u0433\u0430\u043D\u0456\u0437\u0443\u0439\u0442\u0435","step3Title":"\u0420\u043E\u0437\u043A\u0430\u0436\u0456\u0442\u044C \u0456\u043D\u0448\u0438\u043C","step3Para":"\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0445\u0435\u0448\u0442\u0435\u0433\u0438","step3ParaPost":"\u0456 \u0440\u043E\u0437\u043F\u043E\u0432\u0456\u0434\u0430\u0439\u0442\u0435 \u0456\u043D\u0448\u0438\u043C \u043F\u0440\u043E Human Safari","instagram":"Instagram","step2Bullet1":"\u043A\u0456\u043D\u043E\u043F\u043E\u043A\u0430\u0437","step2Bullet2":"\u043F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u0430\u043A\u0446\u0456\u044F","step2Bullet3":"\u0432\u0438\u0441\u0432\u0456\u0442\u043B\u0435\u043D\u043D\u044F \u0432 \u043C\u0435\u0434\u0456\u0430","publicActionLead":"\u041F\u0440\u0438\u0432\u0435\u0440\u0442\u0430\u0439\u0442\u0435 \u0443\u0432\u0430\u0433\u0443 \u0434\u043E \xab\u043B\u044E\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0430\u0444\u0430\u0440\u0456\xbb \u0442\u0430\u043C, \u0434\u0435 \u0432\u0438 \u0454.","reachOutPre":"\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435","reachOut":"\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F","reachOutPost":"\u043F\u043E \u0456\u0434\u0435\u0457 \u0442\u0430 \u0440\u0435\u0441\u0443\u0440\u0441\u0438","newsCoverageLead":"\u0447\u0435\u0440\u0435\u0437 \u0432\u0430\u0448\u0456 \u043C\u0435\u0434\u0456\u0439\u043D\u0456 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0438. \u0420\u043E\u0437\u043A\u0430\u0436\u0456\u0442\u044C \u0457\u043C \u043F\u0440\u043E \xab\u043B\u044E\u0434\u0441\u044C\u043A\u0435 \u0441\u0430\u0444\u0430\u0440\u0456\xbb \u0442\u0430 \u043F\u0440\u043E \u0437\u0430\u0433\u0440\u043E\u0437\u0443 \u0434\u043B\u044F \u0432\u0441\u0456\u0445 \u043D\u0438\u043D\u0456\u0448\u043D\u0456\u0445 \u0456 \u043C\u0430\u0439\u0431\u0443\u0442\u043D\u0456\u0445 \u0437\u043E\u043D \u043A\u043E\u043D\u0444\u043B\u0456\u043A\u0442\u0443.","putInTouchPre":"\u0412\u0438 \u0442\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u0435\u0442\u0435","putInTouch":"\u0437\u0432\u0435\u0441\u0442\u0438 \u043D\u0430\u0441 \u043D\u0430\u043F\u0440\u044F\u043C\u0443","inform":"\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044C","informSub":"\u0441\u0435\u0431\u0435 \u0442\u0430 \u0456\u043D\u0448\u0438\u0445","policyTitle":"\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0430","policyBody":"\u0417\u0430\u043F\u0440\u043E\u043F\u043E\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043A\u043E\u043D LORA (Liability for Operators and Responsible Authorities Act) \u0437\u0430\u043F\u0440\u043E\u0432\u0430\u0434\u0438\u0432 \u0431\u0438 \u0441\u0430\u043D\u043A\u0446\u0456\u0457 \u043F\u043E \u0432\u0441\u044C\u043E\u043C\u0443 \u043B\u0430\u043D\u0446\u044E\u0433\u0443 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0456 \u2014 \u0432\u0456\u0434 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0438\u0445 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0456\u0432 FPV-\u0434\u0440\u043E\u043D\u0456\u0432 \u0456 \u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u0456\u0432 \u0434\u043E \u0432\u0438\u0449\u043E\u0433\u043E \u0432\u0456\u0439\u0441\u044C\u043A\u043E\u0432\u043E\u0433\u043E \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u0446\u0442\u0432\u0430, \u0430 \u0442\u0430\u043A\u043E\u0436 \u043F\u0440\u043E\u0442\u0438 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0456\u0432 \u0456 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0456\u0432, \u044F\u043A\u0456 \u0443\u043C\u043E\u0436\u043B\u0438\u0432\u043B\u044E\u044E\u0442\u044C \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E \u0442\u0430 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u0440\u043E\u043D\u0456\u0432 \u043F\u0440\u043E\u0442\u0438 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445.","policyHelp":"\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438 \u043D\u0430 \u043F\u043E\u043B\u0456\u0442\u0438\u0447\u043D\u043E\u043C\u0443 \u0440\u0456\u0432\u043D\u0456?","getInTouch":"\u0417\u0432\'\u044F\u0436\u0456\u0442\u044C\u0441\u044F \u0437 \u043D\u0430\u043C\u0438","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"donate":"\u0417\u0430\u0434\u043E\u043D\u0430\u0442\u0438\u0442\u0438","donateIntro":"\u0426\u0435 \u0456\u043D\u0456\u0446\u0456\u0430\u0442\u0438\u0432\u0438, \u044F\u043A\u0456 \u043D\u0430\u0434\u0430\u044E\u0442\u044C \u0434\u0456\u0454\u0432\u0443 \u0439 \u0430\u0434\u0440\u0435\u0441\u043D\u0443 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0443, \u0449\u043E\u0431 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0437\u0430\u0445\u0438\u0449\u0430\u0442\u0438 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0425\u0435\u0440\u0441\u043E\u043D\u0430 \u0432\u0456\u0434 Human Safari.","shareTitle":"\u041F\u043E\u0448\u0438\u0440\u0442\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E","filmScreening":"\u041E\u0440\u0433\u0430\u043D\u0456\u0437\u0443\u0439\u0442\u0435 \u043F\u043E\u043A\u0430\u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0444\u0456\u043B\u044C\u043C\u0443 \xab\u0425\u0435\u0440\u0441\u043E\u043D\u0441\u044C\u043A\u0435 \u043B\u044E\u0434\u0441\u044C\u043A\u0435 \u0441\u0430\u0444\u0430\u0440\u0456\xbb:","howItStarted":"\u042F\u043A \u0446\u0435 \u043F\u043E\u0447\u0430\u043B\u043E\u0441\u044F","kryla":{"name":"\u0411\u043B\u0430\u0433\u043E\u0434\u0456\u0439\u043D\u0438\u0439 \u0444\u043E\u043D\u0434 \xab\u041A\u0440\u0438\u043B\u0430\xbb","desc":"\u041F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u0457\u0445, \u0449\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0436\u0438\u0442\u043B\u043E \u0442\u0430 \u043D\u0430\u0439\u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0456\u0448\u0435 \u0434\u043B\u044F \u043C\u0435\u0448\u043A\u0430\u043D\u0446\u0456\u0432 \u041E\u043B\u0435\u0448\u043E\u043A."}},"action":{"intro":"\u041C\u0438 \u043F\u043E\u0447\u0430\u043B\u0438 \u0437\u0456 \u0441\u0432\u0456\u0442\u043E\u0432\u043E\u0457 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0456\u0457. \u0422\u0435\u043F\u0435\u0440 \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435:","helpLink":"\u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438 \u0442\u0443\u0442"},"accounts":{"heading":"\u0421\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F"},"media":{"close":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","view":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043C\u0435\u0434\u0456\u0430","previous":"\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454","next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435","andrushenkoCredit":"\u041E\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440 \u0410\u043D\u0434\u0440\u044E\u0449\u0435\u043D\u043A\u043E, \u0444\u043E\u0442\u043E\u043A\u043E\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0442 \u043C\u0435\u0434\u0456\u0430 \xab\u0412\u0433\u043E\u0440\u0443\xbb","khersonPoliceCredit":"\u0432\u0456\u0434 @khersonpolice","antypenkoCredit":"\u0406\u0432\u0430\u043D \u0410\u043D\u0442\u0438\u043F\u0435\u043D\u043A\u043E, \u0444\u043E\u0442\u043E\u0436\u0443\u0440\u043D\u0430\u043B\u0456\u0441\u0442 \u0456\u0437 \u0425\u0435\u0440\u0441\u043E\u043D\u0430","telegramChannelCredit":"\u043E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u043E \u0432 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u043E\u043C\u0443 Telegram-\u043A\u0430\u043D\u0430\u043B\u0456 \u043B\u044E\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0430\u0444\u0430\u0440\u0456 \xab\u0432\u0456\u0434 \u041C\u0430\u0440\u0456\u0443\u043F\u043E\u043B\u044F \u0434\u043E \u041A\u0430\u0440\u043F\u0430\u0442\xbb","fruitSellerDescription":"\u041F\u0440\u043E\u0434\u0430\u0432\u0446\u044F \u0444\u0440\u0443\u043A\u0442\u0456\u0432 \u043F\u0435\u0440\u0435\u0441\u043B\u0456\u0434\u0443\u0454 \u0434\u0440\u043E\u043D \u043D\u0430 \u043E\u043F\u0442\u043E\u0432\u043E\u043B\u043E\u043A\u043D\u0456","burntCarDescription":"\u0417\u0433\u043E\u0440\u0456\u043B\u0438\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456","bridgeAttackDescription":"\u041F\u0456\u0434\u043B\u0456\u0442\u043A\u0430 \u0432\u0431\u0438\u0442\u043E FPV-\u0434\u0440\u043E\u043D\u043E\u043C \u043F\u0456\u0434 \u043C\u043E\u0441\u0442\u043E\u043C \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456","busAttackDescription":"\u041E\u0434\u043D\u0430 \u0437 \u0431\u0430\u0433\u0430\u0442\u044C\u043E\u0445 \u0430\u0442\u0430\u043A FPV-\u0434\u0440\u043E\u043D\u0456\u0432 \u043D\u0430 \u0433\u0440\u043E\u043C\u0430\u0434\u0441\u044C\u043A\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442","fpvDroneDescription":"FPV-\u0434\u0440\u043E\u043D \u043D\u0430 \u043F\u043E\u043B\u044E\u0432\u0430\u043D\u043D\u0456 \xabHuman Safari\xbb","antiDroneNetsDescription":"\u0425\u0435\u0440\u0441\u043E\u043D\u0441\u044C\u043A\u0430 \u0432\u0443\u043B\u0438\u0446\u044F, \u043D\u0430\u043A\u0440\u0438\u0442\u0430 \u0441\u0456\u0442\u043A\u0430\u043C\u0438 \u0432\u0456\u0434 \u0434\u0440\u043E\u043D\u0456\u0432 \xabHuman Safari\xbb","firefighterDescription":"\u0420\u044F\u0442\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u043A \u0433\u0430\u0441\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C \u043F\u0456\u0441\u043B\u044F \u0443\u0434\u0430\u0440\u0443 \xabHuman Safari\xbb, \u043F\u043E\u0437\u0430\u0434\u0443 \u043B\u0435\u0436\u0438\u0442\u044C \u043F\u043E\u0441\u0442\u0440\u0430\u0436\u0434\u0430\u043B\u0438\u0439"},"follow":{"title":"\u0421\u0442\u0435\u0436\u0442\u0435","subHumanSafari":"\u044F\u043A\u0456\u0441\u043D\u0456 \u0434\u0436\u0435\u0440\u0435\u043B\u0430, \u044F\u043A\u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u044F\u044E\u0442\u044C \u0456\u0437 \u0425\u0435\u0440\u0441\u043E\u043D\u0430 \u0442\u0430 \u043F\u0440\u043E \xab\u043B\u044E\u0434\u0441\u044C\u043A\u0435 \u0441\u0430\u0444\u0430\u0440\u0456\xbb","subDroneSiege":"\u044F\u043A\u0456\u0441\u043D\u0456 \u0434\u0436\u0435\u0440\u0435\u043B\u0430, \u044F\u043A\u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u044F\u044E\u0442\u044C \u0456\u0437 \u0425\u0435\u0440\u0441\u043E\u043D\u0430 \u0442\u0430 \u043F\u0440\u043E \u0434\u0440\u043E\u043D\u043E\u0432\u0443 \u043E\u0431\u043B\u043E\u0433\u0443","localPress":"\u043C\u0456\u0441\u0446\u0435\u0432\u0430 \u0443\u043A\u0440\u0430\u0457\u043D\u043E\u043C\u043E\u0432\u043D\u0430 \u043F\u0440\u0435\u0441\u0430","lang":{"english":"\u0430\u043D\u0433\u043B\u0456\u0439\u0441\u044C\u043A\u0430","german":"\u043D\u0456\u043C\u0435\u0446\u044C\u043A\u0430","ukrainian":"\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"},"language":"\u041C\u043E\u0432\u0430: {{list}}","languages":"\u041C\u043E\u0432\u0438: {{list}}","langSeparator":", ","zabrisky":{"name":"\u0417\u0430\u0440\u0438\u043D\u0430 \u0417\u0430\u0431\u0440\u0456\u0441\u043A\u0456","desc":"\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0430 \u0436\u0443\u0440\u043D\u0430\u043B\u0456\u0441\u0442\u043A\u0430 \u0439 \u0440\u0435\u0436\u0438\u0441\u0435\u0440\u043A\u0430 \u0432 \u0425\u0435\u0440\u0441\u043E\u043D\u0456, \u043F\u0440\u0430\u0446\u044E\u0454 \u0434\u043B\u044F Byline Times \u0442\u0430 Euromaidan Press; \u0440\u0435\u0436\u0438\u0441\u0435\u0440\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0444\u0456\u043B\u044C\u043C\u0443 Kherson Human Safari."},"naber":{"name":"\u0406\u0431\u0440\u0430\u0433\u0456\u043C \u041D\u0430\u0431\u0435\u0440","desc":"\u0413\u043E\u043B\u043E\u0432\u043D\u0438\u0439 \u0440\u0435\u043F\u043E\u0440\u0442\u0435\u0440 \u043D\u0456\u043C\u0435\u0446\u044C\u043A\u043E\u0457 \u0433\u0430\u0437\u0435\u0442\u0438 Die Welt; \u043F\u0435\u0440\u0456\u043E\u0434\u0438\u0447\u043D\u043E \u0432\u0438\u0441\u0432\u0456\u0442\u043B\u044E\u0454 \xab\u043B\u044E\u0434\u0441\u044C\u043A\u0435 \u0441\u0430\u0444\u0430\u0440\u0456\xbb \u0432 \u0425\u0435\u0440\u0441\u043E\u043D\u0456."},"kelley":{"name":"\u0411\u0440\u0435\u043D\u0434\u0430\u043D \u041A\u0435\u043B\u043B\u0456","desc":"\u0412\u0435\u0434\u0435 Kherson Weekly \u2014 \u0445\u0440\u043E\u043D\u0456\u043A\u0443 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0438\u0445 \u0430\u0442\u0430\u043A \u0434\u0440\u043E\u043D\u0430\u043C\u0438 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456 \u0442\u0430 \u043D\u0430\u0432\u043A\u043E\u043B\u0438\u0448\u043D\u0456\u0445 \u0441\u0435\u043B\u0430\u0445."},"vgoru":{"name":"\u0412\u0433\u043E\u0440\u0443","desc":"\u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u0430 \u043C\u0435\u0434\u0456\u0430\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0425\u0435\u0440\u0441\u043E\u043D\u0449\u0438\u043D\u0438 \u2014 \u043F\u0440\u043E \u0436\u0438\u0442\u0442\u044F \u043F\u0456\u0434 \u043E\u0431\u0441\u0442\u0440\u0456\u043B\u0430\u043C\u0438 \u0442\u0430 \u0432 \u043E\u043A\u0443\u043F\u0430\u0446\u0456\u0457."},"suspilne":{"name":"\u0421\u0443\u0441\u043F\u0456\u043B\u044C\u043D\u0435 \u0425\u0435\u0440\u0441\u043E\u043D","desc":"\u0425\u0435\u0440\u0441\u043E\u043D\u0441\u044C\u043A\u0430 \u0440\u0435\u0434\u0430\u043A\u0446\u0456\u044F \u0421\u0443\u0441\u043F\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043C\u043E\u0432\u043D\u0438\u043A\u0430 \u0423\u043A\u0440\u0430\u0457\u043D\u0438."},"most":{"name":"\u041C\u041E\u0421\u0422","desc":"\u041C\u0456\u0441\u0446\u0435\u0432\u0435 \u0445\u0435\u0440\u0441\u043E\u043D\u0441\u044C\u043A\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0439\u043D\u0435 \u0430\u0433\u0435\u043D\u0442\u0441\u0442\u0432\u043E \u2014 \u043F\u0440\u043E \u043C\u0456\u0441\u0442\u043E \u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u044C."}},"rallies":{"oleshky2026":{"heroStop":"\u0417\u0423\u041F\u0418\u041D\u0418\u041C\u041E \u0414\u0420\u041E\u041D\u041E\u0412\u0423 \u041E\u0411\u041B\u041E\u0413\u0423","heroSave":"\u0412\u0420\u042F\u0422\u0423\u0419\u0422\u0415 \u041E\u041B\u0415\u0428\u041A\u0418","worldwideRally":"\u0441\u0432\u0456\u0442\u043E\u0432\u0430 \u0430\u043A\u0446\u0456\u044F","heroDate":"\u0416\u043E\u0432\u0442\u0435\u043D\u044C","infoText1":"\u0422\u0438\u0441\u044F\u0447\u0456 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u043E\u043F\u0438\u043D\u0438\u043B\u0438\u0441\u044F \u0432 \u043F\u0430\u0441\u0442\u0446\u0456 \u0434\u0440\u043E\u043D\u043E\u0432\u043E\u0457 \u043E\u0431\u043B\u043E\u0433\u0438 \u0432 \u041E\u043B\u0435\u0448\u043A\u0430\u0445, \u0413\u043E\u043B\u0456\u0439 \u041F\u0440\u0438\u0441\u0442\u0430\u043D\u0456, \u0421\u0442\u0430\u0440\u0456\u0439 \u0417\u0431\u0443\u0440\'\u0457\u0432\u0446\u0456 \u0442\u0430 \u041D\u043E\u0432\u0456\u0439 \u0417\u0431\u0443\u0440\'\u0457\u0432\u0446\u0456. \u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0432\u0456\u0439\u0441\u044C\u043A\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C \u0457\u0445 \u044F\u043A \u0436\u0438\u0432\u0438\u0439 \u0449\u0438\u0442, \u0445\u043E\u0432\u0430\u044E\u0447\u0438\u0441\u044C \u0437\u0430 \u043D\u0438\u043C\u0438, \u0449\u043E\u0431 \u0437\u0434\u0456\u0439\u0441\u043D\u044E\u0432\u0430\u0442\u0438 \u0434\u0440\u043E\u043D\u043E\u0432\u0456 \u0430\u0442\u0430\u043A\u0438 \xab\u0441\u0430\u0444\u0430\u0440\u0456 \u043D\u0430 \u043B\u044E\u0434\u0435\u0439\xbb \u043D\u0430 \u043F\u0440\u043E\u0442\u0438\u043B\u0435\u0436\u043D\u0438\u0439 \u0431\u0435\u0440\u0435\u0433.","infoText2":"\u041A\u0440\u0438\u0437\u0430 \u0433\u043E\u0441\u0442\u0440\u0430: \u0431\u0440\u0430\u043A\u0443\u0454 \u0457\u0436\u0456, \u0432\u043E\u0434\u0438, \u043C\u0435\u0434\u0438\u0447\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438, \u043B\u0456\u043A\u0456\u0432, \u0435\u043B\u0435\u043A\u0442\u0440\u0438\u043A\u0438, \u0433\u0430\u0437\u0443 \u0442\u0430 \u0437\u0432\'\u044F\u0437\u043A\u0443. \u0414\u043E\u0440\u043E\u0433\u0438 \u0433\u0443\u0441\u0442\u043E \u0437\u0430\u043C\u0456\u043D\u043E\u0432\u0430\u043D\u0456, \u0430 \u0434\u0440\u043E\u043D\u0438 \u043E\u0431\u043C\u0435\u0436\u0443\u044E\u0442\u044C \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0440\u0443\u0445. <bold>\u0412\u0418 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041F\u0440\u0438\u0454\u0434\u043D\u0443\u0439\u0442\u0435\u0441\u044C \u0434\u043E \u0442\u0438\u0441\u044F\u0447 \u043B\u044E\u0434\u0435\u0439 \u043F\u043E \u0432\u0441\u044C\u043E\u043C\u0443 \u0441\u0432\u0456\u0442\u0443, \u0449\u043E\u0431 \u0432\u0438\u043C\u0430\u0433\u0430\u0442\u0438 \u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438 \u0434\u0440\u043E\u043D\u043E\u0432\u0443 \u043E\u0431\u043B\u043E\u0433\u0443.</bold>","imageAlt":"\u0412\u0438\u0441\u043D\u0430\u0436\u0435\u043D\u0438\u0439 \u0441\u043E\u0431\u0430\u043A\u0430 \u0441\u0435\u0440\u0435\u0434 \u043B\u044E\u0434\u0441\u044C\u043A\u0438\u0445 \u043A\u0456\u0441\u0442\u043E\u043A \u0443 \u0437\u0440\u0443\u0439\u043D\u043E\u0432\u0430\u043D\u0438\u0445 \u041E\u043B\u0435\u0448\u043A\u0430\u0445 \u043F\u0456\u0434 \u0447\u0435\u0440\u0432\u043E\u043D\u0438\u043C \u043D\u0435\u0431\u043E\u043C, \u043F\u043E\u0432\u043D\u0438\u043C \u0434\u0440\u043E\u043D\u0456\u0432, \u0437 \u043D\u0430\u043F\u0438\u0441\u043E\u043C Stop Russian Drone Siege","demandsTitle":"\u041C\u0438 \u0437\u0430\u043A\u043B\u0438\u043A\u0430\u0454\u043C\u043E \u0434\u043E:","demand1":"\u0431\u0435\u0437\u043F\u0435\u0447\u043D\u0438\u0445 \u0442\u0430 \u0435\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u0438\u0445 \u043A\u043E\u0440\u0438\u0434\u043E\u0440\u0456\u0432 \u0434\u043E \u041E\u043B\u0435\u0448\u043E\u043A \u0442\u0430 \u0456\u043D\u0448\u0438\u0445 \u043F\u043E\u0441\u0442\u0440\u0430\u0436\u0434\u0430\u043B\u0438\u0445 \u0433\u0440\u043E\u043C\u0430\u0434.","demand2":"\u043D\u0435\u0433\u0430\u0439\u043D\u043E\u0457 \u0433\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438 \u0442\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u0436\u0435\u0440\u0442\u0432\u0430\u043C \u0430\u0442\u0430\u043A \xab\u043B\u044E\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0430\u0444\u0430\u0440\u0456\xbb.","demand3":"\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0438\u0445 \u0441\u0430\u043D\u043A\u0446\u0456\u0439 \u043F\u0440\u043E\u0442\u0438 \u043E\u0441\u0456\u0431 \u0456 \u043B\u0430\u043D\u0446\u044E\u0433\u0456\u0432 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043D\u043D\u044F, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0445 \u0437\u0430 \u0430\u0442\u0430\u043A\u0438 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445.","demand4":"\u0437\u0430\u0445\u043E\u0434\u0456\u0432, \u0449\u043E \u0441\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u043C\u0430\u043B\u0438\u0445 \u0434\u0440\u043E\u043D\u0456\u0432 \u0434\u043B\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0447\u043D\u0438\u0445 \u0430\u0442\u0430\u043A \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0456 \u0457\u0445 \u0442\u0435\u0440\u043E\u0440\u0438\u0437\u0443\u0432\u0430\u043D\u043D\u044F \u0432 \u0425\u0435\u0440\u0441\u043E\u043D\u0456, \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u0442\u0430 \u0434\u0435\u0456\u043D\u0434\u0435.","cities":{"edinburgh":{"city":"\u0415\u0434\u0456\u043D\u0431\u0443\u0440\u0433","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u0415\u0434\u0456\u043D\u0431\u0443\u0440\u0433 - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 14:00","location":"\u041C\u043E\u043D\u0443\u043C\u0435\u043D\u0442 \u0433\u0435\u0440\u0446\u043E\u0433\u0430 \u0412\u0435\u043B\u043B\u0456\u043D\u0433\u0442\u043E\u043D\u0430","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"\u0411\u0456\u0440\u043C\u0456\u043D\u0433\u0435\u043C","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u0411\u0456\u0440\u043C\u0456\u043D\u0433\u0435\u043C - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 14:00 - 16:00","location":"\u041D\u0430\u0432\u043F\u0440\u043E\u0442\u0438 \u0417\u0430\u043B\u0438 \u043F\u0430\u043C\'\u044F\u0442\u0456 (Hall of Memory), B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"\u0412\u0456\u0434\u0435\u043D\u044C","country":"\u0410\u0432\u0441\u0442\u0440\u0456\u044F","time":"\u0412\u0456\u0434\u0435\u043D\u044C - \u0410\u0432\u0441\u0442\u0440\u0456\u044F, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"\u041C\u044E\u043D\u0445\u0435\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u041C\u044E\u043D\u0445\u0435\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 16:00 - 18:00","location":"\u0414\u0430\u0443\u043D\u0456\u043D\u0433-\u0441\u0442\u0440\u0456\u0442","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"\u041C\u0430\u043D\u0447\u0435\u0441\u0442\u0435\u0440","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041C\u0430\u043D\u0447\u0435\u0441\u0442\u0435\u0440 - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 14:00 - 15:30","location":"\u041F\u043B\u043E\u0449\u0430 \u0421\u0432\u044F\u0442\u043E\u0433\u043E \u041F\u0435\u0442\u0440\u0430 (St Peter\'s Square)","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"\u0421\u0456\u0434\u043D\u0435\u0439","country":"\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F","time":"\u0421\u0456\u0434\u043D\u0435\u0439 - \u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F, 14:00","location":"\u0420\u0430\u0442\u0443\u0448\u0430 \u0421\u0456\u0434\u043D\u0435\u044F (Sydney Town Hall)","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"\u041F\u0430\u0440\u0438\u0436","country":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","time":"\u041F\u0430\u0440\u0438\u0436 - \u0424\u0440\u0430\u043D\u0446\u0456\u044F, 15:30 - 18:30","location":"\u0412\u0456\u0434 \u0446\u0435\u0440\u043A\u0432\u0438 \u0421\u0432\u044F\u0442\u043E\u0433\u043E \u0412\u043E\u043B\u043E\u0434\u0438\u043C\u0438\u0440\u0430 \u0434\u043E \u043F\u043B\u043E\u0449\u0456 \u0421\u0435\u043D-\u041C\u0456\u0448\u0435\u043B\u044C","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"\u041F\u0430\u0440\u0438\u0436","country":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","time":"\u041F\u0430\u0440\u0438\u0436 - \u0424\u0440\u0430\u043D\u0446\u0456\u044F, 18:00","location":"\u0421\u0442\u0430\u043D\u0446\u0456\u044F \u043C\u0435\u0442\u0440\u043E \xab\u0420\u0430\u043C\u0431\u044E\u0442\u043E\xbb","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"\u041B\u0456\u043E\u043D","country":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","time":"\u041B\u0456\u043E\u043D - \u0424\u0440\u0430\u043D\u0446\u0456\u044F, 14:00","location":"\u041F\u043B\u043E\u0449\u0430 \u041A\u043E\u043C\u0435\u0434\u0456\u0457 (Place de la Com\xe9die)","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"\u0414\u0443\u0431\u043B\u0456\u043D","country":"\u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F","time":"\u0414\u0443\u0431\u043B\u0456\u043D - \u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F, 13:00","location":"\u0413\u043E\u043B\u043E\u0432\u043F\u043E\u0448\u0442\u0430\u043C\u0442 (The GPO)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"\u0411\u0440\u044E\u0441\u0441\u0435\u043B\u044C","country":"\u0411\u0435\u043B\u044C\u0433\u0456\u044F","time":"\u0411\u0440\u044E\u0441\u0441\u0435\u043B\u044C - \u0411\u0435\u043B\u044C\u0433\u0456\u044F, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 \u0411\u0440\u044E\u0441\u0441\u0435\u043B\u044C (\u043A\u0456\u043B\u044C\u0446\u0435 \u0428\u0443\u043C\u0430\u043D)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"\u041E\u0442\u0442\u0430\u0432\u0430","country":"\u041A\u0430\u043D\u0430\u0434\u0430","time":"\u041E\u0442\u0442\u0430\u0432\u0430 - \u041A\u0430\u043D\u0430\u0434\u0430, 12:30 - 13:30","location":"\u041F\u043E\u0441\u043E\u043B\u044C\u0441\u0442\u0432\u043E \u0440\u043E\u0441\u0456\u0457, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"\u041D\u0430\u043D\u0442","country":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","time":"\u041D\u0430\u043D\u0442 - \u0424\u0440\u0430\u043D\u0446\u0456\u044F, 15:00 - 16:30","location":"\u041A\u043E\u0440\u043E\u043B\u0456\u0432\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430 (Place Royale)","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"\u0413\u0434\u0430\u043D\u0441\u044C\u043A","country":"\u041F\u043E\u043B\u044C\u0449\u0430","time":"\u0413\u0434\u0430\u043D\u0441\u044C\u043A - \u041F\u043E\u043B\u044C\u0449\u0430, 18:30 - 19:30","location":"D\u0142ugi Targ, \u0431\u0456\u043B\u044F \u0444\u043E\u043D\u0442\u0430\u043D\u0443 \u041D\u0435\u043F\u0442\u0443\u043D\u0430","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"\u0427\u0438\u043A\u0430\u0433\u043E","country":"\u0421\u0428\u0410","time":"\u0427\u0438\u043A\u0430\u0433\u043E - \u0421\u0428\u0410, 13:00","location":"410 N. Michigan ave. (\u0411\u0443\u0434\u0456\u0432\u043B\u044F Wrigley)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"\u0427\u0438\u043A\u0430\u0433\u043E","country":"\u0421\u0428\u0410","time":"\u0427\u0438\u043A\u0430\u0433\u043E - \u0421\u0428\u0410, 13:00","location":"410 N. Michigan ave. (\u0411\u0443\u0434\u0456\u0432\u043B\u044F Wrigley)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"\u0427\u0438\u043A\u0430\u0433\u043E","country":"\u0421\u0428\u0410","time":"\u0427\u0438\u043A\u0430\u0433\u043E - \u0421\u0428\u0410, 13:00","location":"410 N. Michigan ave. (\u0411\u0443\u0434\u0456\u0432\u043B\u044F Wrigley)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"\u0427\u0438\u043A\u0430\u0433\u043E","country":"\u0421\u0428\u0410","time":"\u0427\u0438\u043A\u0430\u0433\u043E - \u0421\u0428\u0410, 13:00","location":"410 N. Michigan ave. (\u0411\u0443\u0434\u0456\u0432\u043B\u044F Wrigley)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"\u0414\u0440\u0435\u0437\u0434\u0435\u043D","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0414\u0440\u0435\u0437\u0434\u0435\u043D - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 14:00","location":"\u041D\u043E\u0439\u043C\u0430\u0440\u043A\u0442 (Neumarkt)","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"\u041C\u0430\u043B\u0430\u0433\u0430","country":"\u0406\u0441\u043F\u0430\u043D\u0456\u044F","time":"\u041C\u0430\u043B\u0430\u0433\u0430 - \u0406\u0441\u043F\u0430\u043D\u0456\u044F, 19:00","location":"\u041F\u043B\u043E\u0449\u0430 \u041C\u0430\u0440\u0438\u043D\u0430 (Plaza de la Marina)","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 18:00","location":"\u0422\u0440\u0430\u0444\u0430\u043B\u044C\u0433\u0430\u0440\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"\u041F\u043B\u043E\u0432\u0434\u0438\u0432","country":"\u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F","time":"\u041F\u043B\u043E\u0432\u0434\u0438\u0432 - \u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F, 17:00","location":"\u0413\u043E\u043B\u043E\u0432\u043D\u0430 \u0432\u0443\u043B\u0438\u0446\u044F, \u0431\u0456\u043B\u044F \u0441\u0445\u043E\u0434\u0456\u0432 \xab\u041A\u0430\u043C\u0435\u043D\u0438\u0446\u0430\xbb / \u043D\u0430\u043F\u0438\u0441\u0443 \xabTogether\xbb","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"\u0411\u0443\u0434\u0430\u043F\u0435\u0448\u0442","country":"\u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430","time":"\u0411\u0443\u0434\u0430\u043F\u0435\u0448\u0442 - \u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (\u043F\u043B\u043E\u0449\u0430 \u0421\u0432\u044F\u0442\u043E\u0433\u043E \u0406\u0448\u0442\u0432\u0430\u043D\u0430)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 17:00","location":"\u0422\u0440\u0430\u0444\u0430\u043B\u044C\u0433\u0430\u0440\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 12:00","location":"\u0422\u0440\u0430\u0444\u0430\u043B\u044C\u0433\u0430\u0440\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"\u0413\u0430\u043C\u0431\u0443\u0440\u0433","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u0413\u0430\u043C\u0431\u0443\u0440\u0433 - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, \u043D\u0430\u0432\u043F\u0440\u043E\u0442\u0438 \u043F\u0440\u0438\u0447\u0430\u043B\u0443 1, 20359 \u0413\u0430\u043C\u0431\u0443\u0440\u0433","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"\u041A\u0456\u043B\u044C","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u041A\u0456\u043B\u044C - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 15:00 - 16:00","location":"\u0413\u043E\u043B\u044C\u0448\u0442\u0435\u043D\u0448\u0442\u0440\u0430\u0441\u0435 (Holstenstra\xdfe)","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"\u041E\u0441\u043B\u043E","country":"\u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F","time":"\u041E\u0441\u043B\u043E - \u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F","location":"\u041F\u043B\u043E\u0449\u0430 \u0415\u0439\u0434\u0441\u0432\u043E\u043B\u043B\u0430 (Eidsvolls plass)","cleanTime":"","day":"schedule3"},"leipzig":{"city":"\u041B\u0435\u0439\u043F\u0446\u0438\u0433","country":"\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430","time":"\u041B\u0435\u0439\u043F\u0446\u0438\u0433 - \u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430, 17:00 - 18:00","location":"\u0413\u043E\u043B\u043E\u0432\u043D\u0438\u0439 \u0432\u043E\u043A\u0437\u0430\u043B (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 17:00","location":"\u0422\u0440\u0430\u0444\u0430\u043B\u044C\u0433\u0430\u0440\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"\u041B\u043E\u043D\u0434\u043E\u043D","country":"\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F","time":"\u041B\u043E\u043D\u0434\u043E\u043D - \u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F, 13:00","location":"\u0422\u0440\u0430\u0444\u0430\u043B\u044C\u0433\u0430\u0440\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"\u0414\u0443\u0431\u043B\u0456\u043D","country":"\u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F","time":"\u0414\u0443\u0431\u043B\u0456\u043D - \u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F, 13:00","location":"\u0413\u043E\u043B\u043E\u0432\u043F\u043E\u0448\u0442\u0430\u043C\u0442 (The GPO)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"\u0414\u0443\u0431\u043B\u0456\u043D","country":"\u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F","time":"\u0414\u0443\u0431\u043B\u0456\u043D - \u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F, 14:00","location":"\u0413\u043E\u043B\u043E\u0432\u043F\u043E\u0448\u0442\u0430\u043C\u0442 (The GPO)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"\u041D\u0430\u043D\u0442","country":"\u0424\u0440\u0430\u043D\u0446\u0456\u044F","time":"\u041D\u0430\u043D\u0442 - \u0424\u0440\u0430\u043D\u0446\u0456\u044F, 15:00 - 16:30","location":"\u041A\u043E\u0440\u043E\u043B\u0456\u0432\u0441\u044C\u043A\u0430 \u043F\u043B\u043E\u0449\u0430 (Place Royale)","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"\u0417\u0443\u043F\u0438\u043D\u0456\u0442\u044C \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0443 \u0434\u0440\u043E\u043D\u043E\u0432\u0443 \u043E\u0431\u043B\u043E\u0433\u0443","posterNoRoadOut":"\u0428\u043B\u044F\u0445\u0438 \u0432 \u041E\u043B\u0435\u0448\u043A\u0438 \u0442\u0430 \u0437 \u043D\u0438\u0445 \u0437\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u0456","posterHumanitarianCatastrophe":"\u041E\u043B\u0435\u0448\u043A\u0438. \u0413\u0443\u043C\u0430\u043D\u0456\u0442\u0430\u0440\u043D\u0430 \u043A\u0430\u0442\u0430\u0441\u0442\u0440\u043E\u0444\u0430 \u043F\u0456\u0434 \u043E\u043A\u0443\u043F\u0430\u0446\u0456\u0454\u044E","seeGallery":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 / \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u043B\u0430\u043A\u0430\u0442\u0438"},"artBy":"\u0410\u0432\u0442\u043E\u0440: {{name}}","downloadPoster":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u043B\u0430\u043A\u0430\u0442","reel":{"download":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0432\u0456\u0434\u0435\u043E (MP4)"},"addDemo":{"title":"\u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u044E \u0430\u043A\u0446\u0456\u044E","where":"\u0434\u0435: \u043C\u0456\u0441\u0442\u043E","contact":"email/\u043D\u043E\u043C\u0435\u0440","message":"\u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F: \u043A\u043E\u0433\u043E \u0432\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0454\u0442\u0435, \u0430\u043A\u0446\u0456\u044E \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E \u0447\u0438 \u0432\u043E\u043D\u0430 \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0456, \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043E\u043D\u043B\u0430\u0439\u043D-\u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F, \u0456\u043D\u0448\u0456 \u0434\u0435\u0442\u0430\u043B\u0456","submit":"\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438","sending":"\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u2026","thanks":"\u0414\u044F\u043A\u0443\u0454\u043C\u043E! \u041C\u0438 \u0437 \u0432\u0430\u043C\u0438 \u0437\u0432\'\u044F\u0436\u0435\u043C\u043E\u0441\u044F.","error":"\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.","contactInvalid":"\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0434\u0456\u0439\u0441\u043D\u0438\u0439 email \u0430\u0431\u043E \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0437 \u043A\u043E\u0434\u043E\u043C \u043A\u0440\u0430\u0457\u043D\u0438 (\u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, +380 67 123 4567).","date":"\u0434\u0430\u0442\u0430","time":"\u0447\u0430\u0441 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 (\u043C\u0456\u0441\u0446\u0435\u0432\u0438\u0439)","whereInvalid":"\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u043C\u0456\u0441\u0442\u0430, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434 \u041A\u0438\u0457\u0432 \u0430\u0431\u043E \u041F\u0430\u0440\u0438\u0436, \u0424\u0440\u0430\u043D\u0446\u0456\u044F.","datePlaceholder":"\u0434\u0430\u0442\u0430: \u0434\u0434/\u043C\u043C"}},"seo":{"oleshky":{"title":"\u0417\u0443\u043F\u0438\u043D\u0438\u043C\u043E \u0434\u0440\u043E\u043D\u043E\u0432\u0443 \u043E\u0431\u043B\u043E\u0433\u0443 \u2014 \u0412\u0440\u044F\u0442\u0443\u0439\u0442\u0435 \u041E\u043B\u0435\u0448\u043A\u0438 | \u0410\u043A\u0446\u0456\u0457 \u0443 \u0441\u0432\u0456\u0442\u0456","description":"\u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0434\u0440\u043E\u043D\u0438 \u0442\u0440\u0438\u043C\u0430\u044E\u0442\u044C \u0432 \u043E\u0431\u043B\u043E\u0437\u0456 \u0442\u0438\u0441\u044F\u0447\u0456 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0432 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0438\u0445 \u041E\u043B\u0435\u0448\u043A\u0430\u0445, \u0432\u0456\u0434\u0440\u0456\u0437\u0430\u043D\u0438\u0445 \u0432\u0456\u0434 \u0457\u0436\u0456, \u0432\u043E\u0434\u0438 \u0442\u0430 \u043B\u0456\u043A\u0456\u0432. \u0417\u043D\u0430\u0439\u0434\u0456\u0442\u044C \u0430\u043A\u0446\u0456\u044E \u043F\u043E\u0440\u0443\u0447 \u0456 \u0432\u0438\u043C\u0430\u0433\u0430\u0439\u0442\u0435 \u0431\u0435\u0437\u043F\u0435\u0447\u043D\u043E\u0433\u043E \u0432\u0438\u0445\u043E\u0434\u0443."},"leftBank":{"title":"\u0414\u0440\u043E\u043D\u043E\u0432\u0430 \u043E\u0431\u043B\u043E\u0433\u0430 \u041E\u043B\u0435\u0448\u043E\u043A \u0442\u0430 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u043E\u0457 \u0425\u0435\u0440\u0441\u043E\u043D\u0449\u0438\u043D\u0438","description":"\u0422\u0438\u0441\u044F\u0447\u0456 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u043E\u043F\u0438\u043D\u0438\u043B\u0438\u0441\u044F \u0432 \u043F\u0430\u0441\u0442\u0446\u0456 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u043E\u0457 \u0434\u0440\u043E\u043D\u043E\u0432\u043E\u0457 \u043E\u0431\u043B\u043E\u0433\u0438 \u0432 \u043E\u043A\u0443\u043F\u043E\u0432\u0430\u043D\u0438\u0445 \u041E\u043B\u0435\u0448\u043A\u0430\u0445, \u0413\u043E\u043B\u0456\u0439 \u041F\u0440\u0438\u0441\u0442\u0430\u043D\u0456 \u0442\u0430 \u0434\u043E\u0432\u043A\u043E\u043B\u0438\u0448\u043D\u0456\u0445 \u0441\u0435\u043B\u0430\u0445. \u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0456\u0434\u0431\u0443\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u0456 \u044F\u043A \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438."},"help":{"title":"\u0417\u0443\u043F\u0438\u043D\u0456\u043C\u043E Human Safari \u2014 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0434\u0440\u043E\u043D\u0438 \u043F\u043E\u043B\u044E\u044E\u0442\u044C \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456","description":"\u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0434\u0440\u043E\u043D\u0438 \u043F\u043E\u043B\u044E\u044E\u0442\u044C \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456. \u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u043F\u0440\u043E \u0432\u043E\u0454\u043D\u043D\u0438\u0439 \u0437\u043B\u043E\u0447\u0438\u043D Human Safari \u0442\u0430 \u044F\u043A \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438 \u0439\u043E\u0433\u043E \u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438."},"action":{"title":"\u0421\u0432\u0456\u0442\u043E\u0432\u0430 \u0430\u043A\u0446\u0456\u044F, \u0433\u0440\u0443\u0434\u0435\u043D\u044C 2025 \u2014 \u0417\u0443\u043F\u0438\u043D\u0456\u043C\u043E Human Safari","description":"\u0424\u043E\u0442\u043E, \u043F\u043B\u0430\u043A\u0430\u0442\u0438 \u0442\u0430 \u043C\u0456\u0441\u0446\u044F \u0441\u0432\u0456\u0442\u043E\u0432\u043E\u0457 \u0430\u043A\u0446\u0456\u0457 \u0443 \u0433\u0440\u0443\u0434\u043D\u0456 2025 \u0440\u043E\u043A\u0443 \u043F\u0440\u043E\u0442\u0438 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0438\u0445 \u0430\u0442\u0430\u043A \u0434\u0440\u043E\u043D\u0456\u0432 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456."},"rallies":{"title":"\u0424\u043E\u0442\u043E \u0437 \u0430\u043A\u0446\u0456\u0439 \u2014 \u0417\u0443\u043F\u0438\u043D\u0456\u043C\u043E Human Safari","description":"\u0424\u043E\u0442\u043E \u0437 \u0430\u043A\u0446\u0456\u0439 \u0443 \u0432\u0441\u044C\u043E\u043C\u0443 \u0441\u0432\u0456\u0442\u0456 \u043F\u0440\u043E\u0442\u0438 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0438\u0445 \u0430\u0442\u0430\u043A \u0434\u0440\u043E\u043D\u0456\u0432 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456."},"resources":{"title":"Human Safari \u2014 \u0437\u0432\u0456\u0442\u0438, \u0441\u0442\u0430\u0442\u0442\u0456 \u0442\u0430 \u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F","description":"\u0417\u0432\u0456\u0442\u0438, \u0441\u0442\u0430\u0442\u0442\u0456, \u0456\u043D\u0442\u0435\u0440\u0432\u2019\u044E \u0442\u0430 \u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F \u043E\u0447\u0435\u0432\u0438\u0434\u0446\u0456\u0432 \u043F\u0440\u043E \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0456 \u0430\u0442\u0430\u043A\u0438 \u0434\u0440\u043E\u043D\u0456\u0432 \u043D\u0430 \u0446\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0445 \u0443 \u0425\u0435\u0440\u0441\u043E\u043D\u0456."},"reel":{"title":"\u0412\u0440\u044F\u0442\u0443\u0439\u0442\u0435 \u041E\u043B\u0435\u0448\u043A\u0438 \u2014 \u0432\u0456\u0434\u0435\u043E \u0437 \u0430\u043A\u0446\u0456\u0439","description":"\u0412\u0456\u0434\u0435\u043E \u0437\u0456 \u0441\u0432\u0456\u0442\u043E\u0432\u0438\u0445 \u0430\u043A\u0446\u0456\u0439 \xab\u0412\u0440\u044F\u0442\u0443\u0439\u0442\u0435 \u041E\u043B\u0435\u0448\u043A\u0438\xbb, \u0436\u043E\u0432\u0442\u0435\u043D\u044C 2026."}}}');


var $b0a777bb87628789$exports = {};
$b0a777bb87628789$exports = JSON.parse('{"home":{"heroStop":"STOPPT HUMAN SAFARI","heroSave":"RETTET CHERSON","heroTitle1":"Menschen","heroTitle2":"sind keine Zielscheiben","heroDate":"13., 14. Dezember","worldwideRally":"Weltweite Kundge&shy;bung","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"Seit Sommer 2024 setzt das russische Milit\xe4r kleine Drohnen ein, um die ukrainische Zivilbev\xf6lkerung auf den Stra\xdfen von Cherson und anderer St\xe4dte in der N\xe4he der Front gezielt zu jagen, zu terrorisieren und zu t\xf6ten. <bold>Diese Menschenjagd muss gestoppt werden. SIE k\xf6nnen helfen.</bold> Schlie\xdfen Sie sich tausenden Menschen weltweit an, um zu fordern, dass dieses Kriegsverbrechen beendet wird.","seeGallery":"Siehe weltweite Poster","comingSoon":"Standorte folgen in K\xfcrze","december":"Dezember","dec":"Dez.","october":"Oktober","oct":"Okt.","september":"September","sep":"Sept.","schedule9":"9.","schedule10":"10.","schedule11":"11.","schedule12":"12.","schedule13":"13.","schedule14":"14.","schedule16":"16.","schedule18":"18.","schedule20":"20.","schedule1":"1.","schedule2":"2.","schedule3":"3.","schedule4":"4.","schedule5":"5.","schedule25":"25.","schedule26":"26.","schedule27":"27.","schedule28":"28.","schedule29":"29.","schedule30":"30.","schedule31":"31.","scheduleTBC":"Termin wird best\xe4tigt...","recommendationsTitle":"Empfehlungen der UN-Kommission","recommendationsRussia":"Die Kommission fordert die Russische F\xf6deration auf:","rusRec1":"(a) Die Drohnenangriffe auf Zivilisten und auf zivile Objekte sofort zu beenden","rusRec2":"(b) Alle Handlungen, die Terror unter der Zivilbev\xf6lkerung verbreiten, sofort einzustellen","rusRec3":"(c) Sicherzustellen, dass die T\xe4ter von Drohnenangriffen auf Zivilisten zur Verantwortung gezogen werden","recommendationsUNStates":"Die UN-Kommission empfiehlt anderen Staaten sowie regionalen und internationalen Organisationen:","statesRec1":"(a) Finanzielle und technische Unterst\xfctzung der ukrainischen Regierung und zivilgesellschaftlicher Organisationen, um umfassende Hilfe f\xfcr die Opfer und ihre Familien zu gew\xe4hrleisten;","statesRec2":"(b) F\xfcr Drittstaaten, deren Gebiet Ziel f\xfcr Personen ist, die aus den besetzten Gebieten vertrieben wurden, notwendige Ma\xdfnahmen gemeinsam mit den ukrainischen Konsulardiensten zur Unterst\xfctzung dieser Personen zu ergreifen."},"resources":{"title":"Schl\xfcsselressourcen","linkLibraryTitle":"Link-Bibliothek","linkLibraryDesc":"200 Artikel, Berichte, Interviews, Augenzeugenberichte und Medienberichterstattung","humanSafariMapTitle":"Human-Safari-Karte von Tochnyi","humanSafariMapDesc":"Eine interaktive Karte der Human-Safari-Angriffe in Cherson, zusammengestellt aus offen zug\xe4nglichen Meldungen lokaler Beh\xf6rden und aus Angriffsvideos, die das Tochnyi-Team geolokalisiert hat.","truthHoundsTitle":"Truth Hounds Bericht","truthHoundsDesc":"Killzone: Wie russische Drohnen das rechte Ufer des Flusses Dnipro verw\xfcsten","hrwTitle":"Human Rights Watch Bericht \xfcber Drohnenangriffe in Cherson","hrwDesc":"HRW-Bericht","unReportsTitle":"Berichte des UN-Menschenrechtsrats","report1":"UN-Bericht #1","report3":"UN-Bericht #3","guidelines":"UN-Richtlinien","wikipediaTitle":"Wikipedia","english":"Englisch","french":"Franz\xf6sisch","documentaryTitle":"Dokumentarfilm","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13. - 14. Dez.","eyewitnesses":"Zeugen","rallies":"Fotos","help":"deokkupiertes Cherson","leftBank":"besetztes Cherson","action":"Dez. \'25","oleshky":"globale Demo - Oleshky","menu":"Men\xfc"},"leftBank":{"pageTitle":"Drohnenbelagerung","para1":"Ein akuter humanit\xe4rer Notstand betrifft 6.000 Zivilisten, die im besetzten Oleshky, Hola Prystan, Stara Zburivka und Nova Zburivka unter einer Drohnenbelagerung gefangen sind - besetzte Region Cherson. In Oleshky 1.200 - 2.000. Die Besatzungsmacht ist verpflichtet, sie zu versorgen - stattdessen werden sie von den russischen Streitkr\xe4ften als menschliche Schutzschilde missbraucht, um sich hinter dieser Bev\xf6lkerung zu verstecken, w\xe4hrend sie Human-Safari-Angriffe auf das gegen\xfcberliegende Ufer ver\xfcben. Ukrainische Beh\xf6rden und humanit\xe4re Organisationen berichten von einer systematischen Behinderung der Evakuierung und des humanit\xe4ren Zugangs.","para2":"Den Zivilisten fehlt es an Nahrung, Wasser, medizinischer Versorgung, Medikamenten, Strom, Gas und Kommunikationsmitteln. Die Stra\xdfen sind stark vermint, und Drohnenaktivit\xe4t schr\xe4nkt die Bewegungsfreiheit ein. Seit dem 26. Mai konnten keine Fahrzeuge mehr ein- oder ausfahren. Treibstoff- und Nahrungsmittelvorr\xe4te sind nahezu ersch\xf6pft.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"Video: \u201EKherson and Oleshky: Witnessing Genocide\u201C (12 Min.)","meidasArticle":"Artikel: \u201EThe Kherson Region: How Russia Uses Civilians as a Tool of War\u201C (5 Min. Lesezeit)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Artikel: \u201EGlobal Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate\u201C (7 Min. Lesezeit)","tellPost":"und erz\xe4hle anderen von der Drohnenbelagerung","callToHelp":"SIE k\xf6nnen helfen. So geht\'s","donateIntro":"Diese Initiativen leisten wirkungsvolle, gezielte Hilfe direkt f\xfcr Menschen, die aus Oleshky geflohen sind oder, wo es m\xf6glich ist, dort festsitzen.","signTitle":"Unterschreiben","signSub":"Petitionen","petitionBy":"von {{name}}","petitions":{"euParliament":"Europ\xe4isches Parlament \u2013 Petition Nr. 1439/2026 zur Einrichtung eines humanit\xe4ren Evakuierungskorridors f\xfcr Zivilisten, die im russisch besetzten Oleshky (Ukraine) unter Belagerung festsitzen","ukParliament":"Britisches Parlament \u2013 Einrichtung eines von Gro\xdfbritannien gef\xfchrten humanit\xe4ren Hilfskorridors nach Oleshky in der Ukraine anstreben"},"publicActionLead":"R\xfccke die Drohnenbelagerung dort ins Rampenlicht, wo du bist.","organiseAction":"Organisiere eine Aktion.","policyBody":"Die ukrainischen Beh\xf6rden stehen in Konsultationen mit dem Internationalen Komitee vom Roten Kreuz \xfcber die Einrichtung eines humanit\xe4ren Evakuierungskorridors aus den besetzten Ortschaften in der Region Kherson und die Sicherung des humanit\xe4ren Zugangs f\xfcr Nahrung, Wasser, Medikamente, Treibstoff und medizinische Hilfe. Stand Anfang Juni gibt es keinen funktionierenden Evakuierungskorridor und keinen dauerhaften Mechanismus f\xfcr humanit\xe4ren Zugang.","documentaryTitle":"Oleshky, Kurzdokumentation","downloadTitle":"Download","downloadSub":"Grafiken"},"footer":{"addCityText":"Um Ihre Stadt hinzuzuf\xfcgen, senden Sie eine E-Mail an:","organiseText":"F\xfcge deine Demo hinzu - melde dich:","contact":"Kontakt:"},"byCountry":"nach Land anzeigen","byDate":"nach Datum anzeigen","countries":{"australia":"Australien","austria":"\xd6sterreich","bulgaria":"Bulgarien","canada":"Kanada","czechia":"Tschechien","denmark":"D\xe4nemark","estonia":"Estland","finland":"Finnland","france":"Frankreich","georgia":"Georgien","germany":"Deutschland","hungary":"Ungarn","italy":"Italien","japan":"Japan","mexico":"Mexiko","netherlands":"Niederlande","norway":"Norwegen","poland":"Polen","romania":"Rum\xe4nien","spain":"Spanien","sweden":"Schweden","southAfrica":"S\xfcdafrika","ukraine":"Ukraine","unitedKingdom":"Vereinigtes K\xf6nigreich","usa":"USA","ireland":"Irland","belgium":"Belgien"},"cities":{"alicante":{"city":"Alicante","country":"Spanien","time":"Alicante - Spanien, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcelona","country":"Spanien","time":"Barcelona - Spanien, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"USA","time":"Berkeley - USA, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berlin","country":"Deutschland","time":"Berlin - Deutschland, 12:00","location":"Tempelhofer Feld, Eingang Leinstr./Ecke Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"USA","time":"Bettendorf - USA, 17:30 - Filmvorf\xfchrung","location":"Bettendorf Public Library","cleanTime":"17:30 - Filmvorf\xfchrung","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"Vereinigtes K\xf6nigreich","time":"Birmingham - Vereinigtes K\xf6nigreich, 14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Deutschland","time":"Bonn - Deutschland, 14:00 - 16:00","location":"Poststra\xdfe, vor dem Hauptbahnhof","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Bremen","country":"Deutschland","time":"Bremen - Deutschland, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapest","country":"Ungarn","time":"Budapest - Ungarn, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Constan\u021Ba","country":"Rum\xe4nien","time":"Constan\u021Ba - Rum\xe4nien, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"Kopenhagen","country":"D\xe4nemark","time":"Kopenhagen - D\xe4nemark, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"USA","time":"Dallas - USA, 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"USA","time":"Denver - USA, 12:00","location":"Colorado Capitol-Geb\xe4ude, Westtreppen","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"Edinburgh","country":"Vereinigtes K\xf6nigreich","time":"Edinburgh - Vereinigtes K\xf6nigreich, 13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"USA","time":"Fort Worth - USA, 14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Hamburg","country":"Deutschland","time":"Hamburg - Deutschland, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"USA","time":"Houghton, Michigan - USA, 15:00","location":"TBC","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finnland","time":"Helsinki - Finnland, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Japan","time":"Izumo - Japan, 13:00","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Japan","time":"Izumo - Japan","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops","country":"Kanada","time":"Kamloops - Kanada, 15:00 - 16:00","location":"Rathaus","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kyiv","country":"Ukraine","time":"Kyiv - Ukraine, 17:00 - 18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Leipzig","country":"Deutschland","time":"Leipzig - Deutschland, 12:00 - 13:00","location":"Willy-Brandt-Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 18:30 - Filmvorf\xfchrung","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - Filmvorf\xfchrung","day":"schedule12"},"losAngeles":{"city":"Los Angeles","country":"USA","time":"Los Angeles - USA, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"M\xe1laga","country":"Spanien","time":"M\xe1laga - Spanien, 18:00 - Filmvorf\xfchrung","location":"Maydan - Centro Historico Cultural Ukraniano","cleanTime":"18:00 - Filmvorf\xfchrung","day":"schedule13"},"manchester":{"city":"Manchester","country":"Vereinigtes K\xf6nigreich","time":"Manchester - Vereinigtes K\xf6nigreich, 14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Mexico City","country":"Mexiko","time":"Mexico City - Mexiko, 11:00","location":"Alameda Central. \u201EAmerikas\u201C-Brunnen (zwischen Hemiciclo Ju\xe1rez und Kiosk)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Mailand","country":"Italien","time":"Mailand - Italien, 15:00","location":"Dom zu Mailand","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"M\xfcnchen","country":"Deutschland","time":"M\xfcnchen - Deutschland, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"New York","country":"USA","time":"New York - USA, 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"New York","country":"USA","time":"New York - USA, 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule13"},"nienburg":{"city":"Nienburg (Weser)","country":"Deutschland","time":"Nienburg (Weser) - Deutschland, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Norwegen","time":"Oslo - Norwegen, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Schweden","time":"\xd6stersund - Schweden, 11:00 - 14:00","location":"Stortorget (Hauptplatz)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Kanada","time":"Ottawa - Kanada, 12:30 - 13:30","location":"russische Botschaft","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Kanada","time":"Ottawa - Kanada, 12:00","location":"US-Botschaft","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Paris","country":"Frankreich","time":"Paris - Frankreich, 15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (Marsch)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"Plovdiv","country":"Bulgarien","time":"Plovdiv - Bulgarien, 16:00 - 17:00","location":"bei Levski-Haus","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Prag","country":"Tschechien","time":"Prag - Tschechien, 14:00","location":"Palack\xe9ho Platz","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"S\xfcdafrika","time":"Rosendal - S\xfcdafrika, 11:00","location":"B\xfcros der South African Police Service","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Teneriffa","country":"Spanien","time":"San Andr\xe9s, Teneriffa - Spanien, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"USA","time":"San Diego - USA, 14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"USA","time":"San Francisco - USA, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Deutschland","time":"Schwerin - Deutschland, 19:00 - Filmvorf\xfchrung","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - Filmvorf\xfchrung","day":"schedule13"},"seattle":{"city":"Seattle","country":"USA","time":"Seattle - USA, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sveti Vlas","country":"Bulgarien","time":"Sveti Vlas - Bulgarien, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"Sydney","country":"Australien","time":"Sydney - Australien, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallinn","country":"Estland","time":"Tallinn - Estland, 15:00 - Filmvorf\xfchrung und Rallye","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - Filmvorf\xfchrung und Rallye","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Spanien","time":"Tarragona - Spanien, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"Den Haag","country":"Niederlande","time":"Den Haag - Niederlande, 13:00 - 15:00","location":"Vor dem Friedenspalast / ICC","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tiflis","country":"Georgien","time":"Tiflis - Georgien, 21:00","location":"Tiflis","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Schweden","time":"Tran\xe5s - Schweden, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Wien","country":"\xd6sterreich","time":"Wien - \xd6sterreich, 16:00 - 18:00","location":"Stock im Eisen Platz (neben Stephansdom)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Washington, D.C.","country":"USA","time":"Washington, D.C. - USA, 12:30 - 13:30","location":"Das Wei\xdfe Haus","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Polen","time":"Wroc\u0142aw - Polen, 13:00","location":"Plac Wolno\u015Bci (i retning mod People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"Kontakt:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Teilen auf {{platform}}","website":"Website","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","donate":"Spenden","donateIntro":"Diese Initiativen leisten wirkungsvolle, gezielte Hilfe, um die Zivilbev\xf6lkerung in Cherson direkt vor Human Safari zu sch\xfctzen.","shareTitle":"Verbreite die Nachricht","filmScreening":"Organisiere eine Vorf\xfchrung des Dokumentarfilms Kherson Human Safari:","howItStarted":"Wie alles begann","project1":"Verletzte und vertriebene Zivilisten, Tierheime und/oder Anti-Drohnen-Schutz:","project2":"Anti-Drohnen-Netze f\xfcr die Stra\xdfen von Cherson:","project2LinkText":"Fellas4Europe Netzlieferungen","project3":"Drohnen-Detektoren und Schutzwesten f\xfcr Freiwillige und Rettungsdienste:","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, Journalistin und Filmemacherin, organisierte die weltweite Kundgebung und f\xfchrte Regie beim Dokumentarfilm Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Zivilistenschutz f\xfcr die Stra\xdfen von Cherson \u2013 Schutz der Zivilbev\xf6lkerung vor Drohnenangriffen.","foodDesc":"Lebensmittelhilfe.","foodNote":"Bitte gib beim Spenden den Verwendungszweck \u201EFood for Cherson\u201C an."},"ahs":{"name":"Anti Human Safari Projekt","desc":"Drohnendetektoren und Schutzwesten f\xfcr Freiwillige und Rettungsdienste in Cherson."},"pageTitle":"Stoppt Human Safari","sectionIntro":"Seit dem Sommer 2024 setzt das russische Milit\xe4r kleine Drohnen ein, um Zivilisten auf den Stra\xdfen von Cherson und anderen Frontst\xe4dten in der Ukraine zu jagen, zu t\xf6ten und zu terrorisieren.","sectionIntro2":"Es ist eine systematische und gezielte Mordkampagne: Die russischen Drohnenpiloten ver\xf6ffentlichen die Aufnahmen ihrer Opfer offen in Telegram-Kan\xe4len, um damit zu prahlen. Im Mai 2025 erkannten die Vereinten Nationen die Human Safari als andauerndes Kriegsverbrechen an.","sectionIntro3":"Es wird zu wenig dagegen getan. Human Safari muss gestoppt werden.","sectionIntroBold":"SIE k\xf6nnen helfen. So geht\'s","step2Title":"Organisieren","step3Title":"Erz\xe4hl anderen davon","step3Para":"Benutze die Hashtags","step3ParaPost":"und erz\xe4hle anderen von Human Safari","instagram":"Instagram","step2Bullet1":"eine Filmvorf\xfchrung","step2Bullet2":"eine \xf6ffentliche Aktion","step2Bullet3":"Berichterstattung in den Medien","publicActionLead":"R\xfccke die Human Safari dort ins Rampenlicht, wo du bist.","reachOutPre":"Du kannst dich f\xfcr Ideen und Ressourcen","reachOut":"an uns wenden","reachOutPost":"","newsCoverageLead":"\xfcber deine Medienkontakte. Erz\xe4hle ihnen von der Human Safari und von der Gefahr f\xfcr alle gegenw\xe4rtigen und k\xfcnftigen Konfliktgebiete.","putInTouchPre":"Du kannst auch","putInTouch":"direkt den Kontakt zu uns herstellen","inform":"Informieren","informSub":"dich und andere","policyTitle":"Politik","policyBody":"Der vorgeschlagene LORA Act (Liability for Operators and Responsible Authorities Act) w\xfcrde Sanktionen entlang der gesamten Verantwortungskette einf\xfchren \u2013 von russischen FPV-Operatoren und Kommandeuren bis zur milit\xe4rischen F\xfchrungsebene sowie gegen Hersteller und Zulieferer, die die Produktion und den Einsatz von Drohnen gegen Zivilisten erm\xf6glichen.","policyHelp":"Sie k\xf6nnen auf politischer Ebene helfen?","getInTouch":"Kontakt aufnehmen","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"kryla":{"name":"Kryla Foundation","desc":"Unterst\xfctze sie dabei, Unterkunft und Grundbedarf f\xfcr Bewohner von Oleshky zu bezahlen."}},"action":{"intro":"Wir haben mit einer weltweiten Demonstration begonnen. Jetzt kannst du:","helpLink":"hier helfen"},"accounts":{"heading":"Berichte"},"media":{"close":"Schlie\xdfen","view":"Medien ansehen","previous":"Zur\xfcck","next":"Weiter","andrushenkoCredit":"Oleksandr Andrushenko, Fotokorrespondent des Mediums Vgoru","khersonPoliceCredit":"von @khersonpolice","antypenkoCredit":"Ivan Antypenko, Fotojournalist aus Cherson","telegramChannelCredit":"ver\xf6ffentlicht im russischen Human-Safari-Telegram-Kanal \u201Evon Mariupol bis zu den Karpaten\u201C","fruitSellerDescription":"Obstverk\xe4ufer von einer Glasfaserdrohne verfolgt","burntCarDescription":"Ausgebranntes Auto in Cherson","bridgeAttackDescription":"Ein Jugendlicher wird unter einer Br\xfccke in Cherson von einer FPV-Drohne ermordet","busAttackDescription":"Einer von vielen FPV-Drohnenangriffen auf \xf6ffentliche Verkehrsmittel","fpvDroneDescription":"FPV-Drohne unterwegs auf \u201EHuman Safari\u201C","antiDroneNetsDescription":"Stra\xdfe in Cherson, mit Netzen gegen Drohnen der \u201EHuman Safari\u201C \xfcberspannt","firefighterDescription":"Ein Feuerwehrmann l\xf6scht ein Auto nach einem Angriff der \u201EHuman Safari\u201C, dahinter liegt ein Opfer"},"follow":{"title":"Folgen","subHumanSafari":"hochwertige Quellen, die aus Cherson und \xfcber die Human Safari berichten","subDroneSiege":"hochwertige Quellen, die aus Cherson und \xfcber die Drohnenbelagerung berichten","localPress":"lokale ukrainischsprachige Presse","lang":{"english":"Englisch","german":"Deutsch","ukrainian":"Ukrainisch"},"language":"Sprache: {{list}}","languages":"Sprachen: {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"US-amerikanische Journalistin und Filmemacherin in Cherson, berichtet f\xfcr Byline Times und Euromaidan Press; f\xfchrte Regie beim Dokumentarfilm Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"Chefreporter der Welt; berichtet immer wieder \xfcber die Human Safari in Cherson."},"kelley":{"name":"Brendan Kelley","desc":"Schreibt Kherson Weekly, eine laufende Chronik russischer Drohnenangriffe auf Zivilisten in Cherson und den umliegenden D\xf6rfern."},"vgoru":{"name":"Vgoru","desc":"Unabh\xe4ngige Medienplattform aus der Region Cherson, berichtet \xfcber das Leben unter Beschuss und unter Besatzung."},"suspilne":{"name":"Suspilne Cherson","desc":"Die Cherson-Redaktion des \xf6ffentlich-rechtlichen Rundfunks der Ukraine."},"most":{"name":"MOST","desc":"Lokale Nachrichtenagentur aus Cherson, berichtet \xfcber die Stadt und die Region."}},"rallies":{"oleshky2026":{"heroStop":"STOPPT DIE DROHNEN&shy;BELAGERUNG","heroSave":"RETTET OLESHKY","worldwideRally":"Weltweite Demo","heroDate":"Oktober","infoText1":"Tausende Zivilisten sind in Oleshky, Hola Prystan, Stara Zburivka und Nova Zburivka unter einer Drohnenbelagerung eingeschlossen. Russische Truppen missbrauchen sie als menschliche Schutzschilde und verstecken sich hinter ihnen, um Human-Safari-Drohnenangriffe auf das gegen\xfcberliegende Ufer auszuf\xfchren.","infoText2":"Die Lage ist akut \u2013 es fehlt an Lebensmitteln, Wasser, medizinischer Versorgung, Medikamenten, Strom, Gas und Kommunikation. Die Stra\xdfen sind stark vermint, und Drohnen schr\xe4nken jede Bewegung ein. <bold>SIE k\xf6nnen helfen. Schlie\xdfen Sie sich tausenden Menschen weltweit an, um ein Ende der Drohnenbelagerung zu fordern.</bold>","imageAlt":"Ein verhungernder Hund zwischen menschlichen Knochen im zerst\xf6rten Oleshky, unter einem roten Himmel voller Drohnen, mit den Worten Stop Russian Drone Siege","demandsTitle":"Wir fordern:","demand1":"sichere und wirksame humanit\xe4re Korridore nach Oleshky und in andere betroffene Gemeinden.","demand2":"sofortige humanit\xe4re Hilfe und Unterst\xfctzung f\xfcr die Opfer der Human-Safari-Angriffe.","demand3":"angemessene Sanktionen gegen Personen und Lieferketten, die f\xfcr Angriffe auf Zivilisten verantwortlich sind.","demand4":"Ma\xdfnahmen, um den Einsatz kleiner Drohnen zur systematischen Jagd auf Zivilisten und deren Terrorisierung in Cherson, in der Ukraine und anderswo abzuschrecken.","cities":{"edinburgh":{"city":"Edinburgh","country":"Vereinigtes K\xf6nigreich","time":"Edinburgh - Vereinigtes K\xf6nigreich, 14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"Vereinigtes K\xf6nigreich","time":"Birmingham - Vereinigtes K\xf6nigreich, 14:00 - 16:00","location":"Gegen\xfcber der Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Wien","country":"\xd6sterreich","time":"Wien - \xd6sterreich, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"M\xfcnchen","country":"Deutschland","time":"M\xfcnchen - Deutschland, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"Manchester","country":"Vereinigtes K\xf6nigreich","time":"Manchester - Vereinigtes K\xf6nigreich, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"Sydney","country":"Australien","time":"Sydney - Australien, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Paris","country":"Frankreich","time":"Paris - Frankreich, 15:30 - 18:30","location":"Von der Kirche Saint-Volodymyr zur Place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Paris","country":"Frankreich","time":"Paris - Frankreich, 18:00","location":"Metrostation Rambuteau","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lyon","country":"Frankreich","time":"Lyon - Frankreich, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dublin","country":"Irland","time":"Dublin - Irland, 13:00","location":"The GPO (Hauptpostamt)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Br\xfcssel","country":"Belgien","time":"Br\xfcssel - Belgien, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Br\xfcssel (Schuman-Kreisverkehr)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Kanada","time":"Ottawa - Kanada, 12:30 - 13:30","location":"Russische Botschaft, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"Frankreich","time":"Nantes - Frankreich, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Danzig","country":"Polen","time":"Danzig - Polen, 18:30 - 19:30","location":"D\u0142ugi Targ (Langer Markt), am Neptunbrunnen","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Dresden","country":"Deutschland","time":"Dresden - Deutschland, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"M\xe1laga","country":"Spanien","time":"M\xe1laga - Spanien, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"Plovdiv","country":"Bulgarien","time":"Plovdiv - Bulgarien, 17:00","location":"Hauptstra\xdfe (Glavnata), an der Kamenitza-Treppe / am \u201ETogether\u201C-Schriftzug","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapest","country":"Ungarn","time":"Budapest - Ungarn, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (Stephansplatz)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Hamburg","country":"Deutschland","time":"Hamburg - Deutschland, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, H\xf6he Br\xfccke 1, 20359 Hamburg","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kiel","country":"Deutschland","time":"Kiel - Deutschland, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Norwegen","time":"Oslo - Norwegen","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Leipzig","country":"Deutschland","time":"Leipzig - Deutschland, 17:00 - 18:00","location":"Hauptbahnhof (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"London","country":"Vereinigtes K\xf6nigreich","time":"London - Vereinigtes K\xf6nigreich, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dublin","country":"Irland","time":"Dublin - Irland, 13:00","location":"The GPO (Hauptpostamt)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dublin","country":"Irland","time":"Dublin - Irland, 14:00","location":"The GPO (Hauptpostamt)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"Frankreich","time":"Nantes - Frankreich, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Stoppt die russische Drohnenbelagerung","posterNoRoadOut":"Die Wege nach Oleshky hinein und hinaus sind blockiert","posterHumanitarianCatastrophe":"Oleshky. Eine humanit\xe4re Katastrophe unter Besatzung","seeGallery":"Poster ansehen / herunterladen"},"artBy":"Kunst: {{name}}","downloadPoster":"Poster herunterladen","reel":{"download":"Video herunterladen (MP4)"},"addDemo":{"title":"f\xfcge deine Demo hinzu","where":"wo: Stadt/Ort","contact":"E-Mail/Nummer","message":"nachricht: wen du vertrittst, deine Demo ist best\xe4tigt oder in Planung, Link zur Online-Ank\xfcndigung, weitere Details","submit":"Absenden","sending":"Wird gesendet\u2026","thanks":"Danke! Wir melden uns.","error":"Etwas ist schiefgelaufen. Bitte versuche es erneut.","contactInvalid":"Bitte gib eine g\xfcltige E-Mail-Adresse oder eine Telefonnummer mit L\xe4ndervorwahl ein (z. B. +49 151 23456789).","date":"Datum","time":"Beginn (Ortszeit)","whereInvalid":"Bitte gib den Namen einer Stadt oder eines Ortes ein, z. B. Berlin oder Kyjiw, Ukraine.","datePlaceholder":"Datum: TT/MM"}},"seo":{"oleshky":{"title":"Stoppt die Drohnenbelagerung \u2014 Rettet Oleshky | Weltweite Demos","description":"Russische Drohnen belagern Tausende Zivilisten im besetzten Oleshky in der Ukraine, abgeschnitten von Nahrung, Wasser und Medikamenten. Finde eine Demo in deiner N\xe4he und fordere einen sicheren Ausweg."},"leftBank":{"title":"Drohnenbelagerung von Oleshky und der besetzten Region Cherson","description":"Tausende Zivilisten sind unter russischer Drohnenbelagerung im besetzten Oleshky, Hola Prystan und umliegenden D\xf6rfern gefangen. Erfahre, was geschieht und wie du helfen kannst."},"help":{"title":"Stoppt Human Safari \u2014 Russische Drohnen jagen Zivilisten in Cherson","description":"Russische Drohnen jagen Zivilisten in Cherson, Ukraine. Erfahre mehr \xfcber das Kriegsverbrechen Human Safari und wie du helfen kannst, es zu stoppen."},"action":{"title":"Weltweite Kundgebung Dezember 2025 \u2014 Stoppt Human Safari","description":"Fotos, Plakate und Orte der weltweiten Kundgebung im Dezember 2025 gegen russische Drohnenangriffe auf Zivilisten in Cherson, Ukraine."},"rallies":{"title":"Fotos der Kundgebungen \u2014 Stoppt Human Safari","description":"Fotos von Kundgebungen weltweit gegen russische Drohnenangriffe auf Zivilisten in Cherson, Ukraine."},"resources":{"title":"Human Safari \u2014 Berichte, Artikel und Zeugenaussagen","description":"Berichte, Artikel, Interviews und Augenzeugenberichte zu russischen Drohnenangriffen auf Zivilisten in Cherson, Ukraine."},"reel":{"title":"Rettet Oleshky \u2014 Demo-Video","description":"Video der weltweiten Demos \u201ERettet Oleshky\u201C, Oktober 2026."}}}');


var $e6806cd758d520fa$exports = {};
$e6806cd758d520fa$exports = JSON.parse('{"home":{"heroStop":"ARR\xcaTONS LE HUMAN SAFARI","heroSave":"SAUVONS KHERSON","heroTitle1":"Les civils","heroTitle2":"ne sont pas des cibles","heroDate":"13, 14 d\xe9cembre","worldwideRally":"Rassemblement Mondial","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"Depuis l\'\xe9t\xe9 2024, les forces russes utilisent de petits drones afin de pourchasser, tuer et terroriser les civils dans les rues de Kherson et d\'autres villes proches du front en Ukraine. <bold>Ce safari humain doit cesser. VOUS pouvez aider.</bold> Rejoignez des milliers de personnes dans le monde pour exiger l\'arr\xeat de ce crime de guerre.","seeGallery":"Voir les affiches du monde entier","comingSoon":"Lieux bient\xf4t disponibles","december":"d\xe9cembre","dec":"d\xe9c.","october":"octobre","oct":"oct.","september":"septembre","sep":"sept.","schedule9":"9","schedule10":"10","schedule11":"11","schedule12":"12","schedule13":"13","schedule14":"14","schedule16":"16","schedule18":"18","schedule20":"20","schedule1":"1er","schedule2":"2","schedule3":"3","schedule4":"4","schedule5":"5","schedule25":"25","schedule26":"26","schedule27":"27","schedule28":"28","schedule29":"29","schedule30":"30","schedule31":"31","scheduleTBC":"Date \xe0 confirmer...","recommendationsTitle":"Recommandations de la Commission de l\'ONU","recommendationsRussia":"La Commission recommande \xe0 la F\xe9d\xe9ration de Russie de:","rusRec1":"(a) Mettre imm\xe9diatement fin aux attaques de drones ciblant les civils et les biens civils","rusRec2":"(b) Cesser imm\xe9diatement tous les actes qui r\xe9pandent la terreur parmi la population civile","rusRec3":"(c) Veiller \xe0 ce que tous les auteurs impliqu\xe9s dans les attaques de drones contre des civils soient tenus responsables","recommendationsUNStates":"La Commission recommande aux autres \xc9tats ainsi qu\'aux organisations r\xe9gionales et internationales :","statesRec1":"(a) D\u2019apporter un soutien financier et technique au gouvernement ukrainien et aux organisations de la soci\xe9t\xe9 civile pour fournir une aide compl\xe8te aux victimes et \xe0 leurs familles ;","statesRec2":"(b) Pour les \xc9tats tiers accueillant des personnes d\xe9plac\xe9es des territoires temporairement occup\xe9s, d\u2019entreprendre les efforts n\xe9cessaires pour soutenir ces personnes avec les services consulaires ukrainiens."},"resources":{"title":"Ressources cl\xe9s","linkLibraryTitle":"Biblioth\xe8que de liens","linkLibraryDesc":"200 articles, rapports, interviews, t\xe9moignages directs et reportagese","humanSafariMapTitle":"Carte du Human Safari de Tochnyi","humanSafariMapDesc":"Une carte interactive des attaques du Human Safari \xe0 Kherson, compil\xe9e \xe0 partir de rapports en source ouverte des autorit\xe9s locales et de vid\xe9os d\'attaques g\xe9olocalis\xe9es par l\'\xe9quipe de Tochnyi.","truthHoundsTitle":"Rapport Truth Hounds","truthHoundsDesc":"Killzone : comment les drones russes d\xe9vastent la rive droite du Dnipro","hrwTitle":"Rapport Human Rights Watch sur les attaques de drones \xe0 Kherson","hrwDesc":"Rapport HRW","unReportsTitle":"Rapports du Conseil des Droits de l\u2019Homme de l\u2019ONU","report1":"Rapport ONU #1","report3":"Rapport ONU #3","guidelines":"Directives de l\u2019ONU","wikipediaTitle":"Wikip\xe9dia","english":"Anglais","french":"Fran\xe7ais","documentaryTitle":"Documentaire","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13 - 14 d\xe9c.","eyewitnesses":"T\xe9moins","rallies":"Photos","help":"Kherson d\xe9soccup\xe9e","leftBank":"Kherson occup\xe9e","action":"d\xe9c. \'25","oleshky":"manif mondiale - Oleshky","menu":"Menu"},"leftBank":{"pageTitle":"Si\xe8ge par drones","para1":"Une grave urgence humanitaire touche 6 000 civils pris au pi\xe8ge d\'un si\xe8ge par drones dans les villes occup\xe9es d\'Oleshky, Hola Prystan, Stara Zburivka et Nova Zburivka - r\xe9gion occup\xe9e de Kherson. \xc0 Oleshky, entre 1 200 et 2 000. La puissance occupante est tenue de leur venir en aide - au lieu de cela, les forces russes les utilisent comme boucliers humains, pour se cacher derri\xe8re cette population tout en menant des attaques de safari humain sur la rive oppos\xe9e. Les autorit\xe9s ukrainiennes et les acteurs humanitaires signalent une obstruction syst\xe9matique de l\'\xe9vacuation et de l\'acc\xe8s humanitaire.","para2":"Les civils manquent de nourriture, d\'eau, de soins m\xe9dicaux, de m\xe9dicaments, d\'\xe9lectricit\xe9, de gaz et de moyens de communication. Les routes sont fortement min\xe9es et l\'activit\xe9 des drones restreint les d\xe9placements. Aucun v\xe9hicule n\'a pu entrer ni sortir depuis le 26 mai. Les r\xe9serves de carburant et de nourriture sont presque \xe9puis\xe9es.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"Vid\xe9o : \xab Kherson and Oleshky: Witnessing Genocide \xbb (12 min)","meidasArticle":"Article : \xab The Kherson Region: How Russia Uses Civilians as a Tool of War \xbb (5 min de lecture)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Article : \xab Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate \xbb (7 min de lecture)","tellPost":"et parlez du Si\xe8ge par drones autour de vous","callToHelp":"VOUS pouvez aider. Voici comment","donateIntro":"Ces initiatives apportent une aide cibl\xe9e et \xe0 fort impact directement aux personnes qui ont fui Oleshky ou, lorsque c\u2019est possible, qui y sont encore pi\xe9g\xe9es.","signTitle":"Signez","signSub":"p\xe9titions","petitionBy":"par {{name}}","petitions":{"euParliament":"Parlement europ\xe9en \u2013 P\xe9tition n\xb0 1439/2026 demandant l\u2019ouverture d\u2019un corridor humanitaire d\u2019\xe9vacuation pour les civils pris au pi\xe8ge du si\xe8ge \xe0 Oleshky (Ukraine), occup\xe9e par la Russie","ukParliament":"Parlement britannique \u2013 Mettre en place un corridor d\u2019aide humanitaire dirig\xe9 par le Royaume-Uni vers Oleshky, en Ukraine"},"publicActionLead":"Braquez les projecteurs sur le si\xe8ge par drones l\xe0 o\xf9 vous \xeates.","organiseAction":"Organisez une action.","policyBody":"Les autorit\xe9s ukrainiennes m\xe8nent des consultations avec le Comit\xe9 international de la Croix-Rouge en vue d\'\xe9tablir un couloir humanitaire d\'\xe9vacuation depuis les localit\xe9s occup\xe9es de la r\xe9gion de Kherson et de garantir un acc\xe8s humanitaire pour la nourriture, l\'eau, les m\xe9dicaments, le carburant et l\'assistance m\xe9dicale. D\xe9but juin, aucun couloir d\'\xe9vacuation fonctionnel ni m\xe9canisme durable d\'acc\xe8s humanitaire n\'est en place.","documentaryTitle":"Oleshky, court documentaire","downloadTitle":"T\xe9l\xe9charger","downloadSub":"visuels"},"footer":{"addCityText":"Pour ajouter votre ville, envoyez un e-mail \xe0 :","organiseText":"Ajoutez votre manifestation - contactez-nous :","contact":"Contact :"},"byCountry":"voir par pays","byDate":"voir par date","countries":{"australia":"Australie","austria":"Autriche","bulgaria":"Bulgarie","canada":"Canada","czechia":"Tch\xe9quie","denmark":"Danemark","estonia":"Estonie","finland":"Finlande","france":"France","georgia":"G\xe9orgie","germany":"Allemagne","hungary":"Hongrie","italy":"Italie","japan":"Japon","mexico":"Mexique","netherlands":"Pays-Bas","norway":"Norv\xe8ge","poland":"Pologne","romania":"Roumanie","spain":"Espagne","sweden":"Su\xe8de","southAfrica":"Afrique du Sud","ukraine":"Ukraine","unitedKingdom":"Royaume-Uni","usa":"\xc9tats-Unis","ireland":"Irlande","belgium":"Belgique"},"cities":{"alicante":{"city":"Alicante","country":"Espagne","time":"Alicante - Espagne, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcelone","country":"Espagne","time":"Barcelone - Espagne, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"\xc9tats-Unis","time":"Berkeley - USA, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berlin","country":"Allemagne","time":"Berlin - Allemagne, 12:00","location":"Tempelhofer Feld, entr\xe9e Leinstr./coin de Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"\xc9tats-Unis","time":"Bettendorf - USA, 17:30 - Projection","location":"Bettendorf Public Library","cleanTime":"17:30 - Projection","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"Royaume-Uni","time":"Birmingham - Royaume-Uni, 14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Allemagne","time":"Bonn - Allemagne, 14:00 - 16:00","location":"Poststra\xdfe, devant la gare centrale","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Br\xeame","country":"Allemagne","time":"Br\xeame - Allemagne, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapest","country":"Hongrie","time":"Budapest - Hongrie, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"\xc9tats-Unis","time":"Chicago - USA, 13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Constan\u021Ba","country":"Roumanie","time":"Constan\u021Ba - Roumanie, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"Copenhague","country":"Danemark","time":"Copenhague - Danemark, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"\xc9tats-Unis","time":"Dallas - USA, 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"\xc9tats-Unis","time":"Denver - USA, 12:00","location":"Colorado Capitol Building, marches ouest","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"\xc9dimbourg","country":"Royaume-Uni","time":"\xc9dimbourg - Royaume-Uni, 13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"\xc9tats-Unis","time":"Fort Worth - USA, 14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Hambourg","country":"Allemagne","time":"Hambourg - Allemagne, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"\xc9tats-Unis","time":"Houghton, Michigan - USA, 15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finlande","time":"Helsinki - Finlande, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Japon","time":"Izumo - Japon, 13:00","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Japon","time":"Izumo - Japon","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops","country":"Canada","time":"Kamloops - Canada, 15:00 - 16:00","location":"H\xf4tel de ville","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kyiv","country":"Ukraine","time":"Kyiv - Ukraine, 17:00 - 18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Leipzig","country":"Allemagne","time":"Leipzig - Allemagne, 12:00 - 13:00","location":"Willy Brandt Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 18:30 - Projection","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - Projection","day":"schedule12"},"losAngeles":{"city":"Los Angeles","country":"\xc9tats-Unis","time":"Los Angeles - USA, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"M\xe1laga","country":"Espagne","time":"M\xe1laga - Espagne, 18:00 - Projection","location":"Maydan - Centro Historico Cultural Ukraniano","cleanTime":"18:00 - Projection","day":"schedule13"},"manchester":{"city":"Manchester","country":"Royaume-Uni","time":"Manchester - Royaume-Uni, 14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Mexico City","country":"Mexique","time":"Mexico City - Mexique, 11:00","location":"Alameda Central. Fontaine \\"Am\xe9riques\\" (entre Hemiciclo Ju\xe1rez et Kiosque)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Milan","country":"Italie","time":"Milan - Italie, 15:00","location":"Cath\xe9drale de Milan","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"Munich","country":"Allemagne","time":"Munich - Allemagne, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"New York","country":"\xc9tats-Unis","time":"New York - USA, 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"New York","country":"\xc9tats-Unis","time":"New York - USA, 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"Nienburg (Weser)","country":"Allemagne","time":"Nienburg (Weser) - Allemagne, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Norv\xe8ge","time":"Oslo - Norv\xe8ge, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Su\xe8de","time":"\xd6stersund - Su\xe8de, 11:00 - 14:00","location":"Stortorget (place principale)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"Ambassade de russie","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:00 - 13:00","location":"Ambassade des \xc9tats-Unis","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Paris","country":"France","time":"Paris - France, 15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (marche)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"Plovdiv","country":"Bulgarie","time":"Plovdiv - Bulgarie, 16:00 - 17:00","location":"pr\xe8s de la Maison Levski","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Prague","country":"Tch\xe9quie","time":"Prague - Tch\xe9quie, 14:00","location":"Palack\xe9ho Square","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"Afrique du Sud","time":"Rosendal - Afrique du Sud, 11:00","location":"Bureaux du South African Police Service","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Tenerife","country":"Espagne","time":"San Andr\xe9s, Tenerife - Espagne, 13:00","location":"--","cleanTime":"13.00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"\xc9tats-Unis","time":"San Diego - USA, 14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"\xc9tats-Unis","time":"San Francisco - USA, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Allemagne","time":"Schwerin - Allemagne, 19:00 - Projection","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - Projection","day":"schedule13"},"seattle":{"city":"Seattle","country":"\xc9tats-Unis","time":"Seattle - USA, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sveti Vlas","country":"Bulgarie","time":"Sveti Vlas - Bulgarie, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"Sydney","country":"Australie","time":"Sydney - Australie, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallinn","country":"Estonie","time":"Tallinn - Estonie, 15:00 - Projection et Rassemblement","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - Projection et Rassemblement","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Espagne","time":"Tarragona - Espagne, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"La Haye","country":"Pays-Bas","time":"La Haye - Pays-Bas, 13:00 - 15:00","location":"Devant le Palais de la Paix / CPI","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tbilissi","country":"G\xe9orgie","time":"Tbilissi - G\xe9orgie, 21:00","location":"Tbilissi","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Su\xe8de","time":"Tran\xe5s - Su\xe8de, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Vienne","country":"Autriche","time":"Vienne - Autriche, 16:00 - 18:00","location":"Stock im Eisen Platz (\xe0 c\xf4t\xe9 de la cath\xe9drale Saint-\xc9tienne)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Washington, D.C.","country":"\xc9tats-Unis","time":"Washington, D.C. - USA, 12:30 - 13:30","location":"La Maison Blanche","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Pologne","time":"Wroc\u0142aw - Pologne, 13:00","location":"Place de la Libert\xe9 (direction People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"Organisez ! Pour ajouter votre ville, envoyez un e-mail \xe0 :","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Partager sur {{platform}}","website":"Site web","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, journaliste et cin\xe9aste, a organis\xe9 le rassemblement mondial et a r\xe9alis\xe9 le documentaire Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Protection des civils pour les rues de Kherson \u2014 prot\xe9ger les civils des attaques de drones.","foodDesc":"Aide alimentaire.","foodNote":"Lors de votre don, indiquez \xab Food for Cherson \xbb en r\xe9f\xe9rence."},"ahs":{"name":"Projet Anti Human Safari","desc":"D\xe9tecteurs de drones et gilets de protection pour les b\xe9n\xe9voles et les services d\'urgence \xe0 Kherson."},"pageTitle":"Arr\xeatez le Human Safari","sectionIntro":"Depuis l\'\xe9t\xe9 2024, l\'arm\xe9e russe utilise de petits drones pour chasser, tuer et terroriser des civils dans les rues de Kherson et d\'autres villes de premi\xe8re ligne en Ukraine.","sectionIntro2":"C\'est une campagne de meurtres syst\xe9matique et d\xe9lib\xe9r\xe9e : les op\xe9rateurs de drones russes publient ouvertement les images de leurs victimes sur des cha\xeenes Telegram pour s\'en vanter. En mai 2025, l\'ONU a reconnu le Human Safari comme un crime de guerre en cours.","sectionIntro3":"Trop peu est fait. Le Human Safari doit cesser.","sectionIntroBold":"VOUS pouvez aider. Voici comment","step2Title":"Organisez","step3Title":"Parlez-en autour de vous","step3Para":"Utilisez les hashtags","step3ParaPost":"et parlez du Human Safari autour de vous","instagram":"Instagram","step2Bullet1":"une projection de film","step2Bullet2":"une action publique","step2Bullet3":"une couverture m\xe9diatique","publicActionLead":"Braquez les projecteurs sur le safari humain l\xe0 o\xf9 vous \xeates.","reachOutPre":"Vous pouvez","reachOut":"nous contacter","reachOutPost":"pour des id\xe9es et des ressources","newsCoverageLead":"via vos contacts dans les m\xe9dias. Parlez-leur du safari humain et du risque pour toutes les zones de conflit actuelles et futures.","putInTouchPre":"Vous pouvez aussi","putInTouch":"nous mettre directement en relation","inform":"Informez","informSub":"vous et les autres","policyTitle":"Politique","policyBody":"La proposition de loi LORA (Liability for Operators and Responsible Authorities Act) instaurerait des sanctions tout au long de la cha\xeene de responsabilit\xe9 : des op\xe9rateurs et commandants russes de drones FPV jusqu\'au haut commandement militaire, ainsi que des fabricants et fournisseurs qui permettent la production et le d\xe9ploiement de drones contre les civils.","policyHelp":"Vous pouvez agir au niveau politique ?","getInTouch":"Contactez-nous","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"donate":"Faire un don","donateIntro":"Ces initiatives apportent une aide cibl\xe9e et \xe0 fort impact pour prot\xe9ger directement les civils de Kherson du Human Safari.","shareTitle":"Faites passer le mot","filmScreening":"Organisez une projection du documentaire Kherson Human Safari :","howItStarted":"Comment tout a commenc\xe9","kryla":{"name":"Kryla Foundation","desc":"Aidez-les \xe0 financer l\u2019h\xe9bergement et les produits de premi\xe8re n\xe9cessit\xe9 des habitants d\u2019Oleshky."}},"action":{"intro":"Nous avons commenc\xe9 avec une manifestation mondiale. Vous pouvez maintenant :","helpLink":"aider ici"},"accounts":{"heading":"T\xe9moignages"},"media":{"close":"Fermer","view":"Voir le m\xe9dia","previous":"Pr\xe9c\xe9dent","next":"Suivant","andrushenkoCredit":"Oleksandr Andrushenko, photocorrespondant du m\xe9dia Vgoru","khersonPoliceCredit":"de @khersonpolice","antypenkoCredit":"Ivan Antypenko, photojournaliste de Kherson","telegramChannelCredit":"publi\xe9 par la cha\xeene Telegram russe du Human Safari \xab de Marioupol aux Carpates \xbb","fruitSellerDescription":"Un vendeur de fruits poursuivi par un drone \xe0 fibre optique","burntCarDescription":"Voiture calcin\xe9e \xe0 Kherson","bridgeAttackDescription":"Un adolescent tu\xe9 par un drone FPV sous un pont \xe0 Kherson","busAttackDescription":"Une des nombreuses attaques de drones FPV contre les transports publics","fpvDroneDescription":"Drone FPV en chasse pendant le \xab Human Safari \xbb","antiDroneNetsDescription":"Rue de Kherson recouverte de filets contre les drones du \xab Human Safari \xbb","firefighterDescription":"Un pompier \xe9teint une voiture apr\xe8s une frappe du \xab Human Safari \xbb, une victime g\xeet derri\xe8re"},"follow":{"title":"Suivre","subHumanSafari":"des sources de qualit\xe9 qui informent depuis Kherson et sur le Human Safari","subDroneSiege":"des sources de qualit\xe9 qui informent depuis Kherson et sur le si\xe8ge par drones","localPress":"presse locale en ukrainien","lang":{"english":"anglais","german":"allemand","ukrainian":"ukrainien"},"language":"Langue : {{list}}","languages":"Langues : {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"Journaliste et cin\xe9aste am\xe9ricaine bas\xe9e \xe0 Kherson, collabore avec Byline Times et Euromaidan Press ; r\xe9alisatrice du documentaire Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"Grand reporter du journal allemand Die Welt ; couvre r\xe9guli\xe8rement le Human Safari \xe0 Kherson."},"kelley":{"name":"Brendan Kelley","desc":"Publie Kherson Weekly, une chronique continue des attaques de drones russes contre les civils \xe0 Kherson et dans les villages alentour."},"vgoru":{"name":"Vgoru","desc":"Plateforme m\xe9diatique ind\xe9pendante de la r\xe9gion de Kherson, sur la vie sous les frappes et sous l\'occupation."},"suspilne":{"name":"Suspilne Kherson","desc":"La r\xe9daction de Kherson du diffuseur public ukrainien."},"most":{"name":"MOST","desc":"Agence de presse locale de Kherson, couvrant la ville et la r\xe9gion."}},"rallies":{"oleshky2026":{"heroStop":"ARR\xcaTONS LE SI\xc8GE PAR DRONES","heroSave":"SAUVONS OLESHKY","worldwideRally":"Manif Mondiale","heroDate":"Octobre","infoText1":"Des milliers de civils sont pris au pi\xe8ge d\'un si\xe8ge par drones \xe0 Oleshky, Hola Prystan, Stara Zburivka et Nova Zburivka. Les forces russes s\'en servent comme boucliers humains et se cachent derri\xe8re eux pour mener des attaques de safari humain par drones sur la rive oppos\xe9e.","infoText2":"La crise est aigu\xeb : manque de nourriture, d\'eau, de soins m\xe9dicaux, de m\xe9dicaments, d\'\xe9lectricit\xe9, de gaz et de moyens de communication. Les routes sont lourdement min\xe9es et les drones entravent tout d\xe9placement. <bold>VOUS pouvez aider. Rejoignez des milliers de personnes dans le monde pour exiger la fin du si\xe8ge par drones.</bold>","imageAlt":"Un chien affam\xe9 parmi des ossements humains dans Oleshky en ruines, sous un ciel rouge rempli de drones, avec les mots Stop Russian Drone Siege","demandsTitle":"Nous demandons :","demand1":"des couloirs humanitaires s\xfbrs et efficaces vers Oleshky et les autres communaut\xe9s touch\xe9es.","demand2":"une aide humanitaire imm\xe9diate et une assistance aux victimes des attaques de safari humain.","demand3":"des sanctions appropri\xe9es contre les personnes et les cha\xeenes d\'approvisionnement responsables d\'attaques visant des civils.","demand4":"des mesures pour dissuader l\'utilisation de petits drones pour cibler et terroriser syst\xe9matiquement des civils \xe0 Kherson, en Ukraine et ailleurs.","cities":{"edinburgh":{"city":"\xc9dimbourg","country":"Royaume-Uni","time":"\xc9dimbourg - Royaume-Uni, 14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"Royaume-Uni","time":"Birmingham - Royaume-Uni, 14:00 - 16:00","location":"En face du Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Vienne","country":"Autriche","time":"Vienne - Autriche, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"Munich","country":"Allemagne","time":"Munich - Allemagne, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"Manchester","country":"Royaume-Uni","time":"Manchester - Royaume-Uni, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"Sydney","country":"Australie","time":"Sydney - Australie, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Paris","country":"France","time":"Paris - France, 15:30 - 18:30","location":"De l\'\xe9glise Saint-Volodymyr \xe0 la place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Paris","country":"France","time":"Paris - France, 18:00","location":"M\xe9tro Rambuteau","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lyon","country":"France","time":"Lyon - France, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dublin","country":"Irlande","time":"Dublin - Irlande, 13:00","location":"The GPO (poste centrale)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Bruxelles","country":"Belgique","time":"Bruxelles - Belgique, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Bruxelles (rond-point Schuman)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"Ambassade de Russie, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"France","time":"Nantes - France, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Gda\u0144sk","country":"Pologne","time":"Gda\u0144sk - Pologne, 18:30 - 19:30","location":"D\u0142ugi Targ, \xe0 c\xf4t\xe9 de la fontaine de Neptune","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"\xc9tats-Unis","time":"Chicago - \xc9tats-Unis, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"\xc9tats-Unis","time":"Chicago - \xc9tats-Unis, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"\xc9tats-Unis","time":"Chicago - \xc9tats-Unis, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"\xc9tats-Unis","time":"Chicago - \xc9tats-Unis, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Dresde","country":"Allemagne","time":"Dresde - Allemagne, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"Malaga","country":"Espagne","time":"Malaga - Espagne, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"Plovdiv","country":"Bulgarie","time":"Plovdiv - Bulgarie, 17:00","location":"Rue principale (Glavnata), pr\xe8s des escaliers Kamenitza / de l\'inscription \xab Together \xbb","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapest","country":"Hongrie","time":"Budapest - Hongrie, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (place Saint-\xc9tienne)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Hambourg","country":"Allemagne","time":"Hambourg - Allemagne, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, au niveau du ponton 1, 20359 Hambourg","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kiel","country":"Allemagne","time":"Kiel - Allemagne, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Norv\xe8ge","time":"Oslo - Norv\xe8ge","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Leipzig","country":"Allemagne","time":"Leipzig - Allemagne, 17:00 - 18:00","location":"Gare centrale (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"Londres","country":"Royaume-Uni","time":"Londres - Royaume-Uni, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dublin","country":"Irlande","time":"Dublin - Irlande, 13:00","location":"The GPO (poste centrale)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dublin","country":"Irlande","time":"Dublin - Irlande, 14:00","location":"The GPO (poste centrale)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"France","time":"Nantes - France, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Stop au si\xe8ge russe par drones","posterNoRoadOut":"Les routes pour entrer et sortir d\'Oleshky sont bloqu\xe9es","posterHumanitarianCatastrophe":"Oleshky. Une catastrophe humanitaire sous l\'occupation","seeGallery":"Voir / t\xe9l\xe9charger les affiches"},"artBy":"Art : {{name}}","downloadPoster":"T\xe9l\xe9charger l\'affiche","reel":{"download":"T\xe9l\xe9charger la vid\xe9o (MP4)"},"addDemo":{"title":"ajoutez votre manifestation","where":"o\xf9 : ville","contact":"e-mail/num\xe9ro","message":"message : qui vous repr\xe9sentez, votre manifestation est confirm\xe9e ou en pr\xe9paration, lien vers l\'annonce en ligne, autres d\xe9tails","submit":"Envoyer","sending":"Envoi\u2026","thanks":"Merci ! Nous vous recontacterons.","error":"Une erreur s\'est produite. Veuillez r\xe9essayer.","contactInvalid":"Veuillez saisir un e-mail valide ou un num\xe9ro de t\xe9l\xe9phone avec l\'indicatif du pays (ex. +33 6 12 34 56 78).","date":"date","time":"heure de d\xe9but (locale)","whereInvalid":"Veuillez saisir le nom d\'une ville, ex. Paris ou Kyiv, Ukraine.","datePlaceholder":"date : jj/mm"}},"seo":{"oleshky":{"title":"Arr\xeatons le si\xe8ge par drones \u2014 Sauvons Oleshky","description":"Des drones russes assi\xe8gent des milliers de civils \xe0 Oleshky, en Ukraine occup\xe9e, priv\xe9s de nourriture, d\'eau et de m\xe9dicaments. Trouvez une manifestation pr\xe8s de chez vous et exigez un passage s\xfbr."},"leftBank":{"title":"Si\xe8ge par drones d\'Oleshky et de la r\xe9gion occup\xe9e de Kherson","description":"Des milliers de civils sont pris au pi\xe8ge d\'un si\xe8ge russe par drones \xe0 Oleshky, Hola Prystan et dans les villages occup\xe9s voisins. D\xe9couvrez ce qui se passe et comment aider."},"help":{"title":"Arr\xeatons le Human Safari \u2014 Des drones russes traquent les civils \xe0 Kherson","description":"Des drones russes traquent les civils \xe0 Kherson, en Ukraine. D\xe9couvrez le crime de guerre du Human Safari et comment aider \xe0 l\'arr\xeater."},"action":{"title":"Rassemblement mondial de d\xe9cembre 2025 \u2014 Arr\xeatons le Human Safari","description":"Photos, affiches et lieux du rassemblement mondial de d\xe9cembre 2025 contre les attaques russes de drones sur les civils \xe0 Kherson, en Ukraine."},"rallies":{"title":"Photos des rassemblements \u2014 Arr\xeatons le Human Safari","description":"Photos de rassemblements dans le monde contre les attaques russes de drones sur les civils \xe0 Kherson, en Ukraine."},"resources":{"title":"Ressources sur le Human Safari \u2014 Rapports, articles et t\xe9moignages","description":"Rapports, articles, entretiens et t\xe9moignages sur les attaques russes de drones contre les civils \xe0 Kherson, en Ukraine."},"reel":{"title":"Sauvons Oleshky \u2014 Vid\xe9o des manifestations","description":"Vid\xe9o des manifestations mondiales \xab Sauvons Oleshky \xbb, octobre 2026."}}}');


var $968b2cdfadc8e543$exports = {};
$968b2cdfadc8e543$exports = JSON.parse('{"home":{"heroStop":"STOP HUMAN SAFARI","heroSave":"RED KHERSON","heroTitle1":"Civile mennesker","heroTitle2":"Er Ikke skydeskiver","heroDate":"13., 14. december","worldwideRally":"Verdens&shy;omsp\xe6ndende demonstration","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"Siden sommeren 2024 har russiske styrker brugt sm\xe5 droner til at jage, dr\xe6be og terrorisere civile p\xe5 gaderne i Kherson og andre frontlinje-byer i Ukraine. <bold>Menneske-safari skal stoppes. DU kan g\xf8re en forskel </bold>Deltag sammen med tusinder verden over for at kr\xe6ve, at denne krigsforbrydelse oph\xf8rer.","seeGallery":"Se plakater fra hele verden","comingSoon":"Lokationer kommer snart","december":"december","dec":"dec.","october":"oktober","oct":"okt.","september":"september","sep":"sep.","schedule9":"9.","schedule10":"10.","schedule11":"11.","schedule12":"12.","schedule13":"13.","schedule14":"14.","schedule16":"16.","schedule18":"18.","schedule20":"20.","schedule1":"1.","schedule2":"2.","schedule3":"3.","schedule4":"4.","schedule5":"5.","schedule25":"25.","schedule26":"26.","schedule27":"27.","schedule28":"28.","schedule29":"29.","schedule30":"30.","schedule31":"31.","scheduleTBC":"Bekr\xe6fter dato...","recommendationsTitle":"Anbefalinger fra FN-Kommissionen","recommendationsRussia":"Kommissionen opfordrer kraftigt Den Russiske F\xf8deration til :","rusRec1":"(a) Straks at stoppe droneangreb rettet mod civile og civile objekter","rusRec2":"(b) Straks at stoppe med at terrorisere civilbefolkningen","rusRec3":"(c) At holde alle gerningsm\xe6nd involveret i droneangreb mod civile ansvarlige","recommendationsUNStates":"Kommissionen opfordrer andre stater samt regionale og internationale organisationer til:","statesRec1":"(a) At bidrage b\xe5de \xf8konomisk og med teknisk r\xe5dgivning til Ukraines regering og civilsamfundsorganisationer med det form\xe5l at yde omfattende st\xf8tte til ofre og deres familier;","statesRec2":"(b) At tredjelande, hvor deporterede personer fra de besatte omr\xe5der befinder sig, samarbejder med de ukrainske konsul\xe6re myndigheder om at yde den n\xf8dvendige st\xf8tte til disse personer.","reference":"Kilde","linkUN":"FN-Kommissionen: Ruslands \u201Cmenneske-safari\u201D i Ukraine er en forbrydelse mod menneskeheden","linkGuidelines":"FN-Retningslinjer","linkWiki":"Wikipedia"},"resources":{"title":"Vigtige kilder","linkLibraryTitle":"Link-bibliotek","linkLibraryDesc":"200 artikler, rapporter, interviews, \xf8jenvidneberetninger og medied\xe6kning","humanSafariMapTitle":"Tochnyis Human Safari-kort","humanSafariMapDesc":"Et interaktivt kort over Human Safari-angreb i Kherson, samlet ud fra \xe5bne kilder som lokale myndigheders indberetninger og angrebsvideoer, som Tochnyi-teamet har geolokaliseret.","truthHoundsTitle":"Truth Hounds-rapport","truthHoundsDesc":"Killzone: Hvordan russiske droner \xf8del\xe6gger Dnipro-flodens h\xf8jre bred","hrwTitle":"Human Rights Watch-rapport om droneangreb i Kherson","hrwDesc":"HRW-rapport","unReportsTitle":"FN\u2019s Menneskerettighedsr\xe5ds rapporter","report1":"FN-rapport #1","report3":"FN-rapport #3","guidelines":"FN-Retningslinjer","wikipediaTitle":"Wikipedia","english":"Engelsk","french":"Fransk","documentaryTitle":"Dokumentar","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13. - 14. dec.","eyewitnesses":"vidner","rallies":"fotos","help":"deokkuperet Kherson","leftBank":"besat Kherson","action":"dec. \'25","oleshky":"global demo - Oleshky","menu":"Menu"},"leftBank":{"pageTitle":"Dronebelejring","para1":"En akut humanit\xe6r n\xf8dsituation rammer 6.000 civile, der er fanget under en dronebelejring i det besatte Oleshky, Hola Prystan, Stara Zburivka og Nova Zburivka - den besatte Kherson-region. I Oleshky 1.200 - 2.000. Bes\xe6ttelsesmagten er forpligtet til at st\xf8tte dem - i stedet bruges de som menneskelige skjolde af de russiske styrker, der gemmer sig bag denne befolkning, mens de udf\xf8rer Human Safari-angreb p\xe5 den modsatte bred. Ukrainske myndigheder og humanit\xe6re akt\xf8rer rapporterer om systematisk hindring af evakuering og humanit\xe6r adgang.","para2":"De civile mangler mad, vand, l\xe6gehj\xe6lp, medicin, elektricitet, gas og kommunikation. Vejene er kraftigt minerede, og droneaktivitet begr\xe6nser bev\xe6gelsesfriheden. Ingen k\xf8ret\xf8jer har kunnet komme ind eller ud siden den 26. maj. Br\xe6ndstof- og f\xf8devareforsyningerne er n\xe6sten opbrugt.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"Video: \xbbKherson and Oleshky: Witnessing Genocide\xab (12 min)","meidasArticle":"Artikel: \xbbThe Kherson Region: How Russia Uses Civilians as a Tool of War\xab (5 min l\xe6sning)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Artikel: \xbbGlobal Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate\xab (7 min l\xe6sning)","tellPost":"og fort\xe6l andre om Dronebelejringen","callToHelp":"DU kan hj\xe6lpe. S\xe5dan g\xf8r du","donateIntro":"Disse initiativer yder m\xe5lrettet hj\xe6lp med stor effekt direkte til mennesker, der er flygtet fra Oleshky, eller, hvor det er muligt, sidder fanget der.","signTitle":"Skriv under","signSub":"underskriftsindsamlinger","petitionBy":"af {{name}}","petitions":{"euParliament":"Europa-Parlamentet \u2013 Andragende nr. 1439/2026 om oprettelse af en humanit\xe6r evakueringskorridor for civile, der sidder fanget under belejring i det russisk besatte Oleshky i Ukraine","ukParliament":"Det britiske parlament \u2013 Arbejd for en britisk ledet humanit\xe6r hj\xe6lpekorridor til Oleshky i Ukraine"},"publicActionLead":"S\xe6t fokus p\xe5 dronebelejringen, d\xe9r hvor du er.","organiseAction":"Organiser en aktion.","policyBody":"De ukrainske myndigheder er i konsultationer med Den Internationale R\xf8de Kors-Komit\xe9 om at oprette en humanit\xe6r evakueringskorridor fra de besatte bos\xe6ttelser i Kherson-regionen og sikre humanit\xe6r adgang for mad, vand, medicin, br\xe6ndstof og l\xe6gehj\xe6lp. I begyndelsen af juni er der ingen fungerende evakueringskorridor eller vedvarende mekanisme for humanit\xe6r adgang.","documentaryTitle":"Oleshky, kort dokumentarfilm","downloadTitle":"Download","downloadSub":"grafik"},"footer":{"addCityText":"For at tilf\xf8je din by, send en e-mail til: ","organiseText":"Tilf\xf8j din demo - kontakt os:","contact":"Kontakt:"},"byCountry":"vis efter land","byDate":"vis efter dato","countries":{"australia":"Australien","austria":"\xd8strig","bulgaria":"Bulgarien","canada":"Canada","czechia":"Tjekkiet","denmark":"Danmark","estonia":"Estland","finland":"Finland","france":"Frankrig","georgia":"Georgien","germany":"Tyskland","hungary":"Ungarn","italy":"Italien","japan":"Japan","mexico":"Mexico","netherlands":"Nederlandene","norway":"Norge","poland":"Polen","romania":"Rum\xe6nien","spain":"Spanien","sweden":"Sverige","southAfrica":"Sydafrika","ukraine":"Ukraine","unitedKingdom":"Storbritannien","usa":"USA","ireland":"Irland","belgium":"Belgien"},"cities":{"alicante":{"city":"Alicante","country":"Spanien","time":"Alicante - Spanien, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcelona","country":"Spanien","time":"Barcelona - Spanien, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"USA","time":"Berkeley - USA, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berlin","country":"Tyskland","time":"Berlin - Tyskland, 12:00","location":"Tempelhofer Feld, indgang Leinstr./hj\xf8rne af Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"USA","time":"Bettendorf - USA, 17:30 - Filmvisning","location":"Bettendorf Public Library","cleanTime":"17:30 - Filmvisning","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"Storbritannien","time":"Birmingham - Storbritannien, 14:00 - 15:30","location":"Baskerville House, Cambridge Str.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Tyskland","time":"Bonn - Tyskland, 14:00 - 16:00","location":"Poststra\xdfe, foran hovedbaneg\xe5rden","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Bremen","country":"Tyskland","time":"Bremen - Tyskland, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapest","country":"Ungarn","time":"Budapest - Ungarn, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Constan\u021Ba","country":"Rum\xe6nien","time":"Constan\u021Ba - Rum\xe6nien, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"K\xf8benhavn","country":"Danmark","time":"K\xf8benhavn - Danmark, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"USA","time":"Dallas - USA, 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"USA","time":"Denver - USA, 12:00","location":"Colorado Capitol-bygning, vesttrapperne","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"Edinburgh","country":"Storbritannien","time":"Edinburgh - Storbritannien, 13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"USA","time":"Fort Worth - USA, 14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Hamburg","country":"Tyskland","time":"Hamburg - Tyskland, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"USA","time":"Houghton, Michigan - USA, 15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finland","time":"Helsinki - Finland, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Japan","time":"Izumo - Japan, 13:00","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Japan","time":"Izumo - Japan","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops","country":"Canada","time":"Kamloops - Canada, 15:00 - 16:00","location":"R\xe5dhuset","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kyiv","country":"Ukraine","time":"Kyiv - Ukraine, 17:00 - 18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Leipzig","country":"Tyskland","time":"Leipzig - Tyskland, 12:00 - 13:00","location":"Willy-Brandt-Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 18:30 - Filmvisning","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - Filmvisning","day":"schedule12"},"losAngeles":{"city":"Los Angeles","country":"USA","time":"Los Angeles - USA, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"M\xe1laga","country":"Spanien","time":"M\xe1laga - Spanien, 18:00  - Filmvisning","location":"Maydan - Centro Historico Cultural Ukraniano","cleanTime":"18:00 - Filmvisning","day":"schedule13"},"manchester":{"city":"Manchester","country":"Storbritannien","time":"Manchester - Storbritannien, 14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Mexico City","country":"Mexico","time":"Mexico City - Mexico, 11:00","location":"Alameda Central. \\"Americas\\" springvand (mellem Hemiciclo Ju\xe1rez og Kiosk)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Milano","country":"Italien","time":"Milano - Italien, 15:00","location":"Domkirken i Milano","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"M\xfcnchen","country":"Tyskland","time":"M\xfcnchen - Tyskland, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"New York","country":"USA","time":"New York - USA, 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"New York","country":"USA","time":"New York - USA, 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"Nienburg (Weser)","country":"Tyskland","time":"Nienburg (Weser) - Tyskland, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Norge","time":"Oslo - Norge, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Sverige","time":"\xd6stersund - Sverige, 11:00 - 14:00","location":"Stortorget (Hovedpladsen)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"russiske ambassade","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:00","location":"USAs ambassade","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Paris","country":"Frankrig","time":"Paris - Frankrig, 15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (march)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"Plovdiv","country":"Bulgarien","time":"Plovdiv - Bulgarien, 16:00 - 17:00","location":"ved Levski-huset","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Prag","country":"Tjekkiet","time":"Prag - Tjekkiet, 14:00","location":"Palack\xe9ho Square","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"Sydafrika","time":"Rosendal - Sydafrika, 11:00","location":"kontorer for South African Police Service","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Tenerife","country":"Spanien","time":"San Andr\xe9s, Tenerife - Spanien, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"USA","time":"San Diego - USA, 14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"USA","time":"San Francisco - USA, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Tyskland","time":"Schwerin - Tyskland, 19:00 - Filmvisning","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - Filmvisning","day":"schedule13"},"seattle":{"city":"Seattle","country":"USA","time":"Seattle - USA, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sveti Vlas","country":"Bulgarien","time":"Sveti Vlas - Bulgarien, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"Sydney","country":"Australien","time":"Sydney - Australien, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallinn","country":"Estland","time":"Tallinn - Estland, 15:00 - Filmvisning og rally","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - Filmvisning og rally","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Spanien","time":"Tarragona - Spanien, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"Haag","country":"Holland","time":"Haag - Holland, 13:00 - 15:00","location":"Foran Fredspaladset / ICC","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tbilisi","country":"Georgien","time":"Tbilisi - Georgien, 21:00","location":"Tbilisi","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Sverige","time":"Tran\xe5s - Sverige, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Wien","country":"\xd8strig","time":"Wien - \xd8strig, 16:00 - 18:00","location":"Stock im Eisen Platz (ved siden af Stephansdom)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Washington, D.C.","country":"USA","time":"Washington, D.C. - USA, 12:30 - 13:30","location":"The White House","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Polen","time":"Wroc\u0142aw - Polen, 13:00","location":"Plac Wolno\u015Bci (i retning mod People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"Organiser! For at tilf\xf8je din by, send en e-mail til:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Del p\xe5 {{platform}}","website":"Hjemmeside","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, journalist og filminstrukt\xf8r, stod i spidsen for den verdensomsp\xe6ndende demonstration og instruerede dokumentarfilmen Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Beskyttelse af civile til gaderne i Kherson \u2014 beskytter civile mod drone-angreb.","foodDesc":"F\xf8devarehj\xe6lp.","foodNote":"Skriv \xbbFood for Cherson\xab som reference, n\xe5r du donerer."},"ahs":{"name":"Anti Human Safari-projektet","desc":"Dronedetektorer og beskyttelsesveste til frivillige og redningstjenester i Kherson."},"pageTitle":"Stop Human Safari","sectionIntro":"Siden sommeren 2024 har det russiske milit\xe6r brugt sm\xe5 droner til at jage, dr\xe6be og terrorisere civile p\xe5 gaderne i Kherson og andre frontbyer i Ukraine.","sectionIntro2":"Det er en systematisk og bevidst mordkampagne: de russiske droneoperat\xf8rer l\xe6gger \xe5bent optagelserne af deres ofre ud i Telegram-kanaler for at prale. I maj 2025 anerkendte FN Human Safari som en igangv\xe6rende krigsforbrydelse.","sectionIntro3":"Der bliver gjort for lidt. Human Safari skal stoppes.","sectionIntroBold":"DU kan hj\xe6lpe. Her er hvordan","step2Title":"Organiser","step3Title":"Fort\xe6l andre","step3Para":"Brug hashtags","step3ParaPost":"og fort\xe6l andre om Human Safari","instagram":"Instagram","step2Bullet1":"en filmvisning","step2Bullet2":"en offentlig handling","step2Bullet3":"medied\xe6kning","publicActionLead":"S\xe6t fokus p\xe5 menneskesafarien, d\xe9r hvor du er.","reachOutPre":"Du kan","reachOut":"kontakte os","reachOutPost":"for id\xe9er og ressourcer","newsCoverageLead":"via dine mediekontakter. Fort\xe6l dem om menneskesafarien og om risikoen for alle nuv\xe6rende og fremtidige konfliktomr\xe5der.","putInTouchPre":"Du kan ogs\xe5","putInTouch":"s\xe6tte os i direkte kontakt","inform":"Inform\xe9r","informSub":"dig selv og andre","policyTitle":"Politik","policyBody":"Det foresl\xe5ede LORA Act (Liability for Operators and Responsible Authorities Act) ville indf\xf8re sanktioner i hele ansvarsk\xe6den \u2013 fra russiske FPV-operat\xf8rer og befalingsm\xe6nd til den \xf8verste milit\xe6re ledelse samt producenter og leverand\xf8rer, der muligg\xf8r produktion og inds\xe6ttelse af droner mod civile.","policyHelp":"Kan du hj\xe6lpe p\xe5 det politiske plan?","getInTouch":"Kom i kontakt","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"donate":"Doner","donateIntro":"Disse initiativer yder m\xe5lrettet hj\xe6lp med stor effekt for direkte at beskytte civile i Kherson mod Human Safari.","shareTitle":"Spred budskabet","filmScreening":"Organiser en visning af dokumentarfilmen Kherson Human Safari:","howItStarted":"S\xe5dan begyndte det","kryla":{"name":"Kryla Foundation","desc":"St\xf8t dem i at betale for husly og basale forn\xf8denheder til indbyggere i Oleshky."}},"action":{"intro":"Vi startede med en verdensomsp\xe6ndende demonstration. Nu kan du:","helpLink":"hj\xe6lp her"},"accounts":{"heading":"Beretninger"},"media":{"close":"Luk","view":"Se medie","previous":"Forrige","next":"N\xe6ste","andrushenkoCredit":"Oleksandr Andrushenko, fotokorrespondent for mediet Vgoru","khersonPoliceCredit":"fra @khersonpolice","antypenkoCredit":"Ivan Antypenko, fotojournalist fra Kherson","telegramChannelCredit":"delt i den russiske Human Safari-Telegramkanal \xbbfra Mariupol til Karpaterne\xab","fruitSellerDescription":"Frugts\xe6lger jagtet af en fiberoptisk drone","burntCarDescription":"Udbr\xe6ndt bil i Kherson","bridgeAttackDescription":"Teenagedreng dr\xe6bt af en FPV-drone under en bro i Kherson","busAttackDescription":"Et af mange FPV-droneangreb p\xe5 offentlig transport","fpvDroneDescription":"FPV-drone p\xe5 jagt under \xbbHuman Safari\xab","antiDroneNetsDescription":"Gade i Kherson d\xe6kket af net mod droner fra \xbbHuman Safari\xab","firefighterDescription":"En brandmand slukker en bil efter et angreb i \xbbHuman Safari\xab; bagved ligger et offer"},"follow":{"title":"F\xf8lg","subHumanSafari":"kvalitetskilder, der rapporterer fra Kherson og om Human Safari","subDroneSiege":"kvalitetskilder, der rapporterer fra Kherson og om dronebelejringen","localPress":"lokal ukrainsksproget presse","lang":{"english":"engelsk","german":"tysk","ukrainian":"ukrainsk"},"language":"Sprog: {{list}}","languages":"Sprog: {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"Amerikansk journalist og filminstrukt\xf8r bosat i Kherson, rapporterer for Byline Times og Euromaidan Press; instrukt\xf8r p\xe5 dokumentarfilmen Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"Chefreporter p\xe5 den tyske avis Die Welt; rapporterer j\xe6vnligt om Human Safari i Kherson."},"kelley":{"name":"Brendan Kelley","desc":"Skriver Kherson Weekly, en l\xf8bende optegnelse over russiske droneangreb p\xe5 civile i Kherson og landsbyerne omkring."},"vgoru":{"name":"Vgoru","desc":"Uafh\xe6ngig medieplatform fra Kherson-regionen om livet under angreb og under bes\xe6ttelse."},"suspilne":{"name":"Suspilne Kherson","desc":"Kherson-redaktionen hos Ukraines public service-medie."},"most":{"name":"MOST","desc":"Lokalt nyhedsbureau i Kherson, der d\xe6kker byen og regionen."}},"rallies":{"oleshky2026":{"heroStop":"STOP DRONE&shy;BELEJRINGEN","heroSave":"RED OLESHKY","worldwideRally":"Verdens&shy;omsp\xe6ndende demo","heroDate":"Oktober","infoText1":"Tusindvis af civile er fanget under dronebelejring i Oleshky, Hola Prystan, Stara Zburivka og Nova Zburivka. Russiske styrker bruger dem som menneskelige skjolde og gemmer sig bag dem for at udf\xf8re menneske-safari-droneangreb mod den modsatte bred.","infoText2":"Krisen er akut \u2013 der mangler mad, vand, l\xe6gehj\xe6lp, medicin, elektricitet, gas og kommunikation. Vejene er kraftigt minerede, og droner begr\xe6nser al bev\xe6gelse. <bold>DU kan hj\xe6lpe. Deltag sammen med tusinder verden over for at kr\xe6ve, at dronebelejringen stopper.</bold>","imageAlt":"En udsultet hund blandt menneskeknogler i det \xf8delagte Oleshky under en r\xf8d himmel fuld af droner, med ordene Stop Russian Drone Siege","demandsTitle":"Vi kr\xe6ver:","demand1":"sikre og effektive humanit\xe6re korridorer til Oleshky og andre ber\xf8rte lokalsamfund.","demand2":"\xf8jeblikkelig humanit\xe6r n\xf8dhj\xe6lp og bistand til ofrene for Human Safari-angreb.","demand3":"passende sanktioner mod personer og forsyningsk\xe6der, der er ansvarlige for angreb rettet mod civile.","demand4":"skridt til at afskr\xe6kke brugen af sm\xe5 droner til systematisk at angribe og terrorisere civile i Kherson, Ukraine og andre steder.","cities":{"edinburgh":{"city":"Edinburgh","country":"Storbritannien","time":"Edinburgh - Storbritannien, 14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"Storbritannien","time":"Birmingham - Storbritannien, 14:00 - 16:00","location":"Over for Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Wien","country":"\xd8strig","time":"Wien - \xd8strig, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"M\xfcnchen","country":"Tyskland","time":"M\xfcnchen - Tyskland, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"Manchester","country":"Storbritannien","time":"Manchester - Storbritannien, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"Sydney","country":"Australien","time":"Sydney - Australien, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Paris","country":"Frankrig","time":"Paris - Frankrig, 15:30 - 18:30","location":"Fra Saint Volodymyr-kirken til Place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Paris","country":"Frankrig","time":"Paris - Frankrig, 18:00","location":"Rambuteau metrostation","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lyon","country":"Frankrig","time":"Lyon - Frankrig, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dublin","country":"Irland","time":"Dublin - Irland, 13:00","location":"The GPO (hovedpostkontoret)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Bruxelles","country":"Belgien","time":"Bruxelles - Belgien, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Bruxelles (Schuman-rundk\xf8rslen)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"Den russiske ambassade, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"Frankrig","time":"Nantes - Frankrig, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Gda\u0144sk","country":"Polen","time":"Gda\u0144sk - Polen, 18:30 - 19:30","location":"D\u0142ugi Targ, ved Neptun-springvandet","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Dresden","country":"Tyskland","time":"Dresden - Tyskland, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"M\xe1laga","country":"Spanien","time":"M\xe1laga - Spanien, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"Plovdiv","country":"Bulgarien","time":"Plovdiv - Bulgarien, 17:00","location":"Hovedgaden (Glavnata), ved Kamenitza-trappen / \xbbTogether\xab-skiltet","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapest","country":"Ungarn","time":"Budapest - Ungarn, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (Sankt Stefans Plads)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Hamburg","country":"Tyskland","time":"Hamburg - Tyskland, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, ud for bro 1, 20359 Hamburg","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kiel","country":"Tyskland","time":"Kiel - Tyskland, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Norge","time":"Oslo - Norge","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Leipzig","country":"Tyskland","time":"Leipzig - Tyskland, 17:00 - 18:00","location":"Hovedbaneg\xe5rden (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"London","country":"Storbritannien","time":"London - Storbritannien, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dublin","country":"Irland","time":"Dublin - Irland, 13:00","location":"The GPO (hovedpostkontoret)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dublin","country":"Irland","time":"Dublin - Irland, 14:00","location":"The GPO (hovedpostkontoret)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"Frankrig","time":"Nantes - Frankrig, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Stop den russiske dronebelejring","posterNoRoadOut":"Vejene ind og ud af Oleshky er blokeret","posterHumanitarianCatastrophe":"Oleshky. En humanit\xe6r katastrofe under bes\xe6ttelse","seeGallery":"Se / download plakater"},"artBy":"Kunst: {{name}}","downloadPoster":"Download plakat","reel":{"download":"Download video (MP4)"},"addDemo":{"title":"tilf\xf8j din demo","where":"hvor: by","contact":"e-mail/nummer","message":"besked: hvem du repr\xe6senterer, din demo er bekr\xe6ftet eller undervejs, link til online-opslag, andre detaljer","submit":"Send","sending":"Sender\u2026","thanks":"Tak! Vi kontakter dig.","error":"Noget gik galt. Pr\xf8v igen.","contactInvalid":"Indtast en gyldig e-mail eller et telefonnummer med landekode (f.eks. +45 20 12 34 56).","date":"dato","time":"starttid (lokal)","whereInvalid":"Indtast navnet p\xe5 en by, f.eks. K\xf8benhavn eller Kyiv, Ukraine.","datePlaceholder":"dato: dd/mm"}},"seo":{"oleshky":{"title":"Stop dronebelejringen \u2014 Red Oleshky | Demoer verden over","description":"Russiske droner belejrer tusindvis af civile i det besatte Oleshky i Ukraine, afsk\xe5ret fra mad, vand og medicin. Find en demo n\xe6r dig og kr\xe6v sikker passage."},"leftBank":{"title":"Dronebelejringen af Oleshky og den besatte Kherson-region","description":"Tusindvis af civile er fanget under en russisk dronebelejring i det besatte Oleshky, Hola Prystan og n\xe6rliggende landsbyer. L\xe6s hvad der sker, og hvordan du kan hj\xe6lpe."},"help":{"title":"Stop Human Safari \u2014 Russiske droner jager civile i Kherson","description":"Russiske droner jager civile i Kherson, Ukraine. L\xe6s om krigsforbrydelsen Human Safari, og hvordan du kan hj\xe6lpe med at stoppe den."},"action":{"title":"Verdensomsp\xe6ndende demonstration december 2025 \u2014 Stop Human Safari","description":"Fotos, plakater og steder fra den verdensomsp\xe6ndende demonstration i december 2025 mod russiske droneangreb p\xe5 civile i Kherson, Ukraine."},"rallies":{"title":"Fotos fra demonstrationer \u2014 Stop Human Safari","description":"Fotos fra demonstrationer verden over mod russiske droneangreb p\xe5 civile i Kherson, Ukraine."},"resources":{"title":"Human Safari \u2014 Rapporter, artikler og vidneudsagn","description":"Rapporter, artikler, interviews og vidneudsagn om russiske droneangreb p\xe5 civile i Kherson, Ukraine."},"reel":{"title":"Red Oleshky \u2014 Demovideo","description":"Video fra de verdensomsp\xe6ndende demoer \xbbRed Oleshky\xab, oktober 2026."}}}');


var $a396a1e28512ab83$exports = {};
$a396a1e28512ab83$exports = JSON.parse('{"home":{"heroStop":"FERMARE IL HUMAN SAFARI","heroSave":"SALVARE CHERSON","heroTitle1":"Gli esseri umani","heroTitle2":"Non sono bersagli","heroDate":"13-14 dicembre","worldwideRally":"Raduno mondiale","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"Dall\'estate 2024, i militari russi utilizzano piccoli droni per cacciare, uccidere e terrorizzare i civili per le strade di Cherson e di altre citt\xe0 al fronte in Ucraina. <bold>Il safari umano deve fermarsi. TU puoi aiutare.</bold> Unisciti a migliaia di persone nel mondo per chiedere che questo crimine di guerra finisca.","seeGallery":"Vedi i poster in tutto il mondo","comingSoon":"Localit\xe0 in arrivo","december":"dicembre","dec":"dic.","october":"ottobre","oct":"ott.","september":"settembre","sep":"sett.","schedule9":"9","schedule10":"10","schedule11":"11","schedule12":"12","schedule13":"13","schedule14":"14","schedule16":"16","schedule18":"18","schedule20":"20","schedule1":"1","schedule2":"2","schedule3":"3","schedule4":"4","schedule5":"5","schedule25":"25","schedule26":"26","schedule27":"27","schedule28":"28","schedule29":"29","schedule30":"30","schedule31":"31","scheduleTBC":"Data da confermare...","recommendationsTitle":"Raccomandazioni della Commissione ONU","recommendationsRussia":"La Commissione raccomanda alla Federazione Russa:","rusRec1":"(a) Porre immediatamente fine agli attacchi dei droni contro civili e obiettivi civili","rusRec2":"(b) Fermare immediatamente tutti gli atti che diffondono il terrore tra la popolazione civile","rusRec3":"(c) Garantire che tutti i responsabili coinvolti negli attacchi dei droni contro civili siano ritenuti responsabili","recommendationsUNStates":"La Commissione raccomanda ad altri Stati e organizzazioni regionali e internazionali:","statesRec1":"(a) Contribuire sia finanziariamente che con consulenza tecnica al governo ucraino e alle organizzazioni della societ\xe0 civile, per fornire supporto completo alle vittime e alle loro famiglie;","statesRec2":"(b) Per i terzi Stati il cui territorio \xe8 destinazione di persone deportate dai territori occupati, intraprendere gli sforzi necessari insieme ai servizi consolari ucraini per supportare queste persone.","reference":"Riferimento","linkUN":"Commissione ONU: il \'safari umano\' della Russia in Ucraina \xe8 un crimine contro l\'umanit\xe0","linkGuidelines":"Linee guida ONU","linkWiki":"Wikipedia"},"witnesses":{"title":"Stiamo raccogliendo testimonianze oculari!","email":"Se sei di Cherson, Nikopol, Zaporizhzhia, Sumy o delle zone di prima linea del Donbas e hai assistito di persona a un \u201Csafari umano\u201D, inviaci le tue storie a \uD83D\uDCE7 <mail>khersonhumansafari@gmail.com</mail>, oggetto: \u201Csafari umano.\u201D","type":"Se hai assistito alla morte di un amico o vicino in un attacco di droni e vuoi condividere la tua testimonianza, indica \u201Ctestimone oculare\u201D; se sei stato personalmente attaccato, indica \u201Csopravvissuto.\u201D","requirements":"<b>Ci\xf2 di cui abbiamo bisogno:</b> citt\xe0/luogo, data dell\u2019attacco, breve racconto (3\u20136 frasi; factual, prima persona).","honesty":"Sii onesto, conciso e evita di includere posizioni militari sensibili \u2014 puoi rimanere anonimo.","media":"<b>Foto/video?</b> Scrivi \u201CFoto/video disponibili\u201D. Non allegare file \u2014 ti contatteremo se servono materiali visivi.","consent":"<b>Consenso alla pubblicazione:</b> \u201CAcconsento che questa storia venga pubblicata pubblicamente sul sito HumanSafari.org.\u201D"},"resources":{"title":"Risorse chiave","linkLibraryTitle":"Archivio link","linkLibraryDesc":"200 articoli, rapporti, interviste, testimonianze dirette e copertura mediatica","humanSafariMapTitle":"Mappa dell\u2019Human Safari di Tochnyi","humanSafariMapDesc":"Una mappa interattiva degli attacchi dell\'Human Safari a Cherson, costruita a partire da segnalazioni open source delle autorit\xe0 locali e da video degli attacchi geolocalizzati dal team di Tochnyi.","truthHoundsTitle":"Rapporto Truth Hounds","truthHoundsDesc":"Killzone: Come i droni russi devastano la sponda destra del fiume Dnipro","hrwTitle":"Rapporto Human Rights Watch sugli attacchi con droni a Cherson","hrwDesc":"Rapporto HRW","unReportsTitle":"Rapporti del Consiglio ONU per i Diritti Umani","report1":"Rapporto ONU #1","report3":"Rapporto ONU #3","guidelines":"Linee guida ONU","wikipediaTitle":"Wikipedia","english":"Inglese","french":"Francese","documentaryTitle":"Documentario","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13-14 dicembre","eyewitnesses":"testimonianze","rallies":"le foto","help":"Cherson deoccupata","leftBank":"Cherson occupata","action":"dicembre \'25","oleshky":"azione globale - Oleshky","menu":"Menu"},"leftBank":{"pageTitle":"Assedio con droni","para1":"Una grave emergenza umanitaria colpisce 6.000 civili intrappolati sotto un assedio di droni nelle localit\xe0 occupate di Oleshky, Hola Prystan, Stara Zburivka e Nova Zburivka - regione occupata di Cherson. A Oleshky 1.200 - 2.000. L\'autorit\xe0 occupante \xe8 obbligata a sostenerli - invece le forze russe li usano come scudi umani, per nascondersi dietro questa popolazione mentre conducono attacchi di safari umano sulla sponda opposta. Le autorit\xe0 ucraine e le organizzazioni umanitarie denunciano un\'ostruzione sistematica dell\'evacuazione e dell\'accesso umanitario.","para2":"I civili sono privi di cibo, acqua, cure mediche, medicinali, elettricit\xe0, gas e comunicazioni. Le strade sono pesantemente minate e l\'attivit\xe0 dei droni limita gli spostamenti. Dal 26 maggio nessun veicolo \xe8 potuto entrare o uscire. Le scorte di carburante e cibo sono quasi esaurite.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"Video: \xabKherson and Oleshky: Witnessing Genocide\xbb (12 min)","meidasArticle":"Articolo: \xabThe Kherson Region: How Russia Uses Civilians as a Tool of War\xbb (5 min di lettura)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Articolo: \xabGlobal Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate\xbb (7 min di lettura)","tellPost":"e parla dell\'Assedio con droni agli altri","callToHelp":"TU puoi aiutare. Ecco come","donateIntro":"Queste iniziative offrono un aiuto mirato e ad alto impatto direttamente alle persone fuggite da Oleshky o, dove possibile, ancora intrappolate l\xec.","signTitle":"Firma","signSub":"petizioni","petitionBy":"di {{name}}","petitions":{"euParliament":"Parlamento europeo \u2013 Petizione n. 1439/2026 per l\u2019istituzione di un corridoio umanitario di evacuazione per i civili intrappolati sotto assedio a Oleshky (Ucraina), occupata dalla Russia","ukParliament":"Parlamento britannico \u2013 Istituire un corridoio di aiuti umanitari guidato dal Regno Unito verso Oleshky, in Ucraina"},"publicActionLead":"Punta i riflettori sull\'assedio con droni dove ti trovi.","organiseAction":"Organizza un\'azione.","policyBody":"Le autorit\xe0 ucraine sono in consultazione con il Comitato Internazionale della Croce Rossa per l\'istituzione di un corridoio umanitario di evacuazione dalle localit\xe0 occupate della regione di Kherson e per garantire l\'accesso umanitario a cibo, acqua, medicine, carburante e assistenza medica. All\'inizio di giugno non \xe8 in funzione alcun corridoio di evacuazione n\xe9 un meccanismo stabile di accesso umanitario.","documentaryTitle":"Oleshky, breve documentario","downloadTitle":"Scarica","downloadSub":"grafiche"},"footer":{"addCityText":"Per aggiungere la tua citt\xe0, invia un\'email a: ","organiseText":"Aggiungi la tua manifestazione - contattaci:","contact":"Contatto:"},"byCountry":"vedi per paese","byDate":"vedi per data","countries":{"australia":"Australia","austria":"Austria","bulgaria":"Bulgaria","canada":"Canada","czechia":"Repubblica Ceca","denmark":"Danimarca","estonia":"Estonia","finland":"Finlandia","france":"Francia","georgia":"Georgia","germany":"Germania","hungary":"Ungheria","italy":"Italia","japan":"Giappone","mexico":"Messico","netherlands":"Paesi Bassi","norway":"Norvegia","poland":"Polonia","romania":"Romania","spain":"Spagna","sweden":"Svezia","southAfrica":"Sudafrica","ukraine":"Ucraina","unitedKingdom":"Regno Unito","usa":"USA","ireland":"Irlanda","belgium":"Belgio"},"cities":{"alicante":{"city":"Alicante","country":"Spagna","time":"Alicante - Spagna, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcellona","country":"Spagna","time":"Barcellona - Spagna, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"USA","time":"Berkeley - USA, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berlino","country":"Germania","time":"Berlino - Germania, 12:00","location":"Tempelhofer Feld, ingresso Leinstr./angolo di Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"USA","time":"Bettendorf - USA, 17:30 - Proiezione","location":"Bettendorf Public Library","cleanTime":"17:30 - Proiezione","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"Regno Unito","time":"Birmingham - Regno Unito, 14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Germania","time":"Bonn - Germania, 14:00 - 16:00","location":"Poststra\xdfe, davanti alla stazione principale","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Bremen","country":"Germania","time":"Bremen - Germania, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapest","country":"Ungheria","time":"Budapest - Ungheria, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Constan\u021Ba","country":"Romania","time":"Constan\u021Ba - Romania, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"Copenaghen","country":"Danimarca","time":"Copenaghen - Danimarca, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"USA","time":"Dallas - USA, 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"USA","time":"Denver - USA, 12:00","location":"Colorado Capitol Building, gradini Ovest","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"Edimburgo","country":"Regno Unito","time":"Edimburgo - Regno Unito, 13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"USA","time":"Fort Worth - USA, 14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Amburgo","country":"Germania","time":"Amburgo - Germania, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"USA","time":"Houghton, Michigan - USA, 15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finlandia","time":"Helsinki - Finlandia, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Giappone","time":"Izumo - Giappone, 13:00","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Giappone","time":"Izumo - Giappone","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops","country":"Canada","time":"Kamloops - Canada, 15:00 - 16:00","location":"Municipio","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kyiv","country":"Ucraina","time":"Kyiv - Ucraina, 17:00 - 18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Leipzig","country":"Germania","time":"Leipzig - Germania, 12:00 - 13:00","location":"Willy Brandt Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 18:30 - Proiezione","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - Proiezione","day":"schedule12"},"losAngeles":{"city":"Los Angeles","country":"USA","time":"Los Angeles - USA, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"M\xe1laga","country":"Spagna","time":"M\xe1laga - Spagna, 18:00 - Proiezione","location":"Maydan - Centro Storico Culturale Ucraino","cleanTime":"18:00 - Proiezione","day":"schedule13"},"manchester":{"city":"Manchester","country":"Regno Unito","time":"Manchester - Regno Unito, 14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Citt\xe0 del Messico","country":"Messico","time":"Citt\xe0 del Messico - Messico, 11:00","location":"Alameda Central. Fontana \\"Americhe\\" (tra Hemiciclo Ju\xe1rez e Chiosco)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Milano","country":"Italia","time":"Milano - Italia, 15:00","location":"Duomo di Milano","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"Monaco di Baviera","country":"Germania","time":"Monaco di Baviera - Germania, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"New York","country":"USA","time":"New York - USA, 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"New York","country":"USA","time":"New York - USA, 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"Nienburg (Weser)","country":"Germania","time":"Nienburg (Weser) - Germania, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Norvegia","time":"Oslo - Norvegia, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Svezia","time":"\xd6stersund - Svezia, 11:00 - 14:00","location":"Stortorget (Piazza principale)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"Ambasciata russa","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:00","location":"Ambasciata USA","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Parigi","country":"Francia","time":"Parigi - Francia, 15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (marcia)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"Plovdiv","country":"Bulgaria","time":"Plovdiv - Bulgaria, 16:00 - 17:00","location":"vicino alla Casa Levski","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Praga","country":"Cechia","time":"Praga - Cechia, 14:00","location":"Palack\xe9ho Square","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"Sudafrica","time":"Rosendal - Sudafrica, 11:00","location":"Uffici del South African Police Service","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Tenerife","country":"Spagna","time":"San Andr\xe9s, Tenerife - Spagna, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"USA","time":"San Diego - USA, 14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"USA","time":"San Francisco - USA, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Germania","time":"Schwerin - Germania, 19:00 - Proiezione","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - Proiezione","day":"schedule13"},"seattle":{"city":"Seattle","country":"USA","time":"Seattle - USA, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sveti Vlas","country":"Bulgaria","time":"Sveti Vlas - Bulgaria, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"Sydney","country":"Australia","time":"Sydney - Australia, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallin","country":"Estonia","time":"Tallin - Estonia, 15:00 - Proiezione e manifestazione","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - Proiezione e manifestazione","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Spagna","time":"Tarragona - Spagna, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"L\'Aia","country":"Paesi Bassi","time":"L\'Aia - Paesi Bassi, 13:00 - 15:00","location":"Davanti al Palazzo della Pace / CPI","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tbilisi","country":"Georgia","time":"Tbilisi - Georgia, 21:00","location":"Tbilisi","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Svezia","time":"Tran\xe5s - Svezia, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Vienna","country":"Austria","time":"Vienna - Austria, 16:00 - 18:00","location":"Stock im Eisen Platz (vicino a Stephansdom)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Washington D.C.","country":"USA","time":"Washington D.C. - USA, 12:30 - 13:30","location":"Casa Bianca","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Polonia","time":"Wroc\u0142aw - Polonia, 13:00","location":"Piazza della Libert\xe0 (direzione People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"Organizza! Per aggiungere la tua citt\xe0, invia un\'email a:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Condividi su {{platform}}","website":"Sito web","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, giornalista e regista, ha organizzato la manifestazione mondiale e ha diretto il documentario Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Protezione dei civili per le strade di Kherson \u2014 proteggendo i civili dagli attacchi dei droni.","foodDesc":"Aiuti alimentari.","foodNote":"Quando doni, scrivi \xabFood for Cherson\xbb come causale."},"ahs":{"name":"Progetto Anti Human Safari","desc":"Rilevatori di droni e giubbotti protettivi per volontari e servizi di emergenza a Kherson."},"pageTitle":"Fermate il Human Safari","sectionIntro":"Dall\'estate del 2024, i militari russi usano piccoli droni per cacciare, uccidere e terrorizzare civili nelle strade di Kherson e altre citt\xe0 di prima linea in Ucraina.","sectionIntro2":"\xc8 una campagna di omicidi sistematica e deliberata: gli operatori di droni russi pubblicano apertamente i video delle loro vittime su canali Telegram per vantarsene. Nel maggio 2025 l\'ONU ha riconosciuto l\'Human Safari come un crimine di guerra in corso.","sectionIntro3":"Si sta facendo troppo poco. Il Human Safari deve finire.","sectionIntroBold":"VOI potete aiutare. Ecco come","step2Title":"Organizza","step3Title":"Dillo agli altri","step3Para":"Usa gli hashtag","step3ParaPost":"e parla del Human Safari agli altri","instagram":"Instagram","step2Bullet1":"una proiezione cinematografica","step2Bullet2":"un\'azione pubblica","step2Bullet3":"una copertura mediatica","publicActionLead":"Punta i riflettori sul safari umano dove ti trovi.","reachOutPre":"Puoi","reachOut":"contattarci","reachOutPost":"per idee e risorse","newsCoverageLead":"tramite i tuoi contatti nei media. Parla loro del safari umano e del rischio per tutte le zone di conflitto attuali e future.","putInTouchPre":"Puoi anche","putInTouch":"metterci in contatto diretto","inform":"Informati","informSub":"te stesso e gli altri","policyTitle":"Politica","policyBody":"La proposta di legge LORA (Liability for Operators and Responsible Authorities Act) introdurrebbe sanzioni lungo l\'intera catena di responsabilit\xe0: dagli operatori e comandanti russi dei droni FPV fino agli alti vertici militari, nonch\xe9 nei confronti dei produttori e fornitori che rendono possibile la produzione e l\'impiego di droni contro i civili.","policyHelp":"Puoi aiutare a livello politico?","getInTouch":"Mettiti in contatto","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"donate":"Dona","donateIntro":"Queste iniziative offrono un aiuto mirato e ad alto impatto per proteggere direttamente i civili di Kherson dallo Human Safari.","shareTitle":"Diffondi la notizia","filmScreening":"Organizza una proiezione del documentario Kherson Human Safari:","howItStarted":"Come \xe8 iniziato","kryla":{"name":"Kryla Foundation","desc":"Sostienili nel pagare alloggio e beni di prima necessit\xe0 per gli abitanti di Oleshky."}},"action":{"intro":"Abbiamo iniziato con una manifestazione mondiale. Ora puoi:","helpLink":"aiuta qui"},"accounts":{"heading":"Account"},"media":{"close":"Chiudi","view":"Guarda il contenuto","previous":"Precedente","next":"Successivo","andrushenkoCredit":"Oleksandr Andrushenko, fotoreporter della testata Vgoru","khersonPoliceCredit":"da @khersonpolice","antypenkoCredit":"Ivan Antypenko, fotogiornalista di Cherson","telegramChannelCredit":"pubblicato sul canale Telegram russo dell\'Human Safari \xabda Mariupol ai Carpazi\xbb","fruitSellerDescription":"Un venditore di frutta inseguito da un drone a fibra ottica","burntCarDescription":"Auto bruciata a Cherson","bridgeAttackDescription":"Un adolescente ucciso da un drone FPV sotto un ponte a Cherson","busAttackDescription":"Uno dei tanti attacchi con droni FPV contro i mezzi pubblici","fpvDroneDescription":"Drone FPV a caccia durante l\'\xabHuman Safari\xbb","antiDroneNetsDescription":"Strada di Cherson coperta da reti contro i droni dell\'\xabHuman Safari\xbb","firefighterDescription":"Un vigile del fuoco spegne un\'auto dopo un attacco dell\'\xabHuman Safari\xbb, dietro giace una vittima"},"follow":{"title":"Segui","subHumanSafari":"fonti di qualit\xe0 che raccontano da Cherson e sull\'Human Safari","subDroneSiege":"fonti di qualit\xe0 che raccontano da Cherson e sull\'assedio con droni","localPress":"stampa locale in ucraino","lang":{"english":"inglese","german":"tedesco","ukrainian":"ucraino"},"language":"Lingua: {{list}}","languages":"Lingue: {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"Giornalista e regista statunitense con base a Cherson, collabora con Byline Times ed Euromaidan Press; ha diretto il documentario Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"Caporeporter del quotidiano tedesco Die Welt; racconta periodicamente l\'Human Safari a Cherson."},"kelley":{"name":"Brendan Kelley","desc":"Scrive Kherson Weekly, una cronaca costante degli attacchi con droni russi contro i civili a Cherson e nei villaggi circostanti."},"vgoru":{"name":"Vgoru","desc":"Piattaforma d\'informazione indipendente della regione di Cherson, racconta la vita sotto attacco e sotto occupazione."},"suspilne":{"name":"Suspilne Cherson","desc":"La redazione di Cherson dell\'emittente pubblica ucraina."},"most":{"name":"MOST","desc":"Agenzia di stampa locale di Cherson, segue la citt\xe0 e la regione."}},"rallies":{"oleshky2026":{"heroStop":"FERMARE L\'ASSEDIO CON DRONI","heroSave":"SALVARE OLESHKY","worldwideRally":"Azione globale","heroDate":"Ottobre","infoText1":"Migliaia di civili sono intrappolati sotto l\'assedio dei droni a Oleshky, Hola Prystan, Stara Zburivka e Nova Zburivka. Le forze russe li usano come scudi umani, nascondendosi dietro di loro per condurre attacchi di safari umano con droni sulla sponda opposta.","infoText2":"La crisi \xe8 acuta: mancano cibo, acqua, cure mediche, medicinali, elettricit\xe0, gas e comunicazioni. Le strade sono pesantemente minate e i droni limitano ogni spostamento. <bold>TU puoi aiutare. Unisciti a migliaia di persone nel mondo per chiedere la fine dell\'assedio con droni.</bold>","imageAlt":"Un cane affamato tra ossa umane nella Oleshky in rovina, sotto un cielo rosso pieno di droni, con la scritta Stop Russian Drone Siege","demandsTitle":"Chiediamo:","demand1":"corridoi umanitari sicuri ed efficaci verso Oleshky e le altre comunit\xe0 colpite.","demand2":"aiuti umanitari immediati e assistenza alle vittime degli attacchi di safari umano.","demand3":"sanzioni adeguate contro le persone e le catene di approvvigionamento responsabili di attacchi contro i civili.","demand4":"misure per scoraggiare l\'uso di piccoli droni per colpire e terrorizzare sistematicamente i civili a Cherson, in Ucraina e altrove.","cities":{"edinburgh":{"city":"Edimburgo","country":"Regno Unito","time":"Edimburgo - Regno Unito, 14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"Regno Unito","time":"Birmingham - Regno Unito, 14:00 - 16:00","location":"Di fronte alla Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Vienna","country":"Austria","time":"Vienna - Austria, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"Monaco di Baviera","country":"Germania","time":"Monaco di Baviera - Germania, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"Manchester","country":"Regno Unito","time":"Manchester - Regno Unito, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"Sydney","country":"Australia","time":"Sydney - Australia, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Parigi","country":"Francia","time":"Parigi - Francia, 15:30 - 18:30","location":"Dalla chiesa di San Volodymyr a Place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Parigi","country":"Francia","time":"Parigi - Francia, 18:00","location":"Metro Rambuteau","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lione","country":"Francia","time":"Lione - Francia, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dublino","country":"Irlanda","time":"Dublino - Irlanda, 13:00","location":"The GPO (Ufficio postale generale)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Bruxelles","country":"Belgio","time":"Bruxelles - Belgio, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Bruxelles (rotonda Schuman)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Canada","time":"Ottawa - Canada, 12:30 - 13:30","location":"Ambasciata russa, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"Francia","time":"Nantes - Francia, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Danzica","country":"Polonia","time":"Danzica - Polonia, 18:30 - 19:30","location":"D\u0142ugi Targ, accanto alla Fontana di Nettuno","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Dresda","country":"Germania","time":"Dresda - Germania, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"Malaga","country":"Spagna","time":"Malaga - Spagna, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"Plovdiv","country":"Bulgaria","time":"Plovdiv - Bulgaria, 17:00","location":"Via principale (Glavnata), vicino alla scalinata Kamenitza / alla scritta \\"Together\\"","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapest","country":"Ungheria","time":"Budapest - Ungheria, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (piazza Santo Stefano)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Amburgo","country":"Germania","time":"Amburgo - Germania, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, all\'altezza del pontile 1, 20359 Amburgo","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kiel","country":"Germania","time":"Kiel - Germania, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Norvegia","time":"Oslo - Norvegia","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Leipzig","country":"Germania","time":"Leipzig - Germania, 17:00 - 18:00","location":"Stazione centrale (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"Londra","country":"Regno Unito","time":"Londra - Regno Unito, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dublino","country":"Irlanda","time":"Dublino - Irlanda, 13:00","location":"The GPO (Ufficio postale generale)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dublino","country":"Irlanda","time":"Dublino - Irlanda, 14:00","location":"The GPO (Ufficio postale generale)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"Francia","time":"Nantes - Francia, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Fermate l\'assedio russo con i droni","posterNoRoadOut":"Le vie d\'accesso e d\'uscita da Oleshky sono bloccate","posterHumanitarianCatastrophe":"Oleshky. Una catastrofe umanitaria sotto occupazione","seeGallery":"Vedi / scarica i poster"},"artBy":"Arte: {{name}}","downloadPoster":"Scarica il poster","reel":{"download":"Scarica il video (MP4)"},"addDemo":{"title":"aggiungi la tua manifestazione","where":"dove: citt\xe0/paese","contact":"email/numero","message":"messaggio: chi rappresenti, la tua manifestazione \xe8 confermata o in preparazione, link all\'annuncio online, altri dettagli","submit":"Invia","sending":"Invio\u2026","thanks":"Grazie! Ti contatteremo.","error":"Qualcosa \xe8 andato storto. Riprova.","contactInvalid":"Inserisci un\'email valida o un numero di telefono con prefisso internazionale (es. +39 312 345 6789).","date":"data","time":"ora di inizio (locale)","whereInvalid":"Inserisci il nome di una citt\xe0 o di un paese, es. Roma o Kyiv, Ucraina.","datePlaceholder":"data: gg/mm"}},"seo":{"oleshky":{"title":"Fermiamo l\'assedio con droni \u2014 Salviamo Oleshky","description":"Droni russi assediano migliaia di civili a Oleshky, Ucraina occupata, senza cibo, acqua e medicinali. Trova una manifestazione vicino a te e chiedi un passaggio sicuro."},"leftBank":{"title":"Assedio con droni di Oleshky e della regione occupata di Kherson","description":"Migliaia di civili sono intrappolati sotto un assedio russo con droni a Oleshky, Hola Prystan e nei villaggi occupati vicini. Scopri cosa succede e come puoi aiutare."},"help":{"title":"Fermiamo lo Human Safari \u2014 Droni russi danno la caccia ai civili a Kherson","description":"Droni russi danno la caccia ai civili a Kherson, in Ucraina. Scopri il crimine di guerra dello Human Safari e come aiutare a fermarlo."},"action":{"title":"Manifestazione mondiale di dicembre 2025 \u2014 Fermiamo lo Human Safari","description":"Foto, manifesti e luoghi della manifestazione mondiale di dicembre 2025 contro gli attacchi russi con droni sui civili a Kherson, in Ucraina."},"rallies":{"title":"Foto delle manifestazioni \u2014 Fermiamo lo Human Safari","description":"Foto di manifestazioni in tutto il mondo contro gli attacchi russi con droni sui civili a Kherson, in Ucraina."},"resources":{"title":"Risorse sullo Human Safari \u2014 Rapporti, articoli e testimonianze","description":"Rapporti, articoli, interviste e testimonianze sugli attacchi russi con droni contro i civili a Kherson, in Ucraina."},"reel":{"title":"Salviamo Oleshky \u2014 Video delle manifestazioni","description":"Video delle manifestazioni mondiali \xabSalviamo Oleshky\xbb, ottobre 2026."}}}');


var $38443901ba4773cc$exports = {};
$38443901ba4773cc$exports = JSON.parse('{"home":{"heroStop":"DETENGAN EL HUMAN SAFARI","heroSave":"SALVEMOS JERS\xd3N","heroTitle1":"Los seres humanos","heroTitle2":"No son objetivos","heroDate":"13-14 de diciembre","worldwideRally":"Acci\xf3n global","heroHashtags":"#LosSeresHumanosNoSonObjetivos #StopHumanSafari #SaveKherson","infoText":"Desde el verano de 2024, el ej\xe9rcito ruso utiliza peque\xf1os drones para cazar, matar y aterrorizar a los civiles en las calles de Jers\xf3n y otras ciudades en primera l\xednea en Ucrania. <bold>El safari humano debe detenerse. T\xda puedes ayudar.</bold> \xdanete a miles de personas en todo el mundo para exigir que este crimen de guerra termine.","seeGallery":"Ver carteles de todo el mundo","comingSoon":"Ubicaciones pr\xf3ximamente","december":"de diciembre","dec":"dic.","october":"de octubre","oct":"oct.","september":"de septiembre","sep":"sept.","schedule9":"9","schedule10":"10","schedule11":"11","schedule12":"12","schedule13":"13","schedule14":"14","schedule16":"16","schedule18":"18","schedule20":"20","schedule1":"1","schedule2":"2","schedule3":"3","schedule4":"4","schedule5":"5","schedule25":"25","schedule26":"26","schedule27":"27","schedule28":"28","schedule29":"29","schedule30":"30","schedule31":"31","scheduleTBC":"Fecha por confirmar...","recommendationsTitle":"Recomendaciones de la Comisi\xf3n de la ONU","recommendationsRussia":"La Comisi\xf3n recomienda que la Federaci\xf3n Rusa:","rusRec1":"(a) Ponga fin de inmediato a los ataques con drones dirigidos a civiles y objetos civiles","rusRec2":"(b) Detenga inmediatamente todos los actos que propaguen terror entre la poblaci\xf3n civil","rusRec3":"(c) Asegure que todos los responsables de ataques con drones contra civiles sean llevados ante la justicia","recommendationsUNStates":"La Comisi\xf3n recomienda que otros Estados y organizaciones regionales e internacionales:","statesRec1":"(a) Contribuyan tanto financieramente como con asesoramiento t\xe9cnico al Gobierno de Ucrania y a las organizaciones de la sociedad civil, para proporcionar apoyo integral a las v\xedctimas y sus familias;","statesRec2":"(b) Para los Estados terceros cuyo territorio sea el destino de personas deportadas desde los territorios ocupados, realizar los esfuerzos necesarios junto con los servicios consulares ucranianos para apoyar a estas personas.","reference":"Referencia","linkUN":"Comisi\xf3n de la ONU: El \\"safari humano\\" de Rusia en Ucrania es un crimen contra la humanidad","linkGuidelines":"Directrices de la ONU","linkWiki":"Wikipedia"},"witnesses":{"title":"\xa1Estamos recopilando testimonios de testigos!","email":"Si eres de Jers\xf3n, Nikopol, Zaporizhia, Sumy o de las \xe1reas de primera l\xednea del Donb\xe1s y si has presenciado un \u201Csafari humano\u201D, env\xedanos tus historias a \uD83D\uDCE7 <mail>khersonhumansafari@gmail.com</mail>, asunto: \u201Csafari humano\u201D.","type":"Si presenciaste la muerte de un amigo o vecino en un ataque con drones y deseas compartir tu relato, indica \u201Ctestigo ocular\u201D; si fuiste atacado personalmente, indica \u201Csuperviviente\u201D.","requirements":"<b>Lo que necesitamos:</b> ciudad/ubicaci\xf3n, fecha del ataque, breve relato (3\u20136 frases; factual, en primera persona).","honesty":"S\xe9 honesto, conciso y evita incluir posiciones militares sensibles \u2014 puedes permanecer en el anonimato.","media":"<b>\xbfFotos/videos?</b> Escribe \u201CFotos/videos disponibles\u201D. No adjuntes archivos \u2014 nos pondremos en contacto si se necesitan materiales visuales.","consent":"<b>Consentimiento para publicaci\xf3n:</b> \u201CAcepto que esta historia sea publicada p\xfablicamente en el sitio HumanSafari.org.\u201D"},"resources":{"title":"Recursos clave","linkLibraryTitle":"Biblioteca de enlaces","linkLibraryDesc":"200 art\xedculos, informes, entrevistas, testimonios directos y cobertura medi\xe1tica","humanSafariMapTitle":"Mapa del Human Safari de Tochnyi","humanSafariMapDesc":"Un mapa interactivo de los ataques del Human Safari en Jers\xf3n, elaborado a partir de informes de fuentes abiertas de las autoridades locales y de v\xeddeos de los ataques geolocalizados por el equipo de Tochnyi.","truthHoundsTitle":"Informe Truth Hounds","truthHoundsDesc":"Killzone: C\xf3mo los drones rusos devastan la margen derecha del r\xedo Dni\xe9per","hrwTitle":"Informe de Human Rights Watch sobre ataques con drones en Jers\xf3n","hrwDesc":"Informe HRW","unReportsTitle":"Informes del Consejo de Derechos Humanos de la ONU","report1":"Informe ONU #1","report3":"Informe ONU #3","guidelines":"Directrices de la ONU","wikipediaTitle":"Wikipedia","english":"Ingl\xe9s","french":"Franc\xe9s","documentaryTitle":"Documental","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13-14 dic","eyewitnesses":"testimonios","rallies":"fotos","help":"Jers\xf3n desocupada","leftBank":"Jers\xf3n ocupada","action":"dic \'25","oleshky":"acci\xf3n global - Oleshky","menu":"Men\xfa"},"leftBank":{"pageTitle":"Asedio con drones","para1":"Una grave emergencia humanitaria afecta a 6000 civiles atrapados bajo un asedio con drones en las localidades ocupadas de Oleshky, Hola Prystan, Stara Zburivka y Nova Zburivka - regi\xf3n ocupada de Jers\xf3n. En Oleshky, entre 1200 y 2000. La autoridad ocupante est\xe1 obligada a asistirlos - en cambio, las fuerzas rusas los utilizan como escudos humanos para esconderse tras esta poblaci\xf3n mientras llevan a cabo ataques de safari humano en la margen opuesta. Las autoridades ucranianas y las organizaciones humanitarias denuncian una obstrucci\xf3n sistem\xe1tica de la evacuaci\xf3n y del acceso humanitario.","para2":"Los civiles carecen de alimentos, agua, atenci\xf3n m\xe9dica, medicamentos, electricidad, gas y comunicaciones. Las carreteras est\xe1n fuertemente minadas y la actividad de drones restringe el movimiento. Ning\xfan veh\xedculo ha podido entrar ni salir desde el 26 de mayo. Las reservas de combustible y alimentos est\xe1n casi agotadas.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"V\xeddeo: \xabKherson and Oleshky: Witnessing Genocide\xbb (12 min)","meidasArticle":"Art\xedculo: \xabThe Kherson Region: How Russia Uses Civilians as a Tool of War\xbb (5 min de lectura)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Art\xedculo: \xabGlobal Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate\xbb (7 min de lectura)","tellPost":"y cu\xe9ntaselo a los dem\xe1s","callToHelp":"T\xda puedes ayudar. As\xed es c\xf3mo","donateIntro":"Estas son iniciativas que ofrecen ayuda espec\xedfica y de gran impacto directamente a las personas que han huido de Oleshky o, donde es posible, siguen atrapadas all\xed.","signTitle":"Firma","signSub":"peticiones","petitionBy":"de {{name}}","petitions":{"euParliament":"Parlamento Europeo \u2013 Petici\xf3n n.\xba 1439/2026 sobre la creaci\xf3n de un corredor humanitario de evacuaci\xf3n para los civiles atrapados bajo asedio en Oleshky (Ucrania), ocupada por Rusia","ukParliament":"Parlamento del Reino Unido \u2013 Impulsar un corredor de ayuda humanitaria liderado por el Reino Unido hacia Oleshky, en Ucrania"},"publicActionLead":"Pon el foco sobre el asedio con drones all\xed donde est\xe9s.","organiseAction":"Organiza una acci\xf3n.","policyBody":"Las autoridades ucranianas mantienen consultas con el Comit\xe9 Internacional de la Cruz Roja sobre el establecimiento de un corredor humanitario de evacuaci\xf3n desde las localidades ocupadas de la regi\xf3n de Jers\xf3n y la garant\xeda de acceso humanitario para alimentos, agua, medicinas, combustible y asistencia m\xe9dica. A principios de junio, no existe ning\xfan corredor de evacuaci\xf3n operativo ni un mecanismo sostenido de acceso humanitario.","documentaryTitle":"Oleshky, documental corto","downloadTitle":"Descargar","downloadSub":"gr\xe1ficos"},"footer":{"addCityText":"Para agregar tu ciudad, env\xeda un correo electr\xf3nico a: ","organiseText":"A\xf1ade tu manifestaci\xf3n - ponte en contacto:","contact":"Contacto:"},"byCountry":"ver por pa\xeds","byDate":"ver por fecha","countries":{"australia":"Australia","austria":"Austria","bulgaria":"Bulgaria","canada":"Canad\xe1","czechia":"Chequia","denmark":"Dinamarca","estonia":"Estonia","finland":"Finlandia","france":"Francia","georgia":"Georgia","germany":"Alemania","hungary":"Hungr\xeda","italy":"Italia","japan":"Jap\xf3n","mexico":"M\xe9xico","netherlands":"Pa\xedses Bajos","norway":"Noruega","poland":"Polonia","romania":"Ruman\xeda","spain":"Espa\xf1a","sweden":"Suecia","southAfrica":"Sud\xe1frica","ukraine":"Ucrania","unitedKingdom":"Reino Unido","usa":"EE.\xa0UU.","ireland":"Irlanda","belgium":"B\xe9lgica"},"cities":{"alicante":{"city":"Alicante","country":"Espa\xf1a","time":"Alicante - Espa\xf1a, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcelona","country":"Espa\xf1a","time":"Barcelona - Espa\xf1a, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"EE. UU.","time":"Berkeley - EE. UU., 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berl\xedn","country":"Alemania","time":"Berl\xedn - Alemania, 12:00","location":"Tempelhofer Feld, entrada Leinstr./esquina de Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"EE. UU.","time":"Bettendorf - EE. UU., 17:30 - Proyecci\xf3n","location":"Bettendorf Public Library","cleanTime":"17:30 - Proyecci\xf3n","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"Reino Unido","time":"Birmingham - Reino Unido, 14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Alemania","time":"Bonn - Alemania, 14:00 - 16:00","location":"Poststra\xdfe, frente a la estaci\xf3n central","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Bremen","country":"Alemania","time":"Bremen - Alemania, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapest","country":"Hungr\xeda","time":"Budapest - Hungr\xeda, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"EE. UU.","time":"Chicago - EE. UU., 13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Constan\u021Ba","country":"Ruman\xeda","time":"Constan\u021Ba - Ruman\xeda, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"copenhagen":{"city":"Copenhague","country":"Dinamarca","time":"Copenhague - Dinamarca, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"EE. UU.","time":"Dallas - EE. UU., 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"EE. UU.","time":"Denver - EE. UU., 12:00","location":"Colorado Capitol Building, escaleras oeste","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"Edimburgo","country":"Reino Unido","time":"Edimburgo - Reino Unido, 13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"EE. UU.","time":"Fort Worth - EE. UU., 14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Hamburgo","country":"Alemania","time":"Hamburgo - Alemania, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"EE. UU.","time":"Houghton, Michigan - EE. UU., 15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finlandia","time":"Helsinki - Finlandia, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Jap\xf3n","time":"Izumo - Jap\xf3n, 13:00","location":"Santuario Izumo Taisha, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Jap\xf3n","time":"Izumo - Jap\xf3n","location":"Santuario Izumo Taisha, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops","country":"Canad\xe1","time":"Kamloops - Canad\xe1, 15:00 - 16:00","location":"Ayuntamiento","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kyiv","country":"Ucrania","time":"Kyiv - Ucrania, 17:00 - 18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Leipzig","country":"Alemania","time":"Leipzig - Alemania, 12:00 - 13:00","location":"Willy Brandt Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 18:30 - Proyecci\xf3n","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - Proyecci\xf3n","day":"schedule12"},"losAngeles":{"city":"Los \xc1ngeles","country":"EE. UU.","time":"Los \xc1ngeles - EE. UU., 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"M\xe1laga","country":"Espa\xf1a","time":"M\xe1laga - Espa\xf1a, 18:00 - Proyecci\xf3n","location":"Maydan - Centro Hist\xf3rico Cultural Ucraniano","cleanTime":"18:00 - Proyecci\xf3n","day":"schedule13"},"manchester":{"city":"Manchester","country":"Reino Unido","time":"Manchester - Reino Unido, 14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Ciudad de M\xe9xico","country":"M\xe9xico","time":"Ciudad de M\xe9xico - M\xe9xico, 11:00","location":"Alameda Central. Fuente \\"Am\xe9ricas\\" (entre Hemiciclo Ju\xe1rez y Kiosco)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Mil\xe1n","country":"Italia","time":"Mil\xe1n - Italia, 15:00","location":"Catedral de Mil\xe1n","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"M\xfanich","country":"Alemania","time":"M\xfanich - Alemania, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"Nueva York","country":"EE. UU.","time":"Nueva York - EE. UU., 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"Nueva York","country":"EE. UU.","time":"Nueva York - EE. UU., 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"Nienburg (Weser)","country":"Alemania","time":"Nienburg (Weser) - Alemania, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Noruega","time":"Oslo - Noruega, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Suecia","time":"\xd6stersund - Suecia, 11:00 - 14:00","location":"Stortorget (Plaza principal)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Canad\xe1","time":"Ottawa - Canad\xe1, 12:30 - 13:30","location":"Embajada de rusia","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Canad\xe1","time":"Ottawa - Canad\xe1, 12:00","location":"Embajada de EE. UU.","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Par\xeds","country":"Francia","time":"Par\xeds - Francia, 15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (marcha)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"Plovdiv","country":"Bulgaria","time":"Plovdiv - Bulgaria, 16:00 - 17:00","location":"junto a la Casa Levski","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Praga","country":"Chequia","time":"Praga - Chequia, 14:00","location":"Palack\xe9ho Square","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"Sud\xe1frica","time":"Rosendal - Sud\xe1frica, 11:00","location":"Oficinas del South African Police Service","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Tenerife","country":"Espa\xf1a","time":"San Andr\xe9s, Tenerife - Espa\xf1a, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"EE. UU.","time":"San Diego - EE. UU., 14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"EE. UU.","time":"San Francisco - EE. UU., 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Alemania","time":"Schwerin - Alemania, 19:00 - Proyecci\xf3n","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - Proyecci\xf3n","day":"schedule13"},"seattle":{"city":"Seattle","country":"EE. UU.","time":"Seattle - EE. UU., 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sveti Vlas","country":"Bulgaria","time":"Sveti Vlas - Bulgaria, TBC","location":"","cleanTime":"TBC","day":"scheduleTBC"},"sydney":{"city":"S\xeddney","country":"Australia","time":"S\xeddney - Australia, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallin","country":"Estonia","time":"Tallin - Estonia, 15:00 - Proyecci\xf3n y manifestaci\xf3n","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - Proyecci\xf3n y manifestaci\xf3n","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Espa\xf1a","time":"Tarragona - Espa\xf1a, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"La Haya","country":"Pa\xedses Bajos","time":"La Haya - Pa\xedses Bajos, 13:00 - 15:00","location":"Delante del Palacio de la Paz / CPI","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tiflis","country":"Georgia","time":"Tiflis - Georgia, 21:00","location":"Tiflis","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Suecia","time":"Tran\xe5s - Suecia, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Viena","country":"Austria","time":"Viena - Austria, 16:00 - 18:00","location":"Stock im Eisen Platz (junto a Stephansdom)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Washington D.C.","country":"EE. UU.","time":"Washington D.C. - EE. UU., 12:30 - 13:30","location":"La Casa Blanca","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Polonia","time":"Wroc\u0142aw - Polonia, 13:00","location":"Plaza de la Libertad (direcci\xf3n People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"\xa1Organiza! Para agregar tu ciudad, env\xeda un correo electr\xf3nico a:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Compartir en {{platform}}","website":"Sitio web","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, periodista y cineasta, lider\xf3 la manifestaci\xf3n mundial y dirigi\xf3 el documental Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Protecci\xf3n de civiles para las calles de Jers\xf3n \u2014 protegiendo a los civiles de los ataques de drones.","foodDesc":"Ayuda alimentaria.","foodNote":"Al donar, escribe \xabFood for Cherson\xbb como concepto."},"ahs":{"name":"Proyecto Anti Human Safari","desc":"Detectores de drones y chalecos protectores para voluntarios y servicios de emergencia en Jers\xf3n."},"pageTitle":"Para el Human Safari","sectionIntro":"Desde el verano de 2024, los militares rusos utilizan peque\xf1os drones para cazar, matar y aterrorizar a civiles en las calles de Jers\xf3n y otras ciudades de primera l\xednea en Ucrania.","sectionIntro2":"Es una campa\xf1a de asesinatos sistem\xe1tica y deliberada: los operadores de drones rusos publican abiertamente las im\xe1genes de sus v\xedctimas en canales de Telegram para presumir. En mayo de 2025, la ONU reconoci\xf3 el Human Safari como un crimen de guerra en curso.","sectionIntro3":"Se est\xe1 haciendo demasiado poco. El Human Safari debe detenerse.","sectionIntroBold":"T\xda puedes ayudar. As\xed es c\xf3mo","step2Title":"Organiza","step3Title":"Cu\xe9ntaselo a la gente","step3Para":"Usa los hashtags","step3ParaPost":"y cu\xe9ntaselo a los dem\xe1s","instagram":"Instagram","step2Bullet1":"una proyecci\xf3n de pel\xedcula","step2Bullet2":"una acci\xf3n p\xfablica","step2Bullet3":"cobertura medi\xe1tica","publicActionLead":"Pon el foco sobre el safari humano all\xed donde est\xe9s.","reachOutPre":"Puedes","reachOut":"ponerte en contacto","reachOutPost":"para pedir ideas y recursos","newsCoverageLead":"a trav\xe9s de tus contactos en los medios. H\xe1blales del safari humano y del riesgo para todas las zonas de conflicto actuales y futuras.","putInTouchPre":"Tambi\xe9n puedes","putInTouch":"ponernos en contacto directamente","inform":"Inf\xf3rmate","informSub":"a ti mismo y a los dem\xe1s","policyTitle":"Pol\xedtica","policyBody":"La propuesta Ley LORA (Ley de Responsabilidad de Operadores y Autoridades Responsables) establecer\xeda sanciones a lo largo de toda la cadena de responsabilidad: desde los operadores y comandantes rusos de drones FPV hasta el alto mando militar, as\xed como los fabricantes y proveedores que hacen posible la producci\xf3n y el despliegue de drones contra la poblaci\xf3n civil.","policyHelp":"\xbfPuedes ayudar a nivel pol\xedtico?","getInTouch":"Ponte en contacto","disdict":{"title":"Disinformation Dictionary","link":"Human Safari"},"donate":"Donar","donateIntro":"Estas son iniciativas que ofrecen ayuda espec\xedfica y de gran impacto para proteger directamente a los civiles de Jers\xf3n del Human Safari.","shareTitle":"Difunde el mensaje","filmScreening":"Organiza una proyecci\xf3n del documental Kherson Human Safari:","howItStarted":"C\xf3mo empez\xf3","kryla":{"name":"Kryla Foundation","desc":"Ap\xf3yalos para pagar alojamiento y suministros b\xe1sicos para los vecinos de Oleshky."}},"action":{"intro":"Empezamos con una manifestaci\xf3n mundial. Ahora puedes:","helpLink":"ayuda aqu\xed"},"accounts":{"heading":"Testimonios"},"media":{"close":"Cerrar","view":"Ver el contenido","previous":"Anterior","next":"Siguiente","andrushenkoCredit":"Oleksandr Andrushenko, fotocorresponsal del medio Vgoru","khersonPoliceCredit":"de @khersonpolice","antypenkoCredit":"Ivan Antypenko, fotoperiodista de Jers\xf3n","telegramChannelCredit":"publicado en el canal de Telegram ruso del Human Safari \xabde Mari\xfapol a los C\xe1rpatos\xbb","fruitSellerDescription":"Un vendedor de fruta perseguido por un dron de fibra \xf3ptica","burntCarDescription":"Coche calcinado en Jers\xf3n","bridgeAttackDescription":"Un adolescente asesinado por un dron FPV bajo un puente en Jers\xf3n","busAttackDescription":"Uno de los muchos ataques con drones FPV contra el transporte p\xfablico","fpvDroneDescription":"Dron FPV de caza durante el \xabHuman Safari\xbb","antiDroneNetsDescription":"Calle de Jers\xf3n cubierta con redes contra los drones del \xabHuman Safari\xbb","firefighterDescription":"Un bombero apaga un coche tras un ataque del \xabHuman Safari\xbb; detr\xe1s yace una v\xedctima"},"follow":{"title":"Sigue","subHumanSafari":"fuentes de calidad que informan desde Jers\xf3n y sobre el Human Safari","subDroneSiege":"fuentes de calidad que informan desde Jers\xf3n y sobre el asedio con drones","localPress":"prensa local en ucraniano","lang":{"english":"ingl\xe9s","german":"alem\xe1n","ukrainian":"ucraniano"},"language":"Idioma: {{list}}","languages":"Idiomas: {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"Periodista y cineasta estadounidense afincada en Jers\xf3n, colabora con Byline Times y Euromaidan Press; dirigi\xf3 el documental Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"Reportero jefe del diario alem\xe1n Die Welt; informa peri\xf3dicamente sobre el Human Safari en Jers\xf3n."},"kelley":{"name":"Brendan Kelley","desc":"Escribe Kherson Weekly, una cr\xf3nica continua de los ataques con drones rusos contra civiles en Jers\xf3n y las aldeas de alrededor."},"vgoru":{"name":"Vgoru","desc":"Plataforma informativa independiente de la regi\xf3n de Jers\xf3n; cuenta la vida bajo los ataques y bajo la ocupaci\xf3n."},"suspilne":{"name":"Suspilne Jers\xf3n","desc":"La redacci\xf3n de Jers\xf3n de la radiotelevisi\xf3n p\xfablica de Ucrania."},"most":{"name":"MOST","desc":"Agencia de noticias local de Jers\xf3n, cubre la ciudad y la regi\xf3n."}},"rallies":{"oleshky2026":{"heroStop":"DETENGAN EL ASEDIO CON DRONES","heroSave":"SALVEMOS OLESHKY","worldwideRally":"Acci\xf3n global","heroDate":"Octubre","infoText1":"Miles de civiles est\xe1n atrapados bajo un asedio con drones en Oleshky, Hola Prystan, Stara Zburivka y Nova Zburivka. Las fuerzas rusas los utilizan como escudos humanos, escondi\xe9ndose tras ellos para lanzar ataques de safari humano con drones contra la orilla opuesta.","infoText2":"La crisis es grave: faltan alimentos, agua, atenci\xf3n m\xe9dica, medicinas, electricidad, gas y comunicaciones. Las carreteras est\xe1n fuertemente minadas y los drones restringen cualquier movimiento. <bold>T\xda puedes ayudar. \xdanete a miles de personas en todo el mundo para exigir el fin del asedio con drones.</bold>","imageAlt":"Un perro fam\xe9lico entre huesos humanos en el Oleshky en ruinas, bajo un cielo rojo lleno de drones, con las palabras Stop Russian Drone Siege","demandsTitle":"Pedimos:","demand1":"corredores humanitarios seguros y eficaces hacia Oleshky y otras comunidades afectadas.","demand2":"ayuda humanitaria inmediata y asistencia para las v\xedctimas de los ataques de safari humano.","demand3":"sanciones adecuadas contra las personas y las cadenas de suministro responsables de ataques contra civiles.","demand4":"medidas para disuadir el uso de peque\xf1os drones para atacar y aterrorizar sistem\xe1ticamente a civiles en Jers\xf3n, Ucrania y otros lugares.","cities":{"edinburgh":{"city":"Edimburgo","country":"Reino Unido","time":"Edimburgo - Reino Unido, 14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"Reino Unido","time":"Birmingham - Reino Unido, 14:00 - 16:00","location":"Frente al Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Viena","country":"Austria","time":"Viena - Austria, 15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"M\xfanich","country":"Alemania","time":"M\xfanich - Alemania, 15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"M\xe1nchester","country":"Reino Unido","time":"M\xe1nchester - Reino Unido, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"S\xeddney","country":"Australia","time":"S\xeddney - Australia, 14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Par\xeds","country":"Francia","time":"Par\xeds - Francia, 15:30 - 18:30","location":"De la iglesia de San Volod\xedmir a la Place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Par\xeds","country":"Francia","time":"Par\xeds - Francia, 18:00","location":"Metro Rambuteau","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lyon","country":"Francia","time":"Lyon - Francia, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dubl\xedn","country":"Irlanda","time":"Dubl\xedn - Irlanda, 13:00","location":"The GPO (Oficina General de Correos)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Bruselas","country":"B\xe9lgica","time":"Bruselas - B\xe9lgica, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Bruselas (rotonda Schuman)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Canad\xe1","time":"Ottawa - Canad\xe1, 12:30 - 13:30","location":"Embajada de Rusia, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"Francia","time":"Nantes - Francia, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Gdansk","country":"Polonia","time":"Gdansk - Polonia, 18:30 - 19:30","location":"D\u0142ugi Targ, junto a la Fuente de Neptuno","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"EE. UU.","time":"Chicago - EE. UU., 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"EE. UU.","time":"Chicago - EE. UU., 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"EE. UU.","time":"Chicago - EE. UU., 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"EE. UU.","time":"Chicago - EE. UU., 13:00","location":"410 N. Michigan ave. (Wrigley Building)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Dresde","country":"Alemania","time":"Dresde - Alemania, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"M\xe1laga","country":"Espa\xf1a","time":"M\xe1laga - Espa\xf1a, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"Plovdiv","country":"Bulgaria","time":"Plovdiv - Bulgaria, 17:00","location":"Calle principal (Glavnata), junto a las escaleras Kamenitza / el letrero \xabTogether\xbb","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapest","country":"Hungr\xeda","time":"Budapest - Hungr\xeda, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (plaza de San Esteban)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Hamburgo","country":"Alemania","time":"Hamburgo - Alemania, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, a la altura del Puente 1, 20359 Hamburgo","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kiel","country":"Alemania","time":"Kiel - Alemania, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Noruega","time":"Oslo - Noruega","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Leipzig","country":"Alemania","time":"Leipzig - Alemania, 17:00 - 18:00","location":"Estaci\xf3n central (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"Londres","country":"Reino Unido","time":"Londres - Reino Unido, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dubl\xedn","country":"Irlanda","time":"Dubl\xedn - Irlanda, 13:00","location":"The GPO (Oficina General de Correos)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dubl\xedn","country":"Irlanda","time":"Dubl\xedn - Irlanda, 14:00","location":"The GPO (Oficina General de Correos)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"Francia","time":"Nantes - Francia, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Detengan el asedio ruso con drones","posterNoRoadOut":"Las v\xedas de entrada y salida de Oleshky est\xe1n bloqueadas","posterHumanitarianCatastrophe":"Oleshky. Una cat\xe1strofe humanitaria bajo la ocupaci\xf3n","seeGallery":"Ver / descargar carteles"},"artBy":"Arte: {{name}}","downloadPoster":"Descargar cartel","reel":{"download":"Descargar v\xeddeo (MP4)"},"addDemo":{"title":"a\xf1ade tu manifestaci\xf3n","where":"d\xf3nde: ciudad/pueblo","contact":"correo/n\xfamero","message":"mensaje: a qui\xe9n representas, tu manifestaci\xf3n est\xe1 confirmada o en preparaci\xf3n, enlace al anuncio en l\xednea, otros detalles","submit":"Enviar","sending":"Enviando\u2026","thanks":"\xa1Gracias! Nos pondremos en contacto.","error":"Algo sali\xf3 mal. Int\xe9ntalo de nuevo.","contactInvalid":"Introduce un correo v\xe1lido o un n\xfamero de tel\xe9fono con prefijo internacional (p. ej. +34 612 345 678).","date":"fecha","time":"hora de inicio (local)","whereInvalid":"Introduce el nombre de una ciudad o pueblo, p. ej. Madrid o Kyiv, Ucrania.","datePlaceholder":"fecha: dd/mm"}},"seo":{"oleshky":{"title":"Detengan el asedio con drones \u2014 Salvemos Oleshky","description":"Drones rusos asedian a miles de civiles en Oleshky, Ucrania ocupada, sin comida, agua ni medicinas. Encuentra una manifestaci\xf3n cerca de ti y exige un paso seguro."},"leftBank":{"title":"Asedio con drones de Oleshky y la regi\xf3n ocupada de Jers\xf3n","description":"Miles de civiles est\xe1n atrapados bajo un asedio ruso con drones en Oleshky, Hola Prystan y pueblos cercanos ocupados. Descubre qu\xe9 ocurre y c\xf3mo puedes ayudar."},"help":{"title":"Detengan el Human Safari \u2014 Drones rusos cazan civiles en Jers\xf3n","description":"Drones rusos cazan civiles en Jers\xf3n, Ucrania. Inf\xf3rmate sobre el crimen de guerra Human Safari y c\xf3mo puedes ayudar a detenerlo."},"action":{"title":"Concentraci\xf3n mundial de diciembre de 2025 \u2014 Detengan el Human Safari","description":"Fotos, carteles y lugares de la concentraci\xf3n mundial de diciembre de 2025 contra los ataques rusos con drones a civiles en Jers\xf3n, Ucrania."},"rallies":{"title":"Fotos de las concentraciones \u2014 Detengan el Human Safari","description":"Fotos de concentraciones en todo el mundo contra los ataques rusos con drones a civiles en Jers\xf3n, Ucrania."},"resources":{"title":"Recursos sobre el Human Safari \u2014 Informes, art\xedculos y testimonios","description":"Informes, art\xedculos, entrevistas y testimonios sobre los ataques rusos con drones a civiles en Jers\xf3n, Ucrania."},"reel":{"title":"Salvemos Oleshky \u2014 V\xeddeo de las manifestaciones","description":"V\xeddeo de las manifestaciones mundiales \xabSalvemos Oleshky\xbb, octubre de 2026."}}}');


var $5092669ac35197c4$exports = {};
$5092669ac35197c4$exports = JSON.parse('{"home":{"heroStop":"\u505C\u6B62\u4EBA\u7C7B\u72E9\u730E","heroSave":"\u62EF\u6551\u8D6B\u5C14\u677E","heroTitle1":"\u4EBA\u7C7B","heroTitle2":"\u4E0D\u662F\u730E\u7269","heroDate":"12\u670813\u65E5\u300114\u65E5","worldwideRally":"\u5168\u7403\u96C6\u4F1A","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"\u81EA2024\u5E74\u590F\u5929\u4EE5\u6765\uFF0C\u4FC4\u7F57\u65AF\u519B\u961F\u4F7F\u7528\u5C0F\u578B\u65E0\u4EBA\u673A\u5728\u8D6B\u5C14\u677E\u53CA\u4E4C\u514B\u5170\u5176\u4ED6\u524D\u7EBF\u57CE\u5E02\u7684\u8857\u9053\u4E0A\u8FFD\u730E\u3001\u6740\u5BB3\u5E76\u6050\u5413\u5E73\u6C11\u3002<bold>\u4EBA\u7C7B\u72E9\u730E\u5FC5\u987B\u505C\u6B62\u3002\u4F60\u53EF\u4EE5\u63D0\u4F9B\u5E2E\u52A9\u3002</bold>\u52A0\u5165\u5168\u7403\u6570\u5343\u4EBA\uFF0C\u5171\u540C\u8981\u6C42\u505C\u6B62\u8FD9\u4E00\u6218\u4E89\u7F6A\u884C\u3002","seeGallery":"\u67E5\u770B\u5168\u7403\u6D77\u62A5","comingSoon":"\u66F4\u591A\u5730\u70B9\u5373\u5C06\u516C\u5E03","december":"\u5341\u4E8C\u6708","dec":"12\u6708","october":"\u5341\u6708","oct":"10\u6708","september":"\u4E5D\u6708","sep":"9\u6708","schedule9":"9\u65E5","schedule10":"10\u65E5","schedule11":"11\u65E5","schedule12":"12\u65E5","schedule13":"13\u65E5","schedule14":"14\u65E5","schedule16":"16\u65E5","schedule18":"18\u65E5","schedule20":"20\u65E5","schedule1":"1\u65E5","schedule2":"2\u65E5","schedule3":"3\u65E5","schedule4":"4\u65E5","schedule5":"5\u65E5","schedule25":"25\u65E5","schedule26":"26\u65E5","schedule27":"27\u65E5","schedule28":"28\u65E5","schedule29":"29\u65E5","schedule30":"30\u65E5","schedule31":"31\u65E5","scheduleTBC":"\u65E5\u671F\u786E\u8BA4\u4E2D\u2026\u2026","recommendationsTitle":"\u8054\u5408\u56FD\u59D4\u5458\u4F1A\u7684\u5EFA\u8BAE","recommendationsRussia":"\u59D4\u5458\u4F1A\u5EFA\u8BAE\u4FC4\u7F57\u65AF\u8054\u90A6\uFF1A","rusRec1":"(a) \u7ACB\u5373\u505C\u6B62\u9488\u5BF9\u5E73\u6C11\u548C\u6C11\u7528\u8BBE\u65BD\u7684\u65E0\u4EBA\u673A\u88AD\u51FB","rusRec2":"(b) \u7ACB\u5373\u505C\u6B62\u4E00\u5207\u5728\u5E73\u6C11\u4E2D\u6563\u5E03\u6050\u6016\u7684\u884C\u4E3A","rusRec3":"(c) \u786E\u4FDD\u6240\u6709\u53C2\u4E0E\u9488\u5BF9\u5E73\u6C11\u7684\u65E0\u4EBA\u673A\u88AD\u51FB\u7684\u8087\u4E8B\u8005\u627F\u62C5\u8D23\u4EFB","recommendationsUNStates":"\u59D4\u5458\u4F1A\u5EFA\u8BAE\u5176\u4ED6\u56FD\u5BB6\u4EE5\u53CA\u533A\u57DF\u548C\u56FD\u9645\u7EC4\u7EC7\uFF1A","statesRec1":"(a) \u5728\u8D22\u653F\u4E0A\u5E76\u4EE5\u6280\u672F\u54A8\u8BE2\u7684\u65B9\u5F0F\uFF0C\u5411\u4E4C\u514B\u5170\u653F\u5E9C\u53CA\u6C11\u95F4\u793E\u4F1A\u7EC4\u7EC7\u63D0\u4F9B\u652F\u6301\uFF0C\u4EE5\u4FBF\u4E3A\u53D7\u5BB3\u8005\u53CA\u5176\u5BB6\u5C5E\u63D0\u4F9B\u5168\u9762\u63F4\u52A9\uFF1B","statesRec2":"(b) \u5BF9\u4E8E\u5176\u9886\u571F\u4E3A\u4ECE\u5360\u9886\u533A\u88AB\u9A71\u9010\u8005\u76EE\u7684\u5730\u7684\u7B2C\u4E09\u56FD\uFF0C\u5E94\u4E0E\u4E4C\u514B\u5170\u9886\u4E8B\u90E8\u95E8\u4E00\u9053\uFF0C\u91C7\u53D6\u5FC5\u8981\u52AA\u529B\u4EE5\u652F\u6301\u8FD9\u4E9B\u4EBA\u5458\u3002","reference":"\u53C2\u8003\u8D44\u6599","linkUN":"\u8054\u5408\u56FD\u59D4\u5458\u4F1A\uFF1A\u4FC4\u7F57\u65AF\u5728\u4E4C\u514B\u5170\u7684\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u662F\u5371\u5BB3\u4EBA\u7C7B\u7F6A","linkGuidelines":"\u8054\u5408\u56FD\u51C6\u5219","linkWiki":"\u7EF4\u57FA\u767E\u79D1"},"witnesses":{"title":" \u6211\u4EEC\u6B63\u5728\u6536\u96C6\u76EE\u51FB\u8005\u8BC1\u8BCD\uFF01","email":"\u5982\u679C\u60A8\u6765\u81EA\u8D6B\u5C14\u677E\u3001\u5C3C\u79D1\u6CE2\u5C14\u3001\u624E\u6CE2\u7F57\u70ED\u3001\u82CF\u6885\u6216\u987F\u5DF4\u65AF\u524D\u7EBF\u5730\u533A\uFF0C\u5E76\u66FE\u4EB2\u773C\u76EE\u7779\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\uFF0C\u8BF7\u5C06\u60A8\u7684\u7ECF\u5386\u53D1\u9001\u81F3 \uD83D\uDCE7 <mail>khersonhumansafari@gmail.com</mail>\uFF0C\u4E3B\u9898\u5199\u201Chuman safari\u201D\u3002","type":" \u5982\u679C\u60A8\u76EE\u7779\u4E86\u670B\u53CB\u6216\u90BB\u5C45\u5728\u65E0\u4EBA\u673A\u88AD\u51FB\u4E2D\u4E27\u751F\u5E76\u5E0C\u671B\u5206\u4EAB\u60A8\u7684\u53D9\u8FF0\uFF0C\u8BF7\u6CE8\u660E\u201C\u76EE\u51FB\u8005\u201D\uFF1B\u5982\u679C\u60A8\u672C\u4EBA\u906D\u5230\u88AD\u51FB\uFF0C\u8BF7\u6CE8\u660E\u201C\u5E78\u5B58\u8005\u201D\u3002","requirements":"<b>\u6211\u4EEC\u9700\u8981\u7684\u4FE1\u606F\uFF1A</b>\u57CE\u5E02/\u5730\u70B9\u3001\u88AD\u51FB\u65E5\u671F\u3001\u7B80\u77ED\u53D9\u8FF0\uFF083\u20136\u53E5\uFF1B\u771F\u5B9E\u3001\u7B2C\u4E00\u4EBA\u79F0\uFF09\u3002","honesty":"\u8BF7\u8BDA\u5B9E\u3001\u7B80\u6D01\uFF0C\u907F\u514D\u63D0\u53CA\u654F\u611F\u7684\u519B\u4E8B\u4F4D\u7F6E\u2014\u2014\u60A8\u53EF\u4EE5\u4FDD\u6301\u533F\u540D\u3002","media":"<b>\u6709\u7167\u7247/\u89C6\u9891\uFF1F</b>\u8BF7\u5199\u201C\u6709\u7167\u7247/\u89C6\u9891\u201D\u3002\u8BF7\u52FF\u9644\u52A0\u6587\u4EF6\u2014\u2014\u5982\u9700\u89C6\u89C9\u6750\u6599\uFF0C\u6211\u4EEC\u4F1A\u4E0E\u60A8\u8054\u7CFB\u3002","consent":"<b>\u53D1\u5E03\u540C\u610F\uFF1A</b>\u201C\u6211\u540C\u610F\u5C06\u6B64\u6545\u4E8B\u516C\u5F00\u53D1\u5E03\u5728 HumanSafari.org \u7F51\u7AD9\u4E0A\u3002\u201D"},"resources":{"title":"\u91CD\u8981\u8D44\u6E90","linkLibraryTitle":"\u94FE\u63A5\u5E93","linkLibraryDesc":"200\u7BC7\u6587\u7AE0\u3001\u62A5\u544A\u3001\u91C7\u8BBF\u3001\u7B2C\u4E00\u624B\u8BC1\u8BCD\u53CA\u5A92\u4F53\u62A5\u9053","humanSafariMapTitle":"Tochnyi \u4EBA\u7C7B\u72E9\u730E\u5730\u56FE","humanSafariMapDesc":"\u4E00\u5F20\u8BB0\u5F55\u8D6B\u5C14\u677E\u4EBA\u7C7B\u72E9\u730E\u88AD\u51FB\u7684\u4EA4\u4E92\u5F0F\u5730\u56FE\uFF0C\u6570\u636E\u6765\u81EA\u5730\u65B9\u5F53\u5C40\u7684\u516C\u5F00\u62A5\u544A\uFF0C\u4EE5\u53CA\u7531 Tochnyi \u56E2\u961F\u5B8C\u6210\u5730\u7406\u5B9A\u4F4D\u7684\u88AD\u51FB\u5F71\u50CF\u3002","truthHoundsTitle":"Truth Hounds \u62A5\u544A","truthHoundsDesc":"\u6740\u622E\u533A\uFF1A\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u5982\u4F55\u6467\u6B8B\u7B2C\u8042\u4F2F\u6CB3\u53F3\u5CB8","hrwTitle":"\u4EBA\u6743\u89C2\u5BDF\u5173\u4E8E\u8D6B\u5C14\u677E\u65E0\u4EBA\u673A\u88AD\u51FB\u7684\u62A5\u544A","hrwDesc":"\u4EBA\u6743\u89C2\u5BDF\u62A5\u544A","unReportsTitle":"\u8054\u5408\u56FD\u4EBA\u6743\u7406\u4E8B\u4F1A\u62A5\u544A","report1":"\u8054\u5408\u56FD\u62A5\u544A #1","report3":"\u8054\u5408\u56FD\u62A5\u544A #3","guidelines":"\u8054\u5408\u56FD\u51C6\u5219","wikipediaTitle":"\u7EF4\u57FA\u767E\u79D1","english":"\u82F1\u6587","french":"\u6CD5\u6587","documentaryTitle":"\u7EAA\u5F55\u7247","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"12\u670813\u65E5\u201314\u65E5","eyewitnesses":"\u8BC1\u8BCD","rallies":"\u7167\u7247","help":"\u5DF2\u6536\u590D\u7684\u8D6B\u5C14\u677E","leftBank":"\u88AB\u5360\u9886\u7684\u8D6B\u5C14\u677E","action":"2025\u5E7412\u6708","oleshky":"\u5168\u7403\u96C6\u4F1A - \u5965\u5217\u4EC0\u57FA","menu":"\u83DC\u5355"},"leftBank":{"pageTitle":"\u65E0\u4EBA\u673A\u56F4\u56F0","para1":"\u4E25\u91CD\u7684\u4EBA\u9053\u4E3B\u4E49\u7D27\u6025\u72B6\u51B5\u6B63\u5F71\u54CD\u77406000\u540D\u5E73\u6C11\u2014\u2014\u4ED6\u4EEC\u88AB\u56F0\u4E8E\u906D\u5360\u9886\u7684\u5965\u5217\u4EC0\u57FA\u3001\u970D\u62C9\u666E\u91CC\u65AF\u5766\u3001\u65E7\u5179\u5E03\u91CC\u592B\u5361\u548C\u65B0\u5179\u5E03\u91CC\u592B\u5361\uFF08\u88AB\u5360\u9886\u7684\u8D6B\u5C14\u677E\u5DDE\uFF09\uFF0C\u5904\u4E8E\u65E0\u4EBA\u673A\u56F4\u56F0\u4E4B\u4E0B\u3002\u5965\u5217\u4EC0\u57FA\u67091200\u81F32000\u4EBA\u3002\u5360\u9886\u5F53\u5C40\u6709\u4E49\u52A1\u4E3A\u4ED6\u4EEC\u63D0\u4F9B\u652F\u63F4\u2014\u2014\u7136\u800C\u4FC4\u7F57\u65AF\u519B\u961F\u5374\u5C06\u4ED6\u4EEC\u7528\u4F5C\u4EBA\u4F53\u76FE\u724C\uFF0C\u8EB2\u5728\u8FD9\u4E9B\u5C45\u6C11\u8EAB\u540E\uFF0C\u5411\u5BF9\u5CB8\u53D1\u52A8\u4EBA\u7C7B\u72E9\u730E\u88AD\u51FB\u3002\u4E4C\u514B\u5170\u5F53\u5C40\u548C\u4EBA\u9053\u4E3B\u4E49\u673A\u6784\u62A5\u544A\u79F0\uFF0C\u64A4\u79BB\u548C\u4EBA\u9053\u4E3B\u4E49\u51C6\u5165\u53D7\u5230\u7CFB\u7EDF\u6027\u963B\u6320\u3002","para2":"\u5E73\u6C11\u7F3A\u4E4F\u98DF\u7269\u3001\u996E\u7528\u6C34\u3001\u533B\u7597\u3001\u836F\u54C1\u3001\u7535\u529B\u3001\u71C3\u6C14\u548C\u901A\u4FE1\u3002\u9053\u8DEF\u5E03\u6EE1\u5730\u96F7\uFF0C\u65E0\u4EBA\u673A\u6D3B\u52A8\u9650\u5236\u4E86\u4EBA\u5458\u6D41\u52A8\u3002\u81EA5\u670826\u65E5\u4EE5\u6765\uFF0C\u6CA1\u6709\u4EFB\u4F55\u8F66\u8F86\u80FD\u591F\u8FDB\u51FA\u3002\u71C3\u6599\u548C\u98DF\u7269\u50A8\u5907\u51E0\u8FD1\u8017\u5C3D\u3002","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"\u89C6\u9891\uFF1A\u300AKherson and Oleshky: Witnessing Genocide\u300B\uFF0812\u5206\u949F\uFF09","meidasArticle":"\u6587\u7AE0\uFF1A\u300AThe Kherson Region: How Russia Uses Civilians as a Tool of War\u300B\uFF08\u9605\u8BFB\u7EA65\u5206\u949F\uFF09","kyivPostTitle":"Kyiv Post","kyivPostArticle":"\u6587\u7AE0\uFF1A\u300AGlobal Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate\u300B\uFF08\u9605\u8BFB\u7EA67\u5206\u949F\uFF09","tellPost":"\u5E76\u5411\u4ED6\u4EBA\u8BB2\u8FF0\u65E0\u4EBA\u673A\u56F4\u56F0","callToHelp":"\u60A8\u53EF\u4EE5\u63D0\u4F9B\u5E2E\u52A9\u3002\u65B9\u6CD5\u5982\u4E0B","donateIntro":"\u8FD9\u4E9B\u5021\u8BAE\u63D0\u4F9B\u9AD8\u6548\u3001\u6709\u9488\u5BF9\u6027\u7684\u76F4\u63A5\u5E2E\u52A9\uFF0C\u63F4\u52A9\u5DF2\u9003\u79BB\u5965\u5217\u4EC0\u57FA\u7684\u4EBA\uFF0C\u4EE5\u53CA\u5728\u53EF\u80FD\u7684\u60C5\u51B5\u4E0B\u4ECD\u88AB\u56F0\u5728\u90A3\u91CC\u7684\u4EBA\u3002","signTitle":"\u7B7E\u7F72","signSub":"\u8BF7\u613F\u4E66","petitionBy":"\u53D1\u8D77\u65B9\uFF1A{{name}}","petitions":{"euParliament":"\u6B27\u6D32\u8BAE\u4F1A\u2014\u2014\u7B2C1439/2026\u53F7\u8BF7\u613F\uFF1A\u8981\u6C42\u4E3A\u88AB\u56F0\u4E8E\u4FC4\u7F57\u65AF\u5360\u9886\u4E0B\u7684\u4E4C\u514B\u5170\u5965\u5217\u4EC0\u57FA\u3001\u5904\u4E8E\u56F4\u56F0\u4E2D\u7684\u5E73\u6C11\u5F00\u8F9F\u4EBA\u9053\u4E3B\u4E49\u64A4\u79BB\u901A\u9053","ukParliament":"\u82F1\u56FD\u8BAE\u4F1A\u2014\u2014\u5BFB\u6C42\u5F00\u8F9F\u7531\u82F1\u56FD\u4E3B\u5BFC\u7684\u901A\u5F80\u4E4C\u514B\u5170\u5965\u5217\u4EC0\u57FA\u7684\u4EBA\u9053\u4E3B\u4E49\u63F4\u52A9\u901A\u9053"},"publicActionLead":"\u5728\u4F60\u6240\u5728\u4E4B\u5904\u8BA9\u65E0\u4EBA\u673A\u56F4\u56F0\u53D7\u5230\u5173\u6CE8\u3002","organiseAction":"\u7EC4\u7EC7\u4E00\u6B21\u884C\u52A8\u3002","policyBody":"\u4E4C\u514B\u5170\u5F53\u5C40\u6B63\u4E0E\u7EA2\u5341\u5B57\u56FD\u9645\u59D4\u5458\u4F1A\u78CB\u5546\uFF0C\u5546\u8BA8\u4ECE\u8D6B\u5C14\u677E\u5730\u533A\u88AB\u5360\u5B9A\u5C45\u70B9\u5F00\u8F9F\u4EBA\u9053\u4E3B\u4E49\u64A4\u79BB\u8D70\u5ECA\uFF0C\u5E76\u786E\u4FDD\u98DF\u7269\u3001\u996E\u7528\u6C34\u3001\u836F\u54C1\u3001\u71C3\u6599\u548C\u533B\u7597\u63F4\u52A9\u7684\u4EBA\u9053\u4E3B\u4E49\u51C6\u5165\u3002\u622A\u81F36\u6708\u521D\uFF0C\u5C1A\u65E0\u6B63\u5E38\u8FD0\u4F5C\u7684\u64A4\u79BB\u8D70\u5ECA\u6216\u6301\u7EED\u7684\u4EBA\u9053\u4E3B\u4E49\u51C6\u5165\u673A\u5236\u3002","documentaryTitle":"\u5965\u5217\u4EC0\u57FA\uFF0C\u7EAA\u5F55\u77ED\u7247","downloadTitle":"\u4E0B\u8F7D","downloadSub":"\u56FE\u7247"},"footer":{"addCityText":"\u5982\u9700\u6DFB\u52A0\u60A8\u7684\u57CE\u5E02\uFF0C\u8BF7\u53D1\u9001\u7535\u5B50\u90AE\u4EF6\u81F3\uFF1A","organiseText":"\u6DFB\u52A0\u60A8\u7684\u793A\u5A01\u6D3B\u52A8 - \u8BF7\u8054\u7CFB\u6211\u4EEC\uFF1A","contact":"\u8054\u7CFB\u65B9\u5F0F\uFF1A"},"byCountry":"\u6309\u56FD\u5BB6\u67E5\u770B","byDate":"\u6309\u65E5\u671F\u67E5\u770B","countries":{"australia":"\u6FB3\u5927\u5229\u4E9A","austria":"\u5965\u5730\u5229","bulgaria":"\u4FDD\u52A0\u5229\u4E9A","canada":"\u52A0\u62FF\u5927","czechia":"\u6377\u514B","denmark":"\u4E39\u9EA6","estonia":"\u7231\u6C99\u5C3C\u4E9A","finland":"\u82AC\u5170","france":"\u6CD5\u56FD","georgia":"\u683C\u9C81\u5409\u4E9A","germany":"\u5FB7\u56FD","hungary":"\u5308\u7259\u5229","italy":"\u610F\u5927\u5229","japan":"\u65E5\u672C","mexico":"\u58A8\u897F\u54E5","netherlands":"\u8377\u5170","norway":"\u632A\u5A01","poland":"\u6CE2\u5170","romania":"\u7F57\u9A6C\u5C3C\u4E9A","spain":"\u897F\u73ED\u7259","sweden":"\u745E\u5178","southAfrica":"\u5357\u975E","ukraine":"\u4E4C\u514B\u5170","unitedKingdom":"\u82F1\u56FD","usa":"\u7F8E\u56FD","ireland":"\u7231\u5C14\u5170","belgium":"\u6BD4\u5229\u65F6"},"cities":{"alicante":{"city":"\u963F\u5229\u574E\u7279","country":"\u897F\u73ED\u7259","time":"\u963F\u5229\u574E\u7279 - \u897F\u73ED\u7259\uFF0C16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"\u5DF4\u585E\u7F57\u90A3","country":"\u897F\u73ED\u7259","time":"\u5DF4\u585E\u7F57\u90A3 - \u897F\u73ED\u7259\uFF0C12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"\u4F2F\u514B\u5229","country":"\u7F8E\u56FD","time":"\u4F2F\u514B\u5229 - \u7F8E\u56FD\uFF0C12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"\u67CF\u6797","country":"\u5FB7\u56FD","time":"\u67CF\u6797 - \u5FB7\u56FD\uFF0C12:00","location":"Tempelhofer Feld, entry Leinstr./corner of Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"\u8D1D\u6ED5\u591A\u592B","country":"\u7F8E\u56FD","time":"\u8D1D\u6ED5\u591A\u592B - \u7F8E\u56FD\uFF0C17:30 - \u7535\u5F71\u653E\u6620","location":"Bettendorf Public Library","cleanTime":"17:30 - \u7535\u5F71\u653E\u6620","day":"schedule11"},"birmingham":{"city":"\u4F2F\u660E\u7FF0","country":"\u82F1\u56FD","time":"\u4F2F\u660E\u7FF0 - \u82F1\u56FD\uFF0C14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"\u6CE2\u6069","country":"\u5FB7\u56FD","time":"\u6CE2\u6069 - \u5FB7\u56FD\uFF0C14:00 - 16:00","location":"Poststra\xdfe, in front of the Hauptbahnhof","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"\u4E0D\u6765\u6885","country":"\u5FB7\u56FD","time":"\u4E0D\u6765\u6885 - \u5FB7\u56FD\uFF0C15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"\u5E03\u8FBE\u4F69\u65AF","country":"\u5308\u7259\u5229","time":"\u5E03\u8FBE\u4F69\u65AF - \u5308\u7259\u5229\uFF0C\u5F85\u5B9A","location":"","cleanTime":"\u5F85\u5B9A","day":"scheduleTBC"},"chicago":{"city":"\u829D\u52A0\u54E5","country":"\u7F8E\u56FD","time":"\u829D\u52A0\u54E5 - \u7F8E\u56FD\uFF0C13:00 - 15:00","location":"410 N. Michigan ave. (Wrigley building)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"\u5EB7\u65AF\u5766\u5BDF","country":"\u7F57\u9A6C\u5C3C\u4E9A","time":"\u5EB7\u65AF\u5766\u5BDF - \u7F57\u9A6C\u5C3C\u4E9A\uFF0C\u5F85\u5B9A","location":"","cleanTime":"\u5F85\u5B9A","day":"scheduleTBC"},"copenhagen":{"city":"\u54E5\u672C\u54C8\u6839","country":"\u4E39\u9EA6","time":"\u54E5\u672C\u54C8\u6839 - \u4E39\u9EA6\uFF0C14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"\u8FBE\u62C9\u65AF","country":"\u7F8E\u56FD","time":"\u8FBE\u62C9\u65AF - \u7F8E\u56FD\uFF0C12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"\u4E39\u4F5B","country":"\u7F8E\u56FD","time":"\u4E39\u4F5B - \u7F8E\u56FD\uFF0C12:00","location":"Colorado Capitol Building, West Steps","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"\u7231\u4E01\u5821","country":"\u82F1\u56FD","time":"\u7231\u4E01\u5821 - \u82F1\u56FD\uFF0C13:00 - 15:00","location":"Duke of Wellington Monument","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"\u6C83\u65AF\u5821","country":"\u7F8E\u56FD","time":"\u6C83\u65AF\u5821 - \u7F8E\u56FD\uFF0C14:00 - 15:00","location":"Tarrant County Courthouse","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"\u6C49\u5821","country":"\u5FB7\u56FD","time":"\u6C49\u5821 - \u5FB7\u56FD\uFF0C14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"\u970D\u987F\uFF08\u5BC6\u6B47\u6839\u5DDE\uFF09","country":"\u7F8E\u56FD","time":"\u970D\u987F\uFF08\u5BC6\u6B47\u6839\u5DDE\uFF09 - \u7F8E\u56FD\uFF0C15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"\u8D6B\u5C14\u8F9B\u57FA","country":"\u82AC\u5170","time":"\u8D6B\u5C14\u8F9B\u57FA - \u82AC\u5170\uFF0C17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"\u51FA\u4E91","country":"\u65E5\u672C","time":"\u51FA\u4E91 - \u65E5\u672C\uFF0C13:00","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"\u51FA\u4E91","country":"\u65E5\u672C","time":"\u51FA\u4E91 - \u65E5\u672C","location":"Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"\u574E\u5362\u666E\u65AF\uFF08\u4E0D\u5217\u98A0\u54E5\u4F26\u6BD4\u4E9A\u7701\uFF09","country":"\u52A0\u62FF\u5927","time":"\u574E\u5362\u666E\u65AF\uFF08\u4E0D\u5217\u98A0\u54E5\u4F26\u6BD4\u4E9A\u7701\uFF09 - \u52A0\u62FF\u5927\uFF0C15:00 - 16:00","location":"City Hall","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"\u57FA\u8F85","country":"\u4E4C\u514B\u5170","time":"\u57FA\u8F85 - \u4E4C\u514B\u5170\uFF0C17:00 - 18:00","location":"Maidan Nezalezhnosti","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"\u83B1\u6BD4\u9521","country":"\u5FB7\u56FD","time":"\u83B1\u6BD4\u9521 - \u5FB7\u56FD\uFF0C12:00 - 13:00","location":"Willy Brandt Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C18:30 - \u7535\u5F71\u653E\u6620","location":"Ukrainian House, 154 Holland Park Avenue","cleanTime":"18:30 - \u7535\u5F71\u653E\u6620","day":"schedule12"},"losAngeles":{"city":"\u6D1B\u6749\u77F6","country":"\u7F8E\u56FD","time":"\u6D1B\u6749\u77F6 - \u7F8E\u56FD\uFF0C15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"\u9A6C\u62C9\u52A0","country":"\u897F\u73ED\u7259","time":"\u9A6C\u62C9\u52A0 - \u897F\u73ED\u7259\uFF0C18:00 - \u7535\u5F71\u653E\u6620","location":"Maydan - Centro Historico Cultural Ukraniano","cleanTime":"18:00 - \u7535\u5F71\u653E\u6620","day":"schedule13"},"manchester":{"city":"\u66FC\u5F7B\u65AF\u7279","country":"\u82F1\u56FD","time":"\u66FC\u5F7B\u65AF\u7279 - \u82F1\u56FD\uFF0C14:00 - 15:30","location":"St Peter\'s Square Emmeline Pankhurst Memorial","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"\u58A8\u897F\u54E5\u57CE","country":"\u58A8\u897F\u54E5","time":"\u58A8\u897F\u54E5\u57CE - \u58A8\u897F\u54E5\uFF0C11:00","location":"Alameda Central. \\"Americas\\" fountain (between Hemiciclo Ju\xe1rez and Kiosk)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"\u7C73\u5170","country":"\u610F\u5927\u5229","time":"\u7C73\u5170 - \u610F\u5927\u5229\uFF0C15:00","location":"The Duomo di Milano","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"\u6155\u5C3C\u9ED1","country":"\u5FB7\u56FD","time":"\u6155\u5C3C\u9ED1 - \u5FB7\u56FD\uFF0C17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"\u7EBD\u7EA6","country":"\u7F8E\u56FD","time":"\u7EBD\u7EA6 - \u7F8E\u56FD\uFF0C16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"\u7EBD\u7EA6","country":"\u7F8E\u56FD","time":"\u7EBD\u7EA6 - \u7F8E\u56FD\uFF0C13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"\u5C3C\u6069\u5821\uFF08\u5A01\u6089\u6CB3\uFF09","country":"\u5FB7\u56FD","time":"\u5C3C\u6069\u5821\uFF08\u5A01\u6089\u6CB3\uFF09 - \u5FB7\u56FD\uFF0C17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"\u5965\u65AF\u9646","country":"\u632A\u5A01","time":"\u5965\u65AF\u9646 - \u632A\u5A01\uFF0C12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\u5384\u65AF\u7279\u677E\u5FB7","country":"\u745E\u5178","time":"\u5384\u65AF\u7279\u677E\u5FB7 - \u745E\u5178\uFF0C11:00 - 14:00","location":"Stortorget\uFF08\u4E3B\u5E7F\u573A\uFF09","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"\u6E25\u592A\u534E","country":"\u52A0\u62FF\u5927","time":"\u6E25\u592A\u534E - \u52A0\u62FF\u5927\uFF0C12:30 - 13:30","location":"russian Embassy","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"\u6E25\u592A\u534E","country":"\u52A0\u62FF\u5927","time":"\u6E25\u592A\u534E - \u52A0\u62FF\u5927\uFF0C12:00","location":"US Embassy","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"\u5DF4\u9ECE","country":"\u6CD5\u56FD","time":"\u5DF4\u9ECE - \u6CD5\u56FD\uFF0C15:30","location":"Square Taras Chevchenko -> Fontaine Saint-Michel (march)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"\u666E\u7F57\u592B\u8FEA\u592B","country":"\u4FDD\u52A0\u5229\u4E9A","time":"\u666E\u7F57\u592B\u8FEA\u592B - \u4FDD\u52A0\u5229\u4E9A\uFF0C16:00 - 17:00","location":"by the Levski House","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"\u5E03\u62C9\u683C","country":"\u6377\u514B","time":"\u5E03\u62C9\u683C - \u6377\u514B\uFF0C14:00","location":"Palack\xe9ho Square","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"\u7F57\u68EE\u8FBE\u5C14","country":"\u5357\u975E","time":"\u7F57\u68EE\u8FBE\u5C14 - \u5357\u975E\uFF0C11:00","location":"South African Police Service offices","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"\u5723\u5B89\u5FB7\u70C8\u65AF\uFF08\u7279\u5185\u91CC\u8D39\uFF09","country":"\u897F\u73ED\u7259","time":"\u5723\u5B89\u5FB7\u70C8\u65AF\uFF08\u7279\u5185\u91CC\u8D39\uFF09 - \u897F\u73ED\u7259\uFF0C13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"\u5723\u5730\u4E9A\u54E5","country":"\u7F8E\u56FD","time":"\u5723\u5730\u4E9A\u54E5 - \u7F8E\u56FD\uFF0C14:00 - 16:00","location":"El Cid Statue, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"\u65E7\u91D1\u5C71","country":"\u7F8E\u56FD","time":"\u65E7\u91D1\u5C71 - \u7F8E\u56FD\uFF0C14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"\u4EC0\u672A\u6797","country":"\u5FB7\u56FD","time":"\u4EC0\u672A\u6797 - \u5FB7\u56FD\uFF0C19:00 - \u7535\u5F71\u653E\u6620","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - \u7535\u5F71\u653E\u6620","day":"schedule13"},"seattle":{"city":"\u897F\u96C5\u56FE","country":"\u7F8E\u56FD","time":"\u897F\u96C5\u56FE - \u7F8E\u56FD\uFF0C12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"\u5723\u5F17\u62C9\u65AF","country":"\u4FDD\u52A0\u5229\u4E9A","time":"\u5723\u5F17\u62C9\u65AF - \u4FDD\u52A0\u5229\u4E9A\uFF0C\u5F85\u5B9A","location":"","cleanTime":"\u5F85\u5B9A","day":"scheduleTBC"},"sydney":{"city":"\u6089\u5C3C","country":"\u6FB3\u5927\u5229\u4E9A","time":"\u6089\u5C3C - \u6FB3\u5927\u5229\u4E9A\uFF0C14:00","location":"Sydney Town Hall","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"\u5854\u6797","country":"\u7231\u6C99\u5C3C\u4E9A","time":"\u5854\u6797 - \u7231\u6C99\u5C3C\u4E9A\uFF0C15:00 - \u7535\u5F71\u653E\u6620\u53CA\u96C6\u4F1A","location":"S\xf5prus Cinema, Vana-Posti tn.8","cleanTime":"15:00 - \u7535\u5F71\u653E\u6620\u53CA\u96C6\u4F1A","day":"schedule13"},"tarragona":{"city":"\u5854\u62C9\u6208\u7EB3","country":"\u897F\u73ED\u7259","time":"\u5854\u62C9\u6208\u7EB3 - \u897F\u73ED\u7259\uFF0C18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"\u6D77\u7259","country":"\u8377\u5170","time":"\u6D77\u7259 - \u8377\u5170\uFF0C13:00 - 15:00","location":"In front of the Peace Palace / ICC","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"\u7B2C\u6BD4\u5229\u65AF","country":"\u683C\u9C81\u5409\u4E9A","time":"\u7B2C\u6BD4\u5229\u65AF - \u683C\u9C81\u5409\u4E9A\uFF0C21:00","location":"Tbilisi","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"\u7279\u62C9\u8BFA\u65AF","country":"\u745E\u5178","time":"\u7279\u62C9\u8BFA\u65AF - \u745E\u5178\uFF0C11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"\u7EF4\u4E5F\u7EB3","country":"\u5965\u5730\u5229","time":"\u7EF4\u4E5F\u7EB3 - \u5965\u5730\u5229\uFF0C16:00 - 18:00","location":"Stock im Eisen Platz (next to Stephansdom)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"\u534E\u76DB\u987F\u7279\u533A","country":"\u7F8E\u56FD","time":"\u534E\u76DB\u987F\u7279\u533A - \u7F8E\u56FD\uFF0C12:30 - 13:30","location":"The White House","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"\u5F17\u7F57\u8328\u74E6\u592B","country":"\u6CE2\u5170","time":"\u5F17\u7F57\u8328\u74E6\u592B - \u6CE2\u5170\uFF0C13:00","location":"Freedom Square (direction People\'s Forum of Music)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"\u8054\u7CFB\u65B9\u5F0F\uFF1A","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"\u5206\u4EAB\u5230 {{platform}}","website":"\u7F51\u7AD9","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","donate":"\u6350\u6B3E","donateIntro":"\u8FD9\u4E9B\u5021\u8BAE\u63D0\u4F9B\u9AD8\u6548\u3001\u6709\u9488\u5BF9\u6027\u7684\u76F4\u63A5\u5E2E\u52A9\uFF0C\u4FDD\u62A4\u8D6B\u5C14\u677E\u5E73\u6C11\u514D\u906D\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u3002","shareTitle":"\u4F20\u64AD\u4FE1\u606F","filmScreening":"\u7EC4\u7EC7\u653E\u6620\u7EAA\u5F55\u7247\u300A\u8D6B\u5C14\u677E\u4EBA\u7C7B\u72E9\u730E\u300B\uFF1A","howItStarted":"\u4E8B\u60C5\u7684\u8D77\u6E90","khs":{"name":"Kherson Human Safari","desc":"\u8BB0\u8005\u517C\u7535\u5F71\u4EBA\u624E\u4E3D\u5A1C\xb7\u624E\u5E03\u91CC\u65AF\u57FA\uFF08Zarina Zabrisky\uFF09\u9886\u5BFC\u4E86\u8FD9\u573A\u5168\u7403\u96C6\u4F1A\uFF0C\u5E76\u6267\u5BFC\u4E86\u7EAA\u5F55\u7247\u300A\u8D6B\u5C14\u677E\u4EBA\u7C7B\u72E9\u730E\u300B\u3002"},"fellas":{"name":"Fellas4Europe","desc":"\u4E3A\u8D6B\u5C14\u677E\u8857\u9053\u63D0\u4F9B\u5E73\u6C11\u4FDD\u62A4\u2014\u2014\u4FDD\u62A4\u5E73\u6C11\u514D\u53D7\u65E0\u4EBA\u673A\u88AD\u51FB\u3002","foodDesc":"\u98DF\u54C1\u63F4\u52A9\u3002","foodNote":"\u6350\u6B3E\u65F6\u8BF7\u5728\u5907\u6CE8\u4E2D\u586B\u5199\u201CFood for Cherson\u201D\u3002"},"ahs":{"name":"Anti Human Safari Project","desc":"\u4E3A\u8D6B\u5C14\u677E\u7684\u5FD7\u613F\u8005\u548C\u5E94\u6025\u670D\u52A1\u4EBA\u5458\u63D0\u4F9B\u65E0\u4EBA\u673A\u63A2\u6D4B\u5668\u548C\u9632\u62A4\u80CC\u5FC3\u3002"},"pageTitle":"\u505C\u6B62\u4EBA\u7C7B\u72E9\u730E","sectionIntro":"\u81EA2024\u5E74\u590F\u5929\u4EE5\u6765\uFF0C\u4FC4\u7F57\u65AF\u519B\u961F\u4F7F\u7528\u5C0F\u578B\u65E0\u4EBA\u673A\u5728\u8D6B\u5C14\u677E\u53CA\u4E4C\u514B\u5170\u5176\u4ED6\u524D\u7EBF\u57CE\u5E02\u7684\u8857\u9053\u4E0A\u8FFD\u730E\u3001\u6740\u5BB3\u5E76\u6050\u5413\u5E73\u6C11\u3002","sectionIntro2":"\u8FD9\u662F\u4E00\u573A\u7CFB\u7EDF\u800C\u84C4\u610F\u7684\u8C0B\u6740\u884C\u52A8\uFF1A\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u64CD\u4F5C\u5458\u516C\u7136\u628A\u53D7\u5BB3\u8005\u7684\u5F71\u50CF\u53D1\u5E03\u5230 Telegram \u9891\u9053\u4E0A\u70AB\u8000\u30022025\u5E745\u6708\uFF0C\u8054\u5408\u56FD\u8BA4\u5B9A\u4EBA\u7C7B\u72E9\u730E\u662F\u4E00\u9879\u6301\u7EED\u8FDB\u884C\u7684\u6218\u4E89\u7F6A\u3002","sectionIntro3":"\u6240\u505A\u7684\u52AA\u529B\u8FDC\u8FDC\u4E0D\u591F\u3002\u4EBA\u7C7B\u72E9\u730E\u5FC5\u987B\u505C\u6B62\u3002","sectionIntroBold":"\u4F60\u53EF\u4EE5\u63D0\u4F9B\u5E2E\u52A9\u3002\u65B9\u6CD5\u5982\u4E0B","step2Title":"\u7EC4\u7EC7\u884C\u52A8","step3Title":"\u544A\u8BC9\u4ED6\u4EBA","step3Para":"\u4F7F\u7528\u8BDD\u9898\u6807\u7B7E","step3ParaPost":"\u5E76\u5411\u4ED6\u4EBA\u8BB2\u8FF0\u4EBA\u7C7B\u72E9\u730E","instagram":"Instagram","step2Bullet1":"\u7535\u5F71\u653E\u6620","step2Bullet2":"\u4E00\u573A\u516C\u5F00\u884C\u52A8","step2Bullet3":"\u5A92\u4F53\u62A5\u9053","publicActionLead":"\u5728\u4F60\u6240\u5728\u4E4B\u5904\u8BA9\u4EBA\u7C7B\u72E9\u730E\u53D7\u5230\u5173\u6CE8\u3002","reachOutPre":"\u60A8\u53EF\u4EE5","reachOut":"\u8054\u7CFB\u6211\u4EEC","reachOutPost":"\u83B7\u53D6\u60F3\u6CD5\u548C\u8D44\u6E90","newsCoverageLead":"\u901A\u8FC7\u4F60\u7684\u5A92\u4F53\u8054\u7CFB\u4EBA\u3002\u5411\u4ED6\u4EEC\u8BB2\u8FF0\u4EBA\u7C7B\u72E9\u730E\uFF0C\u4EE5\u53CA\u5B83\u5BF9\u5F53\u524D\u548C\u672A\u6765\u6240\u6709\u51B2\u7A81\u5730\u533A\u6784\u6210\u7684\u98CE\u9669\u3002","putInTouchPre":"\u60A8\u4E5F\u53EF\u4EE5","putInTouch":"\u76F4\u63A5\u628A\u6211\u4EEC\u4ECB\u7ECD\u7ED9\u4ED6\u4EEC","inform":"\u4E86\u89E3\u4FE1\u606F","informSub":"\u8BA9\u81EA\u5DF1\u548C\u4ED6\u4EBA\u4E86\u89E3","policyTitle":"\u653F\u7B56","policyBody":"\u62DF\u8BAE\u7684\u300ALORA\u6CD5\u6848\u300B\uFF08Liability for Operators and Responsible Authorities Act\uFF09\u5C06\u5BF9\u6574\u4E2A\u8D23\u4EFB\u94FE\u6761\u5B9E\u65BD\u5236\u88C1\u2014\u2014\u4ECE\u4FC4\u7F57\u65AFFPV\u65E0\u4EBA\u673A\u64CD\u4F5C\u5458\u548C\u6307\u6325\u5B98\uFF0C\u5230\u9AD8\u7EA7\u519B\u4E8B\u9886\u5BFC\u5C42\uFF0C\u4EE5\u53CA\u4E3A\u9488\u5BF9\u5E73\u6C11\u7684\u65E0\u4EBA\u673A\u751F\u4EA7\u548C\u90E8\u7F72\u63D0\u4F9B\u652F\u6301\u7684\u5236\u9020\u5546\u548C\u4F9B\u5E94\u5546\u3002","policyHelp":"\u60A8\u53EF\u4EE5\u5728\u653F\u7B56\u5C42\u9762\u63D0\u4F9B\u5E2E\u52A9\uFF1F","getInTouch":"\u8054\u7CFB\u6211\u4EEC","disdict":{"title":"\u865A\u5047\u4FE1\u606F\u8BCD\u5178","link":"\u4EBA\u7C7B\u72E9\u730E"},"kryla":{"name":"Kryla Foundation","desc":"\u652F\u6301\u4ED6\u4EEC\u4E3A\u5965\u5217\u4EC0\u57FA\u5C45\u6C11\u652F\u4ED8\u4F4F\u5BBF\u548C\u57FA\u672C\u751F\u6D3B\u7528\u54C1\u3002"}},"action":{"intro":"\u6211\u4EEC\u4EE5\u4E00\u573A\u5168\u7403\u793A\u5A01\u62C9\u5F00\u5E8F\u5E55\u3002\u73B0\u5728\u4F60\u53EF\u4EE5\uFF1A","helpLink":"\u5728\u6B64\u63D0\u4F9B\u5E2E\u52A9"},"accounts":{"heading":"\u76EE\u51FB\u8BC1\u8BCD"},"media":{"close":"\u5173\u95ED","view":"\u67E5\u770B\u5A92\u4F53","previous":"\u4E0A\u4E00\u4E2A","next":"\u4E0B\u4E00\u4E2A","andrushenkoCredit":"\u5965\u5217\u514B\u6851\u5FB7\u5C14\xb7\u5B89\u5FB7\u7559\u5148\u79D1\uFF0CVgoru \u5A92\u4F53\u6444\u5F71\u8BB0\u8005","khersonPoliceCredit":"\u6765\u81EA @khersonpolice","antypenkoCredit":"\u4F0A\u4E07\xb7\u5B89\u8482\u7247\u79D1\uFF0C\u6765\u81EA\u8D6B\u5C14\u677E\u7684\u6444\u5F71\u8BB0\u8005","telegramChannelCredit":"\u7531\u4FC4\u65B9\u201C\u4EBA\u7C7B\u72E9\u730E\u201DTelegram \u9891\u9053\u201C\u4ECE\u9A6C\u91CC\u4E4C\u6CE2\u5C14\u5230\u5580\u5C14\u5DF4\u9621\u201D\u53D1\u5E03","fruitSellerDescription":"\u6C34\u679C\u5C0F\u8D29\u906D\u5149\u7EA4\u65E0\u4EBA\u673A\u8FFD\u51FB","burntCarDescription":"\u8D6B\u5C14\u677E\u4E00\u8F86\u88AB\u70E7\u6BC1\u7684\u6C7D\u8F66","bridgeAttackDescription":"\u4E00\u540D\u5C11\u5E74\u5728\u8D6B\u5C14\u677E\u4E00\u5EA7\u6865\u4E0B\u88AB FPV \u65E0\u4EBA\u673A\u6740\u5BB3","busAttackDescription":"\u9488\u5BF9\u516C\u5171\u4EA4\u901A\u7684\u4F17\u591A FPV \u65E0\u4EBA\u673A\u88AD\u51FB\u4E4B\u4E00","fpvDroneDescription":"\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u884C\u52A8\u4E2D\u51FA\u52A8\u7684 FPV \u65E0\u4EBA\u673A","antiDroneNetsDescription":"\u8D6B\u5C14\u677E\u8857\u9053\u4E0A\u5F20\u8D77\u9632\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u65E0\u4EBA\u673A\u7684\u7F51","firefighterDescription":"\u6D88\u9632\u5458\u5728\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u88AD\u51FB\u540E\u6251\u706D\u8D77\u706B\u8F66\u8F86\uFF0C\u540E\u65B9\u8EBA\u7740\u4E00\u540D\u53D7\u5BB3\u8005"},"follow":{"title":"\u5173\u6CE8","subHumanSafari":"\u6765\u81EA\u8D6B\u5C14\u677E\u3001\u62A5\u9053\u4EBA\u7C7B\u72E9\u730E\u7684\u4F18\u8D28\u4FE1\u6E90","subDroneSiege":"\u6765\u81EA\u8D6B\u5C14\u677E\u3001\u62A5\u9053\u65E0\u4EBA\u673A\u56F4\u56F0\u7684\u4F18\u8D28\u4FE1\u6E90","localPress":"\u5F53\u5730\u4E4C\u514B\u5170\u8BED\u5A92\u4F53","lang":{"english":"\u82F1\u8BED","german":"\u5FB7\u8BED","ukrainian":"\u4E4C\u514B\u5170\u8BED"},"language":"\u8BED\u8A00\uFF1A{{list}}","languages":"\u8BED\u8A00\uFF1A{{list}}","langSeparator":"\u3001","zabrisky":{"name":"\u624E\u4E3D\u5A1C\xb7\u624E\u5E03\u91CC\u65AF\u57FA\uFF08Zarina Zabrisky\uFF09","desc":"\u5E38\u9A7B\u8D6B\u5C14\u677E\u7684\u7F8E\u56FD\u8BB0\u8005\u517C\u7535\u5F71\u4EBA\uFF0C\u4E3A Byline Times \u548C Euromaidan Press \u4F9B\u7A3F\uFF1B\u7EAA\u5F55\u7247\u300A\u8D6B\u5C14\u677E\u4EBA\u7C7B\u72E9\u730E\u300B\u5BFC\u6F14\u3002"},"naber":{"name":"\u6613\u535C\u62C9\u6B23\xb7\u7EB3\u8D1D\u5C14\uFF08Ibrahim Naber\uFF09","desc":"\u5FB7\u56FD\u300A\u4E16\u754C\u62A5\u300B\u9996\u5E2D\u8BB0\u8005\uFF1B\u5B9A\u671F\u62A5\u9053\u8D6B\u5C14\u677E\u7684\u4EBA\u7C7B\u72E9\u730E\u3002"},"kelley":{"name":"\u5E03\u4F26\u4E39\xb7\u51EF\u5229\uFF08Brendan Kelley\uFF09","desc":"\u64B0\u5199\u300AKherson Weekly\u300B\uFF0C\u6301\u7EED\u8BB0\u5F55\u4FC4\u519B\u65E0\u4EBA\u673A\u5BF9\u8D6B\u5C14\u677E\u53CA\u5468\u8FB9\u6751\u5E84\u5E73\u6C11\u7684\u88AD\u51FB\u3002"},"vgoru":{"name":"Vgoru\uFF08\u300A\u5411\u4E0A\u300B\uFF09","desc":"\u8D6B\u5C14\u677E\u5DDE\u7684\u72EC\u7ACB\u5A92\u4F53\u5E73\u53F0\uFF0C\u62A5\u9053\u70AE\u706B\u4E0B\u4E0E\u5360\u9886\u533A\u7684\u751F\u6D3B\u3002"},"suspilne":{"name":"Suspilne \u8D6B\u5C14\u677E","desc":"\u4E4C\u514B\u5170\u516C\u5171\u5E7F\u64AD\u516C\u53F8\u7684\u8D6B\u5C14\u677E\u7F16\u8F91\u90E8\u3002"},"most":{"name":"MOST","desc":"\u8D6B\u5C14\u677E\u5F53\u5730\u901A\u8BAF\u793E\uFF0C\u62A5\u9053\u8BE5\u5E02\u53CA\u5168\u5DDE\u3002"}},"rallies":{"oleshky2026":{"heroStop":"\u505C\u6B62\u65E0\u4EBA\u673A\u56F4\u56F0","heroSave":"\u62EF\u6551\u5965\u5217\u4EC0\u57FA","worldwideRally":"\u5168\u7403\u96C6\u4F1A","heroDate":"\u5341\u6708","infoText1":"\u5965\u5217\u4EC0\u57FA\u3001\u970D\u62C9\u666E\u91CC\u65AF\u5766\u3001\u65E7\u5179\u5E03\u91CC\u592B\u5361\u548C\u65B0\u5179\u5E03\u91CC\u592B\u5361\u7684\u6570\u5343\u540D\u5E73\u6C11\u88AB\u56F0\u4E8E\u65E0\u4EBA\u673A\u56F4\u56F0\u4E4B\u4E2D\u3002\u4FC4\u7F57\u65AF\u519B\u961F\u628A\u4ED6\u4EEC\u5F53\u4F5C\u4EBA\u4F53\u76FE\u724C\uFF0C\u8EB2\u5728\u4ED6\u4EEC\u8EAB\u540E\u5411\u5BF9\u5CB8\u53D1\u52A8\u4EBA\u7C7B\u72E9\u730E\u65E0\u4EBA\u673A\u88AD\u51FB\u3002","infoText2":"\u5371\u673A\u5341\u5206\u4E25\u5CFB\uFF1A\u98DF\u7269\u3001\u6C34\u3001\u533B\u7597\u3001\u836F\u54C1\u3001\u7535\u529B\u3001\u71C3\u6C14\u548C\u901A\u8BAF\u5168\u9762\u77ED\u7F3A\u3002\u9053\u8DEF\u5E03\u6EE1\u5730\u96F7\uFF0C\u65E0\u4EBA\u673A\u6D3B\u52A8\u9650\u5236\u4E86\u4E00\u5207\u884C\u52A8\u3002<bold>\u4F60\u53EF\u4EE5\u63D0\u4F9B\u5E2E\u52A9\u3002\u52A0\u5165\u5168\u7403\u6570\u5343\u4EBA\uFF0C\u5171\u540C\u8981\u6C42\u505C\u6B62\u65E0\u4EBA\u673A\u56F4\u56F0\u3002</bold>","imageAlt":"\u5728\u88AB\u6467\u6BC1\u7684\u5965\u5217\u4EC0\u57FA\uFF0C\u4E00\u53EA\u9965\u997F\u7684\u72D7\u5728\u4EBA\u9AA8\u95F4\u89C5\u98DF\uFF0C\u7EA2\u8272\u5929\u7A7A\u4E2D\u5E03\u6EE1\u65E0\u4EBA\u673A\uFF0C\u4E0A\u65B9\u5199\u7740 Stop Russian Drone Siege","demandsTitle":"\u6211\u4EEC\u547C\u5401\uFF1A","demand1":"\u5EFA\u7ACB\u901A\u5F80\u5965\u5217\u4EC0\u57FA\u53CA\u5176\u4ED6\u53D7\u5F71\u54CD\u793E\u533A\u7684\u5B89\u5168\u3001\u6709\u6548\u7684\u4EBA\u9053\u4E3B\u4E49\u8D70\u5ECA\u3002","demand2":"\u4E3A\u4EBA\u7C7B\u72E9\u730E\u88AD\u51FB\u7684\u53D7\u5BB3\u8005\u63D0\u4F9B\u5373\u65F6\u7684\u4EBA\u9053\u4E3B\u4E49\u6551\u6D4E\u548C\u63F4\u52A9\u3002","demand3":"\u5BF9\u88AD\u51FB\u5E73\u6C11\u4E8B\u4EF6\u8D1F\u6709\u8D23\u4EFB\u7684\u4E2A\u4EBA\u548C\u4F9B\u5E94\u94FE\u5B9E\u65BD\u9002\u5F53\u5236\u88C1\u3002","demand4":"\u91C7\u53D6\u63AA\u65BD\uFF0C\u904F\u5236\u5728\u8D6B\u5C14\u677E\u3001\u4E4C\u514B\u5170\u53CA\u5176\u4ED6\u5730\u65B9\u4F7F\u7528\u5C0F\u578B\u65E0\u4EBA\u673A\u7CFB\u7EDF\u6027\u5730\u653B\u51FB\u548C\u6050\u5413\u5E73\u6C11\u3002","cities":{"edinburgh":{"city":"\u7231\u4E01\u5821","country":"\u82F1\u56FD","time":"\u7231\u4E01\u5821 - \u82F1\u56FD\uFF0C14:00","location":"Duke of Wellington Monument","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"\u4F2F\u660E\u7FF0","country":"\u82F1\u56FD","time":"\u4F2F\u660E\u7FF0 - \u82F1\u56FD\uFF0C14:00 - 16:00","location":"Hall of Memory \u5BF9\u9762\uFF0CB1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"\u7EF4\u4E5F\u7EB3","country":"\u5965\u5730\u5229","time":"\u7EF4\u4E5F\u7EB3 - \u5965\u5730\u5229\uFF0C15:00 - 17:00","location":"Stephansplatz, 1010 Wien","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"\u6155\u5C3C\u9ED1","country":"\u5FB7\u56FD","time":"\u6155\u5C3C\u9ED1 - \u5FB7\u56FD\uFF0C15:00 - 17:00","location":"Marienplatz, 80331 M\xfcnchen","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C16:00 - 18:00","location":"\u5510\u5B81\u8857","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"\u66FC\u5F7B\u65AF\u7279","country":"\u82F1\u56FD","time":"\u66FC\u5F7B\u65AF\u7279 - \u82F1\u56FD\uFF0C14:00 - 15:30","location":"\u5723\u5F7C\u5F97\u5E7F\u573A\uFF08St Peter\'s Square\uFF09","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"\u6089\u5C3C","country":"\u6FB3\u5927\u5229\u4E9A","time":"\u6089\u5C3C - \u6FB3\u5927\u5229\u4E9A\uFF0C14:00","location":"\u6089\u5C3C\u5E02\u653F\u5385\uFF08Sydney Town Hall\uFF09","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"\u5DF4\u9ECE","country":"\u6CD5\u56FD","time":"\u5DF4\u9ECE - \u6CD5\u56FD\uFF0C15:30 - 18:30","location":"\u4ECE\u5723\u5F17\u62C9\u57FA\u7C73\u5C14\u6559\u5802\u5230\u5723\u7C73\u6B47\u5C14\u5E7F\u573A","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"\u5DF4\u9ECE","country":"\u6CD5\u56FD","time":"\u5DF4\u9ECE - \u6CD5\u56FD\uFF0C18:00","location":"\u6717\u5E03\u6258\u5730\u94C1\u7AD9\uFF08Rambuteau\uFF09","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"\u91CC\u6602","country":"\u6CD5\u56FD","time":"\u91CC\u6602 - \u6CD5\u56FD\uFF0C14:00","location":"\u559C\u5267\u5E7F\u573A\uFF08Place de la Com\xe9die\uFF09","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"\u90FD\u67CF\u6797","country":"\u7231\u5C14\u5170","time":"\u90FD\u67CF\u6797 - \u7231\u5C14\u5170\uFF0C13:00","location":"\u90AE\u653F\u603B\u5C40\uFF08The GPO\uFF09","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"\u5E03\u9C81\u585E\u5C14","country":"\u6BD4\u5229\u65F6","time":"\u5E03\u9C81\u585E\u5C14 - \u6BD4\u5229\u65F6\uFF0C10:00 - 11:00","location":"La Petite rue de la Loi, 1040 \u5E03\u9C81\u585E\u5C14\uFF08\u8212\u66FC\u73AF\u5C9B\uFF09","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"\u6E25\u592A\u534E","country":"\u52A0\u62FF\u5927","time":"\u6E25\u592A\u534E - \u52A0\u62FF\u5927\uFF0C12:30 - 13:30","location":"\u4FC4\u7F57\u65AF\u5927\u4F7F\u9986\uFF08285 Charlotte St\uFF09","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"\u5357\u7279","country":"\u6CD5\u56FD","time":"\u5357\u7279 - \u6CD5\u56FD\uFF0C15:00 - 16:30","location":"\u7687\u5BB6\u5E7F\u573A\uFF08Place Royale\uFF09","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"\u683C\u4F46\u65AF\u514B","country":"\u6CE2\u5170","time":"\u683C\u4F46\u65AF\u514B - \u6CE2\u5170\uFF0C18:30 - 19:30","location":"\u957F\u5E02\u573A\uFF08D\u0142ugi Targ\uFF09\uFF0C\u6D77\u795E\u55B7\u6CC9\u65C1","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"\u829D\u52A0\u54E5","country":"\u7F8E\u56FD","time":"\u829D\u52A0\u54E5 - \u7F8E\u56FD\uFF0C13:00","location":"410 N. Michigan ave.\uFF08Wrigley \u5927\u53A6\uFF09","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"\u829D\u52A0\u54E5","country":"\u7F8E\u56FD","time":"\u829D\u52A0\u54E5 - \u7F8E\u56FD\uFF0C13:00","location":"410 N. Michigan ave.\uFF08Wrigley \u5927\u53A6\uFF09","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"\u829D\u52A0\u54E5","country":"\u7F8E\u56FD","time":"\u829D\u52A0\u54E5 - \u7F8E\u56FD\uFF0C13:00","location":"410 N. Michigan ave.\uFF08Wrigley \u5927\u53A6\uFF09","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"\u829D\u52A0\u54E5","country":"\u7F8E\u56FD","time":"\u829D\u52A0\u54E5 - \u7F8E\u56FD\uFF0C13:00","location":"410 N. Michigan ave.\uFF08Wrigley \u5927\u53A6\uFF09","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"\u5FB7\u7D2F\u65AF\u987F","country":"\u5FB7\u56FD","time":"\u5FB7\u7D2F\u65AF\u987F - \u5FB7\u56FD\uFF0C14:00","location":"\u65B0\u5E02\u573A\uFF08Neumarkt\uFF09","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"\u9A6C\u62C9\u52A0","country":"\u897F\u73ED\u7259","time":"\u9A6C\u62C9\u52A0 - \u897F\u73ED\u7259\uFF0C19:00","location":"\u7801\u5934\u5E7F\u573A\uFF08Plaza de la Marina\uFF09","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C18:00","location":"\u7279\u62C9\u6CD5\u52A0\u5E7F\u573A","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"\u666E\u7F57\u592B\u8FEA\u592B","country":"\u4FDD\u52A0\u5229\u4E9A","time":"\u666E\u7F57\u592B\u8FEA\u592B - \u4FDD\u52A0\u5229\u4E9A\uFF0C17:00","location":"\u4E3B\u8857\uFF08Glavnata\uFF09\uFF0C\u5361\u6885\u5C3C\u5BDF\uFF08Kamenitza\uFF09\u53F0\u9636\u65C1 / \u201CTogether\u201D\u5B57\u6837\u5904","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"\u5E03\u8FBE\u4F69\u65AF","country":"\u5308\u7259\u5229","time":"\u5E03\u8FBE\u4F69\u65AF - \u5308\u7259\u5229\uFF0C17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r\uFF08\u5723\u4F0A\u4EC0\u7279\u4E07\u5E7F\u573A\uFF09","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C17:00","location":"\u7279\u62C9\u6CD5\u52A0\u5E7F\u573A","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C12:00","location":"\u7279\u62C9\u6CD5\u52A0\u5E7F\u573A","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"\u6C49\u5821","country":"\u5FB7\u56FD","time":"\u6C49\u5821 - \u5FB7\u56FD\uFF0C14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, 1\u53F7\u7801\u5934\u65C1\uFF0C20359 \u6C49\u5821","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"\u57FA\u5C14","country":"\u5FB7\u56FD","time":"\u57FA\u5C14 - \u5FB7\u56FD\uFF0C15:00 - 16:00","location":"\u8377\u5C14\u65AF\u6CF0\u56E0\u5927\u8857\uFF08Holstenstra\xdfe\uFF09","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"\u5965\u65AF\u9646","country":"\u632A\u5A01","time":"\u5965\u65AF\u9646 - \u632A\u5A01","location":"\u57C3\u5179\u6C83\u5C14\u5E7F\u573A\uFF08Eidsvolls plass\uFF09","cleanTime":"","day":"schedule3"},"leipzig":{"city":"\u83B1\u6BD4\u9521","country":"\u5FB7\u56FD","time":"\u83B1\u6BD4\u9521 - \u5FB7\u56FD\uFF0C17:00 - 18:00","location":"\u4E2D\u592E\u706B\u8F66\u7AD9\uFF08Willy-Brandt-Platz\uFF09","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C17:00","location":"\u7279\u62C9\u6CD5\u52A0\u5E7F\u573A","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"\u4F26\u6566","country":"\u82F1\u56FD","time":"\u4F26\u6566 - \u82F1\u56FD\uFF0C13:00","location":"\u7279\u62C9\u6CD5\u52A0\u5E7F\u573A","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"\u90FD\u67CF\u6797","country":"\u7231\u5C14\u5170","time":"\u90FD\u67CF\u6797 - \u7231\u5C14\u5170\uFF0C13:00","location":"\u90AE\u653F\u603B\u5C40\uFF08The GPO\uFF09","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"\u90FD\u67CF\u6797","country":"\u7231\u5C14\u5170","time":"\u90FD\u67CF\u6797 - \u7231\u5C14\u5170\uFF0C14:00","location":"\u90AE\u653F\u603B\u5C40\uFF08The GPO\uFF09","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"\u5357\u7279","country":"\u6CD5\u56FD","time":"\u5357\u7279 - \u6CD5\u56FD\uFF0C15:00 - 16:30","location":"\u7687\u5BB6\u5E7F\u573A\uFF08Place Royale\uFF09","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"\u505C\u6B62\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u56F4\u56F0","posterNoRoadOut":"\u8FDB\u51FA\u5965\u5217\u4EC0\u57FA\u7684\u9053\u8DEF\u5DF2\u88AB\u5C01\u9501","posterHumanitarianCatastrophe":"\u5965\u5217\u4EC0\u57FA\uFF1A\u5360\u9886\u4E0B\u7684\u4EBA\u9053\u4E3B\u4E49\u707E\u96BE","seeGallery":"\u67E5\u770B / \u4E0B\u8F7D\u6D77\u62A5"},"artBy":"\u4F5C\u8005\uFF1A{{name}}","downloadPoster":"\u4E0B\u8F7D\u6D77\u62A5","reel":{"download":"\u4E0B\u8F7D\u89C6\u9891\uFF08MP4\uFF09"},"addDemo":{"title":"\u6DFB\u52A0\u60A8\u7684\u793A\u5A01\u6D3B\u52A8","where":"\u5730\u70B9\uFF1A\u57CE\u9547/\u57CE\u5E02","contact":"\u90AE\u7BB1/\u53F7\u7801","message":"\u7559\u8A00\uFF1A\u60A8\u4EE3\u8868\u54EA\u4E2A\u56E2\u4F53\uFF0C\u793A\u5A01\u6D3B\u52A8\u5DF2\u786E\u8BA4\u6216\u7B79\u5907\u4E2D\uFF0C\u5728\u7EBF\u516C\u544A\u94FE\u63A5\uFF0C\u5176\u4ED6\u8BE6\u60C5","submit":"\u63D0\u4EA4","sending":"\u53D1\u9001\u4E2D\u2026","thanks":"\u8C22\u8C22\uFF01\u6211\u4EEC\u4F1A\u4E0E\u60A8\u8054\u7CFB\u3002","error":"\u51FA\u73B0\u95EE\u9898\uFF0C\u8BF7\u91CD\u8BD5\u3002","contactInvalid":"\u8BF7\u8F93\u5165\u6709\u6548\u7684\u90AE\u7BB1\uFF0C\u6216\u5E26\u56FD\u5BB6\u4EE3\u7801\u7684\u7535\u8BDD\u53F7\u7801\uFF08\u4F8B\u5982 +44 7700 900123\uFF09\u3002","date":"\u65E5\u671F","time":"\u5F00\u59CB\u65F6\u95F4\uFF08\u5F53\u5730\uFF09","whereInvalid":"\u8BF7\u8F93\u5165\u57CE\u9547\u6216\u57CE\u5E02\u540D\u79F0\uFF0C\u4F8B\u5982 \u5DF4\u9ECE \u6216 \u57FA\u8F85\uFF0C\u4E4C\u514B\u5170\u3002","datePlaceholder":"\u65E5\u671F\uFF1A\u65E5/\u6708"}},"seo":{"oleshky":{"title":"\u505C\u6B62\u65E0\u4EBA\u673A\u56F4\u56F0\u2014\u2014\u62EF\u6551\u5965\u5217\u4EC0\u57FA\uFF5C\u5168\u7403\u793A\u5A01","description":"\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u56F4\u56F0\u7740\u4E4C\u514B\u5170\u88AB\u5360\u9886\u7684\u5965\u5217\u4EC0\u57FA\u7684\u6570\u5343\u540D\u5E73\u6C11\uFF0C\u4ED6\u4EEC\u88AB\u5207\u65AD\u4E86\u98DF\u7269\u3001\u6C34\u548C\u836F\u54C1\u3002\u67E5\u627E\u60A8\u9644\u8FD1\u7684\u793A\u5A01\u6D3B\u52A8\uFF0C\u8981\u6C42\u5F00\u8F9F\u5B89\u5168\u901A\u9053\u3002"},"leftBank":{"title":"\u5965\u5217\u4EC0\u57FA\u53CA\u88AB\u5360\u9886\u8D6B\u5C14\u677E\u5DDE\u7684\u65E0\u4EBA\u673A\u56F4\u56F0","description":"\u6570\u5343\u540D\u5E73\u6C11\u88AB\u56F0\u5728\u88AB\u5360\u9886\u7684\u5965\u5217\u4EC0\u57FA\u3001\u970D\u62C9\u666E\u91CC\u65AF\u5766\u53CA\u9644\u8FD1\u6751\u5E84\uFF0C\u906D\u53D7\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u56F4\u56F0\u3002\u4E86\u89E3\u6B63\u5728\u53D1\u751F\u7684\u4E8B\u60C5\u4EE5\u53CA\u60A8\u53EF\u4EE5\u5982\u4F55\u63D0\u4F9B\u5E2E\u52A9\u3002"},"help":{"title":"\u505C\u6B62\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u2014\u2014\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u5728\u8D6B\u5C14\u677E\u730E\u6740\u5E73\u6C11","description":"\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u5728\u4E4C\u514B\u5170\u8D6B\u5C14\u677E\u730E\u6740\u5E73\u6C11\u3002\u4E86\u89E3\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u8FD9\u4E00\u6218\u4E89\u7F6A\u884C\uFF0C\u4EE5\u53CA\u60A8\u53EF\u4EE5\u5982\u4F55\u5E2E\u52A9\u5236\u6B62\u5B83\u3002"},"action":{"title":"2025\u5E7412\u6708\u5168\u7403\u96C6\u4F1A\u2014\u2014\u505C\u6B62\u201C\u4EBA\u7C7B\u72E9\u730E\u201D","description":"2025\u5E7412\u6708\u5168\u7403\u96C6\u4F1A\u7684\u7167\u7247\u3001\u6D77\u62A5\u548C\u5730\u70B9\uFF0C\u6297\u8BAE\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u88AD\u51FB\u4E4C\u514B\u5170\u8D6B\u5C14\u677E\u5E73\u6C11\u3002"},"rallies":{"title":"\u96C6\u4F1A\u7167\u7247\u2014\u2014\u505C\u6B62\u201C\u4EBA\u7C7B\u72E9\u730E\u201D","description":"\u4E16\u754C\u5404\u5730\u6297\u8BAE\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u88AD\u51FB\u4E4C\u514B\u5170\u8D6B\u5C14\u677E\u5E73\u6C11\u7684\u96C6\u4F1A\u7167\u7247\u3002"},"resources":{"title":"\u201C\u4EBA\u7C7B\u72E9\u730E\u201D\u8D44\u6599\u2014\u2014\u62A5\u544A\u3001\u6587\u7AE0\u4E0E\u8BC1\u8BCD","description":"\u5173\u4E8E\u4FC4\u7F57\u65AF\u65E0\u4EBA\u673A\u88AD\u51FB\u4E4C\u514B\u5170\u8D6B\u5C14\u677E\u5E73\u6C11\u7684\u62A5\u544A\u3001\u6587\u7AE0\u3001\u91C7\u8BBF\u548C\u76EE\u51FB\u8005\u8BC1\u8BCD\u3002"},"reel":{"title":"\u62EF\u6551\u5965\u5217\u4EC0\u57FA\u2014\u2014\u793A\u5A01\u89C6\u9891","description":"2026\u5E7410\u6708\u5168\u7403\u201C\u62EF\u6551\u5965\u5217\u4EC0\u57FA\u201D\u793A\u5A01\u6D3B\u52A8\u7684\u89C6\u9891\u3002"}}}');


var $a8516cebb66bc9ef$exports = {};
$a8516cebb66bc9ef$exports = JSON.parse('{"home":{"heroStop":"STOP HUMAN SAFARI","heroSave":"RATUJMY CHERSO\u0143","heroTitle1":"Ludzie","heroTitle2":"to nie cele","heroDate":"13, 14 grudnia","worldwideRally":"Og\xf3lno&shy;\u015Bwiatowy wiec","heroHashtags":"#HumansAreNotTargets #StopHumanSafari #SaveKherson","infoText":"Od lata 2024 roku rosyjskie wojsko u\u017Cywa ma\u0142ych dron\xf3w, by polowa\u0107 na cywil\xf3w, zabija\u0107 ich i terroryzowa\u0107 na ulicach Chersonia i innych przyfrontowych miast Ukrainy. <bold>Human Safari musi si\u0119 sko\u0144czy\u0107. TY mo\u017Cesz pom\xf3c.</bold> Do\u0142\u0105cz do tysi\u0119cy ludzi na ca\u0142ym \u015Bwiecie, kt\xf3rzy domagaj\u0105 si\u0119 powstrzymania tej zbrodni wojennej.","seeGallery":"Zobacz plakaty z ca\u0142ego \u015Bwiata","comingSoon":"Lokalizacje wkr\xf3tce","december":"grudnia","dec":"gru","october":"pa\u017Adziernika","oct":"pa\u017A","september":"wrze\u015Bnia","sep":"wrz","schedule9":"9","schedule10":"10","schedule11":"11","schedule12":"12","schedule13":"13","schedule14":"14","schedule16":"16","schedule18":"18","schedule20":"20","schedule1":"1","schedule2":"2","schedule3":"3","schedule4":"4","schedule5":"5","schedule25":"25","schedule26":"26","schedule27":"27","schedule28":"28","schedule29":"29","schedule30":"30","schedule31":"31","scheduleTBC":"Potwierdzamy dat\u0119...","recommendationsTitle":"Zalecenia Komisji ONZ","recommendationsRussia":"Komisja zaleca, aby Federacja Rosyjska:","rusRec1":"(a) Natychmiast zaprzesta\u0142a atak\xf3w dron\xf3w wymierzonych w ludno\u015B\u0107 cywiln\u0105 i obiekty cywilne","rusRec2":"(b) Natychmiast zaprzesta\u0142a wszelkich dzia\u0142a\u0144 szerz\u0105cych terror w\u015Br\xf3d ludno\u015Bci cywilnej","rusRec3":"(c) Zapewni\u0142a poci\u0105gni\u0119cie do odpowiedzialno\u015Bci wszystkich sprawc\xf3w atak\xf3w dron\xf3w na ludno\u015B\u0107 cywiln\u0105","recommendationsUNStates":"Komisja zaleca, aby inne pa\u0144stwa oraz organizacje regionalne i mi\u0119dzynarodowe: ","statesRec1":"(a) Wspiera\u0142y finansowo i doradztwem technicznym rz\u0105d Ukrainy oraz organizacje spo\u0142ecze\u0144stwa obywatelskiego w zapewnianiu kompleksowej pomocy ofiarom i ich rodzinom;","statesRec2":"(b) W przypadku pa\u0144stw trzecich, do kt\xf3rych deportowano osoby z terytori\xf3w okupowanych \u2013 podj\u0119\u0142y, wsp\xf3lnie z ukrai\u0144skimi s\u0142u\u017Cbami konsularnymi, niezb\u0119dne dzia\u0142ania w celu wsparcia tych os\xf3b.","reference":"\u0179r\xf3d\u0142a","linkUN":"Komisja ONZ: rosyjskie \u201Ehuman safari\u201D na Ukrainie to zbrodnia przeciwko ludzko\u015Bci","linkGuidelines":"Wytyczne ONZ","linkWiki":"Wikipedia"},"witnesses":{"title":" Zbieramy relacje naocznych \u015Bwiadk\xf3w!","email":"Je\u015Bli pochodzisz z Chersonia, Nikopola, Zaporo\u017Ca, Sum lub przyfrontowych teren\xf3w Donbasu i na w\u0142asne oczy widzia\u0142e\u015B/-a\u015B \u201Ehuman safari\u201D, prze\u015Blij nam swoj\u0105 histori\u0119 na \uD83D\uDCE7 <mail>khersonhumansafari@gmail.com</mail>, w temacie: \u201Ehuman safari\u201D.","type":" Je\u015Bli by\u0142e\u015B/-a\u015B \u015Bwiadkiem \u015Bmierci przyjaciela lub s\u0105siada w ataku drona i chcesz podzieli\u0107 si\u0119 swoj\u0105 relacj\u0105, napisz \u201E\u015Bwiadek\u201D; je\u015Bli sam/-a zosta\u0142e\u015B/-a\u015B zaatakowany/-a, napisz \u201Eocala\u0142y/-a\u201D.","requirements":"<b>Czego potrzebujemy:</b> miasto/miejsce, data ataku, kr\xf3tka historia (3\u20136 zda\u0144; rzeczowo, w pierwszej osobie).","honesty":"Pisz szczerze i zwi\u0119\u017Ale, nie podawaj wra\u017Cliwych informacji o pozycjach wojskowych \u2014 mo\u017Cesz pozosta\u0107 anonimowy/-a.","media":"<b>Zdj\u0119cia/filmy?</b> Napisz \u201EMam zdj\u0119cia/filmy\u201D. Nie za\u0142\u0105czaj plik\xf3w \u2014 skontaktujemy si\u0119, je\u015Bli b\u0119d\u0105 potrzebne.","consent":"<b>Zgoda na publikacj\u0119:</b> \u201EZgadzam si\u0119 na publiczne opublikowanie tej historii na stronie HumanSafari.org\u201D."},"resources":{"title":"Najwa\u017Cniejsze \u017Ar\xf3d\u0142a","linkLibraryTitle":"Biblioteka link\xf3w","linkLibraryDesc":"200 artyku\u0142\xf3w, raport\xf3w, wywiad\xf3w, relacji z pierwszej r\u0119ki i materia\u0142\xf3w medialnych","humanSafariMapTitle":"Mapa Human Safari \u2013 Tochnyi","humanSafariMapDesc":"Interaktywna mapa atak\xf3w Human Safari w Chersoniu, opracowana na podstawie otwartych raport\xf3w w\u0142adz lokalnych oraz nagra\u0144 atak\xf3w zgeolokalizowanych przez zesp\xf3\u0142 Tochnyi.","truthHoundsTitle":"Raport Truth Hounds","truthHoundsDesc":"Strefa \u015Bmierci: jak rosyjskie drony pustosz\u0105 prawy brzeg Dniepru","hrwTitle":"Raport Human Rights Watch o atakach dron\xf3w w Chersoniu","hrwDesc":"Raport HRW","unReportsTitle":"Raporty Rady Praw Cz\u0142owieka ONZ","report1":"Raport ONZ nr 1","report3":"Raport ONZ nr 3","guidelines":"Wytyczne ONZ","wikipediaTitle":"Wikipedia","english":"angielski","french":"francuski","documentaryTitle":"Film dokumentalny","documentaryDesc":"www.khersonhumansafari.com"},"navbar":{"main":"13-14 grudnia","eyewitnesses":"relacje","rallies":"zdj\u0119cia","help":"wyzwolony Cherso\u0144","leftBank":"okupowany Cherso\u0144","action":"gru \'25","oleshky":"globalna demonstracja - Oleszki","menu":"Menu"},"leftBank":{"pageTitle":"Obl\u0119\u017Cenie dronami","para1":"Ostry kryzys humanitarny dotyka 6000 cywil\xf3w uwi\u0119zionych w obl\u0119\u017Ceniu dronami w okupowanych Oleszkach, Ho\u0142ej Prystani, Starej Zburiwce i Nowej Zburiwce w okupowanym obwodzie cherso\u0144skim. W samych Oleszkach to 1200\u20132000 os\xf3b. W\u0142adza okupacyjna ma obowi\u0105zek im pomaga\u0107 \u2014 zamiast tego rosyjskie si\u0142y wykorzystuj\u0105 ich jako \u017Cywe tarcze, kryj\u0105c si\u0119 za t\u0105 ludno\u015Bci\u0105 podczas atak\xf3w Human Safari na przeciwleg\u0142y brzeg. W\u0142adze ukrai\u0144skie i organizacje humanitarne informuj\u0105 o systematycznym utrudnianiu ewakuacji i dost\u0119pu humanitarnego.","para2":"Cywilom brakuje \u017Cywno\u015Bci, wody, opieki medycznej, lek\xf3w, pr\u0105du, gazu i \u0142\u0105czno\u015Bci. Drogi s\u0105 g\u0119sto zaminowane, a drony ograniczaj\u0105 mo\u017Cliwo\u015B\u0107 poruszania si\u0119. Od 26 maja \u017Caden pojazd nie zdo\u0142a\u0142 wjecha\u0107 ani wyjecha\u0107. Zapasy paliwa i \u017Cywno\u015Bci s\u0105 niemal wyczerpane.","meidasTitle":"Meidas Touch / Valor Media Network","meidasVideo":"Film: Cherso\u0144 i Oleszki. \u015Awiadkowie ludob\xf3jstwa (12 min)","meidasArticle":"Artyku\u0142: Obw\xf3d cherso\u0144ski. Jak Rosja wykorzystuje cywil\xf3w jako narz\u0119dzie wojny (5 min czytania)","kyivPostTitle":"Kyiv Post","kyivPostArticle":"Artyku\u0142: Spo\u0142eczno\u015B\u0107 mi\u0119dzynarodowa wzywa do pilnej ewakuacji z Oleszek w obliczu pogarszaj\u0105cych si\u0119 warunk\xf3w (7 min czytania)","tellPost":"i opowiadaj innym o obl\u0119\u017Ceniu dronami","callToHelp":"TY mo\u017Cesz pom\xf3c. Oto jak","donateIntro":"To inicjatywy, kt\xf3re zapewniaj\u0105 skuteczn\u0105, ukierunkowan\u0105 pomoc bezpo\u015Brednio osobom, kt\xf3re uciek\u0142y z Oleszek lub, tam gdzie to mo\u017Cliwe, s\u0105 w nich uwi\u0119zione.","signTitle":"Podpisz","signSub":"petycje","petitionBy":"od {{name}}","petitions":{"euParliament":"Parlament Europejski \u2013 Petycja nr 1439/2026 w sprawie utworzenia humanitarnego korytarza ewakuacyjnego dla cywil\xf3w uwi\u0119zionych w obl\u0119\u017Ceniu w okupowanych przez Rosj\u0119 Oleszkach na Ukrainie","ukParliament":"Parlament Wielkiej Brytanii \u2013 Utworzenie prowadzonego przez Wielk\u0105 Brytani\u0119 korytarza pomocy humanitarnej do Oleszek na Ukrainie"},"publicActionLead":"Zwr\xf3\u0107 uwag\u0119 na obl\u0119\u017Cenie dronami tam, gdzie jeste\u015B.","organiseAction":"Zorganizuj akcj\u0119.","policyBody":"W\u0142adze ukrai\u0144skie prowadz\u0105 konsultacje z Mi\u0119dzynarodowym Komitetem Czerwonego Krzy\u017Ca w sprawie utworzenia humanitarnego korytarza ewakuacyjnego z okupowanych miejscowo\u015Bci obwodu cherso\u0144skiego oraz zapewnienia dost\u0119pu humanitarnego dla \u017Cywno\u015Bci, wody, lek\xf3w, paliwa i pomocy medycznej. Na pocz\u0105tku czerwca nie dzia\u0142a\u0142 \u017Caden korytarz ewakuacyjny ani sta\u0142y mechanizm dost\u0119pu humanitarnego.","documentaryTitle":"Oleszki \u2013 kr\xf3tki film dokumentalny","downloadTitle":"Pobierz","downloadSub":"grafiki"},"footer":{"addCityText":"Aby doda\u0107 swoje miasto, napisz na adres: ","organiseText":"Dodaj swoj\u0105 demonstracj\u0119 \u2013 skontaktuj si\u0119 z nami:","contact":"Kontakt:"},"byCountry":"wed\u0142ug kraju","byDate":"wed\u0142ug daty","countries":{"australia":"Australia","austria":"Austria","bulgaria":"Bu\u0142garia","canada":"Kanada","czechia":"Czechy","denmark":"Dania","estonia":"Estonia","finland":"Finlandia","france":"Francja","georgia":"Gruzja","germany":"Niemcy","hungary":"W\u0119gry","italy":"W\u0142ochy","japan":"Japonia","mexico":"Meksyk","netherlands":"Holandia","norway":"Norwegia","poland":"Polska","romania":"Rumunia","spain":"Hiszpania","sweden":"Szwecja","southAfrica":"Republika Po\u0142udniowej Afryki","ukraine":"Ukraina","unitedKingdom":"Wielka Brytania","usa":"USA","ireland":"Irlandia","belgium":"Belgia"},"cities":{"alicante":{"city":"Alicante","country":"Hiszpania","time":"Alicante - Hiszpania, 16:00 - 17:00","location":"Auditorio la Concha, Explanada de Espa\xf1a","cleanTime":"16:00 - 17:00","day":"schedule13"},"barcelona":{"city":"Barcelona","country":"Hiszpania","time":"Barcelona - Hiszpania, 12:00 - 14:00","location":"Placa de Sant Jaume","cleanTime":"12:00 - 14:00","day":"schedule14"},"berkeley":{"city":"Berkeley","country":"USA","time":"Berkeley - USA, 12:00 - 13:00","location":"4th St.","cleanTime":"12:00 - 13:00","day":"schedule13"},"berlin":{"city":"Berlin","country":"Niemcy","time":"Berlin - Niemcy, 12:00","location":"Tempelhofer Feld, wej\u015Bcie Leinstr./r\xf3g Oderstr.","cleanTime":"12:00","day":"schedule14"},"bettendorf":{"city":"Bettendorf","country":"USA","time":"Bettendorf - USA, 17:30 - pokaz filmu","location":"Biblioteka publiczna w Bettendorf","cleanTime":"17:30 - pokaz filmu","day":"schedule11"},"birmingham":{"city":"Birmingham","country":"Wielka Brytania","time":"Birmingham - Wielka Brytania, 14:00 - 15:30","location":"Baskerville House, Cambridge St.","cleanTime":"14:00 - 15:30","day":"schedule13"},"bonn":{"city":"Bonn","country":"Niemcy","time":"Bonn - Niemcy, 14:00 - 16:00","location":"Poststra\xdfe, przed dworcem g\u0142\xf3wnym (Hauptbahnhof)","cleanTime":"14:00 - 16:00","day":"schedule14"},"bremen":{"city":"Brema","country":"Niemcy","time":"Brema - Niemcy, 15:00 - 18:00","location":"Bahnhofsvorplatz","cleanTime":"15:00 - 18:00","day":"schedule14"},"budapest":{"city":"Budapeszt","country":"W\u0119gry","time":"Budapeszt - W\u0119gry, do potwierdzenia","location":"","cleanTime":"do potwierdzenia","day":"scheduleTBC"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00 - 15:00","location":"410 N. Michigan ave. (budynek Wrigley)","cleanTime":"13:00 - 15:00","day":"schedule14"},"constanta":{"city":"Konstanca","country":"Rumunia","time":"Konstanca - Rumunia, do potwierdzenia","location":"","cleanTime":"do potwierdzenia","day":"scheduleTBC"},"copenhagen":{"city":"Kopenhaga","country":"Dania","time":"Kopenhaga - Dania, 14:00","location":"Axeltorv","cleanTime":"14:00","day":"schedule14"},"dallas":{"city":"Dallas","country":"USA","time":"Dallas - USA, 12:00 - 13:00","location":"Dallas City Hall Plaza","cleanTime":"12:00 - 13:00","day":"schedule13"},"denver":{"city":"Denver","country":"USA","time":"Denver - USA, 12:00","location":"Kapitol stanu Kolorado, zachodnie schody","cleanTime":"12:00","day":"schedule14"},"edinburgh":{"city":"Edynburg","country":"Wielka Brytania","time":"Edynburg - Wielka Brytania, 13:00 - 15:00","location":"Pomnik ksi\u0119cia Wellingtona","cleanTime":"13:00 - 15:00","day":"schedule13"},"fortWorth":{"city":"Fort Worth","country":"USA","time":"Fort Worth - USA, 14:00 - 15:00","location":"S\u0105d hrabstwa Tarrant","cleanTime":"14:00 - 15:00","day":"schedule14"},"hamburg":{"city":"Hamburg","country":"Niemcy","time":"Hamburg - Niemcy, 14:00 - 16:00","location":"M\xf6nckebergbrunnen (M\xf6nckebergstra\xdfe)","cleanTime":"14:00 - 16:00","day":"schedule20"},"houghton":{"city":"Houghton, Michigan","country":"USA","time":"Houghton, Michigan - USA, 15:00","location":"Portage Lake Lift Bridge","cleanTime":"15:00","day":"schedule14"},"helsinki":{"city":"Helsinki","country":"Finlandia","time":"Helsinki - Finlandia, 17:00 - 18:00","location":"Narinkkatori","cleanTime":"17:00 - 18:00","day":"schedule16"},"izumo14":{"city":"Izumo","country":"Japonia","time":"Izumo - Japonia, 13:00","location":"Chram Izumo Taisha, 195 Kitsukihigashi, Taishacho","cleanTime":"13:00","day":"schedule14"},"izumo20":{"city":"Izumo","country":"Japonia","time":"Izumo - Japonia","location":"Chram Izumo Taisha, 195 Kitsukihigashi, Taishacho","cleanTime":"","day":"schedule20"},"kamloops":{"city":"Kamloops, BC","country":"Kanada","time":"Kamloops, BC - Kanada, 15:00 - 16:00","location":"Ratusz","cleanTime":"15:00 - 16:00","day":"schedule13"},"kyiv":{"city":"Kij\xf3w","country":"Ukraina","time":"Kij\xf3w - Ukraina, 17:00-18:00","location":"Majdan Niepodleg\u0142o\u015Bci","cleanTime":"17:00 - 18:00","day":"schedule14"},"leipzig":{"city":"Lipsk","country":"Niemcy","time":"Lipsk - Niemcy, 12:00 - 13:00","location":"Willy Brandt Platz","cleanTime":"12:00 - 13:00","day":"schedule13"},"london":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 18:30 - pokaz filmu","location":"Dom Ukrai\u0144ski, 154 Holland Park Avenue","cleanTime":"18:30 - pokaz filmu","day":"schedule12"},"losAngeles":{"city":"Los Angeles","country":"USA","time":"Los Angeles - USA, 15:30","location":"4051 Melrose Ave","cleanTime":"15:30","day":"schedule14"},"malaga":{"city":"Malaga","country":"Hiszpania","time":"Malaga - Hiszpania, 18:00 - pokaz filmu","location":"Maydan - Centro Historico Cultural Ukraniano","cleanTime":"18:00 - pokaz filmu","day":"schedule13"},"manchester":{"city":"Manchester","country":"Wielka Brytania","time":"Manchester - Wielka Brytania, 14:00 - 15:30","location":"St Peter\'s Square, pomnik Emmeline Pankhurst","cleanTime":"14:00 - 15:30","day":"schedule13"},"mexicoCity":{"city":"Miasto Meksyk","country":"Meksyk","time":"Miasto Meksyk - Meksyk, 11:00","location":"Alameda Central, fontanna \u201EAmeryki\u201D (mi\u0119dzy pomnikiem Hemiciclo a Ju\xe1rez a kioskiem)","cleanTime":"11:00","day":"schedule14"},"milan":{"city":"Mediolan","country":"W\u0142ochy","time":"Mediolan - W\u0142ochy, 15:00","location":"Katedra w Mediolanie (Duomo)","cleanTime":"15:00","day":"schedule14"},"munich":{"city":"Monachium","country":"Niemcy","time":"Monachium - Niemcy, 17:00 - 19:00","location":"Odeonsplatz","cleanTime":"17:00 - 19:00","day":"schedule14"},"newYork13":{"city":"Nowy Jork","country":"USA","time":"Nowy Jork - USA, 16:00","location":"Times Square","cleanTime":"16:00","day":"schedule13"},"newYork14":{"city":"Nowy Jork","country":"USA","time":"Nowy Jork - USA, 13:00 - 14:00","location":"Times Square","cleanTime":"13:00 - 14:00","day":"schedule14"},"nienburg":{"city":"Nienburg (Weser)","country":"Niemcy","time":"Nienburg (Weser) - Niemcy, 17:00","location":"Stettiner Str.2A","cleanTime":"17:00","day":"schedule13"},"oslo":{"city":"Oslo","country":"Norwegia","time":"Oslo - Norwegia, 12:00 - 13:00","location":"Eidsvoll Plass, Stortinget","cleanTime":"12:00 - 13:00","day":"schedule14"},"ostersund":{"city":"\xd6stersund","country":"Szwecja","time":"\xd6stersund - Szwecja, 11:00 - 14:00","location":"Stortorget (rynek g\u0142\xf3wny)","cleanTime":"11:00 - 14:00","day":"schedule13"},"ottawa12":{"city":"Ottawa","country":"Kanada","time":"Ottawa - Kanada, 12:30 - 13:30","location":"Ambasada Rosji","cleanTime":"12:30 - 13:30","day":"schedule12"},"ottawa13":{"city":"Ottawa","country":"Kanada","time":"Ottawa - Kanada, 12:00","location":"Ambasada USA","cleanTime":"12:00","day":"schedule13"},"paris":{"city":"Pary\u017C","country":"Francja","time":"Pary\u017C - Francja, 15:30","location":"Skwer Tarasa Szewczenki -> fontanna Saint-Michel (marsz)","cleanTime":"15:30","day":"schedule13"},"plovdiv":{"city":"P\u0142owdiw","country":"Bu\u0142garia","time":"P\u0142owdiw - Bu\u0142garia, 16:00 - 17:00","location":"przy Domu Lewskiego","cleanTime":"16:00 - 17:00","day":"schedule14"},"prague":{"city":"Praga","country":"Czechy","time":"Praga - Czechy, 14:00","location":"plac Palackiego","cleanTime":"14:00","day":"schedule13"},"rosendal":{"city":"Rosendal","country":"Republika Po\u0142udniowej Afryki","time":"Rosendal - Republika Po\u0142udniowej Afryki, 11:00","location":"Siedziba Po\u0142udniowoafryka\u0144skiej S\u0142u\u017Cby Policyjnej","cleanTime":"11:00","day":"schedule13"},"sanAndres":{"city":"San Andr\xe9s, Teneryfa","country":"Hiszpania","time":"San Andr\xe9s, Teneryfa - Hiszpania, 13:00","location":"--","cleanTime":"13:00","day":"schedule13"},"sanDiego":{"city":"San Diego","country":"USA","time":"San Diego - USA, 14:00 - 16:00","location":"Pomnik El Cida, Balboa Park","cleanTime":"14:00 - 16:00","day":"schedule14"},"sanFrancisco":{"city":"San Francisco","country":"USA","time":"San Francisco - USA, 14:00","location":"Ferry Plaza, Embarcadero","cleanTime":"14:00","day":"schedule14"},"schwerin":{"city":"Schwerin","country":"Niemcy","time":"Schwerin - Niemcy, 19:00 - pokaz filmu","location":"Internationales Haus, Ziegenmarkt 4","cleanTime":"19:00 - pokaz filmu","day":"schedule13"},"seattle":{"city":"Seattle","country":"USA","time":"Seattle - USA, 12:30 - 15:30","location":"1005 E Union St.","cleanTime":"12:30 - 15:30","day":"schedule13"},"svetiVlas":{"city":"Sweti Wlas","country":"Bu\u0142garia","time":"Sweti Wlas - Bu\u0142garia, do potwierdzenia","location":"","cleanTime":"do potwierdzenia","day":"scheduleTBC"},"sydney":{"city":"Sydney","country":"Australia","time":"Sydney - Australia, 14:00","location":"Ratusz w Sydney","cleanTime":"14:00","day":"schedule13"},"tallinn":{"city":"Tallinn","country":"Estonia","time":"Tallinn - Estonia, 15:00 - pokaz filmu i wiec","location":"Kino S\xf5prus, Vana-Posti tn.8","cleanTime":"15:00 - pokaz filmu i wiec","day":"schedule13"},"tarragona":{"city":"Tarragona","country":"Hiszpania","time":"Tarragona - Hiszpania, 18:30","location":"Balc\xf3 Mediterrani","cleanTime":"18:30","day":"schedule14"},"theHague":{"city":"Haga","country":"Holandia","time":"Haga - Holandia, 13:00 - 15:00","location":"Przed Pa\u0142acem Pokoju / MTK","cleanTime":"13:00 - 15:00","day":"schedule14"},"tbilisi":{"city":"Tbilisi","country":"Gruzja","time":"Tbilisi - Gruzja, 21:00","location":"Tbilisi","cleanTime":"21:00","day":"schedule14"},"tranas":{"city":"Tran\xe5s","country":"Szwecja","time":"Tran\xe5s - Szwecja, 11:00 - 13:00, 13:00","location":"Storgatan 49 (Kultivera)","cleanTime":"11:00 - 13:00, 13:00","day":"schedule13"},"vienna":{"city":"Wiede\u0144","country":"Austria","time":"Wiede\u0144 - Austria, 16:00 - 18:00","location":"Stock-im-Eisen-Platz (obok katedry \u015Bw. Szczepana)","cleanTime":"16:00 - 18:00","day":"schedule14"},"washingtonDC":{"city":"Waszyngton","country":"USA","time":"Waszyngton - USA, 12:30 - 13:30","location":"Bia\u0142y Dom","cleanTime":"12:30 - 13:30","day":"schedule14"},"wroclaw":{"city":"Wroc\u0142aw","country":"Polska","time":"Wroc\u0142aw - Polska, 13:00","location":"Plac Wolno\u015Bci (od strony Narodowego Forum Muzyki)","cleanTime":"13:00","day":"schedule14"}},"help":{"organise":"Kontakt:","email":"khersonhumansafari@gmail.com","actionEmail":"antihumansafari@gmail.com","share":"Udost\u0119pnij na {{platform}}","website":"Strona internetowa","facebook":"Facebook","x":"X","youtube":"YouTube","bluesky":"Bluesky","donate":"Wesprzyj","donateIntro":"To inicjatywy, kt\xf3re zapewniaj\u0105 skuteczn\u0105, ukierunkowan\u0105 pomoc, by bezpo\u015Brednio chroni\u0107 cywil\xf3w w Chersoniu przed Human Safari.","shareTitle":"Przeka\u017C dalej","filmScreening":"Zorganizuj pokaz filmu dokumentalnego Kherson Human Safari:","howItStarted":"Jak to si\u0119 zacz\u0119\u0142o","khs":{"name":"Kherson Human Safari","desc":"Zarina Zabrisky, dziennikarka i filmowczyni, poprowadzi\u0142a og\xf3lno\u015Bwiatowy wiec i wyre\u017Cyserowa\u0142a film dokumentalny Kherson Human Safari."},"fellas":{"name":"Fellas4Europe","desc":"Ochrona cywil\xf3w na ulicach Chersonia \u2014 ochrona ludno\u015Bci przed atakami dron\xf3w.","foodDesc":"Pomoc \u017Cywno\u015Bciowa.","foodNote":"Przy wp\u0142acie wpisz \u201EFood for Cherson\u201D w tytule przelewu."},"ahs":{"name":"Anti Human Safari Project","desc":"Wykrywacze dron\xf3w i kamizelki ochronne dla wolontariuszy i s\u0142u\u017Cb ratunkowych w Chersoniu."},"pageTitle":"Stop Human Safari","sectionIntro":"Od lata 2024 roku rosyjskie wojsko u\u017Cywa ma\u0142ych dron\xf3w, by polowa\u0107 na cywil\xf3w, zabija\u0107 ich i terroryzowa\u0107 na ulicach Chersonia i innych przyfrontowych miast Ukrainy.","sectionIntro2":"To systematyczna i celowa kampania mord\xf3w \u2014 rosyjscy operatorzy dron\xf3w otwarcie publikuj\u0105 nagrania swoich ofiar na kana\u0142ach Telegram, by si\u0119 nimi chwali\u0107. W maju 2025 roku ONZ uzna\u0142a Human Safari za trwaj\u0105c\u0105 zbrodni\u0119 wojenn\u0105.","sectionIntro3":"Robi si\u0119 zbyt ma\u0142o. Human Safari musi si\u0119 sko\u0144czy\u0107.","sectionIntroBold":"TY mo\u017Cesz pom\xf3c. Oto jak","step2Title":"Zorganizuj","step3Title":"M\xf3w o tym","step3Para":"U\u017Cywaj hashtag\xf3w","step3ParaPost":"i opowiadaj innym o Human Safari","instagram":"Instagram","step2Bullet1":"pokaz filmu","step2Bullet2":"akcj\u0119 publiczn\u0105","step2Bullet3":"relacj\u0119 w mediach","publicActionLead":"Zwr\xf3\u0107 uwag\u0119 na Human Safari tam, gdzie jeste\u015B.","reachOutPre":"Mo\u017Cesz","reachOut":"si\u0119 z nami skontaktowa\u0107","reachOutPost":"po pomys\u0142y i materia\u0142y","newsCoverageLead":"przez swoje kontakty w mediach. Opowiedz im o Human Safari i o zagro\u017Ceniu dla wszystkich obecnych i przysz\u0142ych stref konfliktu.","putInTouchPre":"Mo\u017Cesz te\u017C","putInTouch":"skontaktowa\u0107 ich bezpo\u015Brednio z nami","inform":"Informuj","informSub":"siebie i innych","policyTitle":"Polityka","policyBody":"Proponowana ustawa LORA (Liability for Operators and Responsible Authorities Act) wprowadzi\u0142aby sankcje wobec ca\u0142ego \u0142a\u0144cucha odpowiedzialno\u015Bci \u2014 od rosyjskich operator\xf3w dron\xf3w FPV i dow\xf3dc\xf3w po najwy\u017Csze dow\xf3dztwo wojskowe, a tak\u017Ce producent\xf3w i dostawc\xf3w umo\u017Cliwiaj\u0105cych produkcj\u0119 dron\xf3w i ich u\u017Cycie przeciwko cywilom.","policyHelp":"Mo\u017Cesz pom\xf3c na poziomie politycznym?","getInTouch":"Skontaktuj si\u0119","disdict":{"title":"S\u0142ownik dezinformacji","link":"Human Safari"},"kryla":{"name":"Fundacja Kry\u0142a","desc":"Wesprzyj ich w op\u0142aceniu zakwaterowania i podstawowych artyku\u0142\xf3w dla mieszka\u0144c\xf3w Oleszek."}},"action":{"intro":"Zacz\u0119li\u015Bmy od og\xf3lno\u015Bwiatowej demonstracji. Teraz mo\u017Cesz:","helpLink":"pom\xf3c tutaj"},"accounts":{"heading":"Relacje"},"media":{"close":"Zamknij","view":"Zobacz materia\u0142y","previous":"Poprzednie","next":"Nast\u0119pne","andrushenkoCredit":"O\u0142eksandr Andruszenko, fotoreporter serwisu Vgoru","khersonPoliceCredit":"z @khersonpolice","antypenkoCredit":"Iwan Antypenko, fotoreporter z Chersonia","telegramChannelCredit":"opublikowane przez rosyjski kana\u0142 Telegram Human Safari \u201Eod Mariupola po Karpaty\u201D","fruitSellerDescription":"Sprzedawca owoc\xf3w \u015Bcigany przez drona \u015Bwiat\u0142owodowego","burntCarDescription":"Spalony samoch\xf3d w Chersoniu","bridgeAttackDescription":"Nastolatek zamordowany przez drona FPV pod mostem w Chersoniu","busAttackDescription":"Jeden z wielu atak\xf3w dron\xf3w FPV na komunikacj\u0119 miejsk\u0105","fpvDroneDescription":"Dron FPV na polowaniu Human Safari","antiDroneNetsDescription":"Ulica w Chersoniu os\u0142oni\u0119ta siatkami przed dronami Human Safari","firefighterDescription":"Stra\u017Cak gasi samoch\xf3d po ataku Human Safari, za nim le\u017Cy ofiara"},"follow":{"title":"Obserwuj","subHumanSafari":"rzetelne \u017Ar\xf3d\u0142a relacjonuj\u0105ce z Chersonia i o Human Safari","subDroneSiege":"rzetelne \u017Ar\xf3d\u0142a relacjonuj\u0105ce z Chersonia i o obl\u0119\u017Ceniu dronami","localPress":"lokalna prasa ukrai\u0144skoj\u0119zyczna","lang":{"english":"angielski","german":"niemiecki","ukrainian":"ukrai\u0144ski"},"language":"J\u0119zyk: {{list}}","languages":"J\u0119zyki: {{list}}","langSeparator":", ","zabrisky":{"name":"Zarina Zabrisky","desc":"Ameryka\u0144ska dziennikarka i filmowczyni mieszkaj\u0105ca w Chersoniu, pisze dla Byline Times i Euromaidan Press; re\u017Cyserka filmu dokumentalnego Kherson Human Safari."},"naber":{"name":"Ibrahim Naber","desc":"G\u0142\xf3wny reporter niemieckiego dziennika Die Welt; regularnie relacjonuje Human Safari w Chersoniu."},"kelley":{"name":"Brendan Kelley","desc":"Autor Kherson Weekly, bie\u017C\u0105cego rejestru rosyjskich atak\xf3w dron\xf3w na cywil\xf3w w Chersoniu i okolicznych wsiach."},"vgoru":{"name":"Vgoru","desc":"Niezale\u017Cne medium z obwodu cherso\u0144skiego, relacjonuj\u0105ce \u017Cycie pod ostrza\u0142em i pod okupacj\u0105."},"suspilne":{"name":"Suspilne Cherso\u0144","desc":"Cherso\u0144ska redakcja ukrai\u0144skiego nadawcy publicznego."},"most":{"name":"MOST","desc":"Lokalna agencja informacyjna z Chersonia, relacjonuj\u0105ca wydarzenia w mie\u015Bcie i regionie."}},"rallies":{"oleshky2026":{"heroStop":"STOP OBL\u0118\u017BENIU DRONAMI","heroSave":"RATUJMY OLESZKI","worldwideRally":"Og\xf3lno&shy;\u015Bwiatowa demonstracja","heroDate":"Pa\u017Adziernik","infoText1":"Tysi\u0105ce cywil\xf3w s\u0105 uwi\u0119zione w obl\u0119\u017Ceniu dronami w Oleszkach, Ho\u0142ej Prystani, Starej Zburiwce i Nowej Zburiwce. Rosyjskie si\u0142y wykorzystuj\u0105 ich jako \u017Cywe tarcze, kryj\u0105c si\u0119 za nimi podczas atak\xf3w dron\xf3w Human Safari na przeciwleg\u0142y brzeg.","infoText2":"Kryzys jest dramatyczny \u2014 brakuje \u017Cywno\u015Bci, wody, opieki medycznej, lek\xf3w, pr\u0105du, gazu i \u0142\u0105czno\u015Bci. Drogi s\u0105 g\u0119sto zaminowane, a drony ograniczaj\u0105 mo\u017Cliwo\u015B\u0107 poruszania si\u0119. <bold>TY mo\u017Cesz pom\xf3c. Do\u0142\u0105cz do tysi\u0119cy ludzi na ca\u0142ym \u015Bwiecie, kt\xf3rzy domagaj\u0105 si\u0119 zako\u0144czenia obl\u0119\u017Cenia dronami.</bold>","imageAlt":"Wyg\u0142odzony pies w\u015Br\xf3d ludzkich ko\u015Bci w zrujnowanych Oleszkach, pod czerwonym niebem pe\u0142nym dron\xf3w, z napisem Stop Russian Drone Siege","demandsTitle":"Wzywamy do:","demand1":"bezpiecznych i skutecznych korytarzy humanitarnych do Oleszek i innych dotkni\u0119tych miejscowo\u015Bci.","demand2":"natychmiastowej pomocy humanitarnej i wsparcia dla ofiar atak\xf3w human safari.","demand3":"odpowiednich sankcji wobec os\xf3b i \u0142a\u0144cuch\xf3w dostaw odpowiedzialnych za ataki na ludno\u015B\u0107 cywiln\u0105.","demand4":"dzia\u0142a\u0144 zniech\u0119caj\u0105cych do u\u017Cywania ma\u0142ych dron\xf3w do systematycznego atakowania i terroryzowania cywil\xf3w w Chersoniu, na Ukrainie i gdzie indziej.","cities":{"edinburgh":{"city":"Edynburg","country":"Wielka Brytania","time":"Edynburg - Wielka Brytania, 14:00","location":"Pomnik ksi\u0119cia Wellingtona","cleanTime":"14:00","day":"schedule26"},"birmingham":{"city":"Birmingham","country":"Wielka Brytania","time":"Birmingham - Wielka Brytania, 14:00 - 16:00","location":"Naprzeciwko Hall of Memory, B1 2ND","cleanTime":"14:00 - 16:00","day":"schedule3"},"vienna":{"city":"Wiede\u0144","country":"Austria","time":"Wiede\u0144 - Austria, 15:00 - 17:00","location":"Stephansplatz, 1010 Wiede\u0144","cleanTime":"15:00 - 17:00","day":"schedule27"},"munich":{"city":"Monachium","country":"Niemcy","time":"Monachium - Niemcy, 15:00 - 17:00","location":"Marienplatz, 80331 Monachium","cleanTime":"15:00 - 17:00","day":"schedule3"},"london":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 16:00 - 18:00","location":"Downing Street","cleanTime":"16:00 - 18:00","day":"schedule27"},"manchester":{"city":"Manchester","country":"Wielka Brytania","time":"Manchester - Wielka Brytania, 14:00 - 15:30","location":"St Peter\'s Square","cleanTime":"14:00 - 15:30","day":"schedule26"},"sydney":{"city":"Sydney","country":"Australia","time":"Sydney - Australia, 14:00","location":"Ratusz w Sydney","cleanTime":"14:00","day":"schedule26"},"paris":{"city":"Pary\u017C","country":"Francja","time":"Pary\u017C - Francja, 15:30 - 18:30","location":"Od cerkwi \u015Bw. W\u0142odzimierza do Place Saint-Michel","cleanTime":"15:30 - 18:30","day":"schedule26"},"parisSep30":{"city":"Pary\u017C","country":"Francja","time":"Pary\u017C - Francja, 18:00","location":"Stacja metra Rambuteau","cleanTime":"18:00","day":"schedule30"},"lyon":{"city":"Lyon","country":"Francja","time":"Lyon - Francja, 14:00","location":"Place de la Com\xe9die","cleanTime":"14:00","day":"schedule27"},"dublin":{"city":"Dublin","country":"Irlandia","time":"Dublin - Irlandia, 13:00","location":"Poczta G\u0142\xf3wna (GPO)","cleanTime":"13:00","day":"schedule4"},"brussels":{"city":"Bruksela","country":"Belgia","time":"Bruksela - Belgia, 10:00 - 11:00","location":"La Petite rue de la Loi, 1040 Bruksela (rondo Schumana)","cleanTime":"10:00 - 11:00","day":"schedule28"},"ottawa":{"city":"Ottawa","country":"Kanada","time":"Ottawa - Kanada, 12:30 - 13:30","location":"Ambasada Rosji, 285 Charlotte St","cleanTime":"12:30 - 13:30","day":"schedule2"},"nantes":{"city":"Nantes","country":"Francja","time":"Nantes - Francja, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule3"},"gdansk":{"city":"Gda\u0144sk","country":"Polska","time":"Gda\u0144sk - Polska, 18:30 - 19:30","location":"D\u0142ugi Targ, przy Fontannie Neptuna","cleanTime":"18:30 - 19:30","day":"schedule27"},"chicago":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (budynek Wrigley)","cleanTime":"13:00","day":"schedule27"},"chicagoOct4":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (budynek Wrigley)","cleanTime":"13:00","day":"schedule4"},"chicagoOct11":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (budynek Wrigley)","cleanTime":"13:00","day":"schedule11"},"chicagoOct18":{"city":"Chicago","country":"USA","time":"Chicago - USA, 13:00","location":"410 N. Michigan ave. (budynek Wrigley)","cleanTime":"13:00","day":"schedule18"},"dresden":{"city":"Drezno","country":"Niemcy","time":"Drezno - Niemcy, 14:00","location":"Neumarkt","cleanTime":"14:00","day":"schedule4"},"malaga":{"city":"Malaga","country":"Hiszpania","time":"Malaga - Hiszpania, 19:00","location":"Plaza de la Marina","cleanTime":"19:00","day":"schedule3"},"londonSep29":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 18:00","location":"Trafalgar Square","cleanTime":"18:00","day":"schedule29"},"plovdiv":{"city":"P\u0142owdiw","country":"Bu\u0142garia","time":"P\u0142owdiw - Bu\u0142garia, 17:00","location":"G\u0142\xf3wna ulica (Glawnata), przy schodach \u201EKamenica\u201D / napisie \u201ETogether\u201D","cleanTime":"17:00","day":"schedule3"},"budapest":{"city":"Budapeszt","country":"W\u0119gry","time":"Budapeszt - W\u0119gry, 17:00 - 20:00","location":"Szent Istv\xe1n t\xe9r (plac \u015Bw. Stefana)","cleanTime":"17:00 - 20:00","day":"schedule30"},"londonOct1":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule1"},"londonOct3":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 12:00","location":"Trafalgar Square","cleanTime":"12:00","day":"schedule3"},"hamburg":{"city":"Hamburg","country":"Niemcy","time":"Hamburg - Niemcy, 14:00 - 16:00","location":"Landungsbr\xfccken, Jan-Fedder-Promenade, na wysoko\u015Bci pomostu 1, 20359 Hamburg","cleanTime":"14:00 - 16:00","day":"schedule3"},"kiel":{"city":"Kilonia","country":"Niemcy","time":"Kilonia - Niemcy, 15:00 - 16:00","location":"Holstenstra\xdfe","cleanTime":"15:00 - 16:00","day":"schedule4"},"oslo":{"city":"Oslo","country":"Norwegia","time":"Oslo - Norwegia","location":"Eidsvolls plass","cleanTime":"","day":"schedule3"},"leipzig":{"city":"Lipsk","country":"Niemcy","time":"Lipsk - Niemcy, 17:00 - 18:00","location":"Dworzec g\u0142\xf3wny (Willy-Brandt-Platz)","cleanTime":"17:00 - 18:00","day":"schedule5"},"londonOct9":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 17:00","location":"Trafalgar Square","cleanTime":"17:00","day":"schedule9"},"londonOct10":{"city":"Londyn","country":"Wielka Brytania","time":"Londyn - Wielka Brytania, 13:00","location":"Trafalgar Square","cleanTime":"13:00","day":"schedule10"},"dublinOct11":{"city":"Dublin","country":"Irlandia","time":"Dublin - Irlandia, 13:00","location":"Poczta G\u0142\xf3wna (GPO)","cleanTime":"13:00","day":"schedule11"},"dublinOct25":{"city":"Dublin","country":"Irlandia","time":"Dublin - Irlandia, 14:00","location":"Poczta G\u0142\xf3wna (GPO)","cleanTime":"14:00","day":"schedule25"},"nantesOct31":{"city":"Nantes","country":"Francja","time":"Nantes - Francja, 15:00 - 16:30","location":"Place Royale","cleanTime":"15:00 - 16:30","day":"schedule31"}},"posterStopSiege":"Stop rosyjskiemu obl\u0119\u017Ceniu dronami","posterNoRoadOut":"Drogi do Oleszek i z Oleszek s\u0105 zablokowane","posterHumanitarianCatastrophe":"Oleszki. Katastrofa humanitarna pod okupacj\u0105","seeGallery":"Zobacz / pobierz plakaty"},"artBy":"Autor: {{name}}","downloadPoster":"Pobierz plakat","reel":{"download":"Pobierz wideo (MP4)"},"addDemo":{"title":"dodaj swoj\u0105 demonstracj\u0119","where":"gdzie: miejscowo\u015B\u0107/miasto","contact":"e-mail/telefon","message":"wiadomo\u015B\u0107: kogo reprezentujesz, czy demonstracja jest potwierdzona czy w przygotowaniu, link do og\u0142oszenia w sieci, inne szczeg\xf3\u0142y","submit":"Wy\u015Blij","sending":"Wysy\u0142anie\u2026","thanks":"Dzi\u0119kujemy! Odezwiemy si\u0119.","error":"Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie.","contactInvalid":"Podaj poprawny adres e-mail lub numer telefonu z kierunkowym kraju (np. +48 600 123 456).","date":"data","time":"godzina rozpocz\u0119cia (lokalna)","whereInvalid":"Podaj nazw\u0119 miejscowo\u015Bci lub miasta, np. Pary\u017C albo Kij\xf3w, Ukraina.","datePlaceholder":"data: dd/mm"}},"seo":{"oleshky":{"title":"Stop obl\u0119\u017Ceniu dronami \u2014 Ratujmy Oleszki | Demonstracje","description":"Rosyjskie drony oblegaj\u0105 tysi\u0105ce cywil\xf3w w okupowanych Oleszkach na Ukrainie, odci\u0119tych od \u017Cywno\u015Bci, wody i lek\xf3w. Znajd\u017A demonstracj\u0119 w pobli\u017Cu i domagaj si\u0119 bezpiecznego przej\u015Bcia."},"leftBank":{"title":"Obl\u0119\u017Cenie dronami Oleszek i okupowanego obwodu cherso\u0144skiego","description":"Tysi\u0105ce cywil\xf3w s\u0105 uwi\u0119zione w rosyjskim obl\u0119\u017Ceniu dronami w okupowanych Oleszkach, Ho\u0142ej Prystani i pobliskich wsiach. Dowiedz si\u0119, co si\u0119 dzieje i jak mo\u017Cesz pom\xf3c."},"help":{"title":"Stop Human Safari \u2014 Rosyjskie drony poluj\u0105 na cywil\xf3w w Chersoniu","description":"Rosyjskie drony poluj\u0105 na cywil\xf3w w Chersoniu na Ukrainie. Dowiedz si\u0119 o zbrodni wojennej Human Safari i o tym, jak pom\xf3c j\u0105 powstrzyma\u0107."},"action":{"title":"Og\xf3lno\u015Bwiatowy wiec, grudzie\u0144 2025 \u2014 Stop Human Safari","description":"Zdj\u0119cia, plakaty i miejsca og\xf3lno\u015Bwiatowego wiecu z grudnia 2025 przeciwko rosyjskim atakom dron\xf3w na cywil\xf3w w Chersoniu na Ukrainie."},"rallies":{"title":"Zdj\u0119cia z wiec\xf3w \u2014 Stop Human Safari","description":"Zdj\u0119cia z wiec\xf3w na ca\u0142ym \u015Bwiecie przeciwko rosyjskim atakom dron\xf3w na cywil\xf3w w Chersoniu na Ukrainie."},"resources":{"title":"Human Safari \u2014 Raporty, artyku\u0142y i relacje \u015Bwiadk\xf3w","description":"Raporty, artyku\u0142y, wywiady i relacje naocznych \u015Bwiadk\xf3w o rosyjskich atakach dron\xf3w na cywil\xf3w w Chersoniu na Ukrainie."},"reel":{"title":"Ratujmy Oleszki \u2014 Wideo z demonstracji","description":"Wideo z og\xf3lno\u015Bwiatowych demonstracji \u201ERatujmy Oleszki\u201D, pa\u017Adziernik 2026."}}}');


// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const $01f9c2ffd7693c68$var$resources = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($880c561c4717b40d$exports)))
    },
    uk: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($324b75d4c5497ecc$exports)))
    },
    de: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($b0a777bb87628789$exports)))
    },
    fr: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($e6806cd758d520fa$exports)))
    },
    da: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($968b2cdfadc8e543$exports)))
    },
    it: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($a396a1e28512ab83$exports)))
    },
    es: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($38443901ba4773cc$exports)))
    },
    zh: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($5092669ac35197c4$exports)))
    },
    pl: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($a8516cebb66bc9ef$exports)))
    }
};
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
.init({
    resources: $01f9c2ffd7693c68$var$resources,
    lng: 'en',
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
        escapeValue: false
    }
});
var $01f9c2ffd7693c68$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);


const $70fc9a727fa662ae$var$rootElement = document.getElementById('app');
if ($70fc9a727fa662ae$var$rootElement) {
    const root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$rootElement);
    root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}));
} else console.error('Root element not found');


//# sourceMappingURL=hs-action.79a85ab4.js.map
